document.documentElement.setAttribute('data-theme','glass');

/* ============ i18n 引擎(阶段0 · 2026-07-24 · 中/英/韩)============
   语言联动:Shopify 顶部语言开关切换 → section 的 Liquid 注入 window.__DIY_LOCALE__
   → 这里映射成 zh / en / ko。独立版(localhost 无 Liquid)读 <html lang>;
   本地测试用 ?lang=en 强制覆盖。中文=站点原文,不经字典(applyStaticI18n 对 zh 早退,保证中文字节不变)。 */
const DIY_LOCALES = ['zh', 'en', 'ko'];
// 原始 locale 串(zh-TW / zh-CN / en / ko-KR…),繁简判定要用它,LOCALE 已经被归一成三档了
const RAW_LOCALE = (function () {
  var q = '';
  try { q = (new URLSearchParams(location.search).get('lang') || '').toLowerCase(); } catch (e) {}
  return q || String(window.__DIY_LOCALE__ || document.documentElement.lang || 'zh').toLowerCase();
})();
const LOCALE = (function () {
  var q = RAW_LOCALE;
  if (q.indexOf('ko') === 0) return 'ko';
  if (q.indexOf('en') === 0) return 'en';
  if (q.indexOf('zh') === 0) return 'zh';
  return 'en';                                                  // 店铺主语言英文兜底
})();
// 繁體中文(台湾/香港/澳门):店铺发布的就是 zh-TW,而本模块的中文文案全是简体写的 → 显示前统一转一道
const IS_TRAD = /^zh[-_]?(tw|hk|mo|hant)/.test(RAW_LOCALE);
// 给 :root 打语言标记,供"英文专属调密"等语言相关 CSS 用(英文版布局可与中文不同)
try {
  document.documentElement.setAttribute('data-diy-locale', LOCALE);
  if (IS_TRAD) document.documentElement.setAttribute('data-diy-hant', '1');
  // 2026-10-22 手机版按钮样式:默认值由后台下拉框决定(section 里的内联脚本先打标记),
  //   网址 &chipstyle=tile|classic / &kitstyle=compact|classic 可临时覆盖,方便不改后台先看另一种
  const _cs = (location.search.match(/[?&]chipstyle=(\w+)/) || [])[1];
  if (_cs) document.documentElement.classList.toggle('chip-tile', _cs === 'tile');
  const _ks = (location.search.match(/[?&]kitstyle=(\w+)/) || [])[1];
  if (_ks) document.documentElement.classList.toggle('kit-compact', _ks === 'compact');
} catch (e) {}
// MONIXIBI logo 图源:section 版由 Liquid 注入 asset_url(否则相对路径在店铺解析不到=破图);独立版兜底相对路径
const LOGO_SRC = (typeof window !== 'undefined' && window.__DIY_LOGO__) || 'logo-monixibi.png';

// 文案字典:阶段0 只含 hero + 3步教学 + CTA 若干条,后续阶段往里加
const I18N = {
  zh: {
    // ㉑ 横条左侧引导语(第 98 轮):先说清「这是耳机、你能自己设计」,再由按钮催行动
    banner_lead: '你自己设计的耳机', banner_lead_sub: '每个部件都由你决定。', banner_sub: '动手配一副 ·',
    hero_lead: '一台主机,', hero_sub: '15 种风格。',
    hero_tag1: '40h 续航 · 3D 沉浸音效。', hero_tag2: ' 种延展可能。',
    faq_title: '如何 DIY 这台耳机?',
    guide_title: '只要 3 步,装出你的搭配',
    step1: '选 1 台主机色(4 色任选)',
    step2: '装第 1 套搭配 — 标配 1 套配件(1 个面盖 · 1 对皮套 · 1 条头带)',
    step2_prog: '→ <strong>4 种风格</strong>,可下单',
    step3: '装第 2 套搭配 — 加(${add})购 1 套配件(+1 面盖 · +1 皮套 · +1 头带)',   // {add} = kit2ExtraCost(),与文件夹上方胶囊同源(2026-10-18:原写死 $50 = 折前差价,胶囊是折后 $40,两处打架)
    step3_prog: '→ 风格从 4 跳到 <strong>15 种</strong> · 最划算',
    guide_note: '主机本体只有 1 台,所有"风格"都是同一台主机配不同零件拼出来的造型。',
    // —— 以下动态(renderCta 每次重绘,中文也走字典,须与原文完全一致)——
    cta_add: '加入购物车 →',
    /* 点下去到接口返回之间的等待态。2026-09-13 之前这句是 JS 里硬写的中文，
       没走字典 —— 英文店铺的客人点一下，按钮就蹦出 3 个方框（iOS 上
       Plus Jakarta Sans 是纯拉丁字体，没有中文字形，画成 tofu），
       方框还比拉丁字母高，按钮跟着变高。动态文案一律走 TR()。 */
    cta_adding: '加入中…',
    cta_build_pair: '先装好第 {n} 套搭配',
    style_n_1: '4 种风格', style_n_2: '15 种风格', style_n_3: '上百种风格',
    style_wear_1: '4 种戴法', style_wear_2: '15 种戴法', style_wear_3: '上百种戴法',
    cta_styles: '买 {n} 套 = 立即拥有以上 <strong>{styleN}</strong>',
    hint_full: '完整套餐 · {styleN}',
    hint_need: '还差 {need} 件 · 点这跳过去',
    tab_need: '还差 {need} 件',        // Tab 胶囊上的短版(无"点这跳过去")
    // —— 阶段1 部件名 / aria / 提示 ——
    form_overear: '全包耳', form_halfear: '半包耳',
    aria_build1: '你亲手装的第 1 套搭配', aria_build2: '你亲手装的第 2 套搭配',
    moni_label: '魔尼带',
    set_n_label: '第 {n} 套:',
    note_unlock_pick: '(解锁后可选)',
    note_used_other: '(已被另一套选用)',
    note_bonus: '(套装标配,不可选 / 已含)',
    note_same_b1: '(跟第 1 套同底色,会让两套看着像同一款)',
    // —— 阶段1 区块标题 / 标签 / 绑定说明 ——
    explore_title: 'DIY 图卡集',
    explore_punch: '图卡随你的 DIY 实时变化',
    download_all: '下载全部', download_all_aria: '一键打包下载全部配色图',
    shared_by: '这副是为 {name} 配的', shared_anon: '你正在看一副配好的搭配',
    share_failed: '分享没成功 · 请用右边的小图标试试', share_link_copied: '链接已复制 · 对方点开就能看到你这副', share_local_env: '本地测试环境 · 上线后分享才生效',
    shared_make_mine: '改成我的 →',
    recv_eyebrow_gift: '有人为你配了一副', recv_eyebrow_want: '他想要这一副', recv_eyebrow_show: '看看我配的这一副',
    recv_how: '这一套里的零件', recv_count: '光是这些,就能换出 {n} 种样子 —— 右边每一张都是',
    recv_cta_want: '送 TA 这一副 →', recv_cta_mine: '我也想配一副 →',
    recv_link_explore: '看看还有哪 96,000 种可能 →', recv_fwd: '转给朋友看看',
    explore_slogan: '一台的钱，<br>穿一柜的风格。',
    // 第 117 轮:钩子原来复读了右上角标语("一台的钱穿一柜风格"),同一屏说两遍 = 口号疲劳。
    // 价值主张交给标语,钩子只讲它独有的玩法(签名送礼),字也短了,彩虹光带才透得出来。
    explore_hook: '点开 · 签上名字,它就成了一份礼 <span class="hook-arrow">↓</span>',
    prev_aria: '上一张', next_aria: '下一张',
    kit_1: '1 套', kit_2: '2 套', kit_3: '3 套',
    kit_popular: '主推', kit_soon: '即将上线', kit_soon_title: '3 套功能开发中',
    total_price: '总价',
    bind_title: '头带底色已绑定皮套颜色(推荐)',
    bind_p1: '这是<strong>设计师推荐的搭配模式</strong>:头带和皮套<strong>同底色</strong>,做出来的耳机<strong>整体感最强,99% 不踩雷</strong>。',
    bind_p2: '选了头带,皮套<strong>自动跟色</strong>;反过来也一样。<strong>新手用这个模式最稳</strong>。',
    bind_p3: '<strong>绑定</strong>是推荐的<strong>安全起点</strong>,解绑则交给想<strong>自由发挥</strong>的你。',
    // —— 阶段1 预览大标/卖点/套装标签/魔尼带/报错 ——
    preview_caption: '设计你的 Rainbow',
    preview_tagline: '而颜色,只是开始。真正定义 Rainbow 的,是它戴上之后的弧度:头梁的弧线、耳罩贴合脸庞的比例。这份结构之美,我们早已替你做好。',
    preview_subcaption: '<span class="pv-lead-star">★</span><b class="pv-lead-strong">星级</b>只衡量一副耳机自己的协调度。分高,是安全耐看;分低,往往更大胆、更自由——它跳出了规则,成了只属于你的那一副。没有不好的搭配,只有够不够像你。',
    std_kit: '标准套装', std_kit_incl: '含标配头带 + 皮套',
    kit1_acc: '第一套配件', kit2_acc: '第二套配件',
    lock_locked: '锁色', lock_free: '自由',
    moni_tip_locked: '设计师精选色 · 点 🔒 解锁自选', moni_tip_free: '已自选 · 点 🔒 锁回精选色',
    moni_aria_locked: '设计师精选色,点击解锁自选', moni_aria_free: '已自选,点击锁回精选色',
    err_download: '下载出错,请重试', err_gencard: '生成图卡失败,请重试', dl_preparing: '正在准备图片 {i}/{n}', dl_ready: '图片好了,再点一下黑色图标存到相册',
    err_addcart: '加购失败:{msg}\n\n可能原因:\n1. 当前页面不是 monixibi.com 域名(Ajax API 要求同源)\n2. 某个 variant_id 已下架\n\n请截图给开发人员排查。',
    discount_save: '立享{rateCn} · 省 ${save}',
    // 2026-10-29 套装八折并入标价后:跟「零件分开买的真实结账价」比,不再跟虚高原价比
    sep_price: '分开买 ${sep}', sep_save: '省 ${save}', sep_save_m: '比分开买省 ${save}',
    howto_btn: '看教程', howto_close: '关闭', howto_sound: '声音开关', howto_dialog: '如何 DIY 一副 Rainbow',
    variants_empty: '先选满加购项的 2 个色 →',
    kit1_short: '第1套', kit2_short: '第2套',
    form_over_s: '全包', form_half_s: '半包',
    no_variant: '— 暂无变体 —',
    your_earpad: '你选的皮套',
    link_b2_p1: '这是<strong>设计师推荐的搭配模式</strong>:头带和皮套<strong>同底色</strong>,出来的耳机<strong>整体感最强,99% 不踩雷</strong>。',
    link_b2_p2: '第 1 套是<strong>「{color}」主题</strong>,第 2 套我们已经把<strong>同底色头带自动收起</strong>,引导你挑<strong>另一种底色</strong> — 两套反差大,DIY 才出味道。',
    bind_action: '我还是想自己挑头带 ›',
    unlink_title: '头带独立挑选中', unlink_action: '回到智能搭配 ›',
    unlink_b2_p1: '自由发挥模式:<strong>43 款头带</strong>都能挑,可以跟第 1 套撞色,也可以异色。',
    unlink_b2_p2: '提示:头带和皮套<strong>不同色</strong>其实<strong>很考验搭配功力</strong>,稍不留神整体就会<strong>显乱</strong>。如果不太有把握,建议<strong>回到智能搭配</strong>。',
    unlink_p1: '自由发挥模式:<strong>43 款头带</strong>都能挑,头带和皮套可以不同色。',
    unlink_p2: '提示:头带跟皮套<strong>不同色</strong>是<strong>审美的高阶玩法</strong>,搭不好<strong>容易乱</strong>。如果不太有把握,建议<strong>回到智能搭配</strong>。',
    /* 第 138 轮(2026-09-06)改口径:原来只说「要多付多少」(而且 +$50 还是原价差、折后其实 $40),
       客人看到的是纯支出。改成【价值对比】—— 多付 $40,拿到的是单买要 $168 的一整套配件。
       金额都从 DIY_PRICES / 折扣率 / KIT_VALUE_REF 算出来传进来,别再往字符串里写死。 */
    add2_prompt: '再加 <strong>${add}</strong> = <strong>{deal}</strong>拿下第二套配件 · <span class="a2-nb">风格 <strong>4 → 15</strong></span>',
    add2_prompt_bf: '<b class="bf-tag">黑五:第二套免费</b> 再加 <s class="bf-was">${add}</s> <strong class="bf-free">免费</strong> · <span class="a2-nb">风格 <strong>4 → 15</strong></span>',
    step3_bf: '装第 2 套搭配 — 黑五第二套免费(平时加 ${add})购 1 套配件(+1 面盖 · +1 皮套 · +1 头带)',
    add2_done: '✓ 已装满 2 套 · 15 种风格',
    add2_label: '添加第 2 套',
    lock_need_b1: '🔒 先装好第 1 套搭配',
    moni_sub: '套装内 1 件',
    reset_build: '改', reset_build_title: '清空重选',
    bonus_badge: '标', bonus_badge_title: '标配,已包含在套装内',
    faq_expand_aria: '展开 DIY 教学', remove_kit2_aria: '移除第2套',
    hb_prev_aria: '上一组头带', hb_next_aria: '下一组头带', zoom_aria: '放大预览',
    // —— 全屏图卡集 / 贺卡面板 ——
    // 第 92d 轮(用户 2026-08-06):主标去掉句尾句号 —— 大字号短句本来就自带停顿,
    // 句号在视觉上是个多余的黑点,会把「made one」这个落点的干脆感拖住。
    gift_lead_1: '谁都能买一份礼物', gift_lead_2: '你刚刚,做了一份',
    // 副标改【显式两行】:在破折号处断 —— 那本来就是语义分界(先给动作,再给理由),
    // 不靠容器宽度自然折(那个不可控,换语言/换视口就变)。
    gift_lead_sub_1: '写上他的名字 ——',
    gift_lead_sub_2: '这副耳机之所以长成这样,是因为他。',
    gift_title: '定制贺卡 · Gift Card', gift_name_label: '名字(英文)', gift_msg_label: '祝福语',
    gift_preset_0: '爱人', gift_preset_1: '挚友', gift_preset_2: '家人', gift_preset_3: '送自己',
    gift_preset_4: '生日', gift_preset_5: '节日', gift_preset_6: '纪念日', gift_preset_7: '开学',
    gift_share: '分享我的作品', gift_share_hint: '手机一键发 · Share', copy_link: '复制链接',
    buy_slogan: '一副的价格 · 一柜的风格', add_cart: '加入购物车', download_lookbook: '下载图卡集', close_preview: '关闭全屏预览',
    form_half_std: '半包耳 · 标配',
    diy_tab_1: 'DIY 第 1 套 · 4 种风格', diy_tab_2: 'DIY 第 2 套 · 满 15 种风格',
  },
  en: {
    banner_lead: 'Headphones you design yourself', banner_lead_sub: 'Every part is your call.', banner_sub: 'build your own •',
    hero_lead: 'One Headphone.', hero_sub: 'Endless Styles.',
    hero_tag1: '40-hour battery · 3D immersive sound.', hero_tag2: ' ways to make it yours.',
    faq_title: 'How to DIY your pair',
    guide_title: 'Build your pair in 3 steps',
    step1: 'Pick a host color — 4 to choose',
    step2: 'Add Kit 1 — 1 faceplate · 1 pair of cushions · 1 headband',
    step2_prog: '→ <strong>4 styles</strong>, ready to order',
    step3: 'Add Kit 2 — +${add} for another set (+1 faceplate · +1 cushions · +1 headband)',
    step3_prog: '→ 4 styles jump to <strong>15</strong> · best value',
    guide_note: 'There\'s only one host. Every "style" is that same host wearing different parts.',
    cta_add: 'Add to Cart →',
    cta_adding: 'Adding…',
    cta_build_pair: 'Finish building Kit {n} first',
    style_n_1: '4 styles', style_n_2: '15 styles', style_n_3: '100+ styles',
    style_wear_1: '4 looks', style_wear_2: '15 looks', style_wear_3: '100+ looks',
    cta_styles: 'Buy {n} — own all <strong>{styleN}</strong> above',
    hint_full: 'Full set · {styleN}',
    hint_need: '{need} to go · tap to jump',
    tab_need: '{need} to go',          // Tab 胶囊上的短版(无"点这跳过去")
    form_overear: 'Over-ear', form_halfear: 'Half-ear',
    aria_build1: 'Kit 1 you built', aria_build2: 'Kit 2 you built',
    moni_label: 'Moni-Strap',
    set_n_label: 'Kit {n}:',
    note_unlock_pick: ' (unlock to choose)',
    note_used_other: ' (used by the other kit)',
    note_bonus: ' (set standard · not selectable)',
    note_same_b1: ' (same base as Kit 1 · may look alike)',
    explore_title: 'DIY Lookbook',
    explore_punch: 'Cards update live as you build',
    download_all: 'Download all', download_all_aria: 'Download all style cards',
    shared_by: 'Made for {name}', shared_anon: "You're looking at a pair someone put together",
    share_failed: 'Sharing didn\'t go through — try the icons on the right', share_link_copied: "Link copied — they'll see this exact pair", share_local_env: 'Local test env · sharing works once live',
    shared_make_mine: 'Make it mine →',
    recv_eyebrow_gift: 'Someone put this pair together for you', recv_eyebrow_want: 'This is the pair they want', recv_eyebrow_show: 'Take a look at the pair I put together',
    recv_how: 'What this set includes', recv_count: 'These parts alone make {n} different looks — every card here is one',
    recv_cta_want: 'Get it for them →', recv_cta_mine: 'Make one of my own →',
    recv_link_explore: 'See the other 96,000 ways →', recv_fwd: 'Pass it on',
    explore_slogan: "One pair's price.<br>A wardrobe of styles.",
    explore_hook: 'Open · sign a card, make it a gift <span class="hook-arrow">↓</span>',
    prev_aria: 'Previous', next_aria: 'Next',
    kit_1: '1 Kit', kit_2: '2 Kits', kit_3: '3 Kits',
    kit_popular: 'Best value', kit_soon: 'Coming soon', kit_soon_title: '3-kit option in development',
    total_price: 'Total',
    bind_title: 'Headband base locked to cushion color (recommended)',
    bind_p1: 'This is the <strong>designer-recommended pairing</strong>: headband and cushion share <strong>the same base color</strong>, for the <strong>most cohesive look — hard to get wrong</strong>.',
    bind_p2: 'Pick a headband and the cushion <strong>follows its color</strong> — and vice versa. <strong>The safest mode for first-timers</strong>.',
    bind_p3: '<strong>Linked</strong> is the recommended <strong>safe starting point</strong>; unlink when you want to <strong>go freestyle</strong>.',
    preview_caption: 'Design your Rainbow',
    preview_tagline: 'And color is only the beginning. What truly defines a Rainbow is its shape once worn — the curve of the headband, the way the cushions meet your face. That structural beauty, we\'ve already perfected for you.',
    preview_subcaption: '<span class="pv-lead-star">★</span>The <b class="pv-lead-strong">star score</b> measures how well a pair harmonizes with itself. High is safe and easy on the eyes; low is often bolder and freer — it breaks the rules to become the pair that\'s uniquely yours. No combination is wrong — only how much it looks like you.',
    std_kit: 'Standard set', std_kit_incl: 'Includes headband + cushions',
    kit1_acc: 'Kit 1 accessories', kit2_acc: 'Kit 2 accessories',
    lock_locked: 'Locked', lock_free: 'Free',
    moni_tip_locked: 'Designer-matched · tap 🔒 to customize', moni_tip_free: 'Your pick · tap 🔒 to restore match',
    moni_aria_locked: 'Designer-matched, tap to customize', moni_aria_free: 'Your pick, tap to restore match',
    err_download: 'Download failed, please try again', err_gencard: 'Card generation failed, please try again', dl_preparing: 'Preparing images {i}/{n}', dl_ready: 'Images ready — tap the black icon again to save',
    err_addcart: 'Add to cart failed: {msg}\n\nPossible causes:\n1. This page is not on the monixibi.com domain (the Ajax API requires same-origin)\n2. A variant is no longer available\n\nPlease screenshot this for the developer.',
    discount_save: '{pct}% off · save ${save}',
    sep_price: 'Separately ${sep}', sep_save: 'You save ${save}', sep_save_m: 'Save ${save} vs. buying separately',
    howto_btn: 'How it works', howto_close: 'Close', howto_sound: 'Sound on/off', howto_dialog: 'How to DIY a Rainbow',
    variants_empty: 'Pick 2 add-on colors first →',
    kit1_short: 'Kit 1', kit2_short: 'Kit 2',
    form_over_s: 'Over-ear', form_half_s: 'Half-ear',
    no_variant: '— No variant —',
    your_earpad: 'your cushion',
    link_b2_p1: 'This is the <strong>designer-recommended pairing</strong>: headband and cushion <strong>share a base color</strong>, for the <strong>most cohesive look — hard to get wrong</strong>.',
    link_b2_p2: 'Kit 1 is your <strong>“{color}” theme</strong>. For Kit 2 we\'ve <strong>hidden the same-base headbands</strong> to nudge you toward <strong>a different base</strong> — strong contrast between kits is where DIY gets fun.',
    bind_action: 'I\'d rather pick my own headband ›',
    unlink_title: 'Picking headband freely', unlink_action: 'Back to smart pairing ›',
    unlink_b2_p1: 'Freestyle mode: <strong>all 43 headbands</strong> are open — match Kit 1 or contrast it, your call.',
    unlink_b2_p2: 'Heads-up: a <strong>different color</strong> from the cushion <strong>takes real styling skill</strong> — one slip and it looks <strong>messy</strong>. Not sure? <strong>Go back to smart pairing</strong>.',
    unlink_p1: 'Freestyle mode: <strong>all 43 headbands</strong> are open; headband and cushion can differ.',
    unlink_p2: 'Heads-up: mismatched headband and cushion is an <strong>advanced look</strong> — easy to make <strong>messy</strong>. Not sure? <strong>Go back to smart pairing</strong>.',
    // 英文比中文长得多(列 3 在 1280 宽只有 ~212px 可用):实测「Add $40 more — a full extra set
    // worth $168」那版在 1280 戳出虚线框 44.7px,「…get a $168 accessory set」那版还要折成两行,
    // 压到这句(kit = 本模块一直在用的「套」)才在 1280 单行收得住,多付多少 / 多拿多少两层语义都在。
    add2_prompt: 'Add <strong>${add}</strong> = 2nd kit at <strong>{deal}</strong> · <span class="a2-nb">styles <strong>4 → 15</strong></span>',
    add2_prompt_bf: '<b class="bf-tag">Black Friday: 2nd Kit Free</b> <s class="bf-was">+${add}</s> <strong class="bf-free">FREE</strong> · <span class="a2-nb">styles <strong>4 → 15</strong></span>',
    step3_bf: 'Add Kit 2 — FREE for Black Friday (normally +${add}) for another set (+1 faceplate · +1 cushions · +1 headband)',
    add2_done: '✓ Both kits filled · 15 styles',
    add2_label: 'Add Kit 2',
    lock_need_b1: '🔒 Finish Kit 1 first',
    moni_sub: '1 in the set',
    reset_build: 'Edit', reset_build_title: 'Reset & re-pick',
    bonus_badge: 'Std', bonus_badge_title: 'Standard · included in the set',
    faq_expand_aria: 'Expand DIY guide', remove_kit2_aria: 'Remove Kit 2',
    hb_prev_aria: 'Previous headbands', hb_next_aria: 'Next headbands', zoom_aria: 'Zoom in',
    gift_lead_1: 'Anyone can buy a gift', gift_lead_2: 'You just made one',
    gift_lead_sub_1: 'Put their name on it — ',   // 尾部空格:块级 span 渲染时会折叠,但保住 textContent 的词间隔
    gift_lead_sub_2: 'this pair looks like this because of them.',
    gift_title: 'Gift Card', gift_name_label: 'Name', gift_msg_label: 'Message',
    gift_preset_0: 'Sweetheart', gift_preset_1: 'Best Friend', gift_preset_2: 'Family', gift_preset_3: 'For Myself',
    gift_preset_4: 'Birthday', gift_preset_5: 'Holiday', gift_preset_6: 'Anniversary', gift_preset_7: 'Back to School',
    gift_share: 'Share my design', gift_share_hint: 'Quick share', copy_link: 'Copy link',
    buy_slogan: "One pair's price · A wardrobe of styles", add_cart: 'Add to Cart', download_lookbook: 'Download lookbook', close_preview: 'Close preview',
    form_half_std: 'Half-ear · Standard',
    diy_tab_1: 'DIY Kit 1 · 4 styles', diy_tab_2: 'DIY Kit 2 · 15 styles',
  },
  ko: {}, // 阶段4 补
};

// 取词:当前语言缺 → 回退英文 → 回退中文 → 回退 key;{var} 占位替换
function TR(key, vars) {
  var s = (I18N[LOCALE] && I18N[LOCALE][key]);
  if (s == null) s = (I18N.en && I18N.en[key]);
  if (s == null) s = (I18N.zh && I18N.zh[key]);
  if (s == null) s = key;
  if (vars) for (var k in vars) s = s.split('{' + k + '}').join(vars[k]);
  return s;
}

// 静态文案填充:扫 data-i18n(textContent)/ data-i18n-html(innerHTML)/ data-i18n-attr(属性 "attr:key;attr2:key2")
function applyStaticI18n(root) {
  if (LOCALE === 'zh') return;   // 中文=站点原文,用 DOM 里已有的,不覆盖(字节不变)
  root = root || document;
  root.querySelectorAll('[data-i18n]').forEach(function (el) { el.textContent = TR(el.getAttribute('data-i18n')); });
  root.querySelectorAll('[data-i18n-html]').forEach(function (el) { el.innerHTML = TR(el.getAttribute('data-i18n-html')); });
  root.querySelectorAll('[data-i18n-attr]').forEach(function (el) {
    el.getAttribute('data-i18n-attr').split(';').forEach(function (pair) {
      var i = pair.indexOf(':'); if (i < 0) return;
      el.setAttribute(pair.slice(0, i).trim(), TR(pair.slice(i + 1).trim()));
    });
  });
}

/* ============ 简 → 繁 运行时转换(第 118 轮 · 2026-08-10)============
   店铺发布的中文语言是 zh-TW(繁體,面向台湾/香港),而本模块的中文文案全是简体写的。
   为什么不另写一套繁体文案:图卡上那些搭配描述句(「大漠黃主機 × 綠紅線頭帶…教科書級絕配」)
   是代码按当前搭配现拼的,字典里根本没有对应的 key,写死的第二套文案盖不住它们。
   所以改成在「显示前」统一转一道,动态不动态都管得着。

   表由 scripts/gen-trad-table.py 生成(zhconv 的台湾正体 zh-tw),含两部分:
     char   —— 单字表,兜底覆盖任意中文
     phrase —— 「一简对多繁」的词组例外,优先匹配(签名→簽名 但 标签→標籤;复制→複製;链接→連結)
   生成时跑端到端自检:全部词句的「表转换」结果必须和 zhconv 整句转换一致,不一致直接失败。
   ⚠️ 改了中文文案后要重新生成:python3 scripts/gen-trad-table.py --write */
/* ===== TRAD_TABLE:自动生成,别手改 ===== */
var TRAD_TABLE = {"char":{"与":"與","专":"專","丛":"叢","东":"東","丝":"絲","丢":"丟","两":"兩","个":"個","临":"臨","为":"為","举":"舉","么":"麼","义":"義","书":"書","买":"買","乱":"亂","于":"於","云":"雲","亲":"親","仅":"僅","从":"從","们":"們","价":"價","优":"優","会":"會","伤":"傷","体":"體","余":"餘","偿":"償","储":"儲","关":"關","内":"內","册":"冊","写":"寫","冲":"衝","决":"決","冻":"凍","净":"淨","准":"準","减":"減","几":"幾","凶":"兇","击":"擊","划":"劃","则":"則","刚":"剛","删":"刪","别":"別","务":"務","动":"動","劳":"勞","势":"勢","匀":"勻","区":"區","协":"協","单":"單","占":"佔","压":"壓","参":"參","双":"雙","发":"發","变":"變","叠":"疊","台":"台","叶":"葉","号":"號","后":"後","听":"聽","员":"員","围":"圍","图":"圖","圆":"圓","场":"場","块":"塊","声":"聲","壳":"殼","处":"處","备":"備","复":"復","够":"夠","头":"頭","夹":"夾","学":"學","实":"實","审":"審","宽":"寬","对":"對","导":"導","将":"將","层":"層","屉":"屜","属":"屬","师":"師","带":"帶","帧":"幀","干":"干","并":"並","库":"庫","应":"應","庞":"龐","开":"開","异":"異","张":"張","弹":"彈","强":"強","归":"歸","当":"當","径":"徑","态":"態","总":"總","惯":"慣","户":"戶","托":"託","扫":"掃","扬":"揚","扰":"擾","抠":"摳","抢":"搶","报":"報","拥":"擁","拦":"攔","择":"擇","挂":"掛","挚":"摯","挥":"揮","换":"換","据":"據","摆":"擺","撑":"撐","数":"數","断":"斷","无":"無","旧":"舊","时":"時","显":"顯","晕":"暈","晖":"暉","暂":"暫","朴":"樸","机":"機","条":"條","来":"來","极":"極","构":"構","柜":"櫃","栅":"柵","标":"標","栈":"棧","栏":"欄","栗":"慄","样":"樣","档":"檔","检":"檢","横":"橫","残":"殘","气":"氣","没":"沒","浅":"淺","测":"測","涂":"塗","涟":"漣","涡":"渦","滚":"滾","满":"滿","灯":"燈","灵":"靈","点":"點","热":"熱","爱":"愛","状":"狀","独":"獨","环":"環","现":"現","画":"畫","监":"監","盖":"蓋","盘":"盤","着":"著","码":"碼","砖":"磚","确":"確","礼":"禮","种":"種","积":"積","稳":"穩","竖":"豎","签":"簽","简":"簡","类":"類","红":"紅","约":"約","级":"級","纪":"紀","纯":"純","纳":"納","纸":"紙","纹":"紋","线":"線","组":"組","终":"終","经":"經","绑":"綁","结":"結","绘":"繪","给":"給","络":"絡","绝":"絕","统":"統","继":"繼","绪":"緒","续":"續","绽":"綻","绿":"綠","缓":"緩","缝":"縫","缩":"縮","网":"網","胆":"膽","胶":"膠","脉":"脈","脑":"腦","脚":"腳","脸":"臉","腾":"騰","节":"節","范":"範","荐":"薦","蓝":"藍","补":"補","装":"裝","见":"見","观":"觀","规":"規","视":"視","览":"覽","觉":"覺","触":"觸","计":"計","认":"認","让":"讓","议":"議","记":"記","讲":"講","设":"設","访":"訪","诉":"訴","诊":"診","词":"詞","试":"試","话":"話","该":"該","语":"語","误":"誤","说":"說","请":"請","读":"讀","谁":"誰","调":"調","谧":"謐","谱":"譜","负":"負","责":"責","败":"敗","质":"質","购":"購","贴":"貼","费":"費","贺":"賀","赋":"賦","赶":"趕","跃":"躍","车":"車","转":"轉","轮":"輪","载":"載","辉":"輝","输":"輸","边":"邊","过":"過","还":"還","这":"這","进":"進","远":"遠","连":"連","迟":"遲","适":"適","选":"選","采":"採","释":"釋","里":"裡","针":"針","钉":"釘","钝":"鈍","钩":"鉤","钮":"鈕","钱":"錢","银":"銀","链":"鏈","锁":"鎖","锋":"鋒","错":"錯","锚":"錨","锦":"錦","键":"鍵","镜":"鏡","镶":"鑲","长":"長","闪":"閃","闭":"閉","问":"問","间":"間","队":"隊","阵":"陣","阶":"階","际":"際","随":"隨","隐":"隱","雾":"霧","霭":"靄","静":"靜","韵":"韻","页":"頁","顶":"頂","项":"項","顺":"順","须":"須","顿":"頓","预":"預","频":"頻","题":"題","颜":"顏","风":"風","飘":"飄","飞":"飛","马":"馬","驱":"驅","驻":"駐","验":"驗","鳞":"鱗","鸦":"鴉","麦":"麥","黄":"黃","齐":"齊"},"phrase":{"标签":"標籤","干净":"乾淨","干脆":"乾脆","链接":"連結","复制":"複製","重复":"重複","装折":"裝摺","定制":"定製","松手":"鬆手","台服务器":"台伺服器","鼠标":"滑鼠","移动设备":"行動裝置","字段":"欄位","松了":"鬆了","划算":"划算","关系":"關係","松开":"鬆開"}};
/* ===== TRAD_TABLE 结束 ===== */
var TRAD_PHRASES = Object.keys(TRAD_TABLE.phrase).sort(function (a, b) { return b.length - a.length; });
var TRAD_HEADS = {};
TRAD_PHRASES.forEach(function (p) { TRAD_HEADS[p.charAt(0)] = 1; });

function toTrad(s) {
  if (!s) return s;
  var out = '', i = 0, n = s.length;
  while (i < n) {
    var c = s.charAt(i), 命中 = null;
    if (TRAD_HEADS[c]) {
      for (var k = 0; k < TRAD_PHRASES.length; k++) {
        var p = TRAD_PHRASES[k];
        if (s.substr(i, p.length) === p) { 命中 = p; break; }
      }
    }
    if (命中) { out += TRAD_TABLE.phrase[命中]; i += 命中.length; }
    else { out += (TRAD_TABLE.char[c] || c); i++; }
  }
  return out;
}

// 转换是幂等的(繁体字不在简体表里),所以重复跑无害;只在值真的变了才写回,避免 observer 自激
var 中文 = /[一-鿿]/;
var 不转标签 = { SCRIPT: 1, STYLE: 1, CANVAS: 1, TEXTAREA: 1, CODE: 1 };
function tradTextNode(t) {
  if (!t || !t.nodeValue || !中文.test(t.nodeValue)) return;
  var p = t.parentNode;
  if (p && 不转标签[p.nodeName]) return;          // TEXTAREA 里是用户自己写的祝福语,绝不能动
  var v = toTrad(t.nodeValue);
  if (v !== t.nodeValue) t.nodeValue = v;
}
var 转属性 = ['placeholder', 'title', 'aria-label', 'alt'];
function tradEl(el) {
  if (!el || el.nodeType !== 1) return;
  if (不转标签[el.nodeName]) return;
  var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
  var 待 = [], t;
  while ((t = w.nextNode())) 待.push(t);
  待.forEach(tradTextNode);
  // 属性里的中文也要转:输入框 placeholder、按钮 title / aria-label(读屏用户听到的也该是繁体)
  var 目标 = el.querySelectorAll ? Array.prototype.slice.call(el.querySelectorAll('[' + 转属性.join('],[') + ']')) : [];
  目标.push(el);
  目标.forEach(function (x) {
    转属性.forEach(function (a) {
      var v = x.getAttribute && x.getAttribute(a);
      if (v && 中文.test(v)) { var nv = toTrad(v); if (nv !== v) x.setAttribute(a, nv); }
    });
  });
}

function startTradWatcher() {
  if (!IS_TRAD || LOCALE !== 'zh' || !TRAD_PHRASES.length && !Object.keys(TRAD_TABLE.char).length) return;
  tradEl(document.body);
  if (typeof MutationObserver === 'undefined') return;
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var m = muts[i];
      if (m.type === 'characterData') { tradTextNode(m.target); continue; }
      for (var j = 0; j < m.addedNodes.length; j++) {
        var n = m.addedNodes[j];
        if (n.nodeType === 1) tradEl(n);
        else if (n.nodeType === 3) tradTextNode(n);
      }
    }
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
}
// 繁体转换必须跟在 applyStaticI18n 后面:先把文案填对,再统一转繁,顺序反了会转完又被简体覆盖回去
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { applyStaticI18n(); startTradWatcher(); });
else { applyStaticI18n(); startTradWatcher(); }


// ============ Shopify CDN 映射(嫁接时由脚本注入,2026-05-30)============
const SHOPIFY_CDN_MAP = {"moni-strap-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/moni-strap-navy.png?v=1784738936", "moni-strap-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/moni-strap-darkgreen.png?v=1784738944", "moni-strap-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/moni-strap-purple.png?v=1784738952", "moni-strap-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/moni-strap-brown.png?v=1784738960", "earpad-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/earpad-brown_3504114b-a231-4e42-9a5a-2f7bd25ae1f0.png?v=1780076548", "earpad-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/earpad-darkgreen_275894ea-8949-4c86-bcb6-1851b54889e3.png?v=1780076548", "earpad-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/earpad-navy_491fd150-a5f4-4491-8c89-d0a10fa09f2e.png?v=1780076548", "earpad-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/earpad-purple_fc07eeaa-b787-40df-b17f-f7df2265bc5f.png?v=1780076548", "faceplate-babyblue.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/faceplate-babyblue_9bb17f3b-4c57-4544-959d-6d8c437b5fb8.png?v=1780076577", "faceplate-desertyellow.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/faceplate-desertyellow_6fd4dfe4-5afd-4f7e-b2fc-03ee1564218c.png?v=1780076577", "faceplate-green.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/faceplate-green_3f50b0fb-a7a8-4b70-a969-12dd7075f11f.png?v=1780076577", "faceplate-silver.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/faceplate-silver_eb4225ca-ac10-4abe-9211-ffce3148ad10.png?v=1780076577", "headband-cube-brown.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-cube-brown_7ead48f1-a924-4586-8beb-ea99c14f0255.png?v=1780076577", "headband-cube-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-cube-brown_7ead48f1-a924-4586-8beb-ea99c14f0255.png?v=1780076577", "headband-cube-darkgreen.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-cube-darkgreen_81e53a7d-d4b8-4db9-a8e2-f230e3745121.png?v=1780076577", "headband-cube-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-cube-darkgreen_81e53a7d-d4b8-4db9-a8e2-f230e3745121.png?v=1780076577", "headband-cube-navy.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-cube-navy_fc3255c8-3b8a-4d86-89fb-3c982a9609aa.png?v=1780076578", "headband-cube-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-cube-navy_fc3255c8-3b8a-4d86-89fb-3c982a9609aa.png?v=1780076578", "headband-cube-purple.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-cube-purple_7294b55e-62b2-41c4-9485-16b786b1bdf5.png?v=1780076577", "headband-cube-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-cube-purple_7294b55e-62b2-41c4-9485-16b786b1bdf5.png?v=1780076577", "headband-flower-brown.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-flower-brown_45a52414-830f-4310-bf35-de7e037ed9fc.png?v=1780076578", "headband-flower-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-flower-brown_45a52414-830f-4310-bf35-de7e037ed9fc.png?v=1780076578", "headband-flower-darkgreen.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-flower-darkgreen_b5fcd885-3dbe-4868-b8d0-13a32fc8f786.png?v=1780076577", "headband-flower-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-flower-darkgreen_b5fcd885-3dbe-4868-b8d0-13a32fc8f786.png?v=1780076577", "headband-flower-navy.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-flower-navy_b4f547bc-17c5-4711-91f1-ae717d801cc5.png?v=1780076605", "headband-flower-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-flower-navy_b4f547bc-17c5-4711-91f1-ae717d801cc5.png?v=1780076605", "headband-flower-purple.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-flower-purple_b99a4bd9-ece5-4087-8e39-becc0b770e1a.png?v=1780076606", "headband-flower-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-flower-purple_b99a4bd9-ece5-4087-8e39-becc0b770e1a.png?v=1780076606", "headband-fluid-brown.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-fluid-brown_1402e26a-7008-4f1b-b852-05867e28b2af.png?v=1780076605", "headband-fluid-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-fluid-brown_1402e26a-7008-4f1b-b852-05867e28b2af.png?v=1780076605", "headband-fluid-darkgreen.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-fluid-darkgreen_6aa4346c-e4f6-476c-a7fb-4fbd885caf2f.png?v=1780076605", "headband-fluid-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-fluid-darkgreen_6aa4346c-e4f6-476c-a7fb-4fbd885caf2f.png?v=1780076605", "headband-fluid-navy.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-fluid-navy_63f32837-5b7c-4d43-97dc-5d93e6826ac3.png?v=1780076605", "headband-fluid-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-fluid-navy_63f32837-5b7c-4d43-97dc-5d93e6826ac3.png?v=1780076605", "headband-fluid-purple.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-fluid-purple_88cce80b-124a-44f2-8e47-ed3d9a6aba24.png?v=1780076606", "headband-fluid-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-fluid-purple_88cce80b-124a-44f2-8e47-ed3d9a6aba24.png?v=1780076606", "headband-line-brown-green.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-line-brown-green_be62608a-fe1f-4877-9132-52b9f3d02450.png?v=1780076605", "headband-line-brown-green.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-line-brown-green_be62608a-fe1f-4877-9132-52b9f3d02450.png?v=1780076605", "headband-line-brown-yellow.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-line-brown-yellow_d8d720c3-19dd-40d3-9da7-9c83cf11e0b3.png?v=1780076605", "headband-line-brown-yellow.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-line-brown-yellow_d8d720c3-19dd-40d3-9da7-9c83cf11e0b3.png?v=1780076605", "headband-line-darkgreen-red.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-line-darkgreen-red_5729762f-c6e0-4320-aa82-295bc177e1ec.png?v=1780076605", "headband-line-darkgreen-red.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-line-darkgreen-red_5729762f-c6e0-4320-aa82-295bc177e1ec.png?v=1780076605", "headband-line-darkgreen-yellow.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-line-darkgreen-yellow_32d3a87c-11da-45cb-b182-984bb06267dc.png?v=1780076605", "headband-line-darkgreen-yellow.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-line-darkgreen-yellow_32d3a87c-11da-45cb-b182-984bb06267dc.png?v=1780076605", "headband-line-navy-red.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-line-navy-red_eca68a61-8512-43ce-be8a-f9c426e359de.png?v=1780076631", "headband-line-navy-red.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-line-navy-red_eca68a61-8512-43ce-be8a-f9c426e359de.png?v=1780076631", "headband-line-navy-yellow.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-line-navy-yellow_9a12e37e-ace1-4404-9cbe-8d708351a155.png?v=1780076630", "headband-line-navy-yellow.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-line-navy-yellow_9a12e37e-ace1-4404-9cbe-8d708351a155.png?v=1780076630", "headband-line-purple-navy.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-line-purple-navy_39eacdbf-45db-4cb3-8f18-e0e4d9395750.png?v=1780076630", "headband-line-purple-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-line-purple-navy_39eacdbf-45db-4cb3-8f18-e0e4d9395750.png?v=1780076630", "headband-line-purple-yellow.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-line-purple-yellow_de7bdf91-0035-41c5-aee4-15b7b8a9e5bd.png?v=1780076631", "headband-line-purple-yellow.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-line-purple-yellow_de7bdf91-0035-41c5-aee4-15b7b8a9e5bd.png?v=1780076631", "headband-liuli-brown.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-liuli-brown_20b0c7a0-b4f7-41c4-a388-2a753a249b6c.png?v=1780076630", "headband-liuli-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-liuli-brown_20b0c7a0-b4f7-41c4-a388-2a753a249b6c.png?v=1780076630", "headband-liuli-darkgreen.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-liuli-darkgreen_8525bd5b-56ca-46d2-b872-88490cd33311.png?v=1780076631", "headband-liuli-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-liuli-darkgreen_8525bd5b-56ca-46d2-b872-88490cd33311.png?v=1780076631", "headband-liuli-navy.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-liuli-navy_fd38340b-2af9-4be1-addb-c66fb11dad08.png?v=1780076630", "headband-liuli-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-liuli-navy_fd38340b-2af9-4be1-addb-c66fb11dad08.png?v=1780076630", "headband-liuli-purple.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-liuli-purple_11588861-5c41-43af-879f-69071e0fc11d.png?v=1780076631", "headband-liuli-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-liuli-purple_11588861-5c41-43af-879f-69071e0fc11d.png?v=1780076631", "headband-quantum-brown.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-quantum-brown_15da65f3-3fbc-41a0-8498-1342fb146ac1.png?v=1780076630", "headband-quantum-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-quantum-brown_15da65f3-3fbc-41a0-8498-1342fb146ac1.png?v=1780076630", "headband-quantum-darkgreen.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-quantum-darkgreen_dfab3fed-afed-42fa-b596-5060568124ac.png?v=1780076630", "headband-quantum-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-quantum-darkgreen_dfab3fed-afed-42fa-b596-5060568124ac.png?v=1780076630", "headband-quantum-navy.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-quantum-navy_9d3932dd-f80e-45f8-8986-41c7af028325.png?v=1780076656", "headband-quantum-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-quantum-navy_9d3932dd-f80e-45f8-8986-41c7af028325.png?v=1780076656", "headband-quantum-purple.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-quantum-purple_f24c8673-ad51-4137-ad9d-a8a74bc1c475.png?v=1780076656", "headband-quantum-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-quantum-purple_f24c8673-ad51-4137-ad9d-a8a74bc1c475.png?v=1780076656", "headband-solid-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-solid-brown_ba26d6e9-6e91-4bf4-a926-76aed92218e7.png?v=1780076656", "headband-solid-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-solid-darkgreen_01a6f83d-211e-4cd6-9bc0-78e6fbe33cfe.png?v=1780076656", "headband-solid-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-solid-navy_21b644c9-326b-4d71-9125-ae42f671a595.png?v=1780076656", "headband-solid-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-solid-purple_d0129bd7-18ee-400f-a832-e85dcafd0c2c.png?v=1780076656", "headband-time-brown.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-time-brown_14d1eae2-2cf2-496e-8249-6ece7cb8d777.png?v=1780076656", "headband-time-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-time-brown_14d1eae2-2cf2-496e-8249-6ece7cb8d777.png?v=1780076656", "headband-time-darkgreen.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-time-darkgreen_decaf9a4-461a-4735-a096-c23c1c0773e2.png?v=1780076656", "headband-time-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-time-darkgreen_decaf9a4-461a-4735-a096-c23c1c0773e2.png?v=1780076656", "headband-time-navy.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-time-navy_8cb06dd1-d701-44ae-a28b-ab87aba570cb.png?v=1780076656", "headband-time-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-time-navy_8cb06dd1-d701-44ae-a28b-ab87aba570cb.png?v=1780076656", "headband-time-purple.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-time-purple_4f81a35a-2a8a-472f-a91b-593675f892dd.png?v=1780076656", "headband-time-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-time-purple_4f81a35a-2a8a-472f-a91b-593675f892dd.png?v=1780076656", "headband-totem-brown.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-totem-brown_19ea12f6-c7ca-48fc-b0e5-11059e1a49c8.png?v=1780076684", "headband-totem-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-totem-brown_19ea12f6-c7ca-48fc-b0e5-11059e1a49c8.png?v=1780076684", "headband-totem-darkgreen.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-totem-darkgreen_24f5e721-7718-4043-942d-b297b7b7d18e.png?v=1780076684", "headband-totem-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-totem-darkgreen_24f5e721-7718-4043-942d-b297b7b7d18e.png?v=1780076684", "headband-totem-navy.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-totem-navy_21e4d009-531c-4523-b479-ddc0f28b3861.png?v=1780076684", "headband-totem-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-totem-navy_21e4d009-531c-4523-b479-ddc0f28b3861.png?v=1780076684", "headband-totem-purple.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-totem-purple_fe63c9d6-69be-4e82-8b8f-bd999bcb4312.png?v=1780076684", "headband-totem-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-totem-purple_fe63c9d6-69be-4e82-8b8f-bd999bcb4312.png?v=1780076684", "headband-youth-brown.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-youth-brown_0a580d7b-619e-4966-8754-04709d06faa7.png?v=1780076685", "headband-youth-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-youth-brown_0a580d7b-619e-4966-8754-04709d06faa7.png?v=1780076685", "headband-youth-darkgreen.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-youth-darkgreen_2d960fb0-5a0b-4fde-9aca-026be8f7f1fa.png?v=1780076684", "headband-youth-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-youth-darkgreen_2d960fb0-5a0b-4fde-9aca-026be8f7f1fa.png?v=1780076684", "headband-youth-navy.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-youth-navy_a2561d20-ee41-4a73-9e34-b7a14ab546cf.png?v=1780076684", "headband-youth-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-youth-navy_a2561d20-ee41-4a73-9e34-b7a14ab546cf.png?v=1780076684", "headband-youth-purple.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-youth-purple_a864c0d9-5267-4ef5-b4fb-66676eff49ef.png?v=1780076684", "headband-youth-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-youth-purple_a864c0d9-5267-4ef5-b4fb-66676eff49ef.png?v=1780076684", "earpad-halfear-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/earpad-halfear-brown.png?v=1780076548", "earpad-halfear-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/earpad-halfear-darkgreen.png?v=1780076548", "earpad-halfear-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/earpad-halfear-navy.png?v=1780076548", "earpad-halfear-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/earpad-halfear-purple.png?v=1780076548", "host-babyblue.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/host-babyblue.png?v=1780076684", "host-desertyellow.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/host-desertyellow.png?v=1780076684", "host-green.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/host-green.png?v=1780076707", "host-halfear-babyblue.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/host-halfear-babyblue.png?v=1780076707", "host-halfear-desertyellow.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/host-halfear-desertyellow.png?v=1780076707", "host-halfear-green.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/host-halfear-green.png?v=1780076708", "host-halfear-silver.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/host-halfear-silver.png?v=1780076707", "host-silver.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/host-silver.png?v=1780076707", "shadow.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/shadow.png?v=1780076708", "适配图/earpad-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-earpad-brown.png?v=1780076901", "适配图/earpad-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-earpad-darkgreen.png?v=1780077132", "适配图/earpad-halfear-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-earpad-halfear-darkgreen.png?v=1780076901", "适配图/earpad-halfear-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-earpad-halfear-navy.png?v=1780076901", "适配图/earpad-halfear-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-earpad-halfear-purple.png?v=1780076901", "适配图/earpad-halfear-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-earpad-navy.png?v=1780076901", "适配图/earpad-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-earpad-purple.png?v=1780076901", "适配图/earpad-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-faceplate-babyblue.png?v=1780076901", "适配图/faceplate-babyblue.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-faceplate-desertyellow.png?v=1780076901", "适配图/faceplate-green.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-faceplate-green.png?v=1780076931", "适配图/faceplate-silver.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-faceplate-silver.png?v=1780076931", "适配图/headband-cube-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-cube-brown.png?v=1780076931", "适配图/headband-cube-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-cube-darkgreen.png?v=1780076931", "适配图/headband-cube-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-cube-navy.png?v=1780076931", "适配图/headband-cube-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-cube-purple.png?v=1780076931", "适配图/headband-flower-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-flower-brown.png?v=1780076931", "适配图/headband-flower-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-flower-darkgreen.png?v=1780076931", "适配图/headband-flower-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-flower-navy.png?v=1780076931", "适配图/headband-flower-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-flower-purple.png?v=1780076931", "适配图/headband-fluid-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-fluid-brown.png?v=1780076970", "适配图/headband-fluid-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-fluid-darkgreen.png?v=1780076970", "适配图/headband-fluid-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-fluid-navy.png?v=1780076970", "适配图/headband-fluid-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-fluid-purple.png?v=1780076970", "适配图/headband-line-brown-green.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-line-brown-green.png?v=1780076970", "适配图/headband-line-brown-yellow.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-line-brown-yellow.png?v=1780076970", "适配图/headband-line-darkgreen-red.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-line-darkgreen-red.png?v=1780076970", "适配图/headband-line-darkgreen-yellow.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-line-darkgreen-yellow.png?v=1780076970", "适配图/headband-line-navy-red.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-line-navy-red.png?v=1780076970", "适配图/headband-line-navy-yellow.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-line-navy-yellow.png?v=1780076970", "适配图/headband-line-purple-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-line-purple-navy.png?v=1780077004", "适配图/headband-line-purple-yellow.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-line-purple-yellow.png?v=1780077004", "适配图/headband-liuli-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-liuli-brown.png?v=1780077003", "适配图/headband-liuli-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-liuli-darkgreen.png?v=1780077004", "适配图/headband-liuli-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-liuli-navy.png?v=1780077004", "适配图/headband-liuli-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-liuli-purple.png?v=1780077003", "适配图/headband-quantum-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-quantum-brown.png?v=1780077003", "适配图/headband-quantum-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-quantum-darkgreen.png?v=1780077004", "适配图/headband-quantum-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-quantum-navy.png?v=1780077004", "适配图/headband-quantum-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-quantum-purple.png?v=1780077004", "适配图/headband-solid-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-solid-brown.png?v=1780077035", "适配图/headband-solid-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-solid-darkgreen.png?v=1780077034", "适配图/headband-solid-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-solid-navy.png?v=1780077035", "适配图/headband-solid-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-solid-purple.png?v=1780077035", "适配图/headband-time-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-time-brown.png?v=1780077035", "适配图/headband-time-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-time-darkgreen.png?v=1780077035", "适配图/headband-time-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-time-navy.png?v=1780077034", "适配图/headband-time-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-time-purple.png?v=1780077035", "适配图/headband-totem-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-totem-brown.png?v=1780077034", "适配图/headband-totem-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-totem-darkgreen.png?v=1780077034", "适配图/headband-totem-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-totem-navy.png?v=1780077064", "适配图/headband-totem-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-totem-purple.png?v=1780077064", "适配图/headband-youth-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-youth-brown.png?v=1780077064", "适配图/headband-youth-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-youth-darkgreen.png?v=1780077064", "适配图/headband-youth-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-youth-navy.png?v=1780077064", "适配图/headband-youth-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-youth-purple.png?v=1780077064", "适配图/host-babyblue.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-host-babyblue.png?v=1780077064", "适配图/host-desertyellow.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-host-desertyellow.png?v=1780077064", "适配图/host-green.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-host-green.png?v=1780077064", "适配图/host-halfear-babyblue.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-host-halfear-babyblue.png?v=1780077064", "适配图/host-halfear-desertyellow.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-host-halfear-desertyellow.png?v=1780077081", "适配图/host-halfear-green.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-host-halfear-green.png?v=1780077081", "适配图/host-halfear-silver.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-host-halfear-silver.png?v=1780077081", "适配图/host-silver.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-host-silver.png?v=1780077081", "适配图/shadow.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-shadow.png?v=1780077081"};
/* 缩略图取图宽度(第 101 轮 · 性能诊断 #6,2026-08-07)。
   病根:色块缩略图原图 600×600 / 70~216KB,而实际只显示 60~62px —— 过采样 10 倍。
   取值依据(实测,不是拍脑袋):
     · picker-chip 视觉宽实测 60px(桌面,stage 带 scale(0.85))/ 62px(390 视口)
     · 桌面 CSS 声明宽 = 60 / 0.85 ≈ 71px;.inline-chip 上限 clamp(…,76px)
     · 覆盖 3 倍屏(Retina 最高档):76 × 3 = 228px → 取 240 留余量
   实测收益:mat-headband-totem-brown.png 600px/69,170 字节 → 240px/16,099 字节(省 77%)
   ⚠️ 只给【缩略图】用。主图预览的 4 层适配图走 adaptImg(),显示尺寸大,不能套这个宽度。 */
const THUMB_W = 240;

function cdnUrl(rel, 缩略宽) {
  // rel 形如 '素材/xxx.png' 或 '素材/适配图/xxx.png'
  // 嫁接-9 · 优先查 window.RAINBOW_ASSETS(主题 assets/,Liquid 渲染);
  // 不命中再 fallback 到旧 SHOPIFY_CDN_MAP(Files CDN,部分错位但保留兼容)
  let u;
  if (typeof window !== 'undefined' && window.RAINBOW_ASSETS && window.RAINBOW_ASSETS[rel]) {
    u = window.RAINBOW_ASSETS[rel];
  } else {
    const key = rel.replace(/^素材\//, '');
    u = SHOPIFY_CDN_MAP[key] || rel;
  }
  /* Shopify CDN 的 width 参数在【主题 assets】和【files】两种地址上都生效(2026-08-07 curl 实测:
     .../assets/mat-headband-totem-brown.png?v=…&width=240 → 返回真的 240px 图)。
     只对【CDN 绝对地址】加 —— 本地独立预览走 RAINBOW_ASSETS 的 Proxy,返回 '/05-…/素材/x.png',
     加了查询串虽然静态服务器也能忍,但会让本地和线上 URL 不一致、缓存键也变,没必要。
     🐛 第 101 轮踩的坑:原来写的是 /^https?:/ —— 但 Liquid 的 asset_url 输出的是
        【协议相对地址】`//monixibi.com/cdn/shop/t/36/assets/…`(开头没有 https:),
        于是判断永远为假,52 个请求一个都没带上 width,自检 ③ 当场抓到 0/52。
        必须把 `//` 开头这种也算绝对地址。 */
  if (缩略宽 && /^(https?:)?\/\//i.test(u)) u += (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + 缩略宽;
  return u;
}
// ============ Shopify 产品映射(原 fetch ./data/rainbow-mapping.json,现 inline)============
const SHOPIFY_MAPPING_INLINE = {"host": {"silver": {"product_id": "gid://shopify/Product/8590734229677", "product_handle": "monixibi-rainbow-headphones", "product_title": "Rainbow Headphones", "variant_id": "gid://shopify/ProductVariant/46040387453101", "variant_title": "Starry Silver", "sku": null, "price": "0.00", "inventory": 0}, "desertyellow": {"product_id": "gid://shopify/Product/8590734229677", "product_handle": "monixibi-rainbow-headphones", "product_title": "Rainbow Headphones", "variant_id": "gid://shopify/ProductVariant/46040387944621", "variant_title": "Desert Yellow", "sku": null, "price": "0.00", "inventory": 0}, "babyblue": {"product_id": "gid://shopify/Product/8590734229677", "product_handle": "monixibi-rainbow-headphones", "product_title": "Rainbow Headphones", "variant_id": "gid://shopify/ProductVariant/46040387977389", "variant_title": "Serene Blue", "sku": null, "price": "0.00", "inventory": 0}, "green": {"product_id": "gid://shopify/Product/8590734229677", "product_handle": "monixibi-rainbow-headphones", "product_title": "Rainbow Headphones", "variant_id": "gid://shopify/ProductVariant/46040388010157", "variant_title": "Retro Green", "sku": null, "price": "0.00", "inventory": 0}}, "faceplate": {"babyblue": {"product_id": "gid://shopify/Product/7993460687021", "product_handle": "monixibi-rainbow-ear-cup-cover-faceplates", "product_title": "Rainbow Faceplates", "variant_id": "gid://shopify/ProductVariant/44043074764973", "variant_title": "Serene Blue", "sku": "", "price": "30.00", "inventory": 20}, "green": {"product_id": "gid://shopify/Product/7993460687021", "product_handle": "monixibi-rainbow-ear-cup-cover-faceplates", "product_title": "Rainbow Faceplates", "variant_id": "gid://shopify/ProductVariant/44043074830509", "variant_title": "Retro Green", "sku": "", "price": "30.00", "inventory": 20}, "silver": {"product_id": "gid://shopify/Product/7993460687021", "product_handle": "monixibi-rainbow-ear-cup-cover-faceplates", "product_title": "Rainbow Faceplates", "variant_id": "gid://shopify/ProductVariant/44043074732205", "variant_title": "Starry Silver", "sku": "", "price": "30.00", "inventory": 20}, "desertyellow": {"product_id": "gid://shopify/Product/7993460687021", "product_handle": "monixibi-rainbow-ear-cup-cover-faceplates", "product_title": "Rainbow Faceplates", "variant_id": "gid://shopify/ProductVariant/44043074797741", "variant_title": "Desert Yellow", "sku": "", "price": "30.00", "inventory": 20}}, "earpad_full": {"darkgreen": {"product_id": "gid://shopify/Product/7993455214765", "product_handle": "monixibi-rainbow-ear-cushion-cover-leather-case", "product_title": "Rainbow Over-Ear Cushions", "variant_id": "gid://shopify/ProductVariant/44043066867885", "variant_title": "Dark Green", "sku": "", "price": "39.00", "inventory": 20}, "purple": {"product_id": "gid://shopify/Product/7993455214765", "product_handle": "monixibi-rainbow-ear-cushion-cover-leather-case", "product_title": "Rainbow Over-Ear Cushions", "variant_id": "gid://shopify/ProductVariant/44043066835117", "variant_title": "Deep Purple", "sku": "", "price": "39.00", "inventory": 20}, "navy": {"product_id": "gid://shopify/Product/7993455214765", "product_handle": "monixibi-rainbow-ear-cushion-cover-leather-case", "product_title": "Rainbow Over-Ear Cushions", "variant_id": "gid://shopify/ProductVariant/44043066769581", "variant_title": "Deep Blue", "sku": "", "price": "39.00", "inventory": 20}, "brown": {"product_id": "gid://shopify/Product/7993455214765", "product_handle": "monixibi-rainbow-ear-cushion-cover-leather-case", "product_title": "Rainbow Over-Ear Cushions", "variant_id": "gid://shopify/ProductVariant/44043066802349", "variant_title": "Coffee Brown", "sku": "", "price": "39.00", "inventory": 20}}, "earpad_half": {"brown": {"product_id": "gid://shopify/Product/7993461276845", "product_handle": "monixibi-rainbow-half-ear-earpads", "product_title": "Rainbow Half-Ear Earpads", "variant_id": "gid://shopify/ProductVariant/44043085217965", "variant_title": "Coffee Brown", "sku": "44043085217965", "price": "19.00", "inventory": 20}, "navy": {"product_id": "gid://shopify/Product/7993461276845", "product_handle": "monixibi-rainbow-half-ear-earpads", "product_title": "Rainbow Half-Ear Earpads", "variant_id": "gid://shopify/ProductVariant/44043085185197", "variant_title": "Deep Blue", "sku": "44043085185197", "price": "19.00", "inventory": 20}, "darkgreen": {"product_id": "gid://shopify/Product/7993461276845", "product_handle": "monixibi-rainbow-half-ear-earpads", "product_title": "Rainbow Half-Ear Earpads", "variant_id": "gid://shopify/ProductVariant/44043085250733", "variant_title": "Dark Green", "sku": "44043085250733", "price": "19.00", "inventory": 20}, "purple": {"product_id": "gid://shopify/Product/7993461276845", "product_handle": "monixibi-rainbow-half-ear-earpads", "product_title": "Rainbow Half-Ear Earpads", "variant_id": "gid://shopify/ProductVariant/44043085283501", "variant_title": "Deep Purple", "sku": "44043085283501", "price": "19.00", "inventory": 20}}, "headband": {"line-navy-yellow": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44765795713197", "variant_title": "Blue and Yellow Line", "sku": "44765795713197", "price": "99.00", "inventory": 20}, "line-navy-red": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44765795745965", "variant_title": "Blue and Red Line", "sku": "44765795745965", "price": "99.00", "inventory": 20}, "line-brown-green": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44765795778733", "variant_title": "Brown and Green Line", "sku": "44765795778733", "price": "99.00", "inventory": 20}, "line-brown-yellow": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44765795811501", "variant_title": "Brown and Yellow Line", "sku": "44765795811501", "price": "99.00", "inventory": 20}, "line-darkgreen-red": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766588010669", "variant_title": "Red and Green Line", "sku": "44766588010669", "price": "99.00", "inventory": 20}, "line-darkgreen-yellow": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766588043437", "variant_title": "Yellow and Green Line", "sku": "44766588043437", "price": "99.00", "inventory": 20}, "line-purple-yellow": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766588076205", "variant_title": "Purple and Yellow Line", "sku": "44766588076205", "price": "99.00", "inventory": 20}, "line-purple-navy": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766588108973", "variant_title": "Purple and Blue Line", "sku": "44766588108973", "price": "99.00", "inventory": 20}, "flower-navy": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766588141741", "variant_title": "Floral Blue", "sku": "44766588141741", "price": "99.00", "inventory": 20}, "flower-brown": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766588174509", "variant_title": "Floral Brown", "sku": "44766588174509", "price": "99.00", "inventory": 20}, "flower-darkgreen": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766588207277", "variant_title": "Floral Green", "sku": "44766588207277", "price": "99.00", "inventory": 20}, "flower-purple": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766588240045", "variant_title": "Floral Purple", "sku": "44766588240045", "price": "99.00", "inventory": 20}, "totem-navy": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766588272813", "variant_title": "Blue totem", "sku": "44766588272813", "price": "99.00", "inventory": 20}, "totem-brown": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766588305581", "variant_title": "Brown totem", "sku": "44766588305581", "price": "99.00", "inventory": 20}, "totem-darkgreen": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766588338349", "variant_title": "Green totem", "sku": "44766588338349", "price": "99.00", "inventory": 20}, "totem-purple": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766588371117", "variant_title": "Purple totem", "sku": "44766588371117", "price": "99.00", "inventory": 20}, "fluid-navy": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766604853421", "variant_title": "Flowing Blue", "sku": "44766604853421", "price": "99.00", "inventory": 20}, "fluid-brown": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766604886189", "variant_title": "Flowing Brown", "sku": "44766604886189", "price": "99.00", "inventory": 20}, "fluid-darkgreen": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766604918957", "variant_title": "Flowing Green", "sku": "44766604918957", "price": "99.00", "inventory": 20}, "fluid-purple": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766604951725", "variant_title": "Flowing Purple", "sku": "44766604951725", "price": "99.00", "inventory": 20}, "liuli-navy": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766604984493", "variant_title": "Liuli Blue", "sku": "44766604984493", "price": "99.00", "inventory": 20}, "liuli-brown": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605017261", "variant_title": "Liuli Brown", "sku": "44766605017261", "price": "99.00", "inventory": 20}, "liuli-darkgreen": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605050029", "variant_title": "Liuli Green", "sku": "44766605050029", "price": "99.00", "inventory": 20}, "liuli-purple": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605082797", "variant_title": "Liuli Purple", "sku": "44766605082797", "price": "99.00", "inventory": 20}, "youth-navy": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605115565", "variant_title": "Youth Blue", "sku": "44766605115565", "price": "99.00", "inventory": 20}, "youth-brown": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605148333", "variant_title": "Youth Brown", "sku": "44766605148333", "price": "99.00", "inventory": 20}, "youth-darkgreen": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605181101", "variant_title": "Youth Green", "sku": "44766605181101", "price": "99.00", "inventory": 20}, "youth-purple": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605213869", "variant_title": "Youth Purple", "sku": "44766605213869", "price": "99.00", "inventory": 20}, "cube-navy": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605246637", "variant_title": "Magic Cube Blue", "sku": "44766605246637", "price": "99.00", "inventory": 20}, "cube-brown": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605279405", "variant_title": "Magic Cube Brown", "sku": "44766605279405", "price": "99.00", "inventory": 20}, "cube-darkgreen": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605312173", "variant_title": "Magic Cube Green", "sku": "44766605312173", "price": "99.00", "inventory": 20}, "cube-purple": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605344941", "variant_title": "Magic Cube Purple", "sku": "44766605344941", "price": "99.00", "inventory": 20}, "quantum-navy": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605377709", "variant_title": "Quantum Blue", "sku": "44766605377709", "price": "99.00", "inventory": 20}, "quantum-brown": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605410477", "variant_title": "Quantum Brown", "sku": "44766605410477", "price": "99.00", "inventory": 20}, "quantum-darkgreen": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605443245", "variant_title": "Quantum Green", "sku": "44766605443245", "price": "99.00", "inventory": 20}, "quantum-purple": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605476013", "variant_title": "Quantum Purple", "sku": "44766605476013", "price": "99.00", "inventory": 20}, "time-navy": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605508781", "variant_title": "Year of Flow Blue", "sku": "44766605508781", "price": "99.00", "inventory": 20}, "time-brown": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605541549", "variant_title": "Year of Flow Brown", "sku": "44766605541549", "price": "99.00", "inventory": 20}, "time-darkgreen": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605574317", "variant_title": "Year of Flow Green", "sku": "44766605574317", "price": "99.00", "inventory": 20}, "time-purple": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605607085", "variant_title": "Year of Flow Purple", "sku": "44766605607085", "price": "99.00", "inventory": 20}}, "moni_strap": {"navy": {"product_id": "gid://shopify/Product/7993483526317", "product_handle": "monixibi-rainbow-moni-strap", "product_title": "Rainbow Moni-Strap", "variant_id": "gid://shopify/ProductVariant/44043090559149", "variant_title": "Deep Blue", "sku": "", "price": "79.00", "inventory": 20}, "brown": {"product_id": "gid://shopify/Product/7993483526317", "product_handle": "monixibi-rainbow-moni-strap", "product_title": "Rainbow Moni-Strap", "variant_id": "gid://shopify/ProductVariant/44043090591917", "variant_title": "Coffee Brown", "sku": "", "price": "79.00", "inventory": 20}, "darkgreen": {"product_id": "gid://shopify/Product/7993483526317", "product_handle": "monixibi-rainbow-moni-strap", "product_title": "Rainbow Moni-Strap", "variant_id": "gid://shopify/ProductVariant/44043090624685", "variant_title": "Dark Green", "sku": "", "price": "79.00", "inventory": 20}, "purple": {"product_id": "gid://shopify/Product/7993483526317", "product_handle": "monixibi-rainbow-moni-strap", "product_title": "Rainbow Moni-Strap", "variant_id": "gid://shopify/ProductVariant/44043090657453", "variant_title": "Deep Purple", "sku": "", "price": "79.00", "inventory": 20}}, "_meta": {"generated_at": "2026-05-22T21:35:29.259459", "total_mapped": 60, "unmapped_variants_count": 0, "unmapped_samples": []}};

/* ============================================================
   §7 DATA · 色名 / 色值
   ============================================================ */
// 主机 / 面盖 共池(4 色,同色系)
const HOSTS = [
  { slug: 'silver',       cn: '星空银', hex: '#D6D7DC' },
  { slug: 'desertyellow', cn: '大漠黄', hex: '#E8C97A' },
  { slug: 'babyblue',     cn: '静谧蓝', hex: '#BCD0E8' },
  { slug: 'green',        cn: '复古绿', hex: '#A8C5A1' },
];
// 面盖 4 色(色池跟主机一致,但带 image 字段用真实按钮图)
const FACEPLATES = [
  { slug: 'silver',       cn: '星空银', hex: '#D6D7DC', image: cdnUrl('素材/faceplate-silver.png', THUMB_W) },
  { slug: 'desertyellow', cn: '大漠黄', hex: '#E8C97A', image: cdnUrl('素材/faceplate-desertyellow.png', THUMB_W) },
  { slug: 'babyblue',     cn: '静谧蓝', hex: '#BCD0E8', image: cdnUrl('素材/faceplate-babyblue.png', THUMB_W) },
  { slug: 'green',        cn: '复古绿', hex: '#A8C5A1', image: cdnUrl('素材/faceplate-green.png', THUMB_W) },
];

// 全包耳皮套 4 色(image 是真实皮套按钮图)
const EARPADS = [
  { slug: 'navy',      cn: '深蓝色', hex: '#1F2A55', image: cdnUrl('素材/earpad-navy.png', THUMB_W) },
  { slug: 'darkgreen', cn: '墨绿色', hex: '#243E2C', image: cdnUrl('素材/earpad-darkgreen.png', THUMB_W) },
  { slug: 'purple',    cn: '深紫色', hex: '#3A2557', image: cdnUrl('素材/earpad-purple.png', THUMB_W) },
  { slug: 'brown',     cn: '深棕色', hex: '#5B3F2E', image: cdnUrl('素材/earpad-brown.png', THUMB_W) },
];

// 阶段 A · 魔尼带(Moni-Strap)4 色,跟全包皮套色一一对应,套装内仅 1 件(全局共用,不分副)
const MONI_STRAPS = [
  { slug: 'navy',      cn: '深蓝色', hex: '#1F2A55', image: cdnUrl('素材/moni-strap-navy.png', THUMB_W) },
  { slug: 'darkgreen', cn: '墨绿色', hex: '#243E2C', image: cdnUrl('素材/moni-strap-darkgreen.png', THUMB_W) },
  { slug: 'purple',    cn: '深紫色', hex: '#3A2557', image: cdnUrl('素材/moni-strap-purple.png', THUMB_W) },
  { slug: 'brown',     cn: '深棕色', hex: '#5B3F2E', image: cdnUrl('素材/moni-strap-brown.png', THUMB_W) },
];
// 魔尼带英文色名映射(用于加购 properties,跟 Shopify 后台一致)
const MONI_STRAP_EN = {
  navy:      'Deep Blue',
  darkgreen: 'Dark Green',
  purple:    'Deep Purple',
  brown:     'Coffee Brown',
};

// 阶段 C · 颜色英文映射(Shopify 后台 line item properties 规范,2026-06-01)
const HOST_EN = {
  silver:       'Starry Silver',
  desertyellow: 'Desert Yellow',
  babyblue:     'Serene Blue',
  green:        'Retro Green',
};
// 面盖跟主机色一一对应,英文名相同
const FACEPLATE_EN = HOST_EN;
// 全包皮套 4 色英文名
const EARPAD_EN = {
  navy:      'Deep Blue',
  darkgreen: 'Dark Green',
  purple:    'Deep Purple',
  brown:     'Coffee Brown',
};

// —— 阶段1 i18n · 给色名对象补 en 字段(店铺官方英文名)+ 显示助手 ——
HOSTS.forEach(function (o) { o.en = HOST_EN[o.slug]; });
FACEPLATES.forEach(function (o) { o.en = FACEPLATE_EN[o.slug]; });
EARPADS.forEach(function (o) { o.en = EARPAD_EN[o.slug]; });
MONI_STRAPS.forEach(function (o) { o.en = MONI_STRAP_EN[o.slug]; });
// 显示名:英文优先用 en(店铺官方英文名),缺则回退中文
function dispName(o) { return (o && LOCALE === 'en' && o.en) ? o.en : (o ? (o.cn || '') : ''); }
// 部件词(中/英)
const PARTW = {
  zh: { host: '主机', faceplate: '面盖', headband: '头带', earpad: '全包皮套', pad: '皮套' },
  en: { host: 'Host', faceplate: 'Faceplate', headband: 'Headband', earpad: 'Over-Ear Cushion', pad: 'Cushion' },
};
// 色+部件:中「星空银面盖」/ 英「Starry Silver Faceplate」
function partOfColor(o, part) {
  var n = dispName(o);
  return LOCALE === 'en' ? (n + ' ' + (PARTW.en[part] || '')) : (n + (PARTW.zh[part] || ''));
}
// 部件+色:中「头带深蓝色」/ 英「Headband: Deep Blue」
function partColonLabel(part, o) {
  var n = dispName(o);
  return LOCALE === 'en' ? ((PARTW.en[part] || '') + ': ' + n) : ((PARTW.zh[part] || '') + n);
}

// 阶段 C · Shopify 后台 DIY product 3 个 variant_id(numeric,不是 gid),2026-06-01 用户确认
const DIY_VARIANT_IDS = {
  1: 46073729384621,  // Rainbow DIY - First Pair  $299 · 5 件
  2: 46073729712301,  // Rainbow DIY - Second Pair $349 · 8 件 · 主推
  3: 46073731547309,  // Rainbow DIY - Third Pair  $389 · 11 件
};
/* 2026-10-29 用户拍板:常年 20% 自动折扣并入标价(299/349/389 × 0.8 取整),后台同步改价并停用那条折扣。
   ⚠️ 这三个数必须等于 Shopify 后台三个 DIY 变体的标价,对账脚本 scripts/_verify-price-sync.py。 */
const DIY_PRICES = { 1: 239, 2: 279, 3: 311 };
/* 🖤 黑五活动(2026-11-02 用户在 FB 会话拍板,facebook-79 转来):
   2026-11-17 美东 00:00 → 11-30 23:59:59,2 套 $279→$239(第二套免费)、3 套 $311→$279。
   结账价由 Shopify 自动折扣出(shopify-7b 建),商品标价不改 → DIY_PRICES 不动,这里只管「显示」。
   美东 11 月已是冬令时(UTC−5),所以起点 = 05:00Z,终点 = 次日 04:59:00Z(跟 7b 建的两条自动折扣 endsAt 逐秒对齐,差一秒就会出现「页面说免费、结账不免」)。到点自动显示 / 自动消失。
   验收:网址加 &diynow=2026-11-20 可模拟「现在」的日期(只影响显示,不影响结账)。 */
const BF_PROMO = { start: Date.parse('2026-11-17T05:00:00Z'), end: Date.parse('2026-12-01T04:59:00Z'), prices: { 2: 239, 3: 279 } };
function 黑五中() {
  var now = Date.now();
  try {
    var m = /[?&]diynow=([^&#]+)/.exec(location.search);
    if (m) { var t = Date.parse(decodeURIComponent(m[1]) + (/T/.test(m[1]) ? '' : 'T12:00:00-05:00')); if (isFinite(t)) now = t; }
  } catch (e) { console.error('[DIY] diynow 解析失败:', e); }
  return now >= BF_PROMO.start && now <= BF_PROMO.end;
}
/* 当前实际结账价:活动期内取活动价,平时就是 DIY_PRICES */
function 现价(n) { return (黑五中() && BF_PROMO.prices[n]) || DIY_PRICES[n]; }

// SoT § 7 半包耳锁死表:主机色 → 标配皮套 + 头带色
const LOCKED_PAIRS = {
  silver:       'navy',       // 星空银 → 深蓝
  desertyellow: 'darkgreen',  // 大漠黄 → 墨绿
  babyblue:     'purple',     // 静谧蓝 → 深紫
  green:        'brown',      // 复古绿 → 深棕
};

// —— 头带 44 款生成(SoT § 3) ——
// 4 系列底色 + 8 设计系列 + 8 线条款 + 4 纯色
const BASE_COLORS = ['brown', 'navy', 'purple', 'darkgreen'];
const BASE_HEX = { brown: '#5B3F2E', navy: '#1F2A55', purple: '#3A2557', darkgreen: '#243E2C' };
const BASE_CN  = { brown: '棕', navy: '蓝', purple: '紫', darkgreen: '绿' };
const SOLID_CN = { brown: '深棕色', navy: '深蓝色', purple: '深紫色', darkgreen: '墨绿色' };
const SERIES = [
  { slug: 'totem',   cn: '图腾' },
  { slug: 'liuli',   cn: '琉璃' },
  { slug: 'quantum', cn: '量子' },
  { slug: 'fluid',   cn: '流体' },
  { slug: 'cube',    cn: '魔方' },
  { slug: 'flower',  cn: '花语' },
  { slug: 'youth',   cn: '青春' },
  { slug: 'time',    cn: '流年' },
];
const LINE_PAIRS = [
  ['brown', 'yellow'], ['brown', 'green'],
  ['navy',  'red'],    ['navy',  'yellow'],
  ['purple','navy'],   ['purple','yellow'],
  ['darkgreen','red'], ['darkgreen','yellow'],
];
const ACCENT_CN = { yellow: '黄', red: '红', green: '绿', navy: '蓝' };
const ACCENT_HEX = { yellow: '#E8C97A', red: '#C7423A', green: '#A8C5A1', navy: '#1F2A55' };

function buildHeadbands() {
  const list = [];
  // 头带英文名取店铺官方变体名(纯色款店铺无独立变体,用底色英文名)
  const hbEnName = slug => (SHOPIFY_MAPPING_INLINE.headband[slug] || {}).variant_title;
  // 4 纯色(去底抠图)· baseColor 字段显式标底色,免后续 split('-')[1] 反推
  BASE_COLORS.forEach(c => list.push({
    slug: `solid-${c}`, type: 'solid', hex: BASE_HEX[c],
    cn: SOLID_CN[c], en: EARPAD_EN[c], accentHex: '#ffffff66',
    image: cdnUrl(`素材/headband-solid-${c}.png`, THUMB_W),
    baseColor: c,
  }));
  // 8 线条(有图)
  LINE_PAIRS.forEach(([a, b]) => list.push({
    slug: `line-${a}-${b}`, type: 'line', hex: BASE_HEX[a],
    cn: BASE_CN[a] + ACCENT_CN[b] + '线', en: hbEnName(`line-${a}-${b}`),
    accentHex: ACCENT_HEX[b],
    image: cdnUrl(`素材/headband-line-${a}-${b}.png`, THUMB_W),
    baseColor: a,
  }));
  // 32 设计款(有图)
  SERIES.forEach(s => BASE_COLORS.forEach(c => list.push({
    slug: `${s.slug}-${c}`, type: 'design', hex: BASE_HEX[c],
    cn: s.slug === 'totem' ? (BASE_CN[c] + s.cn) : (s.cn + BASE_CN[c]),
    en: hbEnName(`${s.slug}-${c}`),
    accentHex: 'rgba(255,255,255,.6)',
    image: cdnUrl(`素材/headband-${s.slug}-${c}.png`, THUMB_W),
    baseColor: c,
  })));
  return list;
}
const ALL_HEADBANDS = buildHeadbands();

// 适配图存在性表(主图预览卡 4 层叠加用,1:1 画布 PNG)
// 全包耳形态用 ${type}-${slug}.png(host/faceplate/earpad/headband)
// 半包耳形态用 host-halfear-${slug}.png / earpad-halfear-${slug}.png(2026-05-20 补齐 8 张)
// 直接从数据源派生,避免手写列表跟数据池失同步
const ADAPT_IMAGES = {
  // 头带:ALL_HEADBANDS 全部有 image 字段(44 款都有),用 slug 全集
  headband:  new Set(ALL_HEADBANDS.map(h => h.slug)),
  // 主机 / 面盖 / 全包皮套 跟 4 色池一一对齐
  host:      new Set(HOSTS.map(h => h.slug)),
  faceplate: new Set(FACEPLATES.map(f => f.slug)),
  earpad:    new Set(EARPADS.map(e => e.slug)),
  // 半包耳专属命名空间(目前 4 色全有图,跟 HOSTS / EARPADS 一致;若以后某色缺图,改这里手写)
  host_halfear:   new Set(HOSTS.map(h => h.slug)),
  earpad_halfear: new Set(EARPADS.map(e => e.slug)),
};

// 返回 url('...') 或 'none'(走 fallback 颜色块)
// 缺图静默 fallback 容易把素材缺口憋成视觉怪图,开发期 warn 一下方便发现 typo / 漏图
function adaptImg(type, slug, form) {
  // 半包耳形态走专属命名空间(host 和 earpad 都有视觉差异)
  if (form === 'halfear' && (type === 'host' || type === 'earpad')) {
    const key = `${type}_halfear`;
    if (!ADAPT_IMAGES[key] || !ADAPT_IMAGES[key].has(slug)) {
      console.warn(`[adaptImg] 缺图: ${key} / ${slug}, 走 fallback`);
      return 'none';
    }
    return `url('${cdnUrl('素材/适配图/' + type + '-halfear-' + slug + '.png')}')`;
  }
  if (!ADAPT_IMAGES[type] || !ADAPT_IMAGES[type].has(slug)) {
    console.warn(`[adaptImg] 缺图: ${type} / ${slug}, 走 fallback`);
    return 'none';
  }
  return `url('${cdnUrl('素材/适配图/' + type + '-' + slug + '.png')}')`;
}

// 给定主机色 → 头带池(标配那条保留并标 isBonus,渲染时显示"标"角标 + 禁选)
function getHeadbandPool(host) {
  const lockedSolid = `solid-${LOCKED_PAIRS[host]}`;
  return ALL_HEADBANDS.map(h => h.slug === lockedSolid ? { ...h, isBonus: true } : h);
}
// slug → 头带对象
const HEADBAND_MAP = Object.fromEntries(ALL_HEADBANDS.map(h => [h.slug, h]));
/* ⬆ 第 129 轮上移到这里(原本在 getHeadbandBaseColor 下面,约 260 行之后)。
   原因:?pick= 的单件预选要在解析早期就调 findLinkedEarpad(补做头带↔皮套联动),
   而那个函数用到本常量。函数声明会提升,`const` 却有【暂时性死区】——
   提前调用直接抛 ReferenceError,再被预选那层的 try/catch 静默吞掉:
   预选完全失效、控制台一声不响。纯字面量数组,上移零风险。 */
const EARPAD_COLORS = ['navy', 'darkgreen', 'purple', 'brown'];

// 价格(占位)
const PRICE = {
  base:      269,   // 主机 + 标配头带 + 半包耳皮套(品牌定价,2026-05-25 锁死)
  faceplate: 49,    // 1 套面盖(必含 2 色)
  earpad:    59,    // 1 套全包耳皮套(必含 2 色)
  headband:  29,    // 1 套头带(必含 2 款)
  extraHost: 89,    // 多加 1 主机
  moniStrap: 19,    // 魔尼带
};
// v16.0 MVP · 副数定价表(plan 销售模型,2026-05-29):用副数决定价格,覆盖 totalPrice() 旧模型
// 阶段 C · 价格改 DIY product 真实挂牌价(替代 MVP 测试 199/280/360),2026-06-01
const KIT_PRICE = DIY_PRICES;
function totalPriceMvp() { return 现价(state.kitCount) || KIT_PRICE[state.kitCount] || 349; }   // 黑五期间自动换活动价
// v16.4 · 折后价展示:全店 20% off(八折,无门槛触发)→ 原价划线 + 折后价 + 省多少,跟购物车一致
/* 第 138 轮(2026-09-06):折扣率从写死改成【主题编辑器可配】。
   为什么必须可配:这个数跟 Shopify 后台那条折扣「Be the first to try it and get 20% off instantly!」
   是两份独立的真相。后台改了折扣而这里没改 → 页面显示 $239.20、结账收 $299,是静默的价格错位,
   没有任何报错,只有客人在结账页发现。做成设置项后,改后台折扣时至少能在同一个后台里同步改掉。
   ⚠️ 只搬折扣率这一个数。「满 3 件 7 折」那条是购物车级折扣,配置器只加 1 个商品行(quantity: 1),
      永远触发不了,搬进来只会算错(2026-09-06 已与用户确认)。
   注入链路:build-section.py schema 的 diy_discount_rate → liquid 内联 window.__DIY_DISCOUNT_RATE__ → 此处读。
   本地 index.html 没有 section 设置 → 回退 0.8,预览照常工作。 */
const DISCOUNT_RATE = (function () {
  try {
    var v = parseFloat(window.__DIY_DISCOUNT_RATE__);
    if (isFinite(v) && v > 0 && v <= 1) return v;
  } catch (e) {
    console.error('[DIY] 读折扣率设置(__DIY_DISCOUNT_RATE__)失败,回退 1:', e);
  }
  return 1;     // 本地预览 / 设置项没填 / 填了非法值 → 回退(2026-10-29 起八折已并入标价,无折扣 = 1)
})();
/* 2026-10-29:「分开买」对照价 = 套装里每件东西单买、今天真实结账要付多少(含配件满 3 件 5 折,不是挂牌价加总)。
   draftOrderCalculate 实测(新客·美国):1 套 主机199 + 面盖15 + 全包耳套19.5 + 头带49.5 + 魔尼带39.5 = 322.50;
   2 套 406.50;3 套 490.50。各色各款单价统一,所以只跟套数有关。
   来源:主题编辑器「价格口径」组 diy_separate_1/2/3 → liquid 内联 window.__DIY_SEPARATE__。
   ⚠️ 主机 / 配件改价、或「满 3 件 5 折」力度变了,都要回编辑器改这三格;对账脚本 _verify-price-sync.py 会报红。 */
const SEPARATE_PRICE = (function () {
  var 默认 = { 1: 322.5, 2: 406.5, 3: 490.5 };
  try {
    var s = window.__DIY_SEPARATE__;
    if (s) {
      var 出 = {};
      [1, 2, 3].forEach(function (n) { var v = parseFloat(s[n]); 出[n] = (isFinite(v) && v > 0) ? v : 默认[n]; });
      return 出;
    }
  } catch (e) {
    console.error('[DIY] 读分开买对照价(__DIY_SEPARATE__)失败,回退默认值:', e);
  }
  return 默认;
})();
/* 价格显示:整数不带 .00($239),有零头保留两位($83.50) */
function 美元(v) { return '$' + (Math.round(v * 100) % 100 === 0 ? String(Math.round(v)) : v.toFixed(2)); }
/* 「加第 2 套」提示条的对照基准 = 客人自己去买那 3 件配件【实付】多少。
   ⚠️ 2026-09-06 修正:原先填 168(= 面盖 $30 + 全包耳皮套 $39 + 设计头带 $99 的【挂牌价】加总)是错的。
      客人永远付不到挂牌价 —— 这 3 件一起买就凑够「满 3 件配件 5 折」,draftOrderCalculate 实测实付 $84。
      拿 168 去对比等于把优势夸大一倍,客人把这 3 件丢进购物车 30 秒就能拆穿,还有美国虚高划线价的合规风险。
   配件调价 / 「满 3 件 5 折」那条折扣力度变了,都要回主题编辑器同步改这一格。 */
const KIT_VALUE_REF = (function () {
  try {
    var v = parseFloat(window.__DIY_KIT_VALUE_REF__);
    if (isFinite(v) && v > 0) return Math.round(v);
  } catch (e) {
    console.error('[DIY] 读配件自购实付价(__DIY_KIT_VALUE_REF__)失败,回退 84:', e);
  }
  return 84;
})();
/* 折扣率 → 中文「几折」说法(中文习惯说折后比例:0.8 = 八折,0.75 = 七五折)。
   写成算的而不是写死「八折」,是因为折扣率现在能在主题编辑器里改。 */
function 折扣中文(rate) {
  var 数 = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
  var s = String(Math.round(rate * 100));
  if (s.length !== 2) return Math.round(rate * 100) + '%';   // 极端值(≥100 / <10)不硬套「折」,退回百分比
  var 十 = +s.charAt(0), 个 = +s.charAt(1);
  return 个 === 0 ? 数[十] + '折' : 数[十] + 数[个] + '折';
}
/* 加第 2 套要多付多少(折后):(349 − 299) × 折扣率 = $40。
   ⚠️ 别在文案里写死 —— 原价差是 $50,折后才是 $40,写死过一次就是那句错的「just +$50」。 */
function kit2ExtraCost() {
  var d = (DIY_PRICES[2] || 349) - (DIY_PRICES[1] || 299);
  return Math.round(d * DISCOUNT_RATE);
}
/* 「半价」这个说法是【算出来的】,不是写死的。
   加第 2 套要付 kit2ExtraCost() = $40;同样 3 件配件客人自购实付 KIT_VALUE_REF = $84 → 40/84 = 0.476 →「半价」。
   ⚠️ 为什么不写死:折扣率和配件价都能在主题编辑器改。一旦改到不再接近半价,这里会自动降级成「几折」/百分比,
      不会顶着一句已经不成立的话继续卖。写死过一次「立享八折」和一次「单买 $168」,两次都变成了在撒谎。 */
function 第二套折算() {
  var r = kit2ExtraCost() / (KIT_VALUE_REF || 1);
  if (!isFinite(r) || r <= 0) return { cn: '半价', en: 'half price' };          // 兜底,不让提示条炸
  if (r >= 0.45 && r <= 0.55) return { cn: '半价', en: 'half price' };
  return { cn: 折扣中文(r), en: Math.round(r * 100) + '% of list' };
}
function 第二套折算文案() { return LOCALE === 'en' ? 第二套折算().en : 第二套折算().cn; }
function renderPriceDisplay(price, kitCount) {
  const off  = price * DISCOUNT_RATE;       // 折后价
  const save = price - off;                 // 省多少
  const o = document.getElementById('price-original');
  const t = document.getElementById('total-price');
  const d = document.getElementById('price-discount');
  // 套数按钮上的价跟 DIY_PRICES 走(原来是 HTML 里写死的,改价漏改过)
  document.querySelectorAll('.kit-count__chip[data-count]').forEach(function (chip) {
    var p = chip.querySelector('.kit-count__price'), n = +chip.dataset.count;
    if (!p || !DIY_PRICES[n]) return;
    var 今 = 现价(n);
    if (今 < DIY_PRICES[n]) p.innerHTML = '<s class="bf-was">' + 美元(DIY_PRICES[n]) + '</s>' + 美元(今);   // 黑五:划掉平时价
    else p.textContent = 美元(DIY_PRICES[n]);
  });
  /* 2026-10-29 起没有折扣(折扣率 1):不划线、不说「立享几折」,改跟「分开买」的真实结账价比。
     分开买那个价不划线 —— 紧挨主价的划线价会被读成「原价」,在美国就是虚假原价。 */
  if (DISCOUNT_RATE >= 1) {
    const sep = SEPARATE_PRICE[kitCount];
    const sepSave = sep ? sep - price : 0;
    if (o) { o.textContent = ''; o.hidden = true; }
    if (t) t.textContent = 美元(price);
    document.querySelector('.cta-bar__price')?.classList.add('is-list-price');
    if (d) {
      if (sepSave > 0) {
        // 文案模板里自带 $(跟 discount_save 同口径),这里只传数字部分
        const 数 = v => 美元(v).slice(1);
        d.innerHTML = '<span class="cta-sep">' + TR('sep_price', { sep: 数(sep) }) + '</span>'
          + '<span class="cta-save">' + TR('sep_save', { save: 数(sepSave) }) + '</span>'
          + '<span class="cta-save-m">' + TR('sep_save_m', { save: 数(sepSave) }) + '</span>';
        d.hidden = false;
      } else { d.textContent = ''; d.hidden = true; }
    }
    return;
  }
  document.querySelector('.cta-bar__price')?.classList.remove('is-list-price');
  if (o) { o.textContent = '$' + price; o.hidden = false; }
  if (d) d.hidden = false;
  if (t) t.textContent = '$' + off.toFixed(2);
  /* 折扣力度的说法也得跟着 DISCOUNT_RATE 走。原来中文写死「立享八折」、英文写死「20% off」——
     折扣率一旦在主题编辑器里改成别的,这两句就在撒谎(数字对、说法错,比纯错还难发现)。 */
  if (d) d.textContent = TR('discount_save', {
    save: save.toFixed(2),
    rateCn: 折扣中文(DISCOUNT_RATE),                       // 八折 / 七五折
    pct: Math.round((1 - DISCOUNT_RATE) * 100),           // 20 / 25
  });
}

/* ============================================================
   §8 STATE (v13 · 引导式 DIY)
   ============================================================ */
// 默认进站态:Build 1 空待用户挑(activeBuild=0),Build 2 灰禁锁(等 Build 1 装好)
const state = {
  base: {
    host: 'desertyellow',
  },
  builds: [
    // Build 1 默认示范:大漠黄主机 + 红绿线头带 + 星空银面盖 + 墨绿全包皮套
    { faceplate: 'silver', headband: 'line-darkgreen-red', earpad: 'darkgreen' },
    // Build 2 空(等用户挑)— 因 Build 1 完成,Tab 自动解锁
    { faceplate: null, headband: null, earpad: null },
  ],
  extras: { extraHosts: 0 },
  // 阶段 A · 魔尼带:全套装 1 件,锁色联动 Build 1 的全包皮套色(linked=true);可解锁自由选(linked=false)
  moniStrap: { slug: 'darkgreen', linked: true },
  // v16.9 · 副数默认 1 套(第2套白,点第2套 tab 才加购);1/2/3
  kitCount: 1,
  currentVariantIdx: 0,
  // UI 状态
  activeBuild: 0,
  detailsOpen: [false, false],
  headbandTab: 'design',
  headbandSeries: 'line',   // 头带底部通栏当前系列(纯色/线条/图腾…),默认线条(第1套默认绿红线)
  helpOpen: { host: false, build1: false, build2: false },
  // 头带 ↔ 皮套色双向绑定(默认开):选其中一个,另一个自动同底色
  headbandLinked: true,
  headbandLinkHelpOpen: false,
  // 头带横滑位置缓存(render 重渲染后恢复,避免回弹到第一条)
  headbandScrollLeft: 0,
  // 同步皮套→头带时,要求 render 后把 picker 滚到这个 slug(用完清空)
  headbandScrollTo: null,
  // 滚动对齐方式:'center'(选中 chip 居中) / 'start'(把目标 chip 推到最左,后面 3 条同分类一起露出)
  headbandScrollMode: 'center',
  previewMode: 'build',
  // hero ⊕ 教学卡展开态(默认收起)
  heroGuideOpen: !(window.matchMedia && window.matchMedia('(max-width: 760px), (max-device-width: 760px)').matches),    // 桌面默认展开(填充列1底部);手机(≤760)默认收起,点+展开(2026-07-09 手机版)
};

/* ============ 分享链接:把当前设计编码进网址(第 119 轮 · 2026-08-10)============
   原来 shareUrl() 只返回 window.location.href —— 朋友点开看到的是空白配置器,
   不是你配的那副,喜欢也无从下单。这一段把整副设计编码成短码放进 ?d=,
   打开时还原回来。链接本身就是"保存",配置不再关掉就没。

   编码不查表、不依赖数组顺序 —— 全部跟着 slug 的语义规则走,
   所以以后加配件/改池子顺序都不会让老链接失效(这是选规则编码而不是索引编码的唯一理由)。
     颜色     大写=主机/面盖色系,小写=皮套/头带底色与线条副色
     头带     0+底色=纯色 / 1+底色+副色=线条 / 2~9+底色=设计款(对应 SERIES 顺序)
   形如:1.D.S1krk..k1.1   ← 版本.主机.第1套(面盖+头带+皮套).第2套.魔尼带+联动.副数 */
const SHARE_COLOR = {
  silver: 'S', desertyellow: 'D', babyblue: 'B', green: 'G',          // 主机 / 面盖
  navy: 'n', darkgreen: 'k', purple: 'p', brown: 'w',                 // 皮套 / 头带底色 / 魔尼带
  yellow: 'y', red: 'r',                                              // 线条副色(green/navy 复用上面)
};
const SHARE_COLOR_REV = Object.fromEntries(Object.entries(SHARE_COLOR).map(([k, v]) => [v, k]));
const SHARE_SERIES = ['totem', 'liuli', 'quantum', 'fluid', 'cube', 'flower', 'youth', 'time'];

function encHeadband(slug) {
  if (!slug) return '';
  const m格 = /^(solid|line)-(.+)$/.exec(slug);
  if (m格 && m格[1] === 'solid') return '0' + (SHARE_COLOR[m格[2]] || '');
  if (m格 && m格[1] === 'line') {
    const [a, b] = m格[2].split('-');
    return '1' + (SHARE_COLOR[a] || '') + (SHARE_COLOR[b] || '');
  }
  const i = slug.indexOf('-');
  const 系 = SHARE_SERIES.indexOf(slug.slice(0, i));
  return 系 < 0 ? '' : String(系 + 2) + (SHARE_COLOR[slug.slice(i + 1)] || '');
}
// 返回 [slug, 消耗的字符数] —— 头带码长度不定(纯色2/线条3/设计款2),靠首字符判定
function decHeadband(s, i) {
  const h = s.charAt(i);
  if (h === '0') return ['solid-' + (SHARE_COLOR_REV[s.charAt(i + 1)] || ''), 2];
  if (h === '1') return ['line-' + (SHARE_COLOR_REV[s.charAt(i + 1)] || '') + '-' + (SHARE_COLOR_REV[s.charAt(i + 2)] || ''), 3];
  const 系 = SHARE_SERIES[Number(h) - 2];
  return 系 ? [系 + '-' + (SHARE_COLOR_REV[s.charAt(i + 1)] || ''), 2] : [null, 1];
}

function encodeDesign() {
  const 段 = ['1', SHARE_COLOR[state.base.host] || '-'];
  [0, 1].forEach(function (i) {
    const b = state.builds[i];
    if (!b || (!b.faceplate && !b.headband && !b.earpad)) { 段.push(''); return; }
    段.push((SHARE_COLOR[b.faceplate] || '-') + (encHeadband(b.headband) || '-') + (SHARE_COLOR[b.earpad] || '-'));
  });
  const ms = state.moniStrap || {};
  段.push((SHARE_COLOR[ms.slug] || '-') + (ms.linked ? '1' : '0'));
  段.push(String(state.kitCount || 1));
  return 段.join('.');
}

// 解析 ?d= 并写回 state。只认得懂的部分,任何一段坏掉都跳过那段而不是整体失败 ——
// 链接被聊天软件截断/尾部粘了标点是常事,不能因此白屏。
function applyDesignCode(code) {
  if (!code) return false;
  const 段 = String(code).split('.');
  if (段[0] !== '1') return false;
  let 有效 = false;
  const 取色 = c => SHARE_COLOR_REV[c] || null;
  const h = 取色(段[1]);
  if (h) { state.base.host = h; 有效 = true; }
  [0, 1].forEach(function (i) {
    const s = 段[2 + i];
    if (!s) { if (i === 1) state.builds[1] = { faceplate: null, headband: null, earpad: null }; return; }
    const 面 = 取色(s.charAt(0));
    const [带, 用] = decHeadband(s, 1);
    const 套 = 取色(s.charAt(1 + 用));
    if (面 || 带 || 套) {
      state.builds[i] = { faceplate: 面, headband: 带, earpad: 套 };
      有效 = true;
    }
  });
  const ms = 段[4] || '';
  const 魔 = 取色(ms.charAt(0));
  if (魔) { state.moniStrap = { slug: 魔, linked: ms.charAt(1) !== '0' }; 有效 = true; }
  const k = parseInt(段[5], 10);
  if (k >= 1 && k <= 3) { state.kitCount = k; 有效 = true; }
  return 有效;
}

/* ============ ?pick= 单件预选(第 129 轮 · 2026-08-12)============
   给【配件产品页】的入口用:顾客在某条头带的产品页上,点「用这个配色开始搭」,
   跳到 /pages/design?pick=<变体ID>,配置器进来就已经选好那一件,其余保持默认。
   为什么值得做:从广告落到单个配件页的人,下一句念头是「这个颜色配深灰耳罩什么样」,
   在此之前他没有任何路径过去 —— 这是意图最强的入口,比任何全局按钮都强。

   为什么用【变体 ID】而不是 slug 当参数:产品页的 liquid 手边只有 {{ variant.id }},
   它不知道配置器内部的 slug 叫什么。反查表 SHOPIFY_MAPPING_INLINE 本来就在这份 JS 里
   (60 个变体全映射,unmapped 0),让配置器自己去查,产品页那侧就零知识、不会写错。
   ⚠️ 映射表里存的是 GID(gid://shopify/ProductVariant/447665...),liquid 给的是纯数字,
      所以索引按【数字尾号】建。 */
const PICK_索引 = (function () {
  const 表 = {};
  for (const 部件 in SHOPIFY_MAPPING_INLINE) {
    if (部件 === '_meta') continue;
    for (const slug in SHOPIFY_MAPPING_INLINE[部件]) {
      const gid = String(SHOPIFY_MAPPING_INLINE[部件][slug].variant_id || '');
      const 数字 = gid.split('/').pop();
      if (数字) 表[数字] = { 部件, slug };
    }
  }
  return 表;
})();

function applyPickVariant(vid) {
  if (!vid) return false;
  const 命 = PICK_索引[String(vid).replace(/\D/g, '')];
  if (!命) return false;
  /* 只动被点中的那一件,其余留默认 —— 这是「从这里开始搭」,不是「还原一整副设计」。
     ⚠️ 但头带这件必须【补做联动】:state.headbandLinked 默认开,界面上写着
        「头带底色锁定皮套颜色(推荐)」。光把 headband 塞进 state 而不同步皮套,
        就会出现「联动开着、两者却不同色」的自相矛盾 —— 实测预选 navy 底的头带时
        皮套还停在默认的 darkgreen(第 129 轮验收抓到)。
        复用点击 chip 时用的同一个 findLinkedEarpad,保证预选结果 = 用户手点的结果。 */
  switch (命.部件) {
    case 'host':        state.base.host = 命.slug; break;
    case 'faceplate':   state.builds[0].faceplate = 命.slug; break;
    case 'headband':
      state.builds[0].headband = 命.slug;
      state.headbandScrollTo = 命.slug;                 // 让 picker 滚到它,否则选中那条在屏幕外
      if (state.headbandLinked) {
        const 同色皮套 = findLinkedEarpad(命.slug, 0);
        if (同色皮套) state.builds[0].earpad = 同色皮套;
      }
      break;
    case 'earpad_full':
    case 'earpad_half': state.builds[0].earpad = 命.slug; break;
    /* 魔尼带默认是【锁定跟随 Build 1 皮套色】的(state.moniStrap.linked)。
       只塞 slug 而不解锁没有任何效果 —— getMoniStrapSlug() 在 linked 时直接返回皮套色,
       把用户挑的那条盖掉(第 129 轮验收抓到:pick 深蓝魔尼带,界面仍是默认的墨绿)。
       用户在界面上手点魔尼带 chip 时,代码本来就会自动解锁(见 `state.moniStrap.linked = false` 那行),
       预选照抄同一行为 —— 他是冲着这条带子来的,不该被锁回皮套色。 */
    case 'moni_strap':  state.moniStrap = { slug: 命.slug, linked: false }; break;
    default: return false;
  }
  return true;
}

// 别人分享来的设计:先还原,再走下面的进站初始化(顺序不能反 —— 头带滚动位置要按还原后的搭配算)
const 来自单件预选 = (function () {
  try {
    const v = new URLSearchParams(location.search).get('pick');
    return applyPickVariant(v) ? String(v).replace(/\D/g, '') : null;
  } catch (e) {
    /* ⚠️ 这里【必须吭声】。第 129 轮踩过:applyPickVariant 里调的 findLinkedEarpad
       用到一个定义在后面的 const(暂时性死区)→ 抛 ReferenceError → 被这个 catch 吞掉,
       预选整个失效而控制台一声不响,只能靠端到端验收才发现。
       catch 保留是对的(预选坏了不该拖垮整个配置器),但不能连报都不报。 */
    console.error('[DIY] ?pick= 预选失败,已退回默认搭配:', e);
    return null;
  }
})();

const 来自分享 = (function () {
  try {
    const q = new URLSearchParams(location.search);
    if (!applyDesignCode(q.get('d'))) return null;
    // m = 祝福语:纯数字 = 预设第几条(省地方);'~' 开头 = 用户自己写的原文
    // t = 关系标签序号,只用来判断【意图】:3 = 送自己(心愿单),其余 = 送人,没有 = 单纯给人看
    var m = q.get('m') || '';
    var t = q.get('t');
    return {
      收礼人: (q.get('to') || q.get('by') || '').slice(0, 24),   // by 是第 119 轮的旧参数名,留着兼容已发出去的链接
      祝福语原文: m.charAt(0) === '~' ? decodeURIComponent(m.slice(1)).slice(0, 90) : '',
      祝福语序号: /^\d+$/.test(m) ? parseInt(m, 10) : -1,
      意图: t === null || t === '' ? '给人看' : (t === '3' ? '想要' : '送人'),
    };
  } catch (e) { return null; }
})();

// 进站态:把头带 picker 滚到「线条系列的后 4 条」(紫蓝/紫黄/绿红/绿黄),一屏 4 条全是线条、不混纯色
// (默认选中的绿红线就在这 4 条里,仍高亮;与面盖/皮套 4 列对齐)
(() => {
  const b1Hb = state.builds[0].headband;
  if (b1Hb && HEADBAND_MAP[b1Hb]) {
    state.headbandTab = HEADBAND_MAP[b1Hb].type;
    // 线条后 4 条的第 1 条 = LINE_PAIRS 倒数第 4 对 → 进站贴左缘,后面 3 条正好补满一屏 4 个
    const [la, lb] = LINE_PAIRS[LINE_PAIRS.length - 4];
    const firstOfLastFourLines = `line-${la}-${lb}`;
    state.headbandScrollTo = HEADBAND_MAP[firstOfLastFourLines] ? firstOfLastFourLines : b1Hb;
    state.headbandScrollMode = 'start';   // chip 贴容器左缘(落在网格点)→ 与面盖/皮套 4 列对齐
  }
})();

// ── 工具函数 ──
const buildComplete = (b) => !!(b.faceplate && b.headband && b.earpad);
const allComplete   = () => buildComplete(state.builds[0]) && buildComplete(state.builds[1]);
// 阶段 A · 魔尼带实际生效色 slug:linked 时跟 Build 1 皮套色;否则用 state.moniStrap.slug 用户独立选
function getMoniStrapSlug() {
  if (state.moniStrap.linked) {
    return state.builds[0].earpad || state.moniStrap.slug;
  }
  return state.moniStrap.slug;
}
// 某个槽位在两副里被用过的 slug(防重复 chip 灰禁用)
const usedSlugs     = (field) => [state.builds[0][field], state.builds[1][field]].filter(Boolean);

// ── 头带 ↔ 皮套 双向同色绑定 ──
// 头带数据已带 baseColor 字段(buildHeadbands 构造时显式标),直接读 map,免靠 slug 拆分约定
function getHeadbandBaseColor(slug) {
  if (!slug) return null;
  return HEADBAND_MAP[slug]?.baseColor || null;
}
/* EARPAD_COLORS 已上移到 HEADBAND_MAP 旁边(第 129 轮)—— 见那里的注释 */
// 第二套配色 = 第一套配色的「CP 搭档」(评分表 D 同调最高对),买两套色调和谐
const SECOND_PAIR = { navy: 'purple', purple: 'navy', darkgreen: 'brown', brown: 'darkgreen' };
// linked 时:皮套色变 → 找同纹理 + 同条色(line)+ 新底色的头带,保留用户原本审美选择
// 优先级:① 原纹理 + 原条色 + 新底色  ② 原纹理 + 新底色 ③ solid + 新底色  ④ 任意新底色非占
function findLinkedHeadband(earpadColor, buildIdx) {
  if (!earpadColor) return null;
  const pool = getHeadbandPool(state.base.host);
  const otherSlug = state.builds[1 - buildIdx].headband;
  const currentHb = state.builds[buildIdx].headband;
  const candidates = [];

  if (currentHb) {
    const parts = currentHb.split('-');
    const series = parts[0];  // solid / line / totem / flower / quantum / ...
    if (series === 'line') {
      // line-{底色}-{条色}:保留条色优先
      const oldAccent = parts[2];
      candidates.push(`line-${earpadColor}-${oldAccent}`);
      // 同底色其他 line
      pool.filter(h => h.type === 'line' && getHeadbandBaseColor(h.slug) === earpadColor)
        .forEach(h => candidates.push(h.slug));
    } else {
      // solid / 设计款:同系列 + 新底色
      candidates.push(`${series}-${earpadColor}`);
    }
  }
  // fallback:solid + 新底色
  candidates.push(`solid-${earpadColor}`);
  // fallback:任意同底色
  pool.filter(h => getHeadbandBaseColor(h.slug) === earpadColor)
    .forEach(h => candidates.push(h.slug));

  for (const slug of candidates) {
    const obj = pool.find(h => h.slug === slug);
    if (obj && !obj.isBonus && slug !== otherSlug) return slug;
  }
  return null;
}
// linked 时:给定头带 slug 反推应配的皮套色(若头带底色是全包 4 色之一)
function findLinkedEarpad(headbandSlug, buildIdx) {
  const color = getHeadbandBaseColor(headbandSlug);
  if (!color || !EARPAD_COLORS.includes(color)) return null;
  const otherSlug = state.builds[1 - buildIdx].earpad;
  if (otherSlug === color) return null;  // 被另一副占了,放弃同步
  return color;
}

// Apple FAQ 风搭配规则卡片文案 — 根据 linked 状态和 build 索引动态生成
function buildLinkCardCopy(buildIdx) {
  const linked = state.headbandLinked;
  const b1ep = state.builds[0].earpad;
  const colorCn = b1ep ? dispName(getColor(b1ep)) : TR('your_earpad');
  // Build 1 还在装 → 不强调"避开"的事,只说同色规则;Build 2 才说"避开第 1 副"
  const isBuild2 = buildIdx === 1;
  if (linked) {
    const paras = isBuild2 && b1ep
      ? [ TR('link_b2_p1'), TR('link_b2_p2', { color: colorCn }), TR('bind_p3') ]
      : [ TR('bind_p1'), TR('bind_p2'), TR('bind_p3') ];
    return {
      title: TR('bind_title'),
      paras,
      action: TR('bind_action'),
    };
  }
  // 解绑态
  const paras = isBuild2 && b1ep
    ? [ TR('unlink_b2_p1'), TR('unlink_b2_p2') ]
    : [ TR('unlink_p1'), TR('unlink_p2') ];
  return {
    title: TR('unlink_title'),
    paras,
    action: TR('unlink_action'),
  };
}

/* ============================================================
   §9 ENUMERATE · 变体枚举(v13 · 从 builds 提取)
   ============================================================ */
// memo:同一帧 render 里 enumerate() 被 9 处调用,key 由 host + 2 副 build 的 7 个槽位拼出
// state 变 → key 变 → 重算;state 不变 → 直接返回缓存。state mutator 不必清缓存(key 自动失配)
let _enumerateMemo = { key: null, value: null };
function enumerate() {
  const host = state.base.host;
  const b0 = state.builds[0], b1 = state.builds[1];
  const memoKey = `${host}|${b0.faceplate}|${b0.earpad}|${b0.headband}|${b1.faceplate}|${b1.earpad}|${b1.headband}`;
  if (_enumerateMemo.key === memoKey) return _enumerateMemo.value;
  const halfEarpad   = LOCKED_PAIRS[host];          // 半包皮套(锁主机色)
  const lockedHb     = `solid-${halfEarpad}`;       // 标配纯色头带

  const fps = [b0.faceplate, b1.faceplate].filter(Boolean);
  const eps = [b0.earpad,    b1.earpad   ].filter(Boolean);
  const customHbs = [b0.headband, b1.headband].filter(Boolean);
  const headbands = [lockedHb, ...customHbs];       // 标配 + 加购 = 3 条(全装齐时)

  const variants = [];

  // 全包耳先排(图全, byBuild 标记的"亲手装"也都在这):1 × 面盖 × 皮套 × headbands
  if (fps.length && eps.length) {
    for (const fp of fps) for (const ep of eps) for (const hb of headbands) {
      let byBuild = -1;
      if (buildComplete(b0) && b0.faceplate === fp && b0.earpad === ep && b0.headband === hb) byBuild = 0;
      else if (buildComplete(b1) && b1.faceplate === fp && b1.earpad === ep && b1.headband === hb) byBuild = 1;
      variants.push({ form: 'overear', host, faceplate: fp, earpad: ep, headband: hb, byBuild });
    }
  }
  // 半包耳排后(皮套适配图缺,先放完整全包变体让第 1 张有图)
  for (const hb of headbands) {
    variants.push({ form: 'halfear', host, earpad: halfEarpad, faceplate: null, headband: hb, byBuild: -1 });
  }
  // 把"亲手装的第 1/2 副"(byBuild=0/1)排到最前,其余 13 串色按原枚举顺序排后(sort 稳定)
  variants.sort((a, b) => {
    const ar = a.byBuild >= 0 ? a.byBuild : 99;
    const br = b.byBuild >= 0 ? b.byBuild : 99;
    return ar - br;
  });
  _enumerateMemo = { key: memoKey, value: variants };
  return variants;
}

/* ============================================================
   §10.5 搭配星级评分(SoT:记忆/平台知识/搭配星级评分表.md)
   ------------------------------------------------------------
   合成公式(2026-06-13 用户拍板权重,表 E 加进公式):
     整机星级 = 0.35×配色(表A) + 0.20×面盖(表B) + 0.25×配色×面盖(表E) + 0.20×图案(表C)
     熔断:任一维度 ≤ 3.0 → 整机排除(excluded=true)
     第二套星级 = 0.7×自身整机 + 0.3×两套配色和谐(表D)
   key 用 slug:主机/面盖 = silver/desertyellow/babyblue/green;配色 = navy/darkgreen/purple/brown
   ============================================================ */
// 表 A · 主机 × 配色(头带底色=皮套色)
const TABLE_A = {
  silver:       { navy: 5.0,  darkgreen: 5.0, purple: 5.0, brown: 5.0 },
  desertyellow: { navy: 4.25, darkgreen: 5.0,  purple: 4.25, brown: 5.0 },
  babyblue:     { navy: 4.5,  darkgreen: 4.0, purple: 5.0, brown: 3.5 },
  green:        { navy: 4.5,  darkgreen: 5.0, purple: 3.5, brown: 5.0 },
};
// 表 B · 主机 × 面盖
const TABLE_B = {
  silver:       { silver: 5.0, desertyellow: 4.25, babyblue: 4.25, green: 4.25 },
  desertyellow: { silver: 5.0, desertyellow: 5.0,  babyblue: 4.0,  green: 4.5  },
  babyblue:     { silver: 5.0, desertyellow: 3.5,  babyblue: 5.0,  green: 4.0  },
  green:        { silver: 5.0, desertyellow: 4.5,  babyblue: 4.25, green: 5.0  },
};
// 表 E · 配色 × 面盖(用户最看重的一张:两个配件之间搭不搭)
const TABLE_E = {
  navy:      { silver: 5.0, desertyellow: 4.0, babyblue: 4.75, green: 4.75 },
  darkgreen: { silver: 5.0, desertyellow: 5.0, babyblue: 4.0,  green: 5.0 },
  purple:    { silver: 5.0, desertyellow: 4.0, babyblue: 5.0,  green: 3.5 },
  brown:     { silver: 5.0, desertyellow: 5.0, babyblue: 3.5,  green: 5.0 },
};
// 表 C · 头带图案系列颜值(系列级,线条 8 款并进 1 分=5;决策点①②)
const PATTERN_SCORE = {
  solid: 4.0, line: 5.0, totem: 4.75, liuli: 5.0, quantum: 4.75,
  fluid: 5.0, cube: 4.75, flower: 5.0, youth: 4.5, time: 4.75,
};
// 表 D · 两套配色和谐(无序对,买两套时用);键名按字母序排
const PAIR_HARMONY = {
  'darkgreen|navy': 4.0, 'navy|purple': 5.0, 'brown|navy': 3.0,
  'darkgreen|purple': 4.0, 'brown|darkgreen': 5.0, 'brown|purple': 3.0,
};
const RATING_WEIGHTS = { color: 0.35, faceplate: 0.20, colorface: 0.25, pattern: 0.20 };
const RATING_FUSE = 3.0;   // 熔断线:任一维度 ≤ 此值 → 排除
const CROSS_CAP = 4.5;     // 撞色封顶:头带底色 ≠ 皮套色 → 整机分最高 4.5(2026-06-15 用户拍板,含原 3 条 override 例外一视同仁)

// 头带 slug 第一段 = 图案系列 key(solid/line/totem/...)
const patternKey = (hbSlug) => (hbSlug || '').split('-')[0];

// 两套配色和谐分(无序;同色给中性 4.0)
function pairHarmony(c1, c2) {
  if (!c1 || !c2) return 4.0;
  if (c1 === c2) return 4.0;
  return PAIR_HARMONY[[c1, c2].sort().join('|')] ?? 4.0;
}

// —— 串色三层覆盖(表 G):override > 系列包容度 > 表F底色 ——
// 表 F · 头带底色 × 皮套色(串色基础分,无序;同色=5.0 绝配,不扣分)
const CROSS_HARMONY = {
  'darkgreen|navy': 4.0, 'navy|purple': 4.5, 'brown|navy': 4.0,
  'darkgreen|purple': 4.0, 'brown|darkgreen': 4.25, 'brown|purple': 3.5,
};
// 表 G-1 · 图案系列串色包容度(0=照扣 / 1=完全不扣)。满彩图案串色无所谓,纯色串色扎眼
const SERIES_TOLERANCE = {
  solid: 0, line: 0.4, totem: 0.7, liuli: 1.0, quantum: 0.7,
  fluid: 1.0, cube: 0.7, flower: 1.0, youth: 0.4, time: 0.7,
};
// 表 G-2 · 单条头带 × 串色皮套 override(钉死分,盖过系列/底色;key=完整 headband slug)
const CROSS_OVERRIDE = {
  'line-brown-green':   { darkgreen: 4.75 },   // 棕绿线 配 墨绿皮套
  'line-navy-red':      { purple:    4.75 },   // 蓝红线 配 深紫皮套
  'line-darkgreen-red': { brown:     4.6 },    // 绿红线 配 深棕皮套(2026-06-16 用户:4.75→4.6,底子满分时整机=4.6)
};
// 三层取串色分:① 单条 override → ② 系列包容度削弱表F损失 → ③ 表F底色默认;同色恒 5.0
function crossScore(hbBase, earpad, hbSlug) {
  if (!hbBase || !earpad || hbBase === earpad) return 5.0;        // 同色不串,不扣分
  const ov = hbSlug && CROSS_OVERRIDE[hbSlug] && CROSS_OVERRIDE[hbSlug][earpad];
  if (ov != null) return ov;                                      // ① 单条钉死
  const f = CROSS_HARMONY[[hbBase, earpad].sort().join('|')] ?? 5.0;  // ③ 表F底色
  const tol = SERIES_TOLERANCE[patternKey(hbSlug)] ?? 0;          // ② 系列包容度
  const loss = (1 - f / 5) * (1 - tol);                           // 包容度越高,串色损失越小
  return Math.round(5 * (1 - loss) * 100) / 100;
}

// 表 J · 主机 × 头带颜色 呼应分(默认值,用户 2026-06-14"用默认"):头带含色越呼应主机,越能豁免串色
const ECHO_HOST = {
  brown:     { silver: 4.75, desertyellow: 5.0, babyblue: 3.5, green: 4.5 },
  navy:      { silver: 5.0,  desertyellow: 3.5, babyblue: 5.0, green: 4.0 },
  purple:    { silver: 4.75, desertyellow: 3.5, babyblue: 4.5, green: 3.5 },
  darkgreen: { silver: 4.75, desertyellow: 4.0, babyblue: 4.0, green: 5.0 },
  yellow:    { silver: 4.75, desertyellow: 5.0, babyblue: 3.5, green: 4.5 },   // 线条副色
  red:       { silver: 4.5,  desertyellow: 4.5, babyblue: 3.5, green: 4.0 },   // 线条副色
  green:     { silver: 4.75, desertyellow: 4.5, babyblue: 4.0, green: 5.0 },   // 线条副色(≠墨绿底色)
};
// 头带含的颜色 token(只纯色/线条;设计款返回 null = 暂不参与呼应豁免)
function headbandColors(slug) {
  if (!slug) return null;
  const seg = slug.split('-');
  if (seg[0] === 'solid') return [seg[1]];           // solid-brown → [brown]
  if (seg[0] === 'line')  return [seg[1], seg[2]];   // line-brown-yellow → [brown, yellow]
  return null;
}
// 头带含色里"最呼应主机"的分(无数据返回 null)
function echoHost(host, hbSlug) {
  const colors = headbandColors(hbSlug);
  if (!colors || !host) return null;
  let best = null;
  for (const c of colors) {
    const s = ECHO_HOST[c] && ECHO_HOST[c][host];
    if (s != null && (best == null || s > best)) best = s;
  }
  return best;
}
// 串色分 + 呼应豁免(表J):头带呼应主机 → 豁免三成串色损失(只升不降,同色不受影响)
const ECHO_RELIEF = 0.3;   // 豁免力度:0.5 豁免一半 / 0.3 三成 / 0.2 更少;用户 2026-06-14 觉得 0.5 太多 → 0.3
function crossWithEcho(v) {
  let cross = crossScore(getHeadbandBaseColor(v.headband), v.earpad, v.headband);
  const echo = echoHost(v.host, v.headband);
  if (echo != null && echo > cross) cross = Math.round((cross + (echo - cross) * ECHO_RELIEF) * 100) / 100;
  return cross;
}

// 给一个变体打整机星级。
// 半包耳:标配纯色头带那条 = 标准款 → 不打星(返回 null,卡片仍显示);换设计款头带则评分(无面盖,配色/图案各半 × 串色)
// 全包耳:4 维加权 × 串色
// 返回 { score, excluded, dims, cross, half? } 或 null(数据缺 / 标准款)
function scoreBuild(v) {
  if (!v || !v.earpad || !v.headband) return null;

  // —— 半包耳(无面盖)——
  if (v.form === 'halfear') {
    if (v.headband === `solid-${v.earpad}`) return null;    // 标准款(主机标配纯色头带)不打星
    const color   = TABLE_A[v.host]?.[v.earpad];
    const pattern = PATTERN_SCORE[patternKey(v.headband)] ?? 4.0;
    if (color == null) return null;
    const cross = crossWithEcho(v);
    const raw = (0.5 * color + 0.5 * pattern) * (cross / 5);   // 无面盖:配色/图案各 50%,再乘串色
    const excluded = color <= RATING_FUSE || pattern <= RATING_FUSE || cross <= RATING_FUSE;
    let score = Math.round(raw * 10) / 10;
    const base = getHeadbandBaseColor(v.headband);
    const isOv = !!(v.headband && CROSS_OVERRIDE[v.headband] && CROSS_OVERRIDE[v.headband][v.earpad] != null);
    if (base && base !== v.earpad && !isOv) score = Math.min(score, CROSS_CAP);   // 撞色封顶 4.5(override 优待 3 条豁免)
    return { score, excluded, dims: { color, pattern }, cross, half: true };
  }

  // —— 全包耳 ——
  if (!v.faceplate) return null;
  const color     = TABLE_A[v.host]?.[v.earpad];
  const face      = TABLE_B[v.host]?.[v.faceplate];
  const colorface = TABLE_E[v.earpad]?.[v.faceplate];
  const pattern   = PATTERN_SCORE[patternKey(v.headband)] ?? 4.0;
  if (color == null || face == null || colorface == null) return null;   // 数据缺,不瞎打分
  const dims = { color, face, colorface, pattern };
  const excluded = [color, face, colorface, pattern].some(x => x <= RATING_FUSE);
  let raw = RATING_WEIGHTS.color * color + RATING_WEIGHTS.faceplate * face
          + RATING_WEIGHTS.colorface * colorface + RATING_WEIGHTS.pattern * pattern;
  // 串色三层(表G):头带底色 ≠ 皮套色 → 整机 ×(串色分÷5);同色系数 1.0 不影响
  const cross = crossWithEcho(v);
  raw = raw * (cross / 5);
  let score = Math.round(raw * 10) / 10;
  const base = getHeadbandBaseColor(v.headband);
  const isOv = !!(v.headband && CROSS_OVERRIDE[v.headband] && CROSS_OVERRIDE[v.headband][v.earpad] != null);
  if (base && base !== v.earpad && !isOv) score = Math.min(score, CROSS_CAP);   // 撞色封顶 4.5(override 优待 3 条豁免)
  return { score, excluded, dims, cross };
}

// 第二套星级 = 0.7×自身整机 + 0.3×两套和谐(表D)。c0=第一套配色
function scoreSecondKit(c0, v1) {
  const sb = scoreBuild(v1);
  if (!sb) return null;
  const s = 0.7 * sb.score + 0.3 * pairHarmony(c0, v1.earpad);
  return { score: Math.round(s * 10) / 10, excluded: sb.excluded, own: sb.score };
}

// 智能推荐第二套:枚举「避开第一套配色 + 头带底色=该套配色」的组合,挑「第二套星级」最高那套
// 返回 { faceplate, earpad, headband } 或 null
function pickBestSecondKit(host, b0) {
  const pool = getHeadbandPool(host);
  const fpSlugs = FACEPLATES.map(f => f.slug);
  let best = null, bestScore = -1;
  for (const epColor of EARPAD_COLORS) {
    if (epColor === b0.earpad) continue;                 // 避开第一套配色(撞色)
    for (const fp of fpSlugs) {
      if (fp === b0.faceplate) continue;                 // 第二套面盖不跟第一套同色(两套视觉区分;同分时自动换色)
      for (const hb of pool) {
        if (hb.isBonus) continue;                        // 标配赠送那条不参与
        if (getHeadbandBaseColor(hb.slug) !== epColor) continue;   // 头带底色须=该套配色(整体感最强)
        const v1 = { form: 'overear', host, faceplate: fp, earpad: epColor, headband: hb.slug };
        const s2 = scoreSecondKit(b0.earpad, v1);
        if (!s2 || s2.excluded) continue;                // 跳过熔断组合
        if (s2.score > bestScore) {
          bestScore = s2.score;
          best = { faceplate: fp, earpad: epColor, headband: hb.slug };
        }
      }
    }
  }
  return best;
}

// 星级 HTML —— 5 星条(金色按比例覆盖)+ 数字。size: 'sm'(图卡角标) / 'md'(预览区)
function starRatingHTML(score, size = 'md') {
  if (score == null) return '';
  const pct = Math.max(0, Math.min(100, (score / 5) * 100));
  return `<span class="star-rating star-rating--${size}" title="Rainbow Style Score ${score}" aria-label="Rainbow Style Score ${score}">`
       + `<span class="star-rating__stars">`
       +   `<span class="star-rating__sizer">★★★★★</span>`
       +   `<span class="star-rating__base">★★★★★</span>`
       +   `<span class="star-rating__fill" style="width:${pct.toFixed(2)}%">★★★★★</span>`
       + `</span>`
       + `<span class="star-rating__num">${score.toFixed(1)}</span></span>`;
}

// —— Style Score 升级(2026-06-14,表 H):风格标签 + 点评文案;底层评分算法一律不动 ——
// 双轴:冷暖(主机+皮套) × 张力(面盖+图案) → 风格名(用户拍板照草稿)
const STYLE_NAMES = {
  warm:    { calm: '复古暖调', bold: '暖调多巴胺' },
  natural: { calm: '自然学院', bold: '野趣丛林' },
  cool:    { calm: '极简未来', bold: '冷感先锋' },
};
const CALM_PATTERNS = new Set(['solid', 'line']);   // 克制图案;其余满彩系列 = 张扬
function styleTag(v) {
  if (!v || !v.host || !v.earpad || !v.headband) return '';
  // 轴1 冷暖(主机 + 皮套)
  let temp;
  if (v.host === 'desertyellow' || v.earpad === 'brown') temp = 'warm';
  else if (v.host === 'green' || v.earpad === 'darkgreen') temp = 'natural';
  else temp = 'cool';
  // 轴2 张力:银面盖(或半包无面盖)+ 纯色/线条 = 克制;否则张扬
  const calmFace = !v.faceplate || v.faceplate === 'silver';
  const calmPat = CALM_PATTERNS.has(patternKey(v.headband));
  const tension = (calmFace && calmPat) ? 'calm' : 'bold';
  return STYLE_NAMES[temp][tension];
}
// ===== 专属作品名(表 K)· 种子选词:每模块多候选,整套组合做种子确定性选词 =====
// 皮套底色候选(每色 4 个同色系词)
const NAME_COLOR_POOL = {
  navy:      ['深海', '靛蓝', '午夜', '藏青'],
  darkgreen: ['森林', '墨林', '苔原', '松霭'],
  purple:    ['紫夜', '幽紫', '葡紫', '黛紫'],
  brown:     ['赤土', '栗褐', '可可', '檀褐'],
};
// 皮套底色英文(氛围色词,ALL CAPS;与中文逐位对应,同 index 同义)
const NAME_COLOR_POOL_EN = {
  navy:      ['ABYSS', 'INDIGO', 'MIDNIGHT', 'INK'],
  darkgreen: ['FOREST', 'PINE', 'MOSS', 'FERN'],
  purple:    ['DUSK', 'ORCHID', 'PLUM', 'IRIS'],
  brown:     ['TERRA', 'CHESTNUT', 'COCOA', 'UMBER'],
};
// 头带系列候选(每系列 4 个同图案感词)
// 设计款每系列 8 词:前 4 = 底色 navy/darkgreen/purple/brown 的「图案向」词,后 4 = 对应底色的「颜色/质感向」词
// 每款取 [底色 index] 与 [底色 index+4] 两候选 → 同系列各款候选池零重叠,必不同名
const NAME_SERIES_POOL = {
  // 以下 8 系列词据实际图案重拟(2026-06-16 看色卡):前 4 / 后 4 各对应 navy/darkgreen/purple/brown 款
  liuli:  ['琉璃', '釉彩', '晶窗', '彩窗', '澄光', '流釉', '镶嵌', '光格'],  // 彩绘玻璃马赛克方块
  quantum:['涟漪', '光晕', '波环', '辉斑', '晕圈', '星涡', '光圈', '涡环'],  // 发光同心圆/涟漪光晕
  cube:   ['像素', '方阵', '棋格', '积木', '色格', '矩格', '方砖', '格子'],  // 彩色像素方块矩阵
  fluid:  ['漩涡', '流纹', '云石', '旋纹', '水痕', '卷涡', '流淌', '涡旋'],  // 旋转水滴/大理石漩涡
  totem:  ['鳞羽', '层云', '叠羽', '扇纹', '鳞纹', '翎羽', '叠浪', '羽冠'],  // 层叠鳞片/羽片扇形
  flower: ['花语', '花影', '飞花', '落英', '绽蕊', '簇锦', '芳序', '繁英'],  // 花瓣/飞花剪影散布
  youth:  ['涂鸦', '波普', '律动', '街头', '跃动', '潮纹', '几何', '霓虹'],  // 孟菲斯涂鸦几何碎片
  time:   ['流年', '流光', '极光', '霓光', '虹彩', '曲光', '流韵', '漾光'],  // 流动光带/极光
  // 线条 16 词:每款 2 个,呼应该款亮纹色(LINE_PAIRS 顺序,款 i 取 [2i] [2i+1])
  line:   ['流金', '麦芒', '青脉', '苔芒', '红芒', '红影', '鎏金', '星芒',
           '靛痕', '蓝弦', '暖芒', '流晖', '嫣红', '红晕', '晖金', '穗光'],
  // 纯色 8 词:每款 2 个纯粹质感词(款 i 取 [2i] [2i+1])
  solid:  ['本色', '素直', '纯粹', '澄明', '原色', '凝素', '质朴', '本真'],
};
// 头带英文(图案词,ALL CAPS;与中文 NAME_SERIES_POOL 逐位对应,同 index)
const NAME_SERIES_POOL_EN = {
  liuli:  ['GLAZE', 'ENAMEL', 'CRYSTAL', 'STAINED', 'LUSTRE', 'GLOSS', 'MOSAIC', 'FACET'],     // 彩绘玻璃马赛克
  quantum:['RIPPLE', 'HALO', 'WAVE', 'GLEAM', 'AURA', 'NEBULA', 'CORONA', 'ECHO'],             // 同心圆涟漪光晕
  cube:   ['PIXEL', 'MATRIX', 'CHECKER', 'BLOCK', 'TILE', 'GRID', 'BRICK', 'SQUARE'],          // 彩色像素方块
  fluid:  ['SWIRL', 'MARBLE', 'ONYX', 'EDDY', 'FLUX', 'CURL', 'FLOW', 'SPIRAL'],               // 大理石漩涡
  totem:  ['PLUME', 'STRATA', 'FEATHER', 'FAN', 'SCALE', 'QUILL', 'TIDE', 'CREST'],            // 层叠鳞片羽片
  flower: ['BLOOM', 'PETAL', 'BLOSSOM', 'FLEUR', 'FLORA', 'POSY', 'GARDEN', 'BOUQUET'],        // 花瓣飞花剪影
  youth:  ['GRAFFITI', 'POP', 'GROOVE', 'URBAN', 'JIVE', 'RETRO', 'MEMPHIS', 'NEON'],          // 孟菲斯涂鸦
  time:   ['AURORA', 'SHIMMER', 'BOREALIS', 'GLOW', 'PRISM', 'BEAM', 'LUMEN', 'GLIMMER'],      // 流动光带极光
  // 线条 16 词:每款 2 个,呼应该款亮纹色(直白色词;红纹用直白红词)
  line:   ['GOLD', 'AMBER', 'JADE', 'SAGE', 'RUBY', 'CRIMSON', 'SOLAR', 'TOPAZ',
           'AZURE', 'COBALT', 'SAFFRON', 'HONEY', 'SCARLET', 'VERMILION', 'CITRINE', 'GLINT'],
  // 纯色 8 词:每款 2 个纯粹质感词
  solid:  ['PURE', 'PLAIN', 'ESSENCE', 'CLEAR', 'TONE', 'MATTE', 'RAW', 'TRUE'],
};
// 中英显示开关:'dev' = 英文为主 + 中文小字(开发期);'en' = 纯英文(上线切此)
const NAME_LANG = 'dev';
function nameHash(str, salt) {
  let h = 5381 + salt;
  for (let i = 0; i < str.length; i++) h = ((h << 5) + h + str.charCodeAt(i)) >>> 0;
  return h;
}
// 头带「每一款」一个词:设计款/纯色按底色 index 分(同系列 4 款必不同词);线条 8 款按 slug hash 分
const DEEP_COLOR_IDX = { navy: 0, darkgreen: 1, purple: 2, brown: 3 };
// 线条 8 款固定序号(对齐 LINE_PAIRS 顺序)→ 8 款各占 line 池一词,不撞;LINE_PAIRS 改动时同步
const LINE_IDX = {
  'line-brown-yellow': 0, 'line-brown-green': 1,
  'line-navy-red': 2,     'line-navy-yellow': 3,
  'line-purple-navy': 4,  'line-purple-yellow': 5,
  'line-darkgreen-red': 6,'line-darkgreen-yellow': 7,
};
// 头带款 → {系列 key, 选中的池内 index}。中英共用此 index → 同义不错位
function seriesPick(hbSlug, seed) {
  const key = patternKey(hbSlug);
  const len = (NAME_SERIES_POOL[key] || []).length;
  if (!len) return null;
  let candIdx;
  if (key === 'line') {                                   // 线条:款 i 取 [2i] [2i+1],呼应亮纹色
    const li = (LINE_IDX[hbSlug] != null) ? LINE_IDX[hbSlug] : (nameHash(hbSlug, 3) % 8);
    candIdx = [(li * 2) % len, (li * 2 + 1) % len];
  } else if (key === 'solid') {                           // 纯色:款 i 取 [2i] [2i+1]
    const i = DEEP_COLOR_IDX[hbSlug.split('-')[1]] ?? 0;
    candIdx = [(i * 2) % len, (i * 2 + 1) % len];
  } else {                                                // 设计款:底色 i 取 [i] [i+4]
    const di = DEEP_COLOR_IDX[hbSlug.split('-')[1]];
    const i = (di != null) ? di : (nameHash(hbSlug, 3) % 4);
    candIdx = [i % len, (i + 4) % len];
  }
  return { key, idx: candIdx[nameHash(seed, 2) % 2] };
}
function seriesWord(hbSlug, seed) {                        // 中文头带词
  const p = seriesPick(hbSlug, seed);
  return p ? NAME_SERIES_POOL[p.key][p.idx] : '';
}
function seriesWordEN(hbSlug, seed) {                      // 英文头带词(同 index)
  const p = seriesPick(hbSlug, seed);
  return p ? NAME_SERIES_POOL_EN[p.key][p.idx] : '';
}
// 作品名 = 皮套色候选词(整套 seed 选)+ 头带款 2 候选词(整套 seed 选)
// → 不同头带款必不同名(候选池零重叠);换任一件名字可能变;同组合永远同名
function designName(v) {                                   // 中文作品名(SoT,如「森林琉璃」)
  if (!v || !v.earpad || !v.headband) return '';
  const cpool = NAME_COLOR_POOL[v.earpad];
  if (!cpool) return '';
  const seed = `${v.host}|${v.earpad}|${v.faceplate || ''}|${v.headband}|${v.form}`;
  const sword = seriesWord(v.headband, seed);
  if (!sword) return '';
  return cpool[nameHash(seed, 1) % cpool.length] + sword;
}
function designNameEN(v) {                                 // 英文作品名(如「FOREST GLAZE」),与中文同 index
  if (!v || !v.earpad || !v.headband) return '';
  const cpool = NAME_COLOR_POOL_EN[v.earpad];
  if (!cpool) return '';
  const seed = `${v.host}|${v.earpad}|${v.faceplate || ''}|${v.headband}|${v.form}`;
  const sword = seriesWordEN(v.headband, seed);
  if (!sword) return '';
  return cpool[nameHash(seed, 1) % cpool.length] + ' ' + sword;
}
// 维度夸词(克制口吻);取这套分最高的维度夸一句
const STYLE_PRAISE = {
  color:     '主机和配色基调统一,整体气质立得住',
  face:      '面盖选得讲究,质感更高',
  colorface: '配色和面盖呼应到位,干净高级',
  pattern:   '头带图案有个性,又不抢整体',
};
function reviewText(sb, v) {
  if (!sb) return '';
  const tag = styleTag(v);
  const head = tag ? `这套属于「${tag}」。` : '';
  if (sb.score >= 5) return `${head}教科书级搭配,官方精选。`;
  const dims = sb.dims || {};
  let topKey = null, topVal = -1;
  for (const k in dims) { if (dims[k] > topVal) { topVal = dims[k]; topKey = k; } }
  const praise = STYLE_PRAISE[topKey] || '整体搭配协调';
  let warn = '';
  if (sb.cross != null && sb.cross < 5) warn = '头带和皮套有点撞色,换同色会更稳';
  else { for (const k in dims) { if (dims[k] <= 3.5) { warn = '有个颜色稍冲,可以再微调'; break; } } }
  return `${head}${praise}。${warn ? warn + '。' : ''}`;
}

/* ============================================================
   §9.5 全屏卡 6 字段文案生成(用户 2026-06-24,照参考图 COCOA AMBER)
   —— 复用既有命名词池(NAME_COLOR_POOL_EN / 头带系列词),只新增大标题/副标题/中英正文
   ============================================================ */
// 主机/面盖「展示用」英文营销名:贴合用户参考图(后台契约名 HOST_EN 仍是 Desert Yellow 等,勿混用)
const HOST_DISPLAY_EN = {
  silver:       'Starry Silver',
  desertyellow: 'Desert Gold',   // 参考图把"大漠黄"美化成 Desert Gold(契约名是 Desert Yellow)
  babyblue:     'Serene Blue',
  green:        'Retro Green',
};
function seedOf(v) { return `${v.host}|${v.earpad}|${v.faceplate || ''}|${v.headband}|${v.form}`; }
// 这套整组合选中的皮套色英文词(与产品名同一个词,如 COCOA),供正文/标题复用
function earpadWordEN(v) {
  const cpool = NAME_COLOR_POOL_EN[v.earpad];
  if (!cpool) return '';
  return cpool[nameHash(seedOf(v), 1) % cpool.length];
}
function titleCaseWord(w) { return w ? w[0] + w.slice(1).toLowerCase() : ''; }
// 头带底色家族(slug 第 2 段:solid-navy / line-brown-yellow / totem-navy → navy/brown/navy)
function headbandBase(hbSlug) { return (hbSlug || '').split('-')[1] || ''; }
// 4. 大标题:皮套色词(主色)+ 头带词(次色)套优雅句式,hash 选,ALL CAPS
const TITLE_TPL_EN = [
  (c, a) => `SHADES OF ${c}`,
  (c, a) => `${c} & ${a}`,
  (c, a) => `BETWEEN ${c} AND ${a}`,
  (c, a) => `A STUDY IN ${c}`,
  (c, a) => `NOTES OF ${c}`,
];
function designTitleEN(v) {
  if (!v || !v.earpad || !v.headband) return '';
  const c = earpadWordEN(v);
  const a = seriesWordEN(v.headband, seedOf(v));
  if (!c || !a) return '';
  return TITLE_TPL_EN[nameHash(seedOf(v), 5) % TITLE_TPL_EN.length](c, a);
}
// 5. 副标题:品牌意境短句池,hash 选,每副不同
const SUBTITLE_POOL_EN = [
  'A palette you can wear.',
  'Colour, composed by you.',
  'Where colour finds its calm.',
  'Your colours, your way.',
  'Every pair, one of one.',
  'Wear your own spectrum.',
  'Made to be remade.',
  'One palette, endless pairs.',
  'Colour that moves with you.',
  'Built by you. Worn by you.',
];
function designSubtitleEN(v) {
  return SUBTITLE_POOL_EN[nameHash(seedOf(v), 6) % SUBTITLE_POOL_EN.length];
}
// 6a. 中文正文:主机 × 头带 × 皮套 × 面盖,配色关系,评级,Style Score(照参考图语序)
function designBodyCN(v, sb) {
  if (!v) return '';
  try {
    const hostCN = getColor(v.host).cn;
    const hbCN   = getColor(v.headband).cn;
    const epCN   = getColor(v.earpad).cn.replace(/色$/, '');   // 深棕色 → 深棕
    const same   = headbandBase(v.headband) === v.earpad;
    const rel    = same ? '头带与皮套同色系,沉稳统一' : '头带与皮套撞色碰撞,层次张扬';
    const score  = sb ? sb.score.toFixed(1) : '';
    let grade = '协调好搭';
    if (sb) { if (sb.score >= 5) grade = '教科书级绝配'; else if (sb.score >= 4.5) grade = '高分搭配,耐看'; }
    let s = `${hostCN}主机 × ${hbCN}头带 × ${epCN}皮套`;
    if (v.faceplate) s += ` × ${getColor(v.faceplate).cn}面盖`;
    s += `,${rel},${grade}`;
    if (score) s += `,Rainbow Style Score ${score} 星`;
    return s + '。';
  } catch (e) { return ''; }
}
// 6b. 英文正文:逐配件展示名(主机/面盖=营销名,皮套=色词,头带=色词+图案词),照参考图
function designBodyEN(v, sb) {
  if (!v) return '';
  try {
    const tw = titleCaseWord(earpadWordEN(v));                  // Cocoa
    const aw = seriesWordEN(v.headband, seedOf(v));             // AMBER
    const parts = [`${HOST_DISPLAY_EN[v.host] || ''} host`];
    if (v.faceplate) parts.push(`${HOST_DISPLAY_EN[v.faceplate] || ''} faceplate`);
    parts.push(`${tw} earpads`);
    parts.push(`${tw} ${aw} headband`);                          // Cocoa AMBER
    const score = sb ? sb.score.toFixed(1) : '';
    return parts.join(', ') + '.';   // 删掉 ". Rainbow Style Score X.X." 句:左上角已有星级徽章,重复;腾出右下空间给签名(用户 2026-06-28)
  } catch (e) { return ''; }
}

/* ============================================================
   §10 PRICE(v13 · 超级套装固定基价 + extras)
   ============================================================ */
function totalPrice() {
  // 超级套装:1 主机 + 标配 + 2 面盖 + 2 全包皮套 + 2 头带,固定基价
  let p = PRICE.base + PRICE.faceplate + PRICE.earpad + PRICE.headband;
  p += state.extras.extraHosts * PRICE.extraHost;
  if (state.extras.moniStrap) p += PRICE.moniStrap;
  return p;
}

/* ============================================================
   §11 LOOKUP HELPERS
   ============================================================ */
const $ = sel => document.querySelector(sel);
const HOST_MAP = Object.fromEntries(HOSTS.map(h => [h.slug, h]));
const EARPAD_MAP = Object.fromEntries(EARPADS.map(e => [e.slug, e]));

// 任意 slug 的色值/中文名(自动判断属于哪个池)
// fallback 时 warn,免 typo 把 slug 当中文名直接喷到 UI 上没人发现
function getColor(slug) {
  const hit = HOST_MAP[slug] || EARPAD_MAP[slug] || HEADBAND_MAP[slug];
  if (hit) return hit;
  console.warn(`[getColor] 未知 slug: ${slug}, 走 fallback`);
  return { cn: slug, hex: '#888' };
}

// Build 槽位定义:每副耳机要选 3 件(label 用图标 + tooltip,省横向空间)
const BUILD_SLOTS = [
  { key: 'headband',  label: (PARTW[LOCALE] || PARTW.en).headband,  icon: '➰', type: 'headband', pool: () => getHeadbandPool(state.base.host) },
  { key: 'faceplate', label: (PARTW[LOCALE] || PARTW.en).faceplate, icon: '◉', type: 'color',    pool: () => FACEPLATES },
  { key: 'earpad',    label: (PARTW[LOCALE] || PARTW.en).earpad,    icon: '◆', type: 'color',    pool: () => EARPADS },
];

/* ============================================================
   §12 RENDER
   ============================================================ */
let prevVariantsLen = 0;

function renderHero() {
  // 第 3 步的加价跟文件夹上方胶囊用同一个算法(折后实付);放这里不放 applyStaticI18n:那边跑得早,
  // DISCOUNT_RATE / DIY_PRICES 还在暂时性死区,一调就 ReferenceError。繁中由 startTradWatcher 自动转。
  const step3El = $('[data-i18n="step3"]');
  if (step3El) { const t = TR(黑五中() ? 'step3_bf' : 'step3', { add: kit2ExtraCost() }); if (step3El.textContent !== t) step3El.textContent = t; }
  // v15.4 · 同步 .hero__faq 整张卡的展开/收起态(data-expanded 驱动 CSS)
  const faq   = $('.hero__faq');
  const guide = $('#hero-guide');
  if (faq && guide) {
    const open = state.heroGuideOpen;
    faq.setAttribute('data-expanded', open ? 'true' : 'false');
    faq.setAttribute('aria-expanded', open);
    if (open) guide.removeAttribute('hidden');
    else      guide.setAttribute('hidden', '');
  }
}

function renderVariants() {
  const allVariants = enumerate();
  // 2026-05-20:半包耳皮套 4 张 + 半包主机 4 张已到位,8 张缺口补齐
  // 全包耳 4 层 + 半包耳 3 层 PNG 都全,恢复 isFullVariant 过滤
  const variants = allVariants.filter(isFullVariant);
  const grid = $('#variants-grid');
  const grew = variants.length > prevVariantsLen;
  prevVariantsLen = variants.length;

  if (variants.length === 0) {
    grid.innerHTML = `<div class="variants__empty" style="flex:1;">${TR('variants_empty')}</div>`;
    updateVariantsTrack();
    return;
  }

  // 一次性渲染全部变体(手指横滑切换),下方进度条根据 scroll 位置实时更新
  const pageItems = variants.map((v, i) => ({ v, idx: i }));
  // v15.33 · shadow 已经在 HTML 静态写在 .variants__strip 内,不再每次 render 都插进 grid
  grid.innerHTML = pageItems.map(({ v, idx: globalIdx }) => {
    // 4 层 PNG 适配图(缺图走 fallback 'none' → 该层透明)
    const imgHost = adaptImg('host', v.host, v.form);
    const imgFp   = v.faceplate ? adaptImg('faceplate', v.faceplate, v.form) : 'none';
    const imgEp   = adaptImg('earpad', v.earpad, v.form);
    const imgHb   = adaptImg('headband', v.headband, v.form);
    // 头带无适配图时,几何 fallback 用 hex 色显示一条头带横条
    const hbHex   = getColor(v.headband).hex;
    const hbFbCls = imgHb === 'none' ? ' is-fb' : '';
    // 👐 角标:byBuild=0/1 表示这个变体就是客户亲手装的那 2 副之一
    const handBadge = v.byBuild === 0 ? `<span class="variant__hand">👐 ${TR('kit1_short')}</span>`
                    : v.byBuild === 1 ? `<span class="variant__hand">👐 ${TR('kit2_short')}</span>`
                    : '';
    // 屏幕阅读器可读:形态 + 客户亲手装标记 + 4 件 cn 描述
    const ariaSegs = [v.form === 'overear' ? TR('form_overear') : TR('form_halfear')];
    if (v.byBuild === 0) ariaSegs.push(TR('aria_build1'));
    else if (v.byBuild === 1) ariaSegs.push(TR('aria_build2'));
    const partSegs = [partColonLabel('headband', getColor(v.headband)), partColonLabel('host', getColor(state.base.host))];
    if (v.faceplate) partSegs.push(partColonLabel('faceplate', getColor(v.faceplate)));
    partSegs.push(partColonLabel('pad', getColor(v.earpad)));
    const variantAria = `${ariaSegs.join(' · ')}:${partSegs.join('·')}`;
    return `
      <button class="variant glass-chip"
              data-idx="${globalIdx}"
              data-form="${v.form}"
              aria-pressed="${state.previewMode === 'library' && state.currentVariantIdx === globalIdx}"
              aria-label="${variantAria}"
              style="--img-host:${imgHost}; --img-faceplate:${imgFp}; --img-earpad:${imgEp}; --img-headband:${imgHb}; --c-headband:${hbHex};">
        <span class="variant__core">
          <span class="variant__layer variant__layer--shadow"></span>
          <span class="variant__layer variant__layer--earpad"></span>
          ${v.faceplate ? '<span class="variant__layer variant__layer--faceplate"></span>' : ''}
          <span class="variant__layer variant__layer--host"></span>
          <span class="variant__layer variant__layer--headband${hbFbCls}"></span>
        </span>
        <span class="variant__badge">${v.form === 'overear' ? TR('form_over_s') : TR('form_half_s')}</span>
        ${handBadge}
      </button>
    `;
  }).join('');

  grid.querySelectorAll('.variant').forEach((el) => {
    if (grew) el.classList.add('is-new');
    el.addEventListener('click', () => {
      const clickedIdx = +el.dataset.idx;
      // 修复-12 · 恢复 library mode toggle(用户重新明确要 carousel 横滚 + 一键批量下载)
      if (state.previewMode === 'library' && state.currentVariantIdx === clickedIdx) {
        state.previewMode = 'build';
      } else {
        state.currentVariantIdx = clickedIdx;
        state.previewMode = 'library';
        el.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
      render();
    });
  });

  // v15.33 · shadow 已固定在 .variants__strip 内,不再需要 JS 动态设宽
  updateVariantsTrack();
}

/* 进度条更新 · 嫁接-21.8:variants 不溢出时整条 track 隐藏(避免 thumb 100% 满铺像粗黑线) */
function updateVariantsTrack() {
  const grid = $('#variants-grid');
  const bar  = $('#variants-track-bar');
  if (!grid || !bar) return;
  const track = bar.parentElement;  // .variants__track
  const sw = grid.scrollWidth;
  const cw = grid.clientWidth;
  if (sw <= cw) {
    if (track) track.style.display = 'none';   // 不溢出时整条隐藏
    return;
  }
  if (track) track.style.display = '';
  const widthPct = (cw / sw) * 100;
  const posPct   = (grid.scrollLeft / sw) * 100;
  bar.style.setProperty('--track-w', widthPct + '%');
  bar.style.setProperty('--track-pos', posPct + '%');
}

// 渲染一张预览 card(4 层 PNG 叠加)
function renderPreviewCard(v, idx) {
  if (!v) return '';
  const imgHost = adaptImg('host', v.host, v.form);
  const imgFp   = v.faceplate ? adaptImg('faceplate', v.faceplate, v.form) : 'none';
  const imgEp   = adaptImg('earpad', v.earpad, v.form);
  const imgHb   = adaptImg('headband', v.headband, v.form);
  const epHex   = getColor(v.earpad).hex;
  return `
    <div class="preview-card" data-variant-idx="${idx}" data-form="${v.form}"
         style="--img-host:${imgHost}; --img-faceplate:${imgFp}; --img-earpad:${imgEp}; --img-headband:${imgHb}; --c-earpad-fb:${epHex};">
      <div class="preview-card__inner">
        <span class="preview-card__layer preview-card__layer--shadow"></span>
        <span class="preview-card__layer preview-card__layer--earpad"></span>
        <span class="preview-card__layer preview-card__layer--faceplate"></span>
        <span class="preview-card__layer preview-card__layer--host"></span>
        <span class="preview-card__layer preview-card__layer--headband"></span>
      </div>
    </div>
  `;
}

// 合成当前 Build 的"实时"变体对象(没装齐时降级半包)
function buildCurrentVariant() {
  const build = state.builds[state.activeBuild];
  const host = state.base.host;
  const halfEarpad = LOCKED_PAIRS[host];
  const lockedHb = `solid-${halfEarpad}`;
  const hasFull = build.faceplate && build.earpad;
  return hasFull ? {
    form: 'overear', host,
    faceplate: build.faceplate, earpad: build.earpad,
    headband: build.headband || lockedHb,
  } : {
    form: 'halfear', host,
    faceplate: null, earpad: halfEarpad,
    headband: build.headband || lockedHb,
  };
}

// 预览大图左上角:当前这副(activeBuild)的搭配星级(半包耳/缺维度不显示)
// 挂在 .preview__main(左缘=下方文字左缘)而非居中的 stage,这样胶囊左边能跟文字对齐
function updatePreviewRating(v) {
  const host = document.querySelector('#preview .preview__main');
  if (!host) return;
  let el = host.querySelector('.preview__rating');
  const sb = v ? scoreBuild(v) : null;
  if (sb && !sb.excluded) {
    if (!el) { el = document.createElement('div'); host.appendChild(el); }
    el.className = 'preview__rating' + (sb.score >= 5 ? ' preview__rating--gold' : (sb.score > 4.5 ? ' preview__rating--mid' : ''));   // 5.0 黑金 / >4.5 深灰毛玻璃 / 其余浅灰
    el.innerHTML = starRatingHTML(sb.score, 'md');
  } else if (el) {
    el.remove();
  }
}

/* ── 预览换图丝滑切换(交叉淡入淡出 + 预加载),2026-07-15 ──────────────
   病根:原来每次 render 都 carousel.innerHTML= 把整卡 DOM 拆了重建 → 图硬切、慢网还闪空白。
   现在:同一张卡原地换 --img-* 变量(不重建);换前克隆旧卡当"幽灵"盖在上面,
        预加载好新图后让幽灵淡出移除 → 旧图淡出、新图淡入,顺滑过渡。 */
function variantSig(v) {
  return v ? [v.form, v.host, v.faceplate || '-', v.earpad, v.headband].join('|') : '';
}
// 把变体的 4 层图 + 皮套底色写到已存在的卡上(不重建 DOM)
function applyPreviewVars(card, v) {
  card.style.setProperty('--img-host', adaptImg('host', v.host, v.form));
  card.style.setProperty('--img-faceplate', v.faceplate ? adaptImg('faceplate', v.faceplate, v.form) : 'none');
  card.style.setProperty('--img-earpad', adaptImg('earpad', v.earpad, v.form));
  card.style.setProperty('--img-headband', adaptImg('headband', v.headband, v.form));
  card.style.setProperty('--c-earpad-fb', getColor(v.earpad).hex);
  card.setAttribute('data-form', v.form);
  card.dataset.sig = variantSig(v);
}
// 从 adaptImg 的 url("...") 抠裸地址,预加载并解码 4 层图,避免淡入瞬间闪空白;最多等 360ms 不卡住慢网
function preloadVariant(v) {
  /* 🐛 第 66 轮体检查出的老 bug(2026-08-03):原正则只认**双引号** —— `/url\("?(.*?)"?\)/`,
     但 adaptImg() 产出的是**单引号**:`return \`url('${cdnUrl(...)}')\``(见该函数)。
     于是 `url('/xxx.png')` 匹配时,`"?` 匹配空、捕获组把单引号一起吃进去,
     得到 `'/xxx.png'`(带引号)→ 赋给 img.src 后浏览器当相对路径处理 → **每张都 404**。
     取证:体检时点任一色块,控制台稳定冒出 4 条 404,URL 形如
       http://localhost:8000/07-rainbow-DIY-横版/'/05-rainbow-DIY-配置器/素材/适配图/host-silver.png'
     后果:preloadVariant 的**全部意义**就是预加载+解码 4 层图、避免切换瞬间闪空白 ——
     它从来就没生效过,主图预览卡每次换色都在裸奔。
     修法:两种引号都认,并容忍 url() 内的空白。 */
  const raw = s => { const m = s && s.match(/url\(\s*['"]?(.*?)['"]?\s*\)/); return m ? m[1] : null; };
  const urls = [
    raw(adaptImg('host', v.host, v.form)),
    v.faceplate ? raw(adaptImg('faceplate', v.faceplate, v.form)) : null,
    raw(adaptImg('earpad', v.earpad, v.form)),
    raw(adaptImg('headband', v.headband, v.form)),
  ].filter(Boolean);
  const load = u => new Promise(res => {
    const img = new Image();
    img.onload = () => (img.decode ? img.decode().then(res, res) : res());
    img.onerror = res;
    img.src = u;
  });
  return Promise.race([
    Promise.all(urls.map(load)),
    new Promise(res => setTimeout(res, 360)),
  ]);
}
// 换图入口:首次直接建卡;耳机没变则不动;变了就幽灵交叉淡入
function paintPreview(carousel, v) {
  if (!v) { carousel.innerHTML = ''; return; }
  const existing = carousel.querySelector('.preview-card');
  if (!existing) {   // 首次渲染:建卡,不淡入
    carousel.innerHTML = renderPreviewCard(v, -1);
    const c = carousel.querySelector('.preview-card');
    if (c) c.dataset.sig = variantSig(v);
    return;
  }
  if (existing.dataset.sig === variantSig(v)) return;   // 耳机没变(仅无关 render 触发)→ 不动
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) { applyPreviewVars(existing, v); return; }   // 系统减弱动效:原地换,不淡入
  carousel.querySelectorAll('.preview-card--ghost').forEach(g => g.remove());   // 狂点时清掉上一波幽灵,不堆叠
  if (getComputedStyle(carousel).position === 'static') carousel.style.position = 'relative';
  // 1. 克隆当前卡当幽灵,绝对定位盖在原卡上
  const ghost = existing.cloneNode(true);
  ghost.classList.add('preview-card--ghost');
  ghost.style.position = 'absolute';
  ghost.style.left = existing.offsetLeft + 'px';
  ghost.style.top = existing.offsetTop + 'px';
  ghost.style.width = existing.offsetWidth + 'px';
  ghost.style.height = existing.offsetHeight + 'px';
  ghost.style.margin = '0';
  ghost.style.opacity = '1';
  ghost.style.transition = 'opacity .45s ease';   // 淡入时长 0.3→0.45s(用户 2026-07-15,更柔)
  carousel.appendChild(ghost);
  // 2. 原地把底下的卡换成新搭配(耳机立即就绪,被幽灵盖着看不到跳变)
  applyPreviewVars(existing, v);
  // 3. 预加载好新图 → 幽灵淡出 → 移除(移除时间 > 淡入时长)
  preloadVariant(v).then(() => {
    requestAnimationFrame(() => { ghost.style.opacity = '0'; });
    setTimeout(() => ghost.remove(), 500);
  });
}

function renderPreview() {
  // 横版砍掉 library/build 双模式,只保留 build 实时单副预览
  const root = $('#preview');
  const carousel = $('#preview-carousel');
  root.setAttribute('data-mode', 'build');

  // 只渲染 1 张当前 Build 的实时合成(丝滑交叉淡入,不再整卡硬切)
  const currentV = buildCurrentVariant();
  paintPreview(carousel, currentV);

  if (!currentV) {
    root.removeAttribute('data-form');
    $('#preview-name').textContent = TR('no_variant');
    $('#preview-caption').textContent = 'PREVIEW';
    $('#preview-sub-caption').textContent = '';
    $('#preview-tagline').textContent = '';
    $('#preview-leadin').textContent = '';
    return;
  }

  root.setAttribute('data-form', currentV.form);
  $('#preview-name').innerHTML = previewNameHTML(currentV);
  // add-second「添加第2套」按钮已搬到预览区,在这里(每次 render 重填后)重新绑定点击 → 加购第2套
  // add-second「添加第2套」已搬到列3 #kit-list 顶部槽,事件委托绑一次(#kit-list 不重建,委托不丢)
  if (!window._addSecondBound && $('#kit-list')) {
    $('#kit-list').addEventListener('click', (e) => {
      if (e.target.closest('.add-second-kit__btn')) setKitCount(2);
    });
    window._addSecondBound = true;
  }
  // DIY 模式:Apple 牌坊风 4 段(eyebrow → 主标 → tagline 2行 → leadin 问句 → 预览图)
  // 列2引导区 = 低分安慰(sub-caption)+ 弧度卖点(tagline,略大更突出)(2026-06-15 用户:换掉原功能引导)
  $('#preview-sub-caption').innerHTML = TR('preview_subcaption');
  $('#preview-caption').textContent = TR('preview_caption');
  $('#preview-tagline').textContent = TR('preview_tagline');
  $('#preview-leadin').textContent = '';
  fillMeta(currentV);
  updatePreviewRating(currentV);
}

// 修复-16 · 竖长方形产品图风排版(1500×2000 / 浅灰底 / 耳机居中占 60% / 上下留白)
function composeVariantPng(v) {
  return new Promise(resolve => {
    const W = 1500, H = 2000;
    const earSize = 900;                  // 耳机绘制方块尺寸(占 width 60%)
    const offsetX = Math.floor((W - earSize) / 2);  // 水平居中
    const offsetY = Math.floor((H - earSize) / 2);  // 垂直居中(上下各留 550)
    const canvas = document.createElement('canvas');
    canvas.width = W;
    canvas.height = H;
    const ctx = canvas.getContext('2d');
    // 浅灰底(产品图常用)
    ctx.fillStyle = '#F0F0F0';
    ctx.fillRect(0, 0, W, H);
    // 5 层 raw URL 拼接(跳过 adaptImg 的 url() 包装)
    const halfSuffix = v.form === 'halfear' ? '-halfear' : '';
    const sources = [
      cdnUrl('素材/适配图/shadow.png'),
      cdnUrl(`素材/适配图/earpad${(v.form === 'halfear') ? '-halfear' : ''}-${v.earpad}.png`),
      v.faceplate ? cdnUrl(`素材/适配图/faceplate-${v.faceplate}.png`) : null,
      cdnUrl(`素材/适配图/host${halfSuffix}-${v.host}.png`),
      cdnUrl(`素材/适配图/headband-${v.headband}.png`),
    ];
    const loadOne = src => new Promise(res => {
      if (!src) return res(null);
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => res(img);
      img.onerror = () => { console.warn('[compose] 加载失败:', src); res(null); };
      img.src = src;
    });
    Promise.all(sources.map(loadOne)).then(images => {
      for (const img of images) {
        if (img) ctx.drawImage(img, offsetX, offsetY, earSize, earSize);
      }
      canvas.toBlob(blob => resolve(blob), 'image/png');
    });
  });
}

// 修复-15 · 直接下载 N 张 PNG(浏览器逐张触发,不打包 zip)
async function downloadAllVariantsZip() {
  const btn = $('#explore-download');
  btn.classList.add('is-loading');
  try {
    const variants = enumerate();
    for (let i = 0; i < variants.length; i++) {
      const v = variants[i];
      const blob = await composeVariantPng(v);
      if (!blob) continue;
      const idx = String(i + 1).padStart(2, '0');
      const fp = v.faceplate || 'half';
      const fname = `rainbow-${idx}-host${v.host}-hb${v.headband}-fp${fp}-ep${v.earpad}.png`;
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fname;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      // 延时 200ms 避免浏览器拒绝连续触发
      await new Promise(r => setTimeout(r, 200));
      URL.revokeObjectURL(url);
    }
  } catch (e) {
    console.error('[批量下载] 失败:', e);
    alert(TR('err_download'));
  } finally {
    btn.classList.remove('is-loading');
  }
}

// 主图下方:分 3 组小图标 — ① 主机 + 标配件 ② 第 1 套选的配件 ③ 第 2 套配件(加第2套才显示)
function previewNameHTML(v) {
  const host = state.base.host;
  const lockedColor = LOCKED_PAIRS[host];     // 主机锁定的标配色(大漠黄→墨绿)
  const chip = (type, slug, label) => {
    if (!slug) return '';
    // 面盖/皮套 slug 跟主机色重名(silver 等),必须从各自的表取,否则 getColor 误判成主机 → 缺 image → 掉进适配图(主机嵌入态)
    let c;
    if (type === 'faceplate') c = FACEPLATES.find(x => x.slug === slug);
    else if (type === 'earpad') c = EARPADS.find(x => x.slug === slug);
    else c = getColor(slug);
    c = c || getColor(slug) || {};
    // 配件用列 3 chip 同款产品图(c.image:头带竖条/面盖圆环/皮套R形),主机无产品图则走迷你耳机适配图
    const img = c.image ? `url('${c.image}')` : adaptImg(type, slug, 'overear');
    return `<span class="pv-chip${c.image ? ' pv-chip--product' : ''}" title="${label}:${dispName(c) || slug}" style="--c:${c.hex || '#ccc'}; --img:${img};"></span>`;
  };
  const b1 = state.builds[0];
  const b2 = state.builds[1];
  const twoKits = (state.kitCount || 1) >= 2;
  // 主机行:用 host 色卡同款 3 层 PNG 迷你耳机(主机色 + 标配头带 + 标配皮套合成一个图)
  const imgHb   = adaptImg('headband', 'solid-' + lockedColor, 'halfear');
  const imgHost = adaptImg('host',     host,                    'halfear');
  const imgEp   = adaptImg('earpad',   lockedColor,             'halfear');
  const hostMini = `<span class="pv-mini" style="--img-hb:${imgHb}; --img-host:${imgHost}; --img-ep:${imgEp};"><span class="host-chip__layer host-chip__layer--ep"></span><span class="host-chip__layer host-chip__layer--host"></span><span class="host-chip__layer host-chip__layer--hb"></span></span>`;
  // 某套的整机迷你耳机(全包耳 5 层:主机 + 选的头带/面盖/皮套),凸显该套 DIY 结果
  const miniFull = (bd) => {
    if (!bd.headband || !bd.faceplate || !bd.earpad) return '';
    return `<span class="pv-mini pv-mini--full" style="--img-host:${adaptImg('host', host, 'overear')}; --img-faceplate:${adaptImg('faceplate', bd.faceplate, 'overear')}; --img-earpad:${adaptImg('earpad', bd.earpad, 'overear')}; --img-headband:${adaptImg('headband', bd.headband, 'overear')};"><span class="build-card__layer build-card__layer--shadow"></span><span class="build-card__layer build-card__layer--earpad"></span><span class="build-card__layer build-card__layer--faceplate"></span><span class="build-card__layer build-card__layer--host"></span><span class="build-card__layer build-card__layer--headband"></span></span>`;
  };
  // 配件行:头带 ＋ 面盖 ＋ 皮套(加号连接,filter 掉空 chip 避免落单加号)
  const accChips = (bd) => [
    chip('headband', bd.headband, '头带'),
    chip('faceplate', bd.faceplate, '面盖'),
    chip('earpad', bd.earpad, '皮套'),
  ].filter(Boolean).join('<span class="pv-plus">＋</span>');
  // 末尾等式「= N 种风格」:口径与 CTA hint 一致(1套4种 / 2套15种 / 3套上百)
  const n = state.kitCount || 1;
  const styleEq = `<span class="pv-styles">= ${TR(n === 1 ? 'style_n_1' : n === 2 ? 'style_n_2' : 'style_n_3')}</span>`;
  return `
    <div class="pv-line pv-line--base">
      <span class="pv-line__tag">${TR('std_kit')}</span>
      ${hostMini}
      <span class="pv-line__std">${TR('std_kit_incl')}</span>
    </div>
    <div class="pv-line">
      <span class="pv-line__tag">${TR('kit1_acc')}</span>
      ${accChips(b1)}
      ${twoKits ? '' : styleEq}
    </div>
    ${twoKits ? `<div class="pv-line">
      <span class="pv-line__tag">${TR('kit2_acc')}</span>
      ${accChips(b2)}
      ${styleEq}
    </div>` : ''}
  `;
}

// 竖向白卡内容:4 行清单(头带/主机/面盖/皮套),每行 [色点 + 类别 label + 色名]
function fillMeta(v) {
  const meta = $('#preview-meta');
  if (!v) { meta.innerHTML = ''; return; }
  const rows = [
    { label: '头带', slug: v.headband },
    { label: '主机', slug: v.host },
    v.faceplate ? { label: '面盖', slug: v.faceplate } : null,
    { label: '皮套', slug: v.earpad },
  ].filter(Boolean);
  meta.innerHTML = rows.map(r => {
    const c = getColor(r.slug);
    return `<div class="preview__meta-row">
      <span class="preview__meta-row__dot" style="--c:${c.hex};"></span>
      <span class="preview__meta-row__label">${r.label}</span>
      <span class="preview__meta-row__name">${dispName(c)}</span>
    </div>`;
  }).join('');
}

function renderHostBar() {
  // 横版:4 个主机色 chip 横排在大耳机上方(竖版是 #host-bar-left/right 左右各 2)
  const bar = $('#host-bar-top');
  if (!bar) return;
  const chipsHTML = HOSTS.map(h => {
    // 完整迷你耳机预览:3 层 PNG 叠(头带+主机+半包皮套,按 LOCKED_PAIRS 取该主机色的标配)
    const lockedColor = LOCKED_PAIRS[h.slug];
    const imgHb   = adaptImg('headband', `solid-${lockedColor}`, 'halfear');
    const imgHost = adaptImg('host',     h.slug,                  'halfear');
    const imgEp   = adaptImg('earpad',   lockedColor,             'halfear');
    /* 第 125 轮:主机色卡直接【复用 DIY 选择按钮】(.picker-chip)——
       用户 2026-08-11:「我希望它直接用成 DIY 按钮」。
       原来它是"带底色的小卡片",第三列的头带/面盖/皮套是"色块 + 名字 + 右上角 ✓",
       同一屏两种选择器语言,主机看着不像"能选的东西"。
       共用 class 而不是照抄一份样式:以后 picker-chip 改了,这里自动跟着变。
       三层迷你耳机图保留 —— 那是在说"选这个主机色,标配头带和皮套就锁成这个色"。 */
    const 选中 = state.base.host === h.slug;
    return `
    <button class="picker-chip host-chip" data-host="${h.slug}"
            aria-pressed="${选中}"
            data-pick-order="${选中 ? '✓' : ''}"
            aria-label="${partColonLabel('host', h)}"
            style="--img-hb:${imgHb}; --img-host:${imgHost}; --img-ep:${imgEp};">
      <span class="picker-chip__swatch host-chip__swatch">
        <span class="host-chip__layer host-chip__layer--ep"></span>
        <span class="host-chip__layer host-chip__layer--host"></span>
        <span class="host-chip__layer host-chip__layer--hb"></span>
      </span>
      <span class="picker-chip__name host-chip__name">${dispName(h)}</span>
    </button>
  `;
  });
  bar.innerHTML = chipsHTML.join('');
  bar.querySelectorAll('[data-host]').forEach(el => {
    el.addEventListener('click', () => {
      const prevHost = state.base.host;
      state.base.host = el.dataset.host;
      syncBuildsAfterHostChange(prevHost);
      // 主图自动切到包含新 host 的 4 层全 PNG 变体
      selectVariantBy('host', el.dataset.host);
      render();
    });
  });
}

// 主机切了 → 标配头带 slug 变了 → Build 1/2 里若有人选了"新主机的标配纯色头带",要换掉。
// ⚠️ 铁律(2026-08-04 用户拍板):这里【只能换,不能清空】。
//    以前写的是 b.headband = null,导致换个主机色就把用户的头带扔了,Kit 1 胶囊
//    突然变成"还差 1 件",用户完全不知道自己丢了什么。
function syncBuildsAfterHostChange(prevHost) {
  const lockedSolid = `solid-${LOCKED_PAIRS[state.base.host]}`;
  state.builds.forEach((b, i) => {
    if (b.headband !== lockedSolid) return;
    const rep = pickReplacementHeadband(b, i, prevHost);
    if (rep) b.headband = rep;   // 找不到替代才保留原值(宁可不动,也不留空)
  });
}

// 给一个「当前头带已不可选」的 build 找替代头带。优先级:
//  ① linked 开着 → 跟皮套同底色(维持绑定不被打破)
//  ② 刚被释放出来的那条纯色(= 旧主机的标配色)—— 同为纯色,视觉跳变最小
//  ③ 池子里任意一条可选的(兜底,保证永远不返回 null)
function pickReplacementHeadband(b, buildIdx, prevHost) {
  const pool = getHeadbandPool(state.base.host);
  const otherSlug = state.builds[1 - buildIdx].headband;
  const usable = slug => {
    const o = pool.find(h => h.slug === slug);
    return !!(o && !o.isBonus && slug !== otherSlug);
  };
  if (state.headbandLinked && b.earpad) {
    const linked = findLinkedHeadband(b.earpad, buildIdx);
    if (linked && usable(linked)) return linked;
  }
  if (prevHost && LOCKED_PAIRS[prevHost]) {
    const freed = `solid-${LOCKED_PAIRS[prevHost]}`;
    if (usable(freed)) return freed;
  }
  const any = pool.find(h => !h.isBonus && h.slug !== otherSlug);
  return any ? any.slug : null;
}

function renderKit() {
  const list = $('#kit-list');
  list.innerHTML = '';
  const lockedColor = LOCKED_PAIRS[state.base.host];

  // v15.9 · 顶部锁色说明完全去除(用户要求)
  $('#locked-note-slot').innerHTML = '';

  // —— 2. 装 2 副 DIY · Tab 合并版(两副共用 1 个玻璃卡) ——
  const isB1Done = buildComplete(state.builds[0]);
  // 如果 Build 1 没完成且当前在编辑 Build 2,自动切回 Build 1
  if (!isB1Done && state.activeBuild === 1) state.activeBuild = 0;
  const activeBuildIdx = state.activeBuild;
  const activeBuild = state.builds[activeBuildIdx];
  const activeLocked = activeBuildIdx === 1 && !isB1Done;

  const li = document.createElement('li');
  li.className = 'kit-item kit-item--build kit-item--build-tabs';
  li.setAttribute('aria-checked', 'true');
  li.setAttribute('data-active-build', activeBuildIdx);

  // 文件夹 3 张纸片里放合成迷你耳机(3 种不同风格,体现"加第2套 = 更多风格";用户 2026-07-14)
  const _folderHP = (bd) => `<span class="pv-mini pv-mini--full" style="--img-host:${adaptImg('host', bd.host, 'overear')};--img-faceplate:${adaptImg('faceplate', bd.faceplate, 'overear')};--img-earpad:${adaptImg('earpad', bd.earpad, 'overear')};--img-headband:${adaptImg('headband', bd.headband, 'overear')};"><span class="build-card__layer build-card__layer--shadow"></span><span class="build-card__layer build-card__layer--earpad"></span><span class="build-card__layer build-card__layer--faceplate"></span><span class="build-card__layer build-card__layer--host"></span><span class="build-card__layer build-card__layer--headband"></span></span>`;
  const _folderStyles = [
    { host: 'silver',       faceplate: 'silver',       headband: 'line-darkgreen-red', earpad: 'darkgreen' },
    { host: 'desertyellow', faceplate: 'desertyellow', headband: 'flower-purple',      earpad: 'purple' },
    { host: 'babyblue',     faceplate: 'babyblue',     headband: 'quantum-navy',       earpad: 'navy' },
  ];

  li.innerHTML = `
    <!-- 添加第2套:挪到列3 顶部固定占位槽(用户 2026-06-22 走 C);没装第2套显按钮、装了显提示、
         槽固定高度 → 点击后下方头带/面盖/皮套 picker 纵向位置不跳 -->
    <div class="kit-add-slot">
      ${(isB1Done && (state.kitCount || 1) < 2) ? `
        <div class="add-second-kit add-second-kit--kit">
          <div class="add-second-kit__text">${黑五中() ? TR('add2_prompt_bf', { add: kit2ExtraCost() }) : TR('add2_prompt', { add: kit2ExtraCost(), deal: 第二套折算文案() })}</div>
        </div>` : ((state.kitCount || 1) >= 2 ? `<div class="kit-add-slot__done">${TR('add2_done')}</div>` : '')}
    </div>

    <!-- Tab 横排切换 -->
    <div class="build-tabs__bar" role="tablist">
      ${Array.from({ length: state.kitCount || 1 }, (_unused, i) => {
        const b = state.builds[i];
        const done = buildComplete(b);
        const cnt = [b.faceplate, b.headband, b.earpad].filter(Boolean).length;
        const label = i === 0 ? TR('diy_tab_1') : TR('diy_tab_2');
        const subLabel = done ? '<span class="build-tabs__tab-check">✓</span>' : TR('tab_need', { need: 3 - cnt });
        const plus = (i === 0 && (state.kitCount || 1) >= 2) ? '<span class="build-tabs__plus" aria-hidden="true">+</span>' : '';
        return `
          <div class="build-tabs__tab" role="tab" data-build-tab="${i}"
               data-on="true" aria-selected="${i === activeBuildIdx}">
            <span class="build-tabs__tab-label">${label}</span>
            <span class="build-tabs__tab-state">${subLabel}</span>
            ${i === 1 ? `<button class="build-tabs__remove" data-remove-second type="button" aria-label="${TR('remove_kit2_aria')}"></button>` : ''}
          </div>
          ${plus}
        `;
      }).join('')}
      ${(isB1Done && (state.kitCount || 1) < 2) ? `<span class="build-tabs__plus build-tabs__plus--add" aria-hidden="true">+</span><button class="add-second-kit__btn build-tabs__addsecond folder-add" type="button" data-add-second aria-label="${TR('add2_label')}"><span class="folder"><span class="folder__back"><span class="paper paper-1">${_folderHP(_folderStyles[0])}</span><span class="paper paper-2">${_folderHP(_folderStyles[1])}</span><span class="paper paper-3">${_folderHP(_folderStyles[2])}</span><span class="folder__front"></span><span class="folder__front right"></span></span><span class="folder-label">${TR('add2_label')}</span></span><span class="folder-offer">${黑五中() ? `<s class="bf-was">+$${kit2ExtraCost()}</s><b>FREE</b>` : `<b>+$${kit2ExtraCost()}</b>`} · 4→15</span></button>` : ''}
    </div>

    <!-- 2026-06-11 用户(B方案):绑定横条整条撤掉,说明+解绑链接全部集中到列1 hero__bind-note -->


    <!-- "+" 展开后显示装好内容(横跨 2 个 tab 下方) -->
    ${[0, 1].map(i => {
      const b = state.builds[i];
      if (!buildComplete(b) || !state.detailsOpen[i]) return '';
      const parts = [partOfColor(getColor(b.faceplate), 'faceplate'), partOfColor(getColor(b.headband), 'headband'), partOfColor(getColor(b.earpad), 'earpad')];
      return `
        <div class="build-tabs__details" data-build="${i}">
          <span class="build-tabs__details-tag">${TR('set_n_label', { n: i + 1 })}</span>
          <span class="build-tabs__details-parts">${parts.join(' · ')}</span>
        </div>
      `;
    }).join('')}

    <!-- 当前 tab 的 3 行 picker -->
    <div class="build-tabs__panel" data-build="${activeBuildIdx}">
      ${activeLocked
        ? `<div class="kit-item__lock-overlay--inline"><span>${TR('lock_need_b1')}</span></div>`
        : BUILD_SLOTS.map(slot => renderSlotPicker(activeBuildIdx, slot)).join('')}
    </div>
  `;
  list.appendChild(li);

  // —— 阶段 A · 魔尼带 li(独立行,全套装 1 件,锁色联动 Build 1 皮套 + 解锁按钮) ——
  const moniLi = document.createElement('li');
  moniLi.className = 'kit-item kit-item--moni-strap';
  const activeMoniSlug = getMoniStrapSlug();
  const moniLinked = state.moniStrap.linked;
  const linkedColor = state.builds[0].earpad; // linked 时显示的"被锁的色"
  moniLi.innerHTML = `
    <div class="moni-strap-row">
      <div class="moni-strap-row__head">
        <span class="moni-strap-row__icon" aria-hidden="true"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="5"/><path d="M9 12.5L7 21l5-3 5 3-2-8.5"/></svg></span>
        <span class="moni-strap-row__label">${TR('moni_label')}</span>
        <span class="moni-strap-row__sub">${TR('moni_sub')}</span>
        <button class="moni-strap-row__lock has-tip" type="button"
                data-toggle-moni-lock
                aria-pressed="${moniLinked}"
                data-tip="${moniLinked ? TR('moni_tip_locked') : TR('moni_tip_free')}"
                aria-label="${moniLinked ? TR('moni_aria_locked') : TR('moni_aria_free')}">
          ${moniLinked
            ? '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-2px;margin-right:3px"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>' + TR('lock_locked')
            : '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-2px;margin-right:3px"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0"/></svg>' + TR('lock_free')}<svg class="moni-lock-tip-icon" viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><path d="M12 11.5v4.5M12 8h.01"/></svg>
        </button>
      </div>
      <div class="moni-strap-row__chips slot-row__chips inline-picker">
        ${MONI_STRAPS.map(m => {
          const isSel = activeMoniSlug === m.slug;
          // linked 模式下:只有跟 Build 1 皮套色一致的 chip 选中,其他 chip 灰禁(提示用户解锁才能选)
          const isLockedOut = moniLinked && linkedColor && m.slug !== linkedColor;
          const imgStyle = m.image ? ` --img:url('${m.image}');` : '';
          const disAttr = isLockedOut ? ' disabled data-locked-by-build1="true"' : '';
          const title = isLockedOut ? (dispName(m) + TR('note_unlock_pick')) : dispName(m);
          return `
            <button class="picker-chip picker-chip--moni" data-pick="${m.slug}" data-slot="moni"${disAttr}
                    aria-pressed="${isSel}"
                    aria-label="${TR('moni_label')} ${title}"
                    title="${title}"
                    style="--c:${m.hex};${imgStyle}">
              <span class="picker-chip__swatch picker-chip__swatch--transparent"></span>
              <span class="picker-chip__name">${dispName(m)}</span>
            </button>
          `;
        }).join('')}
      </div>
    </div>
  `;
  list.appendChild(moniLi);

  // 魔尼带 chip click(自由模式下选色)
  moniLi.querySelectorAll('.picker-chip[data-slot="moni"]').forEach(chip => {
    chip.addEventListener('click', (e) => {
      e.stopPropagation();
      if (chip.disabled) return;
      const slug = chip.dataset.pick;
      state.moniStrap.slug = slug;
      // linked 状态下手动改色 → 自动解锁(因为 linked 应该跟皮套走,用户改色 = 想脱离锁定)
      if (state.moniStrap.linked) state.moniStrap.linked = false;
      render();
    });
  });
  // 锁/解锁按钮
  moniLi.querySelectorAll('[data-toggle-moni-lock]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      state.moniStrap.linked = !state.moniStrap.linked;
      // 锁回去 → state.moniStrap.slug 自动跟 Build 1 皮套同色(下次 render 调 getMoniStrapSlug 自动)
      if (state.moniStrap.linked && state.builds[0].earpad) {
        state.moniStrap.slug = state.builds[0].earpad;
      }
      render();
    });
  });

  // —— 事件绑定 ——
  // Tab 切换(点 tab 本身,但要避开 "改" 和 "+" 子按钮)
  li.querySelectorAll('[data-build-tab]').forEach(tab => {
    tab.addEventListener('click', (e) => {
      if (e.target.closest('[data-reset-build]') || e.target.closest('[data-toggle-info]') || e.target.closest('[data-remove-second]')) return;
      e.stopPropagation();
      if (tab.classList.contains('is-locked')) return;
      const newIdx = +tab.dataset.buildTab;
      // 方案2 · 点 tab 只切换编辑焦点(加第2套靠引导卡/底部 CTA,不再 toggle)
      // 切到不同 Build 时:重新定位头带 picker
      if (state.activeBuild !== newIdx) {
        const newBuild = state.builds[newIdx];
        if (newBuild.headband && HEADBAND_MAP[newBuild.headband]) {
          // 该 Build 已选头带 → 滚到该 chip 居中
          state.headbandTab = HEADBAND_MAP[newBuild.headband].type;
          state.headbandScrollTo = newBuild.headband;
          state.headbandScrollMode = 'center';
        } else {
          // 该 Build 未选 → 用 'start' 模式把线条款第 1 条推到最左,后面 3 条同类一起露出(刚好 4 个一屏)
          state.headbandTab = 'line';
          const firstLine = ALL_HEADBANDS.find(h => h.type === 'line');
          if (firstLine) {
            state.headbandScrollTo = firstLine.slug;
            state.headbandScrollMode = 'start';
          }
        }
        state.headbandScrollLeft = 0;
      }
      state.activeBuild = newIdx;
      state.previewMode = 'build';   // 切 Tab → 主图跟随新 Build 预览
      render();
    });
  });

  // (add-second「添加第2套」handler 已移到预览区填充处,见 #preview-name 渲染)

  // 第2套 tab"×移除"→ 取消第2套(只买第1套)
  li.querySelectorAll('[data-remove-second]').forEach(btn => {
    btn.addEventListener('click', (e) => { e.stopPropagation(); setKitCount(1); });
  });

  // "改" 按钮:清空对应 build + 切到那副重选
  li.querySelectorAll('[data-reset-build]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const idx = +btn.dataset.resetBuild;
      state.builds[idx] = { faceplate: null, headband: null, earpad: null };
      state.detailsOpen[idx] = false;  // 一并收起 details
      state.activeBuild = idx;
      state.headbandScrollLeft = 0;     // 重选 → 头带回到第一条
      render();
    });
  });

  // "+" 按钮:toggle 展开装好内容(在 Tab 下方推开文字)
  li.querySelectorAll('[data-toggle-info]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const idx = +btn.dataset.toggleInfo;
      state.detailsOpen[idx] = !state.detailsOpen[idx];
      render();
    });
  });

  if (!activeLocked) {
    // 普通色卡 chip 单选(面盖/皮套) — 仅当前 tab 的 picker
    // v15.55 · 改用 picker-chip 类(跟头带统一造型),用 data-slot 区分,跳过头带槽位
    li.querySelectorAll('.picker-chip[data-slot="faceplate"], .picker-chip[data-slot="earpad"]').forEach(chip => {
      chip.addEventListener('click', (e) => {
        e.stopPropagation();
        if (chip.disabled) return;
        const slot = chip.dataset.slot;
        const slug = chip.dataset.pick;
        // ⚠️ 铁律(2026-08-04 用户拍板):【只有更换,没有取消】。
        //    原来写的是 (===slug ? null : slug),再点一次已选中的就变空 →
        //    套装缺件、胶囊变"还差 N 件"、CTA 被锁死。取消选择在这个界面没有任何用途。
        if (state.builds[activeBuildIdx][slot] === slug) return;   // 点已选中的:什么都不做
        // 防跑转:任何 chip 点击都保持头带横滑位置
        const _hbsc0 = li.querySelector('[data-headband-scroll]');
        if (_hbsc0) state.keepHeadbandScrollLeft = _hbsc0.scrollLeft;
        state.builds[activeBuildIdx][slot] = slug;
        // linked + 选了皮套 → 同步头带(同纹理 + 同条色 + 新底色),并请求 picker 滚到新 chip
        if (state.headbandLinked && slot === 'earpad' && state.builds[activeBuildIdx].earpad) {
          const linkedHb = findLinkedHeadband(state.builds[activeBuildIdx].earpad, activeBuildIdx);
          if (linkedHb) {
            state.builds[activeBuildIdx].headband = linkedHb;
            // 防跑转:linked 改了头带也不滚动,保持当前横滑位置
            const _hbsc = li.querySelector('[data-headband-scroll]');
            if (_hbsc) state.keepHeadbandScrollLeft = _hbsc.scrollLeft;
          }
        }
        state.previewMode = 'build';
        render();
      });
    });

    // 头带 chip 单选(限定 data-slot="headband",防绑到面盖/皮套同类 chip)
    li.querySelectorAll('.picker-chip[data-slot="headband"]').forEach(chip => {
      chip.addEventListener('click', (e) => {
        e.stopPropagation();
        if (chip.disabled) return;
        const slug = chip.dataset.pick;
        // ⚠️ 铁律(2026-08-04 用户拍板):【只有更换,没有取消】,同上。
        if (state.builds[activeBuildIdx].headband === slug) return;   // 点已选中的:什么都不做
        // 防"跑转":点 chip 选头带时,强制保持当前横滑位置(render 里最优先直接设回,跳过自动滚)
        const _sc = chip.closest('[data-headband-scroll]');
        state.keepHeadbandScrollLeft = _sc ? _sc.scrollLeft : 0;
        state.builds[activeBuildIdx].headband = slug;
        // linked + 选了头带 → 反向同步皮套为同底色(若底色是全包 4 色之一)
        if (state.headbandLinked && state.builds[activeBuildIdx].headband) {
          const linkedEp = findLinkedEarpad(state.builds[activeBuildIdx].headband, activeBuildIdx);
          if (linkedEp) state.builds[activeBuildIdx].earpad = linkedEp;
        }
        state.previewMode = 'build';
        render();
      });
    });

    // 头带 + 帮助按钮:toggle 展开说明
    li.querySelectorAll('[data-toggle-link-help]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        state.headbandLinkHelpOpen = !state.headbandLinkHelpOpen;
        render();
      });
    });
    // 解绑 / 重新绑定切换:翻转 linked,重新绑定时立即把头带改成当前皮套同色
    li.querySelectorAll('[data-toggle-linked]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        state.headbandLinked = !state.headbandLinked;
        if (state.headbandLinked) {
          const ep = state.builds[activeBuildIdx].earpad;
          if (ep) {
            const linkedHb = findLinkedHeadband(ep, activeBuildIdx);
            if (linkedHb) state.builds[activeBuildIdx].headband = linkedHb;
          }
        }
        render();
      });
    });

    // 头带横滑:更新进度条位置 + 同步 state.headbandTab(隐性,用于 render 状态保持)
    const hbScroll = li.querySelector('[data-headband-scroll]');
    const hbTrack = li.querySelector('[data-headband-track]');
    // render 后头带 picker 位置处理:① 有 scrollTo 请求 → 居中滚到目标 chip;② 否则恢复之前的横滑位置
    if (hbScroll) {
      if (state.keepHeadbandScrollLeft != null) {
        // 防跑转:点 chip 选头带时,临时关 scroll-snap/smooth,把横滑位置设回原值,不让浏览器吸附跳走
        hbScroll.style.scrollSnapType = 'none';
        hbScroll.style.scrollBehavior = 'auto';
        hbScroll.scrollLeft = state.keepHeadbandScrollLeft;
        state.headbandScrollLeft = state.keepHeadbandScrollLeft;
        state.keepHeadbandScrollLeft = null;
        state.headbandScrollTo = null;
      } else if (state.headbandScrollTo) {
        const mode = state.headbandScrollMode || 'center';
        // 2026-06-11 用户:进站首次渲染头带不要"弹转"(从左滑到目标晃眼)→ 首渲染瞬时定位,
        // 只有后续交互(切第2套等)才平滑滚动
        // 首次渲染 或 切套数(添加/取消第2套)时,头带瞬时到位不弹转;只有手动翻页等才平滑
        const instant = !state.__headbandPainted || state.__headbandInstant;
        state.__headbandPainted = true;
        state.__headbandInstant = false;
        const firstPaint = instant;
        requestAnimationFrame(() => {
          const target = hbScroll.querySelector(`.picker-chip[data-pick="${state.headbandScrollTo}"]`);
          if (target) {
            if (firstPaint) {
              // 瞬时居中/靠左,无动画:手动算 scrollLeft,经 instantScroll 绕开 CSS smooth 劫持
              const off = mode === 'start'
                ? target.offsetLeft
                : target.offsetLeft - (hbScroll.clientWidth - target.offsetWidth) / 2;
              instantScroll(hbScroll, off);
              state.headbandScrollLeft = hbScroll.scrollLeft;
            } else {
              target.scrollIntoView({ behavior: 'smooth', inline: mode, block: 'nearest' });
              setTimeout(() => { state.headbandScrollLeft = hbScroll.scrollLeft; }, 320);
            }
          }
          state.headbandScrollTo = null;
          state.headbandScrollMode = 'center';
        });
      } else if (state.headbandScrollLeft > 0) {
        // instantScroll:此容器 CSS 带 smooth,直接赋值会平滑滚 = 取消第2套时头带"弹转"的源头(2026-06-11)
        instantScroll(hbScroll, state.headbandScrollLeft);
      }
    }
    if (hbScroll && hbTrack) {
      const trackContainer = hbTrack.parentElement;  // .picker-track,点击/拖动区
      const updateTrackAndTab = () => {
        const sw = hbScroll.scrollWidth - hbScroll.clientWidth;
        // 进度条
        if (sw > 0) {
          const ratio = hbScroll.scrollLeft / sw;
          const visibleRatio = hbScroll.clientWidth / hbScroll.scrollWidth;
          // thumb 宽度按可视占比,但留出"thumb 自己"的活动范围(thumb 在 track 内左右移)
          const thumbWidthPct = Math.max(15, visibleRatio * 100);
          hbTrack.style.setProperty('--track-w', `${thumbWidthPct}%`);
          hbTrack.style.setProperty('--track-pos', `${ratio * (100 - thumbWidthPct)}%`);
        } else {
          hbTrack.style.setProperty('--track-pos', '0%');
          hbTrack.style.setProperty('--track-w', '100%');
        }
        // 找当前可视区左边第一个完整 chip 的 type
        const rowRect = hbScroll.getBoundingClientRect();
        const chips = [...hbScroll.querySelectorAll('.picker-chip')];
        let activeType = chips[0]?.dataset.type || 'design';
        for (const chip of chips) {
          const r = chip.getBoundingClientRect();
          // 取中央对齐 row 中央的 chip 作为 active
          if (r.right - 10 >= rowRect.left) {
            activeType = chip.dataset.type;
            break;
          }
        }
        // 同步 state.headbandTab(隐性记录,无 UI 输出)
        if (state.headbandTab !== activeType) {
          state.headbandTab = activeType;
        }
        // 记当前横滑位置,下次 render 后立即恢复
        state.headbandScrollLeft = hbScroll.scrollLeft;
      };
      hbScroll.addEventListener('scroll', updateTrackAndTab, { passive: true });
      requestAnimationFrame(updateTrackAndTab);

      // ── 嫁接-21.7 · slider 可交互:点击 picker-track 任意位置 → 头带瞬移;按住 + 拖动 → 实时滚 ──
      if (trackContainer) {
        // 绝对位置映射:click x 占 track 宽的比例 = 头带滚动比例(无需 thumb 宽度参与)
        const seekFromX = (clientX) => {
          const rect = trackContainer.getBoundingClientRect();
          if (rect.width <= 0) return;
          const ratio = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
          const sw = hbScroll.scrollWidth - hbScroll.clientWidth;
          if (sw > 0) {
            hbScroll.scrollLeft = sw * ratio;
            updateTrackAndTab();  // 嫁接-21.8 · 立即同步 thumb,不等浏览器 scroll 事件回调延迟
          }
        };
        let dragging = false;
        let pointerId = null;
        let rafId = null;
        let pendingX = 0;
        const flush = () => {
          rafId = null;
          seekFromX(pendingX);
        };
        const schedule = (x) => {
          pendingX = x;
          if (rafId == null) rafId = requestAnimationFrame(flush);
        };
        const onDown = (e) => {
          if (e.button !== undefined && e.button !== 0) return;
          e.preventDefault();
          dragging = true;
          pointerId = e.pointerId;
          trackContainer.classList.add('is-dragging');
          try { trackContainer.setPointerCapture(pointerId); } catch (_) {}
          seekFromX(e.clientX);  // 点击立即跳
        };
        const onMove = (e) => {
          if (!dragging) return;
          e.preventDefault();
          schedule(e.clientX);    // rAF 节流跟手
        };
        const onUp = () => {
          if (!dragging) return;
          dragging = false;
          trackContainer.classList.remove('is-dragging');
          if (rafId != null) { cancelAnimationFrame(rafId); rafId = null; }
          try { trackContainer.releasePointerCapture(pointerId); } catch (_) {}
          pointerId = null;
        };
        trackContainer.addEventListener('pointerdown', onDown);
        trackContainer.addEventListener('pointermove', onMove);
        trackContainer.addEventListener('pointerup', onUp);
        trackContainer.addEventListener('pointercancel', onUp);
      }
    }
  }

  // —— 多加主机 + 魔尼带:已下线主流程,改进阶段 C 的 "升级方案 ›" 弹窗(state.extras 保留) ——
  // 历史代码见 快照/index-2026-05-18-v12-引导前.html
}

// ── v13 · Tab 头部:两副 mini 卡常驻(完成则显示缩略图,未完成则显示占位 + "正在装") ──
function renderBuildMiniCardSlot(buildIdx) {
  const build = state.builds[buildIdx];
  const isB1Done = buildComplete(state.builds[0]);
  const locked = buildIdx === 1 && !isB1Done;
  const done = buildComplete(build);
  const isActive = state.activeBuild === buildIdx && !locked;
  if (done) return renderBuildMiniCard(buildIdx, build, isActive);
  return `
    <div class="build-card build-card--placeholder ${locked ? 'is-locked' : ''} ${isActive ? 'is-active' : ''}">
      <div class="build-card__thumb build-card__thumb--placeholder">
        ${locked ? '🔒' : (isActive ? '✏️' : '○')}
      </div>
      <div class="build-card__body">
        <div class="build-card__title build-card__title--placeholder">
          ${locked ? `第 ${buildIdx + 1} 套待装` : (isActive ? `正在装第 ${buildIdx + 1} 套搭配` : `第 ${buildIdx + 1} 套待装`)}
        </div>
        <div class="build-card__parts">${locked ? '先装好第 1 套搭配' : '挑 3 件零件'}</div>
      </div>
    </div>
  `;
}

// ── v13 · build 完成后的定型卡(顶部冒出,4 层缩略图 + 文字 + "改" 链接)──
function renderBuildMiniCard(buildIdx, build, isActive) {
  const host = state.base.host;
  const imgHost = adaptImg('host',      host,           'overear');
  const imgFp   = adaptImg('faceplate', build.faceplate,'overear');
  const imgEp   = adaptImg('earpad',    build.earpad,   'overear');
  const imgHb   = adaptImg('headband',  build.headband, 'overear');
  const hbHex   = getColor(build.headband).hex;
  const parts = [
    getColor(build.faceplate).cn,
    getColor(build.headband).cn,
    getColor(build.earpad).cn,
  ].join(' · ');
  return `
    <div class="build-card ${isActive ? 'is-active' : ''}">
      <div class="build-card__thumb"
           style="--img-host:${imgHost}; --img-faceplate:${imgFp}; --img-earpad:${imgEp}; --img-headband:${imgHb}; --c-headband:${hbHex};">
        <span class="build-card__layer build-card__layer--shadow"></span>
        <span class="build-card__layer build-card__layer--earpad"></span>
        <span class="build-card__layer build-card__layer--faceplate"></span>
        <span class="build-card__layer build-card__layer--host"></span>
        <span class="build-card__layer build-card__layer--headband"></span>
      </div>
      <div class="build-card__body">
        <div class="build-card__title">✅ 第 ${buildIdx + 1} 套搭配</div>
        <div class="build-card__parts">${parts}</div>
      </div>
      <button class="build-card__reset" data-reset-build="${buildIdx}" title="${TR('reset_build_title')}">${TR('reset_build')}</button>
    </div>
  `;
}

// ── v13 · Build 槽位 picker 调度:所有槽位统一 block 模式(icon 在上,chip 横排在下,3 行左对齐) ──
function renderSlotPicker(buildIdx, slot) {
  const pool = slot.pool();
  if (slot.type === 'color') {
    return `
      <div class="slot-row slot-row--block" data-slot="${slot.key}">
        <div class="slot-row__head">
          <span class="slot-row__icon" title="${slot.label}">${slot.icon}</span>
          <span class="slot-row__label-text">${slot.label}</span>
        </div>
        <div class="slot-row__chips inline-picker">
          ${renderInlineChips(buildIdx, slot.key, pool)}
        </div>
      </div>
    `;
  }
  // headband:head 行带 label-text 跟面盖/皮套 head 同高(对齐 3 行 chip Y 位置);link-card 在 renderKit 顶部独立
  return `
    <div class="slot-row slot-row--block" data-slot="${slot.key}">
      <div class="slot-row__head">
        <span class="slot-row__icon" title="${slot.label}">${slot.icon}</span>
        <span class="slot-row__label-text">${slot.label}</span>
      </div>
      ${renderHeadbandGridHTML(buildIdx, pool)}
    </div>
  `;
}

// v15.15 · 头带↔皮套 绑定规则 link-card(从 renderSlotPicker 抽出,供 renderKit 顶部独立调用)
// 2026-06-11 用户(B方案):列3 绑定横条整条撤掉,绑定状态说明集中到列1 hero__bind-note(liquid 静态卡);
// 此函数负责把列1 卡的标题/正文/链接文字跟 headbandLinked 状态同步(解绑后变"头带独立挑选中/回到智能搭配›")
function syncBindNote() {
  const card = document.querySelector('.hero__bind-note');
  if (!card) return;
  const copy = buildLinkCardCopy(state.activeBuild);
  const titleEl = card.querySelector('.hero__bind-note__title');
  const bodyEl  = card.querySelector('.hero__bind-note__body');
  if (titleEl) titleEl.textContent = copy.title;
  if (bodyEl) bodyEl.innerHTML =
    copy.paras.map(p => `<p>${p}</p>`).join('') +
    `<button class="hero__bind-note__link" type="button" data-bind-toggle>${copy.action}</button>`;
}
// 列1 解绑/回归链接:事件委托绑一次(卡内容会被 syncBindNote 重写,委托不丢 handler)
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-bind-toggle]');
  if (!btn) return;
  state.headbandLinked = !state.headbandLinked;
  if (state.headbandLinked) {
    // 重新绑定:立即把当前套的头带改成皮套同色
    const ep = state.builds[state.activeBuild].earpad;
    if (ep) {
      const linkedHb = findLinkedHeadband(ep, state.activeBuild);
      if (linkedHb) state.builds[state.activeBuild].headband = linkedHb;
    }
  }
  render();
});

/* ============ ▶ 如何 DIY 教学视频(用户 2026-11-02,预览图 v7 定稿)============
   预览卡右上角「How it works」→ 整页盖偏白的雾,9:16 圆角视频从按钮处放大展开。
   - 电脑:视频 305 宽,在第二列里居中,第二列的白色大玻璃卡淡掉
   - 手机:视频 340 宽(窄屏再收),贴着预览卡顶、左右居中
   - 雾 fixed 盖满屏;播放器 absolute 挂在 body 上用文档坐标,跟着页面一起滚
   - 静音起播(点了才开声音),✕ / 点雾 / Esc 关;视频文件放在店铺 Files 里 */
(function () {
  var 视频地址 = 'https://cdn.shopify.com/s/files/1/0685/2100/1133/files/how-to-diy-720.mp4?v=1793628791';
  var 封面地址 = 'https://cdn.shopify.com/s/files/1/0685/2100/1133/files/how-to-diy-poster.jpg?v=1793628802';
  var 雾, 播放器, 视频, 进度, 声音键, 来源按钮, 淡掉的卡, 进度帧 = 0;
  var 少动 = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var 声音开 = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9h4l5-4v14l-5-4H4z"/><path d="M16.5 8.5a5 5 0 0 1 0 7"/><path d="M19 6a8.5 8.5 0 0 1 0 12"/></svg>';
  var 声音关 = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9h4l5-4v14l-5-4H4z"/><path d="M17 9.5l5 5M22 9.5l-5 5"/></svg>';

  function 建() {
    if (播放器) return;
    雾 = document.createElement('div');
    雾.className = 'howto-fog'; 雾.innerHTML = '<i></i>';
    播放器 = document.createElement('div');
    播放器.className = 'howto-player';
    播放器.setAttribute('role', 'dialog'); 播放器.setAttribute('aria-modal', 'true');
    播放器.setAttribute('aria-label', TR('howto_dialog'));
    播放器.innerHTML = '<video playsinline webkit-playsinline muted preload="none" poster="' + 封面地址 + '"></video>'
      + '<button type="button" class="howto-c howto-snd" aria-label="' + TR('howto_sound') + '">' + 声音关 + '</button>'
      + '<button type="button" class="howto-c howto-x" aria-label="' + TR('howto_close') + '">'
      + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>'
      + '<span class="howto-bar"><i></i></span>';
    document.body.append(雾, 播放器);
    视频 = 播放器.querySelector('video');
    进度 = 播放器.querySelector('.howto-bar i');
    声音键 = 播放器.querySelector('.howto-snd');
    雾.addEventListener('click', 关);
    播放器.querySelector('.howto-x').addEventListener('click', 关);
    声音键.addEventListener('click', function () {
      视频.muted = !视频.muted;
      声音键.innerHTML = 视频.muted ? 声音关 : 声音开;
      if (视频.paused) 视频.play().catch(function () {});
    });
    // 点画面 = 暂停 / 继续
    视频.addEventListener('click', function () { if (视频.paused) 视频.play().catch(function () {}); else 视频.pause(); });
  }

  // 进度条:播放时每帧按 currentTime 走,比 timeupdate(每秒 4 次)顺
  function 走进度() {
    if (视频.duration) 进度.style.transform = 'scaleX(' + (视频.currentTime / 视频.duration) + ')';
    if (播放器.classList.contains('is-on')) 进度帧 = requestAnimationFrame(走进度);
  }

  function 量位置() {
    var 手机 = window.innerWidth <= 760;
    var 卡 = 来源按钮.closest('.preview__framed').getBoundingClientRect();
    var 宽, 高, 左, 上;
    if (!手机) {
      var 列 = 来源按钮.closest('.col--preview').getBoundingClientRect();
      宽 = Math.min(305, 列.width - 6, (window.innerHeight - 40) * 9 / 16);
      高 = 宽 * 16 / 9;
      左 = 列.left + (列.width - 宽) / 2;
      上 = 列.top + (列.height - 高) / 2;
    } else {
      宽 = Math.min(340, document.documentElement.clientWidth - 40);
      高 = 宽 * 16 / 9;
      左 = 卡.left + (卡.width - 宽) / 2;
      上 = 卡.top - 4;
    }
    return { 手机: 手机, 宽: 宽, 高: 高, 左: 左 + window.scrollX, 上: 上 + window.scrollY };
  }

  function 摆(位) {
    播放器.style.left = 位.左 + 'px'; 播放器.style.top = 位.上 + 'px';
    播放器.style.width = 位.宽 + 'px'; 播放器.style.height = 位.高 + 'px';
  }

  function 开(按钮) {
    建();
    来源按钮 = 按钮;
    var 位 = 量位置();
    摆(位);
    if (!位.手机) {
      淡掉的卡 = 按钮.closest('.col--preview').querySelector('.preview');
      if (淡掉的卡) 淡掉的卡.classList.add('howto-fade');
    }
    if (!视频.getAttribute('src')) 视频.src = 视频地址;
    视频.muted = true; 声音键.innerHTML = 声音关;
    播放器.classList.add('is-on');
    雾.classList.add('is-on');
    // 视频没整个落在屏里(手机上常见)→ 平滑滚到上下居中,播放器是文档坐标,会跟着页面一起过来
    var 屏上 = 位.上 - window.scrollY;
    if (屏上 < 56 || 屏上 + 位.高 > window.innerHeight - 8) {
      window.scrollTo({ top: Math.max(0, 位.上 - Math.max(56, (window.innerHeight - 位.高) / 2)), behavior: 少动 ? 'auto' : 'smooth' });
    }
    // 从按钮中心放大出来(只动 transform / opacity,不触发重排)
    if (!少动 && 播放器.animate) {
      var 钮 = 按钮.getBoundingClientRect();
      var ox = 钮.left + 钮.width / 2 + window.scrollX - 位.左, oy = 钮.top + 钮.height / 2 + window.scrollY - 位.上;
      播放器.style.transformOrigin = ox + 'px ' + oy + 'px';
      播放器.animate([{ transform: 'scale(.12)', opacity: 0 }, { transform: 'scale(1)', opacity: 1 }],
        { duration: 420, easing: 'cubic-bezier(.2,.8,.2,1)' });
    }
    视频.play().catch(function () {});
    cancelAnimationFrame(进度帧); 进度帧 = requestAnimationFrame(走进度);
    播放器.querySelector('.howto-x').focus({ preventScroll: true });
  }

  function 关() {
    if (!播放器 || !播放器.classList.contains('is-on')) return;
    雾.classList.remove('is-on');
    if (淡掉的卡) { 淡掉的卡.classList.remove('howto-fade'); 淡掉的卡 = null; }
    var 收尾 = function () {
      播放器.classList.remove('is-on');
      播放器.getAnimations().forEach(function (an) { an.cancel(); });   // 先藏再撤动画,避免最后一帧弹回原大
      视频.pause();
      try { 视频.currentTime = 0; } catch (e) {}
      进度.style.transform = 'scaleX(0)';
      cancelAnimationFrame(进度帧);
      if (来源按钮) 来源按钮.focus({ preventScroll: true });
    };
    if (!少动 && 播放器.animate) {
      播放器.animate([{ transform: 'scale(1)', opacity: 1 }, { transform: 'scale(.12)', opacity: 0 }],
        { duration: 260, easing: 'cubic-bezier(.4,0,.6,1)', fill: 'forwards' }).onfinish = 收尾;
    } else 收尾();
  }

  document.addEventListener('click', function (e) {
    var 按钮 = e.target.closest('[data-howto-open]');
    if (按钮) { e.preventDefault(); 开(按钮); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') 关(); });
  // 转屏 / 改窗口大小:开着就重新摆位
  window.addEventListener('resize', function () { if (播放器 && 播放器.classList.contains('is-on')) 摆(量位置()); });
})();

// 同行 mini 色点(面盖 / 皮套,单选模型,防重复)
// v15.55 · 复用 picker-chip 结构(swatch + name),跟头带 chip 视觉造型完全一致(都带名字标签,等高)
function renderInlineChips(buildIdx, slotKey, pool) {
  const selected = state.builds[buildIdx][slotKey];
  const otherSlug = state.builds[1 - buildIdx][slotKey];
  return pool.map(c => {
    const isSel = selected === c.slug;
    // 被另一副占用 → 禁选 (防重复,确保 2 副耳机外观不同)
    const isUsedByOther = otherSlug && otherSlug === c.slug;
    const imgStyle = c.image ? ` --img:url('${c.image}');` : '';
    const swatchCls = c.image ? 'picker-chip__swatch picker-chip__swatch--transparent' : 'picker-chip__swatch';
    const disAttr = isUsedByOther ? ' disabled data-used-by-other="true"' : '';
    const title = isUsedByOther ? (dispName(c) + TR('note_used_other')) : dispName(c);
    const slotCn = slotKey === 'faceplate' ? '面盖' : '皮套';
    return `
      <button class="picker-chip" data-pick="${c.slug}" data-slot="${slotKey}"${disAttr}
              aria-pressed="${isSel}"
              aria-label="${slotCn} ${title}"
              data-pick-order="${isSel ? '✓' : ''}"
              title="${title}"
              style="--c:${c.hex};${imgStyle}">
        <span class="${swatchCls}"></span>
        <span class="picker-chip__name">${dispName(c)}</span>
      </button>
    `;
  }).join('');
}

// 头带底部通栏 · 系列 tab(纯色/线条/8 设计) + 当前系列 chip 横滑条
// 头带 tabs(design / line / solid 三类切换;Build 1/2 共享 state.headbandTab)
function headbandGroups(pool) {
  return {
    design: pool.filter(h => h.type === 'design'),
    line:   pool.filter(h => h.type === 'line'),
    solid:  pool.filter(h => h.type === 'solid'),
  };
}
// 头带 strip · 全 44 chip 一字铺(4 纯色 + 8 线条 + 32 设计),横滑 + scroll-snap,tab 跟随当前滑到的分类自动高亮
const HEADBAND_VISIBLE = 4;
function renderHeadbandGridHTML(buildIdx, pool) {
  const g = headbandGroups(pool);
  const allChips = [...g.design, ...g.line, ...g.solid];  // 一字铺,按 design→line→solid 顺序
  const selected = state.builds[buildIdx].headband;
  const otherSlug = state.builds[1 - buildIdx].headband;
  const total = allChips.length;
  const trackW = total > 0 ? Math.max(15, (HEADBAND_VISIBLE / total) * 100) : 100;
  return `
    <div class="picker-strip">
      <button class="picker-strip__arrow picker-strip__arrow--prev" type="button" aria-label="${TR('hb_prev_aria')}" data-headband-arrow="prev"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg></button>
      <div class="picker-strip__main">
        <div class="picker-row" data-headband-scroll>
          ${allChips.map(h => {
            // 智能避撞:Build 2 + linked → 跟 Build 1 皮套同底色的头带禁选
            const lockedColor = (state.headbandLinked && buildIdx === 1) ? state.builds[0].earpad : null;
            const isSel = selected === h.slug;
            const isUsedByOther = otherSlug && otherSlug === h.slug;
            const isBonus = h.isBonus;        // 标配头带(锁主机色,套装内已含)
            const isSameColorAsB1 = lockedColor && getHeadbandBaseColor(h.slug) === lockedColor;
            const imgStyle = h.image ? ` --img:url('${h.image}');` : '';
            const disAttr = (isUsedByOther || isBonus || isSameColorAsB1)
              ? ` disabled${isBonus ? ' data-bonus="true"' : isSameColorAsB1 ? ' data-same-color="true"' : ' data-used-by-other="true"'}`
              : '';
            const titleText = isBonus ? (dispName(h) + TR('note_bonus'))
                            : isSameColorAsB1 ? (dispName(h) + TR('note_same_b1'))
                            : isUsedByOther ? (dispName(h) + TR('note_used_other')) : dispName(h);
            /* headband slot aria uses localized part word */
      const bonusBadge = isBonus ? `<span class="picker-chip__bonus" title="${TR('bonus_badge_title')}">${TR('bonus_badge')}</span>` : '';
            const baseColor = getHeadbandBaseColor(h.slug);
            return `
              <button class="picker-chip" data-pick="${h.slug}" data-slot="headband" data-type="${h.type}" data-base-color="${baseColor}"${disAttr}
                      aria-pressed="${isSel}"
                      aria-label="${(PARTW[LOCALE] || PARTW.en).headband} ${titleText}"
                      data-pick-order="${isSel ? '✓' : ''}"
                      title="${titleText}"
                      style="--c:${h.hex}; --c-accent:${h.accentHex};${imgStyle}">
                <span class="picker-chip__swatch${h.image ? ' picker-chip__swatch--transparent' : ''}"></span>
                ${bonusBadge}
                <span class="picker-chip__name">${dispName(h)}</span>
              </button>
            `;
          }).join('')}
        </div>
        <div class="picker-track">
          <div class="picker-track__bar" data-headband-track style="--track-pos:0%; --track-w:${trackW}%;"></div>
        </div>
      </div>
      <button class="picker-strip__arrow picker-strip__arrow--next" type="button" aria-label="${TR('hb_next_aria')}" data-headband-arrow="next"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg></button>
    </div>
  `;
}

// v16.9 · 统一设置副数:加第2套时填默认配件(红框那套)、取消时清空;同步副数 chip 高亮 + 重渲染
// 真·瞬时滚动:多数横滑容器 CSS 带 scroll-behavior:smooth,直接赋值 scrollLeft 会被劫持成平滑滚
// (= 头带"弹转"/跟 FLIP 抢帧卡顿的根因)→ 程序化定位一律走此函数,临时关掉 smooth 再赋值
function instantScroll(el, left) {
  if (!el) return;
  const prev = el.style.scrollBehavior;
  el.style.scrollBehavior = 'auto';
  el.scrollLeft = Math.max(0, left);
  el.style.scrollBehavior = prev;
}

// —— 图卡集环形轮播(2026-06-13 方案1):transform 单步 + 搬卡复位,卡少也首尾无缝、永不卡死 ——
let exploreAnimating = false;
let exploreCurrent = 0;   // 环形轮播当前居中卡的逻辑索引(不依赖搬卡后的 DOM 位置)
// 图卡集分页计数:总数 = 卡总数;当前 = exploreCurrent 取模(环形可正负无限增减)
function updateExploreCounter() {
  const el = $('#explore-counter');
  const c  = $('#explore-carousel');
  if (!el || !c) return;
  const total = c.children.length;
  if (total <= 1) { el.style.display = 'none'; return; }   // 只 1 张不显示计数
  el.style.display = '';
  const cur = ((exploreCurrent % total) + total) % total + 1;
  const pad = n => String(n).padStart(2, '0');
  el.innerHTML = `<b>${pad(cur)}</b> / ${pad(total)}`;
}
/* ⚠️ 单位铁律(2026-07-29 修):translateX 走的是**布局坐标系**,而 getBoundingClientRect()
   给的是被祖先 transform:scale(0.85) 缩过的**视觉值**(section 桌面端)。
   原来 baseX 拿 `stage.clientWidth`(布局) 减 `card.getBoundingClientRect().width`(视觉),
   step 拿视觉卡宽加 gap(布局),两处都在跨坐标系做减法/加法 →
   实测 baseX 算成 62.36(应 46.47)、step 算成 189.28(应 220.56),图卡不在列4 正中。
   下面统一先反解缩放比 k,把视觉值换算回布局 px 再算。 */
function exploreScale() {                             // 反解祖先缩放比:视觉宽 ÷ 声明宽
  const card = $('#explore-carousel') && $('#explore-carousel').querySelector('.explore-card');
  if (!card) return 1;
  const css = parseFloat(getComputedStyle(card).width) || 0;
  const vis = card.getBoundingClientRect().width || 0;
  return (css > 0 && vis > 0) ? vis / css : 1;
}
function exploreCardW() {                             // 卡片宽度,布局 px
  const card = $('#explore-carousel') && $('#explore-carousel').querySelector('.explore-card');
  if (!card) return 0;
  return parseFloat(getComputedStyle(card).width) || card.offsetWidth || 0;
}
function exploreCardStep() {
  const c = $('#explore-carousel');
  if (!c || !c.querySelector('.explore-card')) return 0;
  const gap = parseFloat(getComputedStyle(c).columnGap || getComputedStyle(c).gap || '12') || 12;
  return exploreCardW() + gap;                        // 两项都是布局 px
}
function exploreBaseX() {
  const c = $('#explore-carousel');
  const stage = c && c.parentElement;                 // .explore__stage
  const card = c && c.querySelector('.explore-card');
  if (!c || !stage || !card) return 0;
  const k = exploreScale();
  const stageW = stage.getBoundingClientRect().width / k;   // 视觉宽 → 布局 px
  const cardW = exploreCardW();
  let x = (stageW - cardW) / 2;   // 让 DOM[0] 居中
  // 手机版有左侧垫卡时:再左移一张,改居中 DOM[1](=逻辑第 1 张),使左右都露半张(用户 2026-07-10)
  if (c.dataset.leftBuffer === '1') x -= exploreCardStep();
  return x;
}
function setExploreX(x, animate) {
  const c = $('#explore-carousel');
  if (!c) return;
  if (animate) {
    c.style.transition = '';                          // 用 CSS 默认 transition 平滑
    c.style.transform = `translateX(${x}px)`;
  } else {
    c.style.transition = 'none';                      // 瞬时:关动画再设,reflow 后恢复
    c.style.transform = `translateX(${x}px)`;
    void c.offsetWidth;
    c.style.transition = '';
  }
}
function exploreCenter() { setExploreX(exploreBaseX(), false); }   // 居中第一张(renderExplore 起点)
/* baseX 依赖舞台宽度,而 exploreCenter 原来只在 renderExplore 里算一次 —— 之后模块展开/窗口缩放
   导致舞台变宽变窄,图卡就停在旧位置了。这里补一个防抖重算。
   翻页逻辑每次都会把 x 复位回 base(DOM 轮转),所以任何时候重算回 base 都是对的,不会打断浏览。*/
(function () {
  let reCenterTimer;
  /* 除了真实的窗口 resize,也听模块自己的 diy:relayout。
     用途:模块展开/收起后画廊要重新居中。以前是 expand() 里 dispatchEvent(new Event('resize'))
     全局广播 —— 为了通知这一个监听器,却让宿主主题里所有听 resize 的组件跟着整页重排一次,
     是「展开末尾整页白一帧」最可疑的来源(2026-07-30)。改成局部事件后主题完全不受打扰。*/
  var onRelayout = function () {
    clearTimeout(reCenterTimer);
    reCenterTimer = setTimeout(function () { exploreCenter(); }, 120);
  };
  window.addEventListener('resize', onRelayout);
  window.addEventListener('diy:relayout', onRelayout);
})();
function exploreCycle(dir) {
  const c = $('#explore-carousel');
  if (!c || exploreAnimating) return;
  const cards = c.querySelectorAll('.explore-card');
  if (cards.length < 2) return;                       // 只 1 张不循环
  const step = exploreCardStep();
  const base = exploreBaseX();
  exploreAnimating = true;
  if (dir === 'next') {
    exploreCurrent++; updateExploreCounter();         // 即时更新计数(不等动画结束)
    setExploreX(base - step, true);                   // 平滑左移一格 → 下一张进中央
    setTimeout(() => {
      c.appendChild(c.querySelector('.explore-card'));// 首卡搬到尾,右侧永远有卡
      setExploreX(base, false);                       // 瞬时复位,视觉不变
      exploreAnimating = false;
    }, 370);                                          // 略大于 .35s transition
  } else {
    exploreCurrent--; updateExploreCounter();         // 即时更新计数
    c.insertBefore(cards[cards.length - 1], c.firstElementChild);  // 尾卡搬到头
    setExploreX(base - step, false);                  // 瞬时补偿,画面不变
    requestAnimationFrame(() => {
      setExploreX(base, true);                        // 平滑右移 → 上一张滑入中央
      setTimeout(() => { exploreAnimating = false; }, 370);
    });
  }
}

// 2026-06-11 用户:点"添加第2套"时 tab/图卡/列3 全是瞬间重绘跳变,晃眼 →
// FLIP 平滑过渡:重渲染前记住每个元素旧位置,重渲染后让它从旧位置滑到新位置(0.36s 缓动);
// 新出现的元素(第2套 tab/图卡)淡入+滑入。
//
// 🚨 2026-08-08 第 107 轮 · 别再给 #kit-list 加整列 opacity 动画
// 旧版这里有一句 #kit-list.animate([{opacity:.3},{opacity:1}], 260ms),本意是"压住重绘闪动"。
// 工作区根 _probe-kitswitch.mjs 做了对照实测(逐帧量列3 平均亮度,--legacy 可回放改前那版):
//   留着它  → 峰值 +18.5(整列被冲淡到 30%,透出背后浅底 = 用户说的"闪一下")
//   去掉它  → 峰值 +3.8(只是内容本身变了),根本没有它要治的"白闪"
// 也就是说那句话不是解药,它自己就是病。已删除,改成下面两件真事:
//   ① 列3 chips 做 FLIP 位移(Kit 2 会收起同底色头带 → chips 重排,让它滑过去而不是瞬移)
//   ② 列1/2/4 只给"文字真的变了"的那几个小元素做 190ms 淡入(面积小,不会有整列褪白感)
// 第 111 轮 · 用户要的「转一圈」:加 Kit 2 后图卡轮播自动转一整圈,15 张全部依次划过,
// 最后减速停在新加的那张 Kit 2 卡上 —— 让人看见"现在真的有 15 张了"。
//
// 上一版做的是「一道光沿单张卡边框绕一圈」,用户看了说不对,整段已删。要点记在这:
//   ⚠️ 这个轮播不吃 scrollLeft(overflow-x:visible,scrollLeft 恒为 0),scrollBy 完全无效。
//      它是 translateX 环形轮播,只能用 setExploreX / exploreBaseX / exploreCardStep 这套。
//
// 做法:先把当前这批卡克隆一份接在尾部(DOM 30 张),再一次性平移 (总数+1) 格 ——
// 动画全程零 DOM 操作,最流畅;转完删克隆 + DOM 轮转一格 + 瞬时复位,
// 中央正好是真正的 Kit 2 卡,和停下那一帧内容完全一致,所以看不出替换。
function 转一圈展示() {
  const c = $('#explore-carousel');
  if (!c || exploreAnimating) return;
  // 用户开了"减少动态效果"就别转,直接落到 Kit 2 那张
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    if (typeof exploreCycle === 'function') exploreCycle('next');
    return;
  }
  const 卡 = Array.prototype.slice.call(c.querySelectorAll('.explore-card'));
  const step = exploreCardStep();
  const base = exploreBaseX();
  if (卡.length < 3 || !step) return;

  // 🚨 用户报的"移影"真凶就在这 —— 必须先把幽灵清掉,否则转圈全程都是双影。
  // renderExplore() 里有个 2026-07-15 加的柔化机制:卡片列表一变就克隆**整条轮播**当幽灵盖在上面
  // (`.explore-carousel--ghost`,保留旧 transform、静止不动),底下重建,幽灵再淡出 0.45s。
  // 加 Kit 2 正好触发它(4 张 → 15 张)。于是:静止的旧幽灵 + 正在转的新轮播同时可见
  //  = 两张清晰的同款卡错开重叠,一张不动一张在跑。
  // 那个柔化是给"原地换搭配"用的,转一圈本身就是过渡,不需要它 —— 直接摘掉。
  const 舞台 = c.closest('.explore__stage');
  if (舞台) 舞台.querySelectorAll('.explore-carousel--ghost').forEach(function (g) { g.remove(); });
  const 格 = 卡.length + 1;              // 转满一圈 + 1 格 → 落点是 DOM[1] = 新加的 Kit 2 那张

  exploreAnimating = true;
  // 补位卡:平移这么多格时右侧才不会露空白。
  // ⚠️ 只克隆「够用」的张数,别整批克隆(第 113 轮):
  //    落点是 DOM[格],右侧还要再露 2 张,所以 DOM 总数够到 格+3 就行。
  //    15 张全克隆 = DOM 30 张、总宽 7000px+,光栅面积白白翻倍 —— 用户报的"移影"就出在这种
  //    大面积快速平移上(GPU 来不及重新光栅化,同一层的新旧 tile 会同时上屏)。
  const 需要 = 格 + 3;
  const 补 = Math.max(0, 需要 - 卡.length);
  const frag = document.createDocumentFragment();
  for (let i = 0; i < 补; i++) {
    const k = 卡[i % 卡.length].cloneNode(true);
    k.classList.add('diy-spin-clone');
    k.setAttribute('aria-hidden', 'true');
    frag.appendChild(k);
  }
  c.appendChild(frag);

  // ⚠️ 别用 linear:匀速转是跑马灯,不是转盘。也别用起步陡的曲线,用户会说"跑得太猛"。
  //    (本机 high-end-visual-design skill 明令禁 linear / ease-in-out 关键字)
  //
  // 曲线是算出来的,不是拍脑袋(第 112 轮,量的是"前 200ms 走完百分之多少"):
  //   .12,.66,.16,1 @1600ms → 前 200ms 就冲掉 55%,半程只用 173ms  ← 用户说"太猛"的那版
  //   .45,.05,.20,1 @2200ms → 前 200ms 只走 2.6%,半程 796ms,尾部 1052ms 长减速
  //   .5,.02,.25,1  @2400ms → 前 400ms 才走 5.6%,起步有"点了没反应"的迟疑感,否掉
  // 总时长 3400ms(1600 →2200 治"太猛"→2600 →3000 →116 轮用户再要慢→3400)。
  const 总时长 = 3400;
  c.style.transition = 'transform ' + 总时长 + 'ms cubic-bezier(.45,.05,.20,1)';
  requestAnimationFrame(function () {
    c.style.transform = 'translateX(' + (base - 格 * step) + 'px)';
  });

  /* ⚠️ 2026-08-18 修:这条收尾定时器原来【没有句柄、也没有自检】。
     转一圈要 3.46 秒,这期间 exploreAnimating 一直为 true(左右箭头哑),但 renderExplore()
     不受它拦 —— 用户在这 3.4 秒里改一下头带/面盖/皮套(每次都会走 render() → renderExplore()),
     整条卡片会被 innerHTML 重建并复位。而这个定时器仍会照常到期:
       .diy-spin-clone 一个也找不到(已被重建冲掉),却仍然把【新列表的第一张】搬到队尾
       并 exploreCurrent++ → 居中的卡和页码永久错开一格,没有任何路径能纠正回来。
     两道保险:① 句柄存全局,renderExplore() 开头清掉;② 到期先自检自己那批 DOM 还在不在。 */
  clearTimeout(window.__diySpinT);
  window.__diySpinT = setTimeout(function () {
    if (!c.querySelector('.diy-spin-clone')) { exploreAnimating = false; return; }   // 自己那批 DOM 已被冲掉:只解锁,不动 DOM
    c.querySelectorAll('.diy-spin-clone').forEach(function (n) { n.remove(); });
    c.appendChild(c.querySelector('.explore-card'));   // DOM 轮转 1 格,把 Kit 2 那张顶到中央
    c.style.transition = '';                           // 交还 CSS 里的默认 .35s
    setExploreX(base, false);                          // 瞬时复位,视觉与停下那帧一致
    exploreCurrent++;
    if (typeof updateExploreCounter === 'function') updateExploreCounter();
    exploreAnimating = false;
  }, 总时长 + 60);
}

function animateKitTransition(renderFn) {
  const EASE = 'cubic-bezier(.22,.61,.36,1)';
  const byAttr = attr => el => el.getAttribute(attr);
  const chipKey = el => el.dataset.slot + '|' + el.dataset.pick;   // 面盖/皮套可能同 slug,必须带槽位
  const snap = (sel, keyFn) => {
    const m = new Map();
    document.querySelectorAll(sel).forEach(el => m.set(keyFn(el), el.getBoundingClientRect()));
    return m;
  };
  const oldTabs  = snap('.build-tabs__tab', byAttr('data-build-tab'));
  const oldCards = snap('.explore-card', byAttr('data-card-key'));
  const oldChips = snap('#kit-list .picker-chip', chipKey);

  // 列1/2/4:先记下每个"叶子文本元素"此刻的字,重绘后只给真的变了的做淡入。
  // 列3 不纳入 —— 它整列 innerHTML 重建,所有元素都算"新的",纳进来就又变成整列闪。
  // .explore-card 内部也跳过 —— 那些卡自己已经在做 FLIP,叠两层动画会打架。
  //
  // ⚠️ key 必须用"结构路径"不能用节点本身:列1 bind-note、列2 preview-name 都是 innerHTML 整块重写,
  // 拿节点当 key 的话重写后全是新节点 → 连"星空银/大漠黄"这种压根没变的字也会跟着淡一遍,
  // 27 个元素一起淡 = 整列闪,又绕回列3 那个老毛病。按路径比对,只有真的换了字的才动。
  const pathOf = (el, root) => {
    const seg = [];
    for (let n = el; n && n !== root && n.parentElement; n = n.parentElement) {
      seg.push(n.tagName + Array.prototype.indexOf.call(n.parentElement.children, n));
    }
    return seg.reverse().join('>');
  };
  const eachLeafText = (fn) => {
    document.querySelectorAll('.col--hero, .col--preview, .col--explore').forEach(root => {
      root.querySelectorAll('*').forEach(el => {
        if (el.children.length || el.closest('.explore-card')) return;
        const t = el.textContent;
        if (t && t.trim() && t.length <= 120) fn(el, t, root.className + '|' + pathOf(el, root));
      });
    });
  };
  const oldText = new Map();
  eachLeafText((el, t, key) => oldText.set(key, t));

  renderFn();

  const play = (sel, keyFn, olds, opt = {}) => {
    document.querySelectorAll(sel).forEach(el => {
      const old = olds.get(keyFn(el));
      let 超限 = false;
      if (old) {
        const now = el.getBoundingClientRect();
        const dx = old.left - now.left, dy = old.top - now.top;
        // maxShift:位移大到不像"同一个元素挪了个位置"时,判定这次匹配不可信,不做位移动画。
        // 两个来源都踩过:
        //   ① 头带 strip 是横向滚动容器,切套数会主动滚到第2套那条,scrollLeft 一变 dx 就是几百 px,
        //      照着 FLIP 会把整行 chip 推出可视区 → 那行空掉 200ms(第 107 轮)
        //   ② 图卡的 key 只有 0/1/-1 三个值,15 张里 14 张都是 -1 全撞在一起,
        //      于是它们共用同一个旧位置,被派发 −2582px 这种荒谬位移(列宽才 390,第 109 轮)
        超限 = Math.abs(dx) > (opt.maxShift || 1e9) || Math.abs(dy) > (opt.maxShift || 1e9);
        if (!超限) {
          if (Math.abs(dx) > 1 || Math.abs(dy) > 1) {
            el.animate(
              [{ transform: `translate(${dx}px, ${dy}px)` }, { transform: 'translate(0, 0)' }],
              { duration: opt.dur || 360, easing: EASE }
            );
          }
          return;                       // 位移小 → 正常 FLIP(或原地不动),收工
        }
        // 匹配上了但位移大 = 同一个东西,只是列表重排把它挪远了。
        // 滑过去是大动作(用户嫌),淡入是无谓闪烁(用户也嫌,第 110 轮就栽在这) → 什么都不做最不打扰。
        return;
      }
      // 走到这里 = 真·新元素(旧列表里根本没有它)。
      // onlyEnter:只给值得强调的那个做入场,其余新元素静默出现。
      // 第 110 轮实测:加 Kit 2 时新增 11 张卡,只有 by-build="1" 那张是用户真正要看的,
      // 其余 10 张多在可视区外或只露一条边,给它们做动画纯属干扰(右边那条边"闪一下"就是这么来的)。
      if (opt.onlyEnter && !el.matches(opt.onlyEnter)) return;
      // 有 spin 的话,转一圈本身就是这张卡的入场,别再叠单卡动画 ——
      // WAAPI 的 transform 会盖过 CSS 的 scale(.92),动画一结束又跳回去,反而闪一下(第 113 轮)
      if (opt.spin) { 转一圈展示(); return; }
      // enterFrom 别给 0:整批换新时一堆元素同时从 0 起会空掉一帧,反而像闪
      el.animate(
        [{ opacity: opt.enterFrom ?? 0, transform: opt.enter || 'translateX(-14px)' }, { opacity: 1, transform: 'none' }],
        { duration: opt.dur || 360, easing: EASE }
      );
    });
  };
  play('.build-tabs__tab', byAttr('data-build-tab'), oldTabs);
  // 图卡(第 110 轮)
  // key 换成 data-card-key(机型+四个部件的内容指纹)。原来用 data-by-build 是错的 —— 它只有 0/1/-1
  // 三个取值,15 张里 14 张都撞成 -1,共用同一个旧位置,被派发 −2582px 的假位移(列宽才 390,第 109 轮)。
  // 换成内容指纹后实测:点击前那 4 张卡内容一个字都没变,全都能正确匹配上 → 走"什么都不做"。
  // maxShift 120 由 _probe-col4-swap.mjs 标定(这批重排位移最小 234.09),别心算改。
  // onlyEnter:11 张新卡里只有 Kit 2 那张触发"转一圈",其余静默出现。
  play('.explore-card', byAttr('data-card-key'), oldCards,
       { maxShift: 120, onlyEnter: '[data-by-build="1"]', spin: true });
  play('#kit-list .picker-chip', chipKey, oldChips, { dur: 260, enter: 'scale(.94)', enterFrom: .55, maxShift: 80 });

  // 列1/2/4:文字变了 / 新冒出来的(如 Kit 2 accessories 那行),柔和淡入,别硬切
  eachLeafText((el, t, key) => {
    if (oldText.get(key) === t) return;
    el.animate(
      [{ opacity: .2, transform: 'translateY(-2px)' }, { opacity: 1, transform: 'none' }],
      { duration: 190, easing: 'ease-out' }
    );
  });
}

/* 副数切换的【唯一入口】。chip 高亮 / 价格 / 副标题三者都由它保证一致。
   第 138 轮(2026-09-06)加 opts:分享链接落地那条路要复用这里的 chip 同步,
   但不能连带把「切去编辑第 2 套 + 头带滚到第 2 套那条」也做了 —— 收礼人刚进站,
   该看到的是第 1 套。opts 见下:
     保持当前焦点 —— 不动 state.activeBuild / 头带滚动目标(分享落地用)
     跳过渲染     —— 不自己 render(调用方紧接着就要 render,别渲两遍) */
function setKitCount(n, opts) {
  const o = opts || {};
  state.kitCount = n;
  if (n >= 2) {
    if (!buildComplete(state.builds[1])) {
      // 第2套智能默认:按评分表挑「第二套星级」最高的组合(避开第1套撞色 + 头带底色=该套配色)
      const best = pickBestSecondKit(state.base.host, state.builds[0]);
      if (best) {
        state.builds[1] = { ...best };
      } else {
        // 兜底:老 CP 逻辑(理论上 pickBestSecondKit 总有解,除非该主机下组合全熔断)
        const c2 = SECOND_PAIR[state.builds[0].earpad] || 'brown';
        state.builds[1] = { ...state.builds[0], earpad: c2, faceplate: 'silver' };
        state.builds[1].headband = findLinkedHeadband(c2, 1) || `solid-${c2}`;
      }
    }
    if (!o.保持当前焦点) {
      state.activeBuild = 1;   // 切去编辑第2套
      if (state.builds[1].headband && HEADBAND_MAP[state.builds[1].headband]) {
        state.headbandTab = HEADBAND_MAP[state.builds[1].headband].type;
        state.headbandScrollTo = state.builds[1].headband;
        state.headbandScrollMode = 'center';
      }
    }
  } else {
    state.builds[1] = { faceplate: null, headband: null, earpad: null };  // 取消第2套
    if (!o.保持当前焦点) state.activeBuild = 0;   // 切回第1套
  }
  document.querySelectorAll('#kit-count .kit-count__chip').forEach(c => {
    c.classList.toggle('is-active', parseInt(c.dataset.count, 10) === n);
  });
  state.__headbandInstant = true;   // 切套数时头带瞬时到位,不弹转(2026-06-11)
  if (o.跳过渲染) return;           // 调用方(init 首渲染前)紧接着自己 render,别渲两遍
  animateKitTransition(render);     // FLIP 平滑过渡替代瞬间重绘
  // 注:add-second 已搬到第2列预览区,点击它在第2列消失,第3列 picker 纵向不动,
  // 所以不再需要给第3列做滚动补偿(上一版的 scrollIntoView 已移除)
}

function renderCta() {
  const btn  = $('#add-to-cart');
  const main = $('#cta-main');
  const hint = $('#cta-hint');
  const n     = state.kitCount || 2;            // 当前选的副数
  const price = totalPriceMvp();                // 当前总价
  renderPriceDisplay(price, state.kitCount);    // 标价 + 「分开买 · 省多少」(有折扣时才是原价划线 + 折后价)
  // 红框位:买 N 套 = 立即拥有以上 X 种风格(数字跟套数,与下方 hint 口径一致)
  const stylesLine = $('#cta-styles');
  if (stylesLine) {
    const styleN = TR(n === 1 ? 'style_n_1' : n === 2 ? 'style_n_2' : 'style_n_3');
    stylesLine.innerHTML = TR('cta_styles', { n: n, styleN: styleN });
  }

  // 嫁接-21.13 · 防呆 A:按 kitCount 跨副检查,任意一副空就禁用 + 提示去装那副
  const buildsNeeded = state.builds.slice(0, n);
  const incompleteIdx = buildsNeeded.findIndex(b => !buildComplete(b));

  if (incompleteIdx === -1) {
    // 前 n 副全装好 → 还原原版"加入购物车 →"动作文案;品牌文案「一副的价格·一柜的风格」只留在图卡画廊买按钮(用户 2026-06-25)
    btn.disabled = false;
    btn.classList.remove('cta-btn--brand');
    main.textContent = TR('cta_add');
    const styleN = TR(n === 1 ? 'style_wear_1' : n === 2 ? 'style_wear_2' : 'style_wear_3');
    hint.textContent = TR('hint_full', { styleN: styleN });
    hint.hidden = false;
    hint.removeAttribute('data-go-build');
    hint.style.cursor = '';
    // 手机版:把折后价塞进按钮右侧(桌面该 span display:none,不受影响)
    const pm = document.getElementById('cta-price-mob');
    if (pm) { pm.textContent = (document.getElementById('total-price') || {}).textContent || ''; pm.hidden = false; }
    return;
  }

  // 有副空 → 禁用 + 提示去装(提示自身可点击跳 Tab)
  btn.disabled = true;
  btn.classList.remove('cta-btn--brand');
  const needBuild = state.builds[incompleteIdx];
  const cnt = [needBuild.faceplate, needBuild.headband, needBuild.earpad].filter(Boolean).length;
  const need = 3 - cnt;
  main.textContent = TR('cta_build_pair', { n: incompleteIdx + 1 });
  hint.textContent = TR('hint_need', { need: need });
  hint.hidden = false;
  hint.dataset.goBuild = incompleteIdx;
  // 未装完不显示价格(按钮此时是"先装好"提示)
  const pmOff = document.getElementById('cta-price-mob');
  if (pmOff) pmOff.hidden = true;
  hint.style.cursor = 'pointer';
}

// 购前引导:底部固定 library 视觉的 15 套 carousel + 👐 角标(前 2 张是 DIY)
function renderExploreCard(v) {
  if (!v) return '';
  const imgHost = adaptImg('host', v.host, v.form);
  const imgFp   = v.faceplate ? adaptImg('faceplate', v.faceplate, v.form) : 'none';
  const imgEp   = adaptImg('earpad', v.earpad, v.form);
  const imgHb   = adaptImg('headband', v.headband, v.form);
  const epHex   = getColor(v.earpad).hex;
  const handIcon = '<svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-1px;margin-right:3px"><path d="M12 4l1.8 5.2L19 11l-5.2 1.8L12 18l-1.8-5.2L5 11l5.2-1.8z"/></svg>';
  const hand = v.byBuild === 0 ? handIcon + TR('kit1_short') : v.byBuild === 1 ? handIcon + TR('kit2_short') : '';
  // 半包耳标准款(主机标配纯色头带)标"标配";换了设计款头带只标"半包耳"
  const isStdHalf = v.form === 'halfear' && v.headband === `solid-${v.earpad}`;
  const formBadge = v.form === 'overear' ? TR('form_overear') : (isStdHalf ? TR('form_half_std') : TR('form_halfear'));
  const isCurrent = v.byBuild === state.activeBuild;     // 当前装的那副 → 加白色底"选中态"
  // 搭配星级角标(全包耳 4 维 / 半包非标准款也打分;标准款 + 熔断不显示)
  const sb = scoreBuild(v);
  // 三色阶胶囊:5.0 黑金 / >4.5 深灰毛玻璃 / 其余浅灰毛玻璃
  const ratingTier = !sb ? '' : (sb.score >= 5 ? ' explore-card__rating--gold' : (sb.score > 4.5 ? ' explore-card__rating--mid' : ''));
  const ratingBadge = (sb && !sb.excluded)
    ? `<div class="explore-card__rating${ratingTier}">${starRatingHTML(sb.score, 'sm')}</div>`
    : '';
  // 专属作品名(卡内底部,星级下方)
  const enTitle = designNameEN(v);
  const zhTitle = designName(v);
  // NAME_LANG: 'en' 纯英文上线态;'dev' 英文为主 + 中文小字(开发期审稿)
  const nameInner = (NAME_LANG === 'en' || !zhTitle)
    ? enTitle
    : `${enTitle}<span class="explore-card__name-zh">${zhTitle}</span>`;
  const nameTag = enTitle ? `<div class="explore-card__name">${nameInner}</div>` : '';
  return `
    <div class="explore-card${isCurrent ? ' is-current' : ''}" data-form="${v.form}" data-by-build="${v.byBuild}"
         data-card-key="${v.form}|${v.host}|${v.faceplate || '-'}|${v.earpad}|${v.headband}"
         style="--img-host:${imgHost}; --img-faceplate:${imgFp}; --img-earpad:${imgEp}; --img-headband:${imgHb}; --c-earpad-fb:${epHex};">
      <div class="explore-card__form${isStdHalf ? ' explore-card__form--std' : ''}">${formBadge}</div>
      <button class="explore-card__zoom" type="button" aria-label="${TR('zoom_aria')}" data-explore-zoom><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 3 21 3 21 9"></polyline><polyline points="9 21 3 21 3 15"></polyline><line x1="21" y1="3" x2="14" y2="10"></line><line x1="3" y1="21" x2="10" y2="14"></line></svg></button>
      ${ratingBadge}
      <div class="preview-card__inner">
        <span class="preview-card__layer preview-card__layer--shadow"></span>
        <span class="preview-card__layer preview-card__layer--earpad"></span>
        <span class="preview-card__layer preview-card__layer--faceplate"></span>
        <span class="preview-card__layer preview-card__layer--host"></span>
        <span class="preview-card__layer preview-card__layer--headband"></span>
      </div>
      ${nameTag}
      ${hand ? `<div class="explore-card__hand">${hand}</div>` : ''}
    </div>
  `;
}
// 合成某副的实时变体(没装齐时降级半包耳 fallback,保证 byBuild=0/1 卡片始终存在)
function buildSlotVariant(buildIdx) {
  const build = state.builds[buildIdx];
  const host = state.base.host;
  const halfEarpad = LOCKED_PAIRS[host];
  const lockedHb = `solid-${halfEarpad}`;
  const hasFull = build.faceplate && build.earpad;
  const v = hasFull ? {
    form: 'overear', host,
    faceplate: build.faceplate, earpad: build.earpad,
    headband: build.headband || lockedHb,
  } : {
    form: 'halfear', host,
    faceplate: null, earpad: halfEarpad,
    headband: build.headband || lockedHb,
  };
  v.byBuild = buildIdx;
  return v;
}
// 用户:去掉到尾/到头变灰 —— 变灰让人以为"到头不能点",跟无限循环矛盾。
// 箭头永远亮,点到最后一张自动顺滑循环回第一张,才是顺手的无限循环。
function updateExploreArrows() {
  $('#explore-arrow-next')?.classList.remove('is-dim');
  $('#explore-arrow-prev')?.classList.remove('is-dim');
}

function renderExplore() {
  const carousel = $('#explore-carousel');
  if (!carousel) return;
  /* ⚠️ 2026-08-18:这里会把轮播整条 innerHTML 重建。若「转一圈展示」正在跑(3.46s),
     它那条收尾定时器必须一起取消并解锁 —— 否则它到期后会按【旧的一批 DOM】去轮转,
     把新列表的第一张搬到队尾 + exploreCurrent++,居中卡与页码永久错开一格。 */
  clearTimeout(window.__diySpinT);
  if (typeof exploreAnimating !== 'undefined') exploreAnimating = false;
  const cards = [];
  // slot1 永远显示(Build 1 进站已默认装好)
  cards.push(buildSlotVariant(0));
  // slot2 只在 Build 2 真装齐时出现 — 没 DIY 完不放"标配版"半包耳 fallback
  if (buildComplete(state.builds[1])) {
    cards.push(buildSlotVariant(1));
  }
  // 后接串色搭配(byBuild < 0)
  const others = enumerate().filter(v => v.byBuild < 0);
  cards.push(...others);
  // 手机版:环形轮播两侧都露半张卡(对称平衡)——把最后一张挪到最前当左侧垫卡,
  // 让逻辑第 1 张落在 DOM[1] 居中,左边有垫卡露半张、右边有下一张露半张;桌面横版不动(用户 2026-07-10)
  const exMobile = window.matchMedia && window.matchMedia('(max-width: 760px), (max-device-width: 760px)').matches;
  const disp = (exMobile && cards.length >= 3) ? [cards[cards.length - 1], ...cards.slice(0, -1)] : cards;
  // 图卡集换搭配丝滑化(2026-07-15):重建前克隆当前整条轮播当"幽灵"盖上,底下重建+居中,
  // 预加载好当前这副的新图后幽灵淡出 → 右边图卡跟预览一样柔,不再硬切。只在卡片真变时淡。
  const newSig = disp.map(v => variantSig(v)).join(',');
  const oldSig = carousel.dataset.sig || '';
  const stage = carousel.closest('.explore__stage');
  const reduceEx = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let exGhost = null;
  if (stage && carousel.children.length && oldSig && oldSig !== newSig && !reduceEx) {
    stage.querySelectorAll('.explore-carousel--ghost').forEach(g => g.remove());   // 狂点不堆叠
    exGhost = carousel.cloneNode(true);
    exGhost.id = '';   // 去重复 id
    exGhost.classList.add('explore-carousel--ghost');
    exGhost.style.position = 'absolute';
    exGhost.style.left = '0';
    exGhost.style.top = '0';
    exGhost.style.width = carousel.offsetWidth + 'px';
    exGhost.style.height = carousel.offsetHeight + 'px';
    exGhost.style.transform = getComputedStyle(carousel).transform;   // 保留旧的居中位置
    exGhost.style.transition = 'opacity .45s ease';
    exGhost.style.opacity = '1';
    exGhost.style.zIndex = '4';   // 盖住新轮播,但低于箭头(z5)
    exGhost.style.pointerEvents = 'none';
    stage.appendChild(exGhost);
  }
  carousel.dataset.leftBuffer = (disp !== cards) ? '1' : '0';
  carousel.innerHTML = disp.map(v => renderExploreCard(v)).join('');
  carousel.dataset.sig = newSig;
  // 环形轮播(方案1):每次重渲染回到"第一张居中"起点,左右都有卡可循环
  exploreCenter();
  exploreCurrent = 0; updateExploreCounter();   // 重渲染回到第 1 张,刷新计数总数
  updateExploreArrows();
  // 第 1/2 张可点选 → 切对应 Build 的 activeBuild,Tab 自动跟随
  carousel.querySelectorAll('.explore-card[data-by-build="0"], .explore-card[data-by-build="1"]').forEach(card => {
    card.addEventListener('click', () => {
      const idx = +card.dataset.byBuild;
      // Build 2 卡在 Build 1 未装齐时禁点(避免越级)
      if (idx === 1 && !buildComplete(state.builds[0])) return;
      state.activeBuild = idx;
      state.previewMode = 'build';
      render();
      // 注:原这里有 .kit scrollIntoView('smooth') 让用户看切换效果,但点这些卡会同时打开画廊(盖住整个区域)→
      // 滚动既看不到又造成"打开画廊时窗口自动上滚"(用户 2026-07-26)。画廊已覆盖,滚动纯多余,故删除。
    });
  });
  // 预加载好当前这副(居中卡 = cards[0])的新图 → 幽灵淡出 → 移除
  if (exGhost) {
    preloadVariant(cards[0]).then(() => {
      requestAnimationFrame(() => { exGhost.style.opacity = '0'; });
      setTimeout(() => exGhost.remove(), 500);
    });
  }
}

function render() {
  renderHero();
  syncBindNote();   // 列1 绑定说明卡:标题/正文/链接随 headbandLinked 状态切换(2026-06-11 B方案)
  // 横版砍掉顶部 15 戴法 variants 宫格(renderVariants 已不调用)
  renderHostBar();
  renderPreview();
  renderKit();
  renderExplore();
  renderCta();
}

/* ============================================================
   §13 ANIM · 数字 count-up
   ============================================================ */
function animateCount(el, to) {
  const from = parseInt(el.textContent, 10) || 0;
  if (from === to) return;
  const dur = 380;
  const start = performance.now();
  function tick(now) {
    const t = Math.min(1, (now - start) / dur);
    const eased = 1 - Math.pow(1 - t, 3);
    el.textContent = Math.round(from + (to - from) * eased);
    if (t < 1) requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
}

/* ============================================================
   §14 INIT
   ============================================================ */
// 判断变体是否所有图层 PNG 完整(2026-05-20:半包耳 8 张到位后放开)
function isFullVariant(v) {
  if (!ADAPT_IMAGES.headband.has(v.headband)) return false;
  if (v.form === 'overear') {
    // 全包耳 4 层:头带 + 面盖 + 主机 + 全包皮套
    if (!ADAPT_IMAGES.host.has(v.host)) return false;
    if (v.faceplate && !ADAPT_IMAGES.faceplate.has(v.faceplate)) return false;
    if (!ADAPT_IMAGES.earpad.has(v.earpad)) return false;
    return true;
  }
  if (v.form === 'halfear') {
    // 半包耳 3 层:头带 + 半包主机 + 半包皮套(无面盖)
    if (!ADAPT_IMAGES.host_halfear.has(v.host)) return false;
    if (!ADAPT_IMAGES.earpad_halfear.has(v.earpad)) return false;
    return true;
  }
  return false;
}
// 找到第一个 4 层全有 PNG 的全包耳变体(进站默认显示完整耳机)
function firstFullVariantIdx(variants) {
  for (let i = 0; i < variants.length; i++) {
    if (isFullVariant(variants[i])) return i;
  }
  return 0;
}

// 用户在 DIY 区点了某模块的某色 → 主图自动切到"包含该色的第一个 4 层全 PNG 变体"
function selectVariantBy(field, slug) {
  const variants = enumerate();
  // 优先:overear 形态 + 4 层全 PNG + 该 field == slug
  for (let i = 0; i < variants.length; i++) {
    const v = variants[i];
    if (v[field] !== slug) continue;
    if (v.form !== 'overear') continue;
    if (!ADAPT_IMAGES.host.has(v.host)) continue;
    if (v.faceplate && !ADAPT_IMAGES.faceplate.has(v.faceplate)) continue;
    if (!ADAPT_IMAGES.earpad.has(v.earpad)) continue;
    if (!ADAPT_IMAGES.headband.has(v.headband)) continue;
    state.currentVariantIdx = i;
    return true;
  }
  // 退化:任意包含该色的变体
  for (let i = 0; i < variants.length; i++) {
    if (variants[i][field] === slug) {
      state.currentVariantIdx = i;
      return true;
    }
  }
  return false;
}

function init() {
  // 默认选第一个 4 层全 PNG 的变体(进站第一眼是完整耳机,不是半包 fallback)
  const initialVariants = enumerate();
  state.currentVariantIdx = firstFullVariantIdx(initialVariants);

  // 横版砍掉 variants 宫格 → 原 variantsGrid scroll + variants__track slider 整块删除

  // 横版只保留 build 实时单副预览 → 原 preview-carousel library 滑动监听整块删除

  // 用户:「如何 DIY」桌面永久释放展开;手机版(≤760)恢复折叠:点整卡 toggle 教学+绑定说明(2026-07-09)
  const heroFaqEl = $('.hero__faq');
  // 2026-10-18 用户:展开/收起要「流畅地长下来」,不要突然弹出 → 整块面板高度从旧值过渡到新值,文字跟着淡入/淡出。
  // 收起时先让文字留着、等面板缩完再真正藏起来(否则文字一瞬间消失、只剩空框在缩)。
  let 面板动画收尾 = null;
  if (heroFaqEl) heroFaqEl.addEventListener('click', (e) => {
    if (!(window.matchMedia && window.matchMedia('(max-width: 760px), (max-device-width: 760px)').matches)) return;  // 桌面不折叠,保持永久展开
    if (e.target.closest('a, button:not(.hero__faq__plus)')) return;                       // 不拦教学内部链接/其它按钮
    if (面板动画收尾) 面板动画收尾();                                                        // 上一次还没播完 → 直接落到终点再开始这次
    const panel = heroFaqEl.closest('.hero__info-panel') || heroFaqEl;
    const 要开 = !state.heroGuideOpen;
    /* 2026-10-23 第三版(用户:展开后「依然会弹震一下」)。模拟器屏幕探针(自动点 + 号、屏上显示每帧耗时,已用完删除)实测:
       空闲每帧 16~17ms,展开/收起期间 20~44ms、最慢 162ms —— 原来动的是面板 height,
       面板每高 1px,下面 2000 多 px 的整个配置器都要重排一次,手机一帧排不完就掉帧、看着一顿一跳。
       改成:动画期间整页排版一律停在【点之前】的样子,播完才排一次(那一帧画面不变,看不出来)。动画只动
         ① 面板下方的几大块:transform 位移(显卡合成,不重排);
         ② 面板自己:clip-path 裁剪露出多少(只重画面板这一小块);展开时面板直接是展开后的高度,
            用等量的负 margin-bottom 把多出来的占位抵消掉,下面几块的排版就一动不动。
       ⚠️ clip-path 别用负的 inset(往盒外多露):无头 WebKit 支持,iOS 模拟器上整段动画直接跳到终点。
       ⚠️ 不能反过来「先排到展开后、再把下面几块用位移挪回原处」:iOS 模拟器实测,下面几块被排到屏幕外后
          再位移回来,起跑那几帧是空白的(常驻 will-change 也一样),看着像内容先消失再出现。 */
    const 量高 = () => { const r = panel.getBoundingClientRect(); const k = panel.offsetWidth ? r.width / panel.offsetWidth : 1; return r.height / (k || 1); };   // 小数高度,并扣掉祖先 transform 缩放
    // 面板下方要跟着走的块:从面板往上到 app-shell,每一层后面的兄弟(手机上就是 col--preview / col--kit / col--explore)
    // ⚠️ 标题上方那条彩色小横条是 .cta-bar::before(absolute,但 .cta-bar 本身没定位,所以一路借到 app-shell 的顶上去显示)。
    //    给它所在那一列加 transform,那一列就成了它的定位基准 → 小横条被带到屏幕外,动画期间消失(用户 2026-10-23:「小横条闪一下」)。
    //    所以含 .cta-bar 的那一列不整体位移,只移它里面除 .cta-bar 以外的孩子;购物车栏本身在屏幕外很远,不动也看不出。
    const 下方 = [];
    for (let el = panel; el && el.parentElement && !el.classList.contains('app-shell'); el = el.parentElement)
      for (let sib = el.nextElementSibling; sib; sib = sib.nextElementSibling) {
        if (sib.querySelector('.cta-bar')) [...sib.children].forEach(ch => { if (!ch.classList.contains('cta-bar') && !ch.querySelector('.cta-bar')) 下方.push(ch); });
        else 下方.push(sib);
      }
    const 起 = 量高();
    state.heroGuideOpen = 要开;
    renderHero();
    const 终 = 量高();
    if (!panel.animate || Math.abs(起 - 终) < 0.5 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!要开) { state.heroGuideOpen = true; renderHero(); }                               // 收起:排版留在展开态,播完才真正收
    const 差 = 终 - 起;                                                                     // 展开为正,收起为负
    const cs = getComputedStyle(panel);
    const 圆角 = cs.borderTopLeftRadius || '0px';
    const 裁 = (下) => 'inset(0px 0px ' + Math.max(0, 下).toFixed(2) + 'px 0px round ' + 圆角 + ')';
    const 移 = (y) => 'translateY(' + y.toFixed(2) + 'px)';
    const 文字 = [...panel.querySelectorAll('#hero-guide, .hero__bind-note')];
    const 旧样式 = panel.getAttribute('style');
    const 藏 = Math.abs(差);                                                               // 面板要被裁掉的那一截
    if (要开) {
      panel.style.height = 终 + 'px';
      panel.style.marginBottom = (-差) + 'px';                                             // 抵消多出来的高度:面板之后的排版停在点之前
      文字.forEach(el => { el.style.opacity = '0'; });
    }
    panel.style.clipPath = panel.style.webkitClipPath = 裁(要开 ? 藏 : 0);
    // 上下两块之间那条白线是上面这块(col--hero)的 border-bottom。动画期间上面这块排版不动,线就会停在原地、
    // 播完才一下跳走(用户 2026-10-23:「展开后白线消失」)。→ 动画期间把线藏掉,在下面那块顶上画一条一样的(box-shadow 往上 1px),跟着一起滑。
    const 上块 = panel.closest('.col'), 下块 = 上块 && 上块.nextElementSibling;
    const 线 = 上块 ? getComputedStyle(上块) : null, 线宽 = 线 ? parseFloat(线.borderBottomWidth) || 0 : 0;
    const 上块旧 = 上块 ? 上块.getAttribute('style') : null, 下块旧 = 下块 ? 下块.getAttribute('style') : null;
    if (线宽 > 0 && 下块) {
      下块.style.boxShadow = '0 -' + 线宽 + 'px 0 0 ' + 线.borderBottomColor;
      上块.style.borderBottomColor = 'transparent';
    }
    const 时长 = 420, 曲线 = 'cubic-bezier(.25,.1,.25,1)';
    let 动画们 = [], 已收尾 = false;
    面板动画收尾 = () => {
      if (已收尾) return; 已收尾 = true;
      面板动画收尾 = null;
      动画们.forEach(a => a.cancel());
      下方.forEach(el => { el.style.transform = ''; el.style.willChange = ''; });
      if (旧样式 === null) panel.removeAttribute('style'); else panel.setAttribute('style', 旧样式);
      if (线宽 > 0 && 下块) {
        if (上块旧 === null) 上块.removeAttribute('style'); else 上块.setAttribute('style', 上块旧);
        下块.style.boxShadow = '';
        if (下块旧 !== null && /box-shadow/.test(下块旧)) 下块.setAttribute('style', 下块旧.replace(/transform:[^;]*;?/, '').replace(/will-change:[^;]*;?/, ''));
      }
      文字.forEach(el => { el.style.opacity = ''; });
      if (!要开) { state.heroGuideOpen = false; renderHero(); }                           // 位移/裁剪撤掉的同一刻排好终态,画面不变
    };
    下方.forEach(el => { el.style.willChange = 'transform'; });
    // 等手机「缓过来」再起跑。模拟器探针实测两段重活:① 点下去那 2~3 帧(整页排版 + 新建图层 + 画新文字)40~60ms;
    // ② 动画【开始的那一帧】还要再建一次动画图层,又是 70+45ms —— 动画时钟此时已在走,下面那块两帧就走掉 234px、直接「跳」出屏幕。
    // 所以:先把动画建好、以极慢速度跑着(画面跟点之前一模一样),让 ①② 的重活都在时钟真正走之前做完,
    // 连着 2 帧恢复到 <22ms 才按播放(最多等 10 帧兜底)。× 号点下就转了,用户有反馈,多等的这几帧看不出。
    const 等稳 = (cb) => { let 上 = 0, 稳 = 0, 次 = 0; const 看 = (t) => { if (上) { 稳 = (t - 上 < 22) ? 稳 + 1 : 0; 次++; } 上 = t; if (稳 >= 2 || 次 >= 10) cb(); else requestAnimationFrame(看); }; requestAnimationFrame(看); };
    const 选项 = { duration: 时长, easing: 曲线, fill: 'forwards' };
    动画们 = 下方.map(el => el.animate([{ transform: 移(0) }, { transform: 移(差) }], 选项));
    const 裁动画 = panel.animate([{ clipPath: 裁(要开 ? 藏 : 0) }, { clipPath: 裁(要开 ? 0 : 藏) }], 选项);
    动画们.push(裁动画);
    文字.forEach(el => 动画们.push(el.animate([{ opacity: 要开 ? 0 : 1 }, { opacity: 要开 ? 1 : 0 }], { duration: 时长, easing: 'ease', fill: 'forwards' })));
    // 暂停的动画手机不建图层,真正跑起来那一帧才建(实测又是一帧 42~88ms)→ 改成先以 1/1000 速度「跑着」(看起来不动),
    // 图层在这几帧里建好,稳了再把速度调回 1。
    动画们.forEach(a => { a.playbackRate = 0.001; });
    裁动画.onfinish = () => { if (面板动画收尾) 面板动画收尾(); };
    等稳(() => { if (!已收尾) 动画们.forEach(a => { if (a.updatePlaybackRate) a.updatePlaybackRate(1); else a.playbackRate = 1; }); });
  });

  // v16.1 MVP · 加入购物车 = 直跳 Shopify(Shift+点击 = 弹 JSON modal review)
  $('#add-to-cart').addEventListener('click', (e) => {
    if ($('#add-to-cart').disabled) return;
    mvpAddToCart(e);
  });
  // 嫁接-21.13 · 防呆 A · CTA hint 自身可点:禁用状态下点提示跳到未完成那副 Tab + 滚到 picker
  $('#cta-hint')?.addEventListener('click', (e) => {
    const hint = $('#cta-hint');
    const goBuild = hint?.dataset.goBuild;
    if (goBuild === undefined || goBuild === '') return;
    e.preventDefault();
    e.stopPropagation();
    const tab = document.querySelector(`[data-build-tab="${goBuild}"]`);
    if (tab && !tab.classList.contains('is-locked')) tab.click();
    // 滚到对应 picker 让用户视野跟上
    setTimeout(() => {
      const panel = document.querySelector(`.build-tabs__panel[data-build="${goBuild}"]`);
      panel?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 80);
  });
  // 副数选择器(1/2/3 副)click + 同步 state.kitCount + 刷价格
  document.querySelectorAll('#kit-count .kit-count__chip').forEach(chip => {
    chip.addEventListener('click', () => {
      if (chip.disabled) return;
      const n = parseInt(chip.dataset.count, 10);
      setKitCount(n);   // v16.9 · 统一:填/清第2套配件 + 同步 chip + 重渲染
    });
  });
  // 嫁接-11 · 头带左右箭头翻页(scroll 4 chip 一组)
  document.addEventListener('click', (e) => {
    const arrow = e.target.closest('[data-headband-arrow]');
    if (!arrow) return;
    const direction = arrow.dataset.headbandArrow;
    const row = arrow.closest('.picker-strip')?.querySelector('[data-headband-scroll]');
    if (!row) return;
    const chip = row.querySelector('.picker-chip');
    if (!chip) return;
    const step = (chip.offsetWidth + 10) * 4;   // 一次翻 4 chip + 3 gap
    row.scrollBy({ left: direction === 'next' ? step : -step, behavior: 'smooth' });
  });

  // 修复-13 · explore-carousel 左右翻页箭头(桌面端鼠标拖不动 carousel,加箭头)
  const exCarousel = $('#explore-carousel');
  const exPrev = $('#explore-arrow-prev');
  const exNext = $('#explore-arrow-next');
  // 方案1 环形轮播:箭头调 exploreCycle(transform 单步搬卡,控制器在上方 instantScroll 之后)
  exPrev?.addEventListener('click', () => exploreCycle('prev'));
  exNext?.addEventListener('click', () => exploreCycle('next'));
  // 手机版:底部图卡集加手指横滑翻页(桌面靠箭头,箭头在 ≤520px 隐藏 → 手机原本翻不动)(用户 2026-07-10)
  // 2026-10-23 用户:「一刷就溜到底、靠力度感应,不要硬缓硬缓的」→ 改成 iPhone 相册那种手感:
  //   ① 手指按住时卡片跟着手走(原来手指动、卡不动,松手才整张跳一格);
  //   ② 松手按手指速度推算还能滑多远(iOS 默认减速率 0.998/ms → 距离 ≈ 速度 × 450),一路滑过几张、减速停在最近那张正中;
  //   ③ 轻轻一拨(>30px 没甩出速度)仍翻一张,跟原来一样。
  //   环形轮播:拖过半张就把一张卡从头搬到尾(或反过来)并补偿位移,所以往哪边拖都永远有卡。
  if (exCarousel) {
    let sx = 0, sy = 0, swiping = false, swipeGuard = false, 采样 = [], 偏 = 0, 转 = 0, 底 = 0, 步 = 0;
    const 写X = (x) => { exCarousel.style.transition = 'none'; exCarousel.style.transform = 'translateX(' + x + 'px)'; };
    exCarousel.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1 || exploreAnimating) return;   // 多指(缩放)不拦;上一下还在滑就先不接
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; swiping = false; 偏 = 0; 转 = 0;
      采样 = [{ x: sx, t: e.timeStamp }];
    }, { passive: true });
    exCarousel.addEventListener('touchmove', function (e) {
      if (e.touches.length !== 1 || exploreAnimating) return;
      const x = e.touches[0].clientX, dx = x - sx, dy = e.touches[0].clientY - sy;
      // 横移 > 竖移 且超 10px 才认作翻页手势;竖滑照常滚页面,不拦
      if (!swiping && Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) {
        swiping = true; 底 = exploreBaseX(); 步 = exploreCardStep();
      }
      if (!swiping) return;
      e.preventDefault();   // 拦掉横向拖动带出的页面滚动/回弹
      采样.push({ x: x, t: e.timeStamp }); if (采样.length > 6) 采样.shift();
      const k = exploreScale() || 1;
      偏 = dx / k + 转 * 步;                                  // 手指位移换算成布局 px
      while (步 > 0 && 偏 < -步 / 2) { exCarousel.appendChild(exCarousel.querySelector('.explore-card')); 转 += 1; 偏 += 步; exploreCurrent++; }
      while (步 > 0 && 偏 > 步 / 2) { const cs = exCarousel.querySelectorAll('.explore-card'); exCarousel.insertBefore(cs[cs.length - 1], exCarousel.firstElementChild); 转 -= 1; 偏 -= 步; exploreCurrent--; }
      写X(底 + 偏);
      updateExploreCounter();
    }, { passive: false });
    exCarousel.addEventListener('touchend', function (e) {
      if (!swiping) return;              // 只是轻点 → 交给下面 open() 的 click 开全屏
      swiping = false;
      swipeGuard = true;                 // 打标:随后浏览器补发的那次 click 是滑动误触,吃掉
      setTimeout(function () { swipeGuard = false; }, 400);
      const dx = e.changedTouches[0].clientX - sx, k = exploreScale() || 1;
      // 速度:最近 ~100ms 的平均(px/ms,布局坐标);停住 >100ms 再松手 = 不甩
      const 末 = 采样[采样.length - 1]; let 首 = 采样[0];
      for (const s of 采样) if (末.t - s.t <= 100) { 首 = s; break; }
      const v = (e.timeStamp - 末.t > 100 || 末.t === 首.t) ? 0 : (末.x - 首.x) / (末.t - 首.t) / k;
      const cards = exCarousel.querySelectorAll('.explore-card'), N = cards.length;
      const lb = exCarousel.dataset.leftBuffer === '1' ? 1 : 0;
      const 上限 = Math.max(1, N - 2 - lb);                  // 一次最多滑几张:目标卡右边还得留一张,环形才接得上
      let n = Math.round(-(偏 + v * 450) / 步);              // 正 = 往后翻(手指左甩)
      if (n === 0 && 转 === 0 && Math.abs(dx) > 30) n = dx < 0 ? 1 : -1;   // 轻轻一拨仍翻一张
      n = Math.max(-上限, Math.min(上限, n));
      if (N < 2) n = 0;
      let 起X = 底 + 偏;
      if (n < 0) {                                          // 往前翻:先把 |n| 张从尾搬到头,补偿位移,画面不变
        for (let i = 0; i < -n; i++) { const cs = exCarousel.querySelectorAll('.explore-card'); exCarousel.insertBefore(cs[cs.length - 1], exCarousel.firstElementChild); }
        起X -= -n * 步; 写X(起X); void exCarousel.offsetWidth;
      }
      const 终X = n > 0 ? 底 - n * 步 : 底;
      const 距 = Math.abs(终X - 起X);
      // easeOutCubic 起始斜率 = 3 × 距离 / 时长 → 让松手瞬间的速度接上手指速度
      const 时 = Math.max(280, Math.min(1100, 3 * 距 / Math.max(Math.abs(v), 0.35)));
      exploreCurrent += n; updateExploreCounter();
      exploreAnimating = true;
      exCarousel.style.transition = 'transform ' + Math.round(时) + 'ms cubic-bezier(.33,1,.68,1)';
      exCarousel.style.transform = 'translateX(' + 终X + 'px)';
      setTimeout(function () {
        for (let i = 0; i < n; i++) exCarousel.appendChild(exCarousel.querySelector('.explore-card'));   // 往后翻:滑完再把 n 张从头搬到尾
        setExploreX(exploreBaseX(), false);                // 瞬时复位到居中,视觉不变
        exploreAnimating = false;
      }, 时 + 30);
    }, { passive: true });
    exCarousel.addEventListener('touchcancel', function () {
      if (!swiping) return; swiping = false;
      exCarousel.style.transition = ''; exCarousel.style.transform = 'translateX(' + exploreBaseX() + 'px)';
    }, { passive: true });
    // 捕获阶段先于 open() 的冒泡 click:滑动刚结束就吃掉误触 click,不开全屏
    exCarousel.addEventListener('click', function (e) {
      if (swipeGuard) { e.stopPropagation(); e.preventDefault(); }
    }, true);
  }
  updateExploreArrows();   // 进站初始化箭头灰态(循环模式两箭头永远可点)

  // 修复-13 · 一键批量下载 explore 区所有戴法 PNG(JSZip 打包)
  $('#explore-download')?.addEventListener('click', downloadAllVariantsZip);

  // 横版砍掉 variants 宫格 → 原 variants 左右翻页箭头删除

  /* 🔗 分享链接落地:副数按钮要跟解码出来的 kitCount 对上(第 131 轮 · 2026-09-06 修)
     ------------------------------------------------------------------
     applyDesignCode() 解码时只写了 state.kitCount,而 #kit-count 那三颗 chip 的 is-active
     是【写死在 HTML 里】的(默认第 1 颗亮),唯一会切它的地方就是 setKitCount()。
     于是分享 2 套的链接进来 → 价格 $279.20、副标题「完整套餐 · 15 种戴法」都是 2 套的,
     按钮却还亮在「1 套」上,三个信息互相打架。钱收得对,但客人只会以为网站坏了。

     为什么放在这里而不是 applyDesignCode 里面:applyDesignCode 在模块顶层解析期就跑了,
     那时 setKitCount 依赖的 buildComplete / pickBestSecondKit(都是后面才定义的 const)
     还在暂时性死区,直接调必抛 ReferenceError(第 129 轮 ?pick= 就是这么栽的)。
     init() 里所有定义都已就位、DOM 也在,是最早的安全点。
     两个 opts 的理由见 setKitCount 头上的注释。 */
  if (typeof 来自分享 !== 'undefined' && 来自分享) {
    try {
      setKitCount(state.kitCount || 1, { 保持当前焦点: true, 跳过渲染: true });
    } catch (e) {
      console.error('[DIY] 分享链接副数同步失败,副数按钮可能与价格不一致:', e);
    }
  }

  render();
  // render 内部 chip scrollIntoView 会副作用滚动外层容器,初始强制各容器回顶
  requestAnimationFrame(() => {
    const shell = document.querySelector('.app-shell');
    if (shell) shell.scrollTop = 0;
    // 横版窄屏:app-shell/col 都 overflow:visible,scrollIntoView 会冒泡滚动外层
    // (真机=drawer / 本地镜像=documentElement)→ 归零所有可能的滚动容器,防 hero 列被顶出
    const drawer = document.getElementById('rainbow-drawer');
    if (drawer) drawer.scrollTop = 0;
    /* ⚠️ 2026-07-30 修:页面级滚动条只有在「模块自己就是整个页面」时才敢归零。
       本地独立版里 documentElement 确实是模块自己的滚动容器,归零安全;
       但嫁接进店铺页面后,documentElement 是**整页**的滚动条 —— 归零等于把用户从任何位置拽回页首。
       用户实测表现:刷新时先闪到刷新前的位置(浏览器的滚动恢复),紧接着被我们拽回顶部。
       判据沿用现成的 .diy-outer(section 外壳)。*/
    if (!document.querySelector('.diy-outer')) {
      document.body.scrollTop = 0;
      if (document.scrollingElement) document.scrollingElement.scrollTop = 0;
      window.scrollTo(0, 0);
    }
  });
}
init();

/* ============================================================
   §15 MVP · Shopify 嫁接(v16.1 直跳购物车,2026-05-30)
   ============================================================ */
// Shopify 店铺前台域名(用户自定义域 — 比 zvg3ra-pi.myshopify.com 更直接)
const SHOPIFY_DOMAIN = 'monixibi.com';
// 1. 全局映射缓存(启动时 fetch ./data/rainbow-mapping.json)
let SHOPIFY_MAPPING = null;

// 2. slug → Shopify variant 翻译(从 mapping.json 查)
function mvpMapSlug(category, slug) {
  if (!SHOPIFY_MAPPING || !slug) return null;
  const entry = SHOPIFY_MAPPING[category]?.[slug];
  if (!entry) return null;
  return {
    variant_id: entry.variant_id,
    sku: entry.sku || '(空)',
    title: entry.variant_title,
    price: entry.price,
    product_handle: entry.product_handle,
  };
}

// 3. 生成完整 Shopify Ajax Cart payload(数据包)
// 阶段 C · 加购协议彻底重写(2026-06-01)
// 旧:6 件散加(主机 + 头带/面盖/皮套 × 每副)→ 6 行 line item,触发零件 5 折逻辑(错的)
// 新:1 个 DIY product variant + line item properties 携带配色 → 1 行 line item,自动享套装折扣
// SoT 见 Shopify 后台工作区 plan 文档「Rainbow 价格体系 + DIY 模块对接交付包 2026-06-01」§ 二、三、四
function mvpBuildPayload() {
  const host = state.base.host;
  const kitCount = state.kitCount;
  const variantId = DIY_VARIANT_IDS[kitCount] || DIY_VARIANT_IDS[2];

  // 颜色名 → 英文(properties 规范,Shopify 后台统一)
  const hostEn = HOST_EN[host] || host;
  const moniSlug = getMoniStrapSlug();
  const moniEn = MONI_STRAP_EN[moniSlug] || moniSlug;
  const moniCn = MONI_STRAPS.find(m => m.slug === moniSlug)?.cn || moniSlug;

  /* properties 命名规范(2026-09-10 第 2 版 · 合并行)
     ────────────────────────────────────────────────
     旧版每个零件单独一行,1 副就是 5 行:
       Host Color / Faceplate Color / Over-Ear Cushion / Headband Design / Moni-Strap Color
     手机购物车里每行还会再折成 2 行 → 一件商品占掉 10 行文字,又长又乱
     (官方 Concept 演示站同一位置只有 1 行)。

     新版按"全局件 / 每副件"分两组,1 副 = 2 行:
       Headset : Desert Yellow · Moni-Strap Dark Green          ← 主机 + 魔尼带(全套装唯一)
       Pair    : Faceplate Starry Silver · Cushion Dark Green · Headband Red & Green Line
     2/3 副时每副各一行(Pair 1 / Pair 2 / Pair 3),行数 = 副数 + 1。

     值里用「部位名 + 颜色名」而不是纯颜色串:配了两套时纯颜色串根本分不清谁是谁。
     ⚠️ 下划线开头的隐藏属性(_host_slug 等)一个都不能动 ——
        购物车缩略图靠它们反查零件图,后台拣货也靠它们。 */
  const properties = {
    // 阶段 E · cart 端缩略图渲染要用的 host slug(全局唯一,不分副)
    _host_slug: host,
  };

  // 每副的 3 件零件(按 kitCount 取前 N 副)
  const useSetSuffix = kitCount > 1;
  const 每副文案 = [];
  state.builds.slice(0, kitCount).forEach((b, i) => {
    const setN = i + 1;
    const suffix = useSetSuffix ? ` (Set ${setN})` : '';
    const fpEn   = FACEPLATE_EN[b.faceplate] || b.faceplate || '?';
    const epEn   = EARPAD_EN[b.earpad] || b.earpad || '?';
    // 头带:取 cn 中文(英文 SoT 待整理)
    const hbCn   = getColor(b.headband)?.en || getColor(b.headband)?.cn || b.headband || '?';
    每副文案.push({
      标签: useSetSuffix ? `Pair ${setN}` : 'Pair',
      文案: `Faceplate ${fpEn} · Cushion ${epEn} · Headband ${hbCn}`,
    });
    // 阶段 E · 给 cart 端缩略图渲染脚本反查 slug 用(下划线 = 隐藏给客户)
    properties[`_faceplate_slug${suffix}`] = b.faceplate || '';
    properties[`_earpad_slug${suffix}`]    = b.earpad    || '';
    properties[`_headband_slug${suffix}`]  = b.headband  || '';
  });

  /* 第 1 行:主机 + 魔尼带(全套装各 1 件,不分副)。
     ⚠️「Moni-Strap」这个词是购物车脚本用来认出 DIY 商品的 DOM 标记 ——
        它必须出现在【客人可见】的属性里(下划线属性不会渲染进 DOM)。改文案时别把它删了。 */
  properties['Headset'] = `${hostEn} · Moni-Strap ${moniEn}`;
  每副文案.forEach(x => { properties[x.标签] = x.文案; });
  properties._moni_slug = moniSlug;

  // 店主拣货用 _ 下划线 metadata(客户不可见)
  properties._ui_version = 'v17.1-stage-e-2026-06-02';
  properties._kit_count = kitCount;
  properties._diy_variant_id = variantId;
  properties._魔尼带色名_中文 = moniCn;
  properties._魔尼带_锁色态 = state.moniStrap.linked ? 'locked' : 'free';

  return {
    meta: {
      ui_version: 'v17.0-stage-c',
      timestamp: new Date().toISOString(),
      kit_count: kitCount,
      total_price_usd: totalPriceMvp(),
      diy_variant_id: variantId,
      note: '阶段 C · 1 个 DIY product variant + properties(取代旧 6 件散加)。Shopify 自动套装折扣 20% / BxGy / ≥3 件 30%。',
    },
    shopify_ajax_cart_payload: {
      id: variantId,           // 数字 ID(直接用)
      quantity: 1,
      properties: properties,
    },
  };
}

/* 加购按钮的「三个白点」等待态(2026-09-15)。配套 CSS 见 <style> 里 ㉒ 段。
   ────────────────────────────────────────────────────────────────
   每一个参数都是【真机触发主题 loading 态后 getAnimations() 读出来的】,不是估的。
   主题那三个点是 JS 动态建 + WAAPI 驱动的,所以在样式表里翻不到 —— 我先搜了两轮 CSS
   才想明白要用 getAnimations()。别再去 CSS 里找了。

   🔴 必须用 WAAPI 不能用 CSS animation:
      三个点靠【各自不同的 delay】错峰(0/175/350)才有"流动"感。
      写成 CSS 要么加三条 nth-child 规则,要么用变量,都不如直接把实测参数照搬过来直白;
      而且 cancel() 能干净地停掉,不留 animation-play-state 这类残留。 */
function diyBtnLoading(btn, 开) {
  if (!btn) return;
  var ld = btn.querySelector('.diy-btn-loader');
  if (开) {
    if (!ld) {
      ld = document.createElement('span');
      ld.className = 'diy-btn-loader';
      ld.setAttribute('aria-hidden', 'true');
      ld.innerHTML = '<span></span><span></span><span></span>';
      btn.appendChild(ld);
    }
    /* 文字层淡出(主题的做法也是给文字层写内联 opacity:0)。
       ⚠️ 只动 loader 以外的直接子元素,别用 innerHTML 清空 —— 那样价格/提示语的
          节点引用会失效,后面 renderCta 再写就写到游离节点上了。 */
    [].forEach.call(btn.children, function (c) { if (c !== ld) c.style.opacity = '0'; });
    ld.style.opacity = '1';
    btn.setAttribute('aria-busy', 'true');
    [].forEach.call(ld.children, function (d, i) {
      try {
        d.__rbAnim = d.animate(
          [{ transform: 'scale(1.6)' }, { transform: 'scale(0.6)' }],
          { duration: 350, delay: i * 175, easing: 'ease',
            iterations: Infinity, direction: 'alternate', fill: 'both' });
      } catch (err) {}
    });
  } else {
    if (ld) {
      [].forEach.call(ld.children, function (d) {
        if (d.__rbAnim) { try { d.__rbAnim.cancel(); } catch (err) {} d.__rbAnim = null; }
      });
      ld.style.opacity = '0';
    }
    [].forEach.call(btn.children, function (c) { if (c !== ld) c.style.opacity = ''; });
    btn.removeAttribute('aria-busy');
  }
}

/* 挂到 window:图卡画廊在【另一个 script 段】(段2 的独立 IIFE)里,够不着这里的局部函数。
   它那个买按钮也要显示同一套三个点,所以必须有个跨段通道 ——
   跟 FAB 传坐标用 __diyOpenOrigin 是同一个套路。 */
window.diyBtnLoading = diyBtnLoading;

// 4. 点击 Add to Cart 时触发 — Ajax /cart/add.js 加购,完成后跳 /cart 页(跟官方一致)
//    Shift+点击 = 弹 JSON modal(开发 review,平时不用)
async function mvpAddToCart(e) {
  // 阶段 C · 不再依赖 SHOPIFY_MAPPING(零件 SKU 映射),DIY variant_id 已硬编码
  const payload = mvpBuildPayload();
  console.log('[Stage C AddToCart] payload =', payload);

  if (e && e.shiftKey) { mvpShowModal(payload); return; }

  const items = mvpCollectCartItems(payload);
  if (!items.length || !items[0].id) {
    alert('⚠️ DIY variant_id 缺失,无法加购。\nShift+点击 看 JSON 排查。');
    return;
  }

  const btn = e?.currentTarget || document.getElementById('add-to-cart');
  const main = document.getElementById('cta-main');
  const originalText = main?.textContent;
  if (btn) btn.disabled = true;
  /* 2026-09-15:等待态从「把文字换成 Adding…」改成【三个白点】,
     照抄产品页主题原生按钮(参数与原理见 <style> 里 ㉒ 段的注释)。
     文字不再被改写,所以下面收尾处也不用还原 textContent 了 —— 但 originalText
     仍保留当兜底(万一 DOM 被别处动过)。 */
  diyBtnLoading(btn, true);

  try {
    // Shopify Ajax Cart API:batch 添加多个 variant
    const resp = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    });
    if (!resp.ok) {
      const errBody = await resp.text().catch(() => '');
      throw new Error(`HTTP ${resp.status}: ${errBody.slice(0, 200)}`);
    }
    // 成功 → 触发主题 cart drawer(跟官方 Add to Cart 行为一致,避免 /cart 被主题 skip 到 checkout)
    // 策略:① dispatch 主题常用 event ② fallback 模拟点击 header cart icon ③ 最后才硬跳 /cart
    // 先关掉 DIY drawer 不挡 cart drawer
    const diyDrawer = document.getElementById('rainbow-drawer');
    const diyFab = document.getElementById('rainbow-fab');
    if (diyDrawer) { diyDrawer.hidden = true; diyDrawer.setAttribute('aria-hidden', 'true'); }
    if (diyFab) { diyFab.hidden = false; }

    /* 2026-09-10 改用主题自己那套写法。
       Concept 的抽屉(assets/cart.js 里的 <cart-drawer>)在 **document** 上监听 cart:refresh，
       处理函数干两件事:
         ① 重新拉一遍 mini cart 的 HTML 塞回去(刷新内容)
         ② `if (event.detail.open === true) this.show()`(打开抽屉)
       ⚠️ detail 必须带 { open: true }:
          不带 detail → 处理函数读 event.detail.open 直接抛 TypeError,内容刷不了也开不了;
          带 open:false → 只刷新不打开。
       原来那三条 cart:refresh / cart:build / cart:added 都没带 detail,而且派在
       documentElement 上,所以抽屉只能靠下面「模拟点击购物车图标」硬撬开 ——
       撬开的是页面加载时那份【空购物车】的旧 HTML,客人看到的是"加了却还是空的"。 */
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));

    // ② 找 header 上的 cart 触发器点一下 — 覆盖主题常见选择器
    /* ⚠️ 2026-09-10:Concept 主题的抽屉触发器叫 `a.cart-drawer-button`,
       原来这份清单里没有它 → 每次都匹配不上、走兜底硬跳 /cart。
       （之前没发现是因为主题设置 cart_type 一直是 page,压根没有抽屉可开；
         改成 drawer 之后才暴露。）实测该页面上的购物车相关元素只有三个：
         a.cart-drawer-button（顶栏）/ cart-drawer（抽屉本体）/ a.dock__item（底部导航栏）。
       下面把主题实际用的那个放在最前面优先匹配。 */
    const cartToggle = document.querySelector(
      'a.cart-drawer-button, ' +
      '[data-cart-drawer-toggle], [data-cart-toggle], [data-action="open-drawer"][data-target="cart"], ' +
      'a.header__cart-link, button.header__cart, .cart-icon-bubble, .js-drawer-open-cart, ' +
      'a[href="/cart"][data-cart-drawer], a[href="/cart"].header__icon--cart'
    );
    // 还原 DIY 按钮状态,下次再点正常工作
    if (btn) btn.disabled = false;
    diyBtnLoading(btn, false);                       // 收起三个白点、文字层淡回来
    if (main && !main.textContent) main.textContent = originalText || TR('cta_add');   // 兜底:万一文字被别处清了

    /* 兜底:万一主题换了实现、上面那条事件没生效,1.2 秒后退回老路。
       判据必须是「抽屉真的可见」,不能是「事件派出去了」—— 派出去不等于生效。 */
    setTimeout(() => {
      const 抽屉 = document.querySelector('cart-drawer');
      const 开着 = 抽屉
        && 抽屉.getBoundingClientRect().width > 0
        && getComputedStyle(抽屉).visibility !== 'hidden'
        && getComputedStyle(抽屉).display !== 'none';
      if (开着) return;
      if (cartToggle) cartToggle.click();
      else window.location.href = '/cart';   // 主题真没抽屉才走老路
    }, 1200);
    return;
  } catch (err) {
    console.error('[MVP AddToCart] 失败:', err);
    if (btn) btn.disabled = false;
    diyBtnLoading(btn, false);                       // 收起三个白点、文字层淡回来
    if (main && !main.textContent) main.textContent = originalText || TR('cta_add');   // 兜底:万一文字被别处清了
    alert(TR('err_addcart', { msg: err.message }));
  }
}

// 收集所有 cart line items(主机 1 件 + 每副的头带/面盖/全包皮套 各 1)
// 阶段 C · 加购 items 现在只有 1 行(DIY product variant + properties)
function mvpCollectCartItems(payload) {
  const item = payload.shopify_ajax_cart_payload;
  if (!item || !item.id) return [];
  return [{
    id: item.id,
    quantity: item.quantity || 1,
    properties: item.properties || {},
  }];
}

// 4b. 生成 Shopify 多变体购物车直链(cart permalink)
// 格式:https://store/cart/{vid1}:{qty1},{vid2}:{qty2},...?attributes[Key]=Value&...
// 多变体每个会显示成购物车 1 个 line item:
//   1 副 = 4 件(主机 + 头带 + 面盖 + 全包皮套)
//   2 副 = 7 件(主机 + 6 零件)
function mvpBuildCartUrl(payload) {
  const item = payload.shopify_ajax_cart_payload;
  if (!item || !item.id || typeof item.id !== 'string' || !item.id.includes('/')) return null;

  const items = [];
  // 主机 variant
  items.push(`${item.id.split('/').pop()}:1`);
  // 每副的 3 件零件(头带 / 面盖 / 全包皮套),平铺到购物车
  (payload.builds_detail_for_picking || []).forEach(b => {
    [b.headband_shopify, b.faceplate_shopify, b.earpad_shopify].forEach(s => {
      if (s && s.variant_id && typeof s.variant_id === 'string' && s.variant_id.includes('/')) {
        items.push(`${s.variant_id.split('/').pop()}:1`);
      }
    });
  });

  const parts = Object.entries(item.properties || {}).map(([k, v]) => {
    return `attributes[${encodeURIComponent(k)}]=${encodeURIComponent(String(v))}`;
  });
  const qs = parts.length ? '?' + parts.join('&') : '';

  return `https://${SHOPIFY_DOMAIN}/cart/${items.join(',')}${qs}`;
}

// 5. modal 弹窗(显示 JSON 给店主 review)
function mvpShowModal(payload) {
  let modal = document.getElementById('mvp-modal');
  if (!modal) {
    modal = document.createElement('div');
    modal.id = 'mvp-modal';
    modal.className = 'mvp-modal';
    modal.innerHTML = `
      <div class="mvp-modal__backdrop" data-close="1"></div>
      <div class="mvp-modal__panel">
        <div class="mvp-modal__head">
          <div class="mvp-modal__title">📦 加入购物车 · 数据包预览(MVP)</div>
          <button class="mvp-modal__close" data-close="1" type="button" aria-label="关闭">✕</button>
        </div>
        <div class="mvp-modal__hint">
          <b>MVP 跳验模式</b>:不会真发到 Shopify,只显示这份 JSON(数据包)给你 review。<br>
          ✅ 检查重点:① <code>shopify_ajax_cart_payload.id</code> 是不是主机 variant_id;② 每副的 <code>_build*_variant_ids</code> 是不是 3 个 ID 用逗号连接;③ <code>主机色</code> 跟你在 UI 选的一致。
        </div>
        <pre class="mvp-modal__pre" id="mvp-modal-pre"></pre>
        <div class="mvp-modal__foot">
          <button class="mvp-modal__btn" data-close="1" type="button">关闭</button>
        </div>
      </div>
    `;
    document.body.appendChild(modal);
    modal.addEventListener('click', (e) => {
      if (e.target.dataset && e.target.dataset.close === '1') {
        modal.classList.remove('is-open');
      }
    });
  }
  document.getElementById('mvp-modal-pre').textContent = JSON.stringify(payload, null, 2);
  modal.classList.add('is-open');
}

// 6. CSS 注入(副数选择器 + modal,避免动现有 <style> 区)
function mvpInjectStyles() {
  if (document.getElementById('mvp-styles')) return;
  const style = document.createElement('style');
  style.id = 'mvp-styles';
  style.textContent = `
    /* 嫁接-14 · 副数选择器:单行扁平,价格剥离去右侧 .cta-bar__price 显示 */
    .kit-count { display: flex; gap: 6px; margin: 0; width: 100%; }
    .kit-count__chip {
      flex: 1; display: flex; align-items: center; justify-content: center; gap: 4px;
      min-height: 32px; padding: 4px 8px;
      border: 1px solid rgba(20,20,20,.14); border-radius: 8px;
      background: #fff; cursor: pointer; position: relative; font-family: inherit;
      transition: background .15s ease, border-color .15s ease, color .15s ease;
    }
    .kit-count__chip:hover:not(:disabled):not(.is-active) { border-color: rgba(20,20,20,.3); }
    .kit-count__chip.is-active {
      background: #1d1d1f; color: #fff; border-color: #1d1d1f;
    }
    .kit-count__chip.is-disabled { opacity: .45; cursor: not-allowed; }
    .kit-count__num { font-size: 13px; font-weight: 600; letter-spacing: .2px; line-height: 1; }
    /* chip 内的小价格隐藏(总价已移到右侧大字显示) */
    .kit-count__price { display: none; }
    .kit-count__tag {
      position: absolute; top: -6px; right: -3px;
      background: #E0432F; color: #fff;
      font-size: 9px; padding: 1px 4px; border-radius: 4px;
      font-weight: 600; letter-spacing: .2px; line-height: 1.2;
    }
    .kit-count__tag--soon { background: #999; }

    /* MVP modal · JSON 预览 */
    .mvp-modal { position: fixed; inset: 0; display: none; z-index: 9999; font-family: inherit; }
    .mvp-modal.is-open { display: block; }
    .mvp-modal__backdrop {
      position: absolute; inset: 0;
      background: rgba(0,0,0,.55); backdrop-filter: blur(4px);
    }
    .mvp-modal__panel {
      position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);
      width: min(92vw, 720px); max-height: 86vh;
      background: #fff; border-radius: 16px;
      box-shadow: 0 20px 60px rgba(0,0,0,.3);
      display: flex; flex-direction: column; overflow: hidden;
    }
    .mvp-modal__head {
      display: flex; align-items: center; justify-content: space-between;
      padding: 14px 18px; border-bottom: 1px solid rgba(20,20,20,.08);
    }
    .mvp-modal__title { font-size: 15px; font-weight: 600; }
    .mvp-modal__close {
      width: 28px; height: 28px; border-radius: 50%;
      background: rgba(20,20,20,.06); border: none; cursor: pointer;
      font-size: 14px; color: inherit; font-family: inherit;
    }
    .mvp-modal__close:hover { background: rgba(20,20,20,.12); }
    .mvp-modal__hint {
      padding: 12px 18px; font-size: 12px; line-height: 1.55;
      color: #444; background: #FAF7EE;
    }
    .mvp-modal__hint code {
      background: #fff; padding: 1px 5px; border-radius: 3px;
      font-family: 'SF Mono', Menlo, monospace; font-size: 11px;
    }
    .mvp-modal__pre {
      flex: 1; margin: 0; padding: 14px 18px;
      background: #1d1d1f; color: #C5C9D2;
      font-family: 'SF Mono', Menlo, Consolas, monospace;
      font-size: 11px; line-height: 1.55;
      overflow: auto; white-space: pre-wrap; word-break: break-word;
    }
    .mvp-modal__foot {
      padding: 12px 18px; border-top: 1px solid rgba(20,20,20,.08);
      display: flex; justify-content: flex-end;
    }
    .mvp-modal__btn {
      background: #1d1d1f; color: #fff; border: none; cursor: pointer;
      padding: 8px 18px; border-radius: 8px; font-size: 13px;
      font-family: inherit;
    }
    .mvp-modal__btn:hover { background: #000; }
  `;
  document.head.appendChild(style);
}

// 7. MVP 自启动(注入 CSS + 加载映射)
(function mvpBootstrap() {
  mvpInjectStyles();
  (function() {
    SHOPIFY_MAPPING = SHOPIFY_MAPPING_INLINE;
    const counts = ['host','faceplate','earpad_full','earpad_half','headband','moni_strap']
      .map(k => `${k}=${Object.keys(SHOPIFY_MAPPING[k]||{}).length}`).join(' / ');
    console.log('[MVP] Shopify 映射已加载(inline) (' + counts + ')');
  })();
})();



(function () {
  // 画廊挂 .mirror-frame(原设计,高度=主体 720,不含 banner)。banner 由 CSS .diy-fs-open 用
  // display:none 移出布局(非 visibility:hidden 留空位),这样开画廊时主体上移到模块顶,
  // 既无顶部渐变带、画廊也不会变高(2026-07-26 回滚 diy-stage 方案)
  var frame = document.querySelector('.mirror-frame');
  if (!frame) return;
  var overlay, track, cards = [], pos = { current: 0, target: 0, max: 0 };
  var raf = null, isDown = false, startX = 0, startPos = 0, moved = false;
  // 定制贺卡:8 段多场景祝福语(英文)+ 当前状态(5 段 2026-06-25,加节日/纪念日/开学 2026-07-02)
  var GIFT_MSGS = [
    "To the one who turns every ordinary day into color.",          // 0 爱人
    "For a friendship that's one of a kind — just like this.",       // 1 挚友
    "Made with heart, for someone I hold close.",                    // 2 家人
    "A little something, just for me — my style, my way.",           // 3 送自己
    "Wishing you a year as bright and bold as you are.",             // 4 生日通用
    "Wishing you a season full of color and joy.",                   // 5 节日
    "Here's to us — and every colorful year ahead.",                 // 6 纪念日
    "New school year, new soundtrack — make it yours.",              // 7 开学
  ];
  // nameEdited:用户有没有真的动过这个输入框。默认的 'Alex' 只是占位示范,
  // 没编辑过就不该被当成收礼人带进分享链接(第 121 轮:用户自己测试时看到「這副是 Alex 配出來的」一头雾水)
  // tagPicked:关系标签有没有被点过。这是判断【分享意图】的唯一依据 ——
  //   点了「送自己」= 心愿单(给看的人买) / 点了别的 = 送人(不该让收礼人掏钱) / 没点 = 单纯给人看
  var giftState = { name: 'Alex', msgIdx: 0, msg: GIFT_MSGS[0], nameEdited: false, tagPicked: false };   // 默认签名:中性美国名 Alex,首字母大写(用户 2026-07-02)
  var giftEditorEl = null, giftLeadEl = null, giftShown = false, hasGiftCard = false;
  /* 引导语定位(用户 2026-08-05):底缘钉在贺卡面板上方 28px。
     为什么不用 top 固定:面板顶到容器顶只有约 155px,而引导语本身约 133px —— top 一写死,
     换个语言/字号面板高度一变就压到面板上(首版实测重叠 45px)。
     量不到位置或上方塞不下时直接不显示:宁可这一屏没有引导语,也不能盖住输入框。 */
  var leadRaf = 0;
  function layoutGiftLead() {
    if (leadRaf) return;                       // rAF 节流:ResizeObserver 一次尺寸变化会连发好几次
    leadRaf = requestAnimationFrame(function () {
      leadRaf = 0;
      if (!giftLeadEl || !giftEditorEl || !overlay) return;
      if (getComputedStyle(giftLeadEl).display === 'none') return;   // 手机端不参与
      giftLeadEl.style.visibility = '';
      giftLeadEl.classList.remove('is-tight');
      giftLeadEl.classList.remove('is-brief');
      var ov = overlay.getBoundingClientRect(), pr = giftEditorEl.getBoundingClientRect();
      if (!ov.height || !pr.height) return;
      // ⚠️ 不能拿 overlay 的坐标去算 bottom 的绝对值:.fs-gift-lead 的【包含块】并不是 overlay
      //    (实测包含块顶 34.35 / 高 770,而 overlay 是 121.8 / 610),算出来的数是对的、落点却是错的。
      //    改成增量修正:量当前实际位置,差多少就在现有 bottom 上加多少 —— 不需要知道包含块是谁。
      var put = function () {
        for (var i = 0; i < 3; i++) {                       // 迭代 2~3 次即可收敛(字号/换行会反过来影响高度)
          var lr0 = giftLeadEl.getBoundingClientRect();
          // ⚠️ 整块是【从底往上】排的:到面板的间距一定,顶部留白就是剩下的那点 ——
          //    这两个数是跷跷板,减一个另一个必然涨,不能分别设定。
          //    第 92c 轮:24(原 42)。用户要「两个空隙都缩、上面留空更大」,
          //    收紧到 24 后顶部自动涨到约 55,正是要的效果。
          var delta = lr0.bottom - (pr.top - 24);           // >0 = 压到面板了,要往上收(到面板留 24px)
          if (Math.abs(delta) < 0.5) break;
          var cur = parseFloat(getComputedStyle(giftLeadEl).bottom) || 0;
          giftLeadEl.style.bottom = (cur + delta) + 'px';
        }
        return giftLeadEl.getBoundingClientRect();
      };
      /* 四级降级。上方可用高度是【硬约束】:实测容器顶到贺卡面板顶只有约 155px。
         第 92 轮把预算重新配平到 30(顶) + 57(主标两行) + 22(主副) + 20(副标一行) + 28(到卡片)
         = 157,刚好卡在硬约束上 —— 副标必须是【一行】,长到折成两行就又会触发降级。
         所以文案改短了(见 gift_lead_sub),这是同时满足「顶部留白 30 + 副标要在 + 松紧看得出」的唯一解。
         降级仍然保留,给字号更大的语言(韩文)或更矮的容器兜底:
           ① 完整(主标 + 副标)  ② 砍副标  ③ 砍副标 + 降字号  ④ 收起
         ⚠️ 必须在展开动画结束后重算:容器高度会随动画变,open 时量一次不够
            (实测动画后容器变矮,引导语顶出去 26.6px,而 open 那一刻是好的)。 */
      /* ⚠️ 这个阈值【不能等于】目标留白 30:排版正好排到 30.1,亚像素一抖就判成「贴顶」,
         副标当场被砍(实测就这么砍掉过一次,顶部反弹到 68.5)。阈值是兜底线,要留余量。
         顶部留白 30 是由上面那个「到卡片 38」倒推出来的,不归这里管。 */
      var 顶部余量 = 22;                       // 低于这个数才算真的「贴顶」
      if (put().top < ov.top + 顶部余量) {
        /* ⚠️ 降级会【删掉用户能看见的内容】,却不给任何信号 —— 上一轮副标凭空消失,
           是用户自己发现的,自检脚本一无所知。凡是「静默吃内容」的机制都必须留痕。 */
        console.warn('[gift-lead] 上方空间不足,已降级:砍副标(可用 ' +
                     (pr.top - ov.top).toFixed(1) + 'px)');
        giftLeadEl.classList.add('is-brief');                       // ② 砍副标
        if (put().top < ov.top + 顶部余量) {
          console.warn('[gift-lead] 仍不足,继续降级:缩字号');
          giftLeadEl.classList.add('is-tight');                     // ③ 再降字号
          if (put().top < ov.top + 12) {
            console.warn('[gift-lead] 空间过小,整块收起');
            giftLeadEl.style.visibility = 'hidden';                 // ④ 收起
          }
        }
      }
    });
  }
  var savedScrollY = 0, vvHandler = null, modalMobile = false;   // 手机模态:滚动锁/键盘跟随状态(用户 2026-07-10 稳定性重构)
  var counterEl = null, counterIdx = -1;   // 页码指示缓存(用户 2026-07-01)
  function syncGiftCard() {   // 把 giftState 写到所有卡片只读展示区
    安排备图(3000);   // 贺卡文字变了 → 备好的下载图也作废,停手后重备
    安排预热(1800);   // 贺卡文字变了 → 旧的分享图作废,防抖后重渲一张备着(四宫格贺卡 + 每张单卡落款)
    if (!overlay) return;
    overlay.querySelectorAll('[data-gift-out="name"]').forEach(function (n) { n.textContent = giftState.name || ''; });
    overlay.querySelectorAll('[data-gift-out="msg"]').forEach(function (m) { m.textContent = giftState.msg || ''; });
    // 名字空则隐藏所有落款/花体名:单卡 fs-card__sig + 四宫格 gift-name + 枚举墙 montage-sig。原本只切 fs-card__sig,漏了 montage → 清空后残留花体鬼影(用户 2026-07-11)
    overlay.querySelectorAll('.fs-card__sig, .montage-sig, .gift-name').forEach(function (s) { s.classList.toggle('sig-empty', !giftState.name); });
    // iOS Safari:花体签名在合成层内,每次改字(打字/删字/清空)旧花体像素不自动刷新 → 每次同步都脉冲当前卡签名区强制重新光栅化,清残渣。覆盖四宫格 .poster + 单卡 .fs-card__foot(本地 Chromium 无此 bug,须真机验)(用户 2026-07-12)
    var curCard = overlay.querySelector('.explore-card.is-current');
    if (curCard) {
      curCard.querySelectorAll('.poster, .fs-card__foot').forEach(function (el) {
        el.style.transform = 'translateZ(0)';
        void el.offsetHeight;   // 强制提交:创建独立层 + 重绘(否则 set→rAF unset 被浏览器合并成空操作)
        requestAnimationFrame(function () { el.style.transform = ''; });
      });
    }
  }
  function escGift(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  var ICON_CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg>';
  var ICON_DL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v12"/><path d="M7 11l5 5 5-5"/><path d="M5 20h14"/></svg>';
  var ICON_BAG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';
  // 分享图标(用户 2026-07-01 方案A):主分享 + Pinterest/Facebook/X/邮件/复制链接
  var ICON_SHARE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.6" y1="13.5" x2="15.4" y2="17.5"/><line x1="15.4" y1="6.5" x2="8.6" y2="10.5"/></svg>';
  var ICON_PIN = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12c0 4.24 2.64 7.86 6.36 9.32-.09-.79-.17-2 .03-2.87.19-.8 1.2-5.08 1.2-5.08s-.31-.61-.31-1.52c0-1.42.83-2.48 1.85-2.48.87 0 1.29.66 1.29 1.44 0 .88-.56 2.19-.85 3.41-.24 1.02.51 1.85 1.52 1.85 1.83 0 3.23-1.93 3.23-4.71 0-2.46-1.77-4.18-4.3-4.18-2.93 0-4.65 2.2-4.65 4.47 0 .89.34 1.84.77 2.36.08.1.09.19.07.29-.08.32-.25 1.02-.29 1.16-.05.19-.15.23-.35.14-1.3-.61-2.11-2.5-2.11-4.03 0-3.28 2.38-6.29 6.87-6.29 3.61 0 6.41 2.57 6.41 6.01 0 3.58-2.26 6.47-5.4 6.47-1.05 0-2.04-.55-2.38-1.2l-.65 2.47c-.23.9-.86 2.03-1.29 2.72.97.3 2 .46 3.07.46 5.52 0 10-4.48 10-10S17.52 2 12 2z"/></svg>';
  var ICON_FB = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>';
  var ICON_X = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M18.9 1.15h3.68l-8.04 9.19L24 22.85h-7.41l-5.8-7.58-6.64 7.58H.47l8.6-9.83L0 1.15h7.59l5.24 6.93zM17.61 20.64h2.04L6.49 3.24H4.31z"/></svg>';
  var ICON_MAIL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="M22 7l-10 6L2 7"/></svg>';
  // 苹果样式的分享图标(方框 + 向上箭头):收礼人信里的下载钮在手机上用它 —— 点了弹的就是系统分享面板(2026-10-23 用户)
  var ICON_IOS_SHARE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v12"/><path d="M8 7l4-4 4 4"/><path d="M8 10H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-2"/></svg>';
  var ICON_LINK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>';

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'fs-gallery';
    overlay.innerHTML =
      '<button class="fs-gallery__close" type="button" aria-label="' + TR('close_preview') + '">' + ICON_CLOSE + '</button>' +
      '<div class="fs-gallery__counter" aria-live="polite">01 / 01</div>' +
      '<div class="fs-gallery__actions">' +   /* 手机端:买=全宽长条 CTA;下载被 JS 移进分享行最右;桌面 display:contents 使二者仍各自 absolute 角落(用户 2026-07-11)*/
        '<button class="fs-gallery__buy" type="button" aria-label="' + TR('add_cart') + '">' + ICON_BAG +
          '<span class="fs-buy-slogan">' + TR('buy_slogan') + '</span>' +   /* 桌面显示 */
          '<span class="fs-buy-long">' + TR('add_cart') + '<b class="fs-buy-price"></b></span>' +   /* 手机长条显示,价格 open 时填 */
        '</button>' +
        '<button class="fs-gallery__download" type="button" aria-label="' + TR('download_lookbook') + '">' + ICON_DL + '<span>' + TR('download_lookbook') + '</span></button>' +
      '</div>' +
      /* 展开区左上角引导语(用户 2026-08-05):目的是让人把收礼人的名字写进 Gift Card。
         文案走「做 vs 买」的对比 —— 送礼者最深的顾虑是「怕看起来像随便买的」,
         而这里刚好是他配完一副、成就感最高的一秒,接住它比催他写有效。
         排版:两行同字号,靠【字重+深浅】分主次(第二行才是重音),不靠字号大小 —— 字号忽大忽小是海报做法。 */
      '<div class="fs-gift-lead">' +
        '<p class="fs-gift-lead__h"><span>' + TR('gift_lead_1') + '</span><span>' + TR('gift_lead_2') + '</span></p>' +
        '<p class="fs-gift-lead__sub"><span>' + TR('gift_lead_sub_1') + '</span><span>' + TR('gift_lead_sub_2') + '</span></p>' +
      '</div>' +
      '<div class="fs-gift-editor">' +
        '<div class="fs-gift-editor__title">' + TR('gift_title') + '</div>' +
        '<label class="fs-gift-editor__label">' + TR('gift_name_label') + '</label>' +
        '<input class="fs-gift-editor__input" type="text" data-gift-in="name" maxlength="22" placeholder="Name">' +
        '<label class="fs-gift-editor__label">' + TR('gift_msg_label') + '</label>' +
        /* maxlength 90(用户 2026-08-28「每一行的最长一定要有限制」):
           这个 90 不是拍脑袋 —— 分享链接里祝福语本来就只截前 90 字(见 shareUrl 的 m 参数),
           不设上限的话超出部分会在【分享出去时被静默砍掉】,写的人根本不知道。
           设在输入端 = 写的时候就打不进去,所见即所得,不会有"发出去少一截"的意外。 */
        '<textarea class="fs-gift-editor__textarea" data-gift-in="msg" rows="3" maxlength="90" placeholder="Write a wish…"></textarea>' +
        '<div class="fs-gift-editor__presets">' +
          '<button type="button" data-gift-preset="0">' + TR('gift_preset_0') + '</button>' +
          '<button type="button" data-gift-preset="1">' + TR('gift_preset_1') + '</button>' +
          '<button type="button" data-gift-preset="2">' + TR('gift_preset_2') + '</button>' +
          '<button type="button" data-gift-preset="5">' + TR('gift_preset_5') + '</button>' +
          '<button type="button" data-gift-preset="3">' + TR('gift_preset_3') + '</button>' +
          '<button type="button" data-gift-preset="4">' + TR('gift_preset_4') + '</button>' +
          '<button type="button" data-gift-preset="6">' + TR('gift_preset_6') + '</button>' +
          '<button type="button" data-gift-preset="7">' + TR('gift_preset_7') + '</button>' +
        '</div>' +
        '<div class="fs-gift-editor__share">' +
          '<button class="fs-share-btn" type="button">' + ICON_SHARE + '<span>' + TR('gift_share') + '</span></button>' +
          '<div class="fs-share-hint">' + TR('gift_share_hint') + '</div>' +
          '<div class="fs-share-row">' +
            '<button class="fs-share-ico" data-share="pinterest" type="button" aria-label="Pinterest">' + ICON_PIN + '</button>' +
            '<button class="fs-share-ico" data-share="facebook" type="button" aria-label="Facebook">' + ICON_FB + '</button>' +
            '<button class="fs-share-ico" data-share="x" type="button" aria-label="X">' + ICON_X + '</button>' +
            '<button class="fs-share-ico" data-share="email" type="button" aria-label="Email">' + ICON_MAIL + '</button>' +
            '<button class="fs-share-ico" data-share="copy" type="button" aria-label="' + TR('copy_link') + '">' + ICON_LINK + '</button>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div class="fs-gallery__stage"><div class="fs-gallery__track"></div></div>';
    frame.appendChild(overlay);
    track = overlay.querySelector('.fs-gallery__track');
    counterEl = overlay.querySelector('.fs-gallery__counter');
    var stage = overlay.querySelector('.fs-gallery__stage');
    overlay.querySelector('.fs-gallery__close').addEventListener('click', function (e) { e.stopPropagation(); close(); });
    overlay.querySelector('.fs-gallery__download').addEventListener('click', function (e) { e.stopPropagation(); downloadGalleryCards(this); });
    /* 购买。2026-09-15 重做 —— 用户录屏指出的问题:
       原来是「先 close() 关画廊,再 60ms 后遥控主 #add-to-cart」,于是
       点的是画廊里这个按钮、三个点却闪在配置器主界面底部那个按钮上,
       人还被硬生生弹回主界面。用户原话:「我现在是在展开涂卡那里点购买,
       它应该这个按钮就是那三个点在闪动,而不是调到首页下面的按钮」。

       现在:画廊【全程留在原地】,三个点就在这个按钮上闪;主按钮在背后跑加购(被画廊盖着,看不见);
       加购结束后【也不关画廊】—— 购物车抽屉自己盖到画廊上面来(靠 ㉓ 段把抽屉提到 z-index 600),
       客人收起购物车,背后还是这张图卡,一步都没挪。

       ⚠️ 第一版曾是「加购完再关画廊」,用户看完录屏否了:
          「画廊关掉然后再弹回配置器主界面,还是有点奇怪 ——
            我希望在哪里点购买时,弹出购物车跟收下购物车,背后界面就是在哪里」。
          所以这里【不许再加 close()】。

       为什么仍然遥控主按钮而不是自己调加购逻辑:
       mvpAddToCart 在段1 的 IIFE 里,这里是段2,跨段够不着;而且那套逻辑还管着
       抽屉唤起、繁中/韩文案、错误兜底 —— 复制一份必然走样。遥控最省事也最不容易错。 */
    overlay.querySelector('.fs-gallery__buy').addEventListener('click', function (e) {
      e.stopPropagation();
      var 买 = this;
      var main = document.getElementById('add-to-cart');
      /* 配置没完成 → 保持老行为:关画廊回面板让他配完(用户 2026-06-25) */
      if (!main || main.disabled) { close(); return; }
      if (买.getAttribute('aria-busy') === 'true') return;      // 防连点
      if (window.diyBtnLoading) window.diyBtnLoading(买, true);

      /* 怎么知道加购跑完了:主按钮的 aria-busy 由 diyBtnLoading 开关,盯这个属性最直接。
         ⚠️ 不监听 cart:refresh —— 那个事件主题别处也会派(抽屉刷新等),会误判成"加购完成"。 */
      var 兜底 = null, 观 = null;
      function 收尾() {
        if (观) { try { 观.disconnect(); } catch (err) {} 观 = null; }
        if (兜底) { clearTimeout(兜底); 兜底 = null; }
        if (window.diyBtnLoading) window.diyBtnLoading(买, false);
        /* 🔴 这里【故意不调 close()】—— 画廊留在原地,购物车抽屉盖上来即可(见上面注释)。 */
      }
      try {
        观 = new MutationObserver(function () {
          if (main.getAttribute('aria-busy') === 'true') return;   // 刚开始,不是结束
          收尾();
        });
        观.observe(main, { attributes: true, attributeFilter: ['aria-busy'] });
      } catch (err) {}
      /* 兜底:万一主流程抛错没清掉 aria-busy,8 秒后也必须把画廊收掉 ——
         宁可早收一点,也不能让按钮永远转圈、画廊永远关不掉。 */
      兜底 = setTimeout(收尾, 8000);
      main.click();
    });
    // 定制贺卡:右侧面板编辑 → 实时写 giftState + 同步卡片只读展示(用户 2026-06-25)
    giftEditorEl = overlay.querySelector('.fs-gift-editor');
    giftLeadEl = overlay.querySelector('.fs-gift-lead');
    /* fs-buy hover:白色弧面上涌(照搬 ⑯ 段 .cta-btn 的进/出两段动作)。
       为什么要 JS:主题的动作进出都是【向上】的,CSS transition 离开只会原路退回,
       必须切两段不同 keyframes。这里绑在 build() 内 —— 按钮是 innerHTML 动态生成的,
       页面初始不存在,写在顶层 IIFE 里会拿到 null。 */
    if (matchMedia('(hover: hover)').matches) {
      var fsBuy = overlay.querySelector('.fs-gallery__buy');
      if (fsBuy) {
        fsBuy.addEventListener('mouseenter', function () {
          if (fsBuy.classList.contains('is-disabled')) return;
          fsBuy.classList.remove('fs-buy-fill-out'); fsBuy.classList.add('fs-buy-fill-in');
        });
        fsBuy.addEventListener('mouseleave', function () {
          if (!fsBuy.classList.contains('fs-buy-fill-in')) return;   // 没进过就别播出场,免得首屏白闪
          fsBuy.classList.remove('fs-buy-fill-in'); fsBuy.classList.add('fs-buy-fill-out');
        });
      }
    }
    window.addEventListener('resize', layoutGiftLead);
    if (window.ResizeObserver) new ResizeObserver(layoutGiftLead).observe(overlay);
    if (giftEditorEl) {
      var giftNameIn = giftEditorEl.querySelector('[data-gift-in="name"]');
      var giftMsgIn = giftEditorEl.querySelector('[data-gift-in="msg"]');
      giftNameIn.addEventListener('input', function () { giftState.name = giftNameIn.value; giftState.nameEdited = true; syncGiftCard(); });
      giftMsgIn.addEventListener('input', function () { giftState.msg = giftMsgIn.value; syncGiftCard(); });
      giftEditorEl.querySelectorAll('[data-gift-preset]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          giftState.msgIdx = parseInt(btn.getAttribute('data-gift-preset'), 10);
          giftState.tagPicked = true;
          giftState.msg = GIFT_MSGS[giftState.msgIdx] || '';
          giftMsgIn.value = giftState.msg; syncGiftCard();
        });
      });
      // 分享(方案A):主按钮走 Web Share(手机原生面板,带 DIY 图);图标排走各平台分享 URL(桌面兜底)
      var shareBtn = giftEditorEl.querySelector('.fs-share-btn');
      if (shareBtn) shareBtn.addEventListener('click', function (e) { e.stopPropagation(); shareCurrentCard(shareBtn); });
      giftEditorEl.querySelectorAll('[data-share]').forEach(function (ib) {
        ib.addEventListener('click', function (e) { e.stopPropagation(); shareVia(ib.getAttribute('data-share')); });
      });
      // 面板交互不触发画廊拖动/关闭
      giftEditorEl.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
      giftEditorEl.addEventListener('click', function (e) { e.stopPropagation(); });
    }
    // 点图卡集周边空白(非卡片、非拖动)→ 退回 DIY,不用点 X(用户 2026-06-24)
    stage.addEventListener('click', function (e) { if (!moved && !e.target.closest('.explore-card')) close(); });
    // 滚轮/触摸板:横竖都认(触摸板两指横滑给 deltaX),按力度比例跟手(用户 2026-06-24 修触摸板不灵敏)
    overlay.addEventListener('wheel', function (e) {
      e.preventDefault();
      var d = Math.abs(e.deltaX) >= Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
      惯性 = null; pos.target += d / 300; clamp(); snapDebounced(); kick();
    }, { passive: false });
    // 指针拖拽(鼠标 + 触摸统一用 pointer 事件),松手吸附;moved 用于区分"点击 vs 拖动"
    // 甩动速度(px/ms,屏幕坐标):手指一扫通常只有几十 px、不到半张卡(120px),光按位置四舍五入永远翻不过去 →
    //   松手时 |速度| ≥ 0.3 就朝甩的方向翻一张(用户 2026-09-19 手扫不灵敏)。指数平滑取最后几帧;停住 >100ms 再松 = 速度归零,不误翻。
    //   另照 Swiper 的规矩:按下到抬起 <300ms 且有位移 = 短扫,不看速度直接翻一张(速度采样受帧率影响,短扫单看速度会漏)。
    //   2026-10-23 用户「一刷就溜到底、靠力度感应」:松手不再只翻一张,按速度推算滑几张(iOS 减速率 0.998/ms → 距离 ≈ 速度 × 450px),
    //   沿 easeOutCubic 减速停在最近一张;起始斜率接上手指速度,所以松手那一刻不会突然变快变慢。滑行中手指一按就接住。
    var flickV = 0, flickX = 0, flickT = 0, downT = 0;
    stage.addEventListener('pointerdown', function (e) { if (惯性) { 惯性 = null; pos.target = pos.current; } isDown = true; moved = false; startX = e.clientX; startPos = pos.target; flickV = 0; flickX = e.clientX; flickT = downT = e.timeStamp; stage.setPointerCapture(e.pointerId); kick(); });
    stage.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      if (Math.abs(e.clientX - startX) > 6) moved = true;
      var dt = e.timeStamp - flickT;
      if (dt > 0) { flickV = flickV * 0.5 + ((e.clientX - flickX) / dt) * 0.5; flickX = e.clientX; flickT = e.timeStamp; }
      pos.target = startPos - (e.clientX - startX) / 240; clamp(); kick();
    });
    function release(e) {
      isDown = false;
      var v = (e && e.timeStamp - flickT > 100) ? 0 : flickV;   // 停住再松手:不算甩
      if (e && moved && e.timeStamp - downT < 300 && Math.abs(v) < 0.3) v = (e.clientX - startX) < 0 ? -0.3 : 0.3;   // 短扫没甩出速度:按净位移方向至少翻一张
      var t = pos.target;
      if (Math.abs(v) >= 0.3) {
        var 到 = Math.round(t - v * 450 / 240);                                       // 手指左甩(v<0)→ 往后翻几张
        if (v < 0) 到 = Math.max(到, Math.floor(t) + 1); else 到 = Math.min(到, Math.ceil(t) - 1);   // 至少翻一张
        到 = Math.max(0, Math.min(pos.max, 到));
        var 距 = Math.abs(到 - pos.current) * 240;
        惯性 = { 从: pos.current, 到: 到, 起: performance.now(), 时: Math.max(300, Math.min(1100, 3 * 距 / Math.abs(v))) };
        pos.target = 到;
        kick();
        return;
      }
      clamp(); snap(); kick();
    }
    stage.addEventListener('pointerup', release);
    stage.addEventListener('pointercancel', release);
    document.addEventListener('keydown', function (e) {
      if (!overlay || !overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') { 惯性 = null; pos.target = Math.min(pos.max, Math.round(pos.target) + 1); kick(); }
      else if (e.key === 'ArrowLeft') { 惯性 = null; pos.target = Math.max(0, Math.round(pos.target) - 1); kick(); }
    });
  }
  // 弧形排列:用浮点位置 p 插值,每张卡 横移 + Y旋转 + 后退(coverflow)
  function layout() {
    var p = pos.current;
    cards.forEach(function (card, i) {
      var off = i - p;
      var abs = Math.abs(off);
      // 🚀 窗口化:满配 15 张卡时,远卡彻底脱离绘制/合成(visibility:hidden 跳过 paint)+ 不再每帧拼 transform
      //    根因:15 张 will-change 合成层 + opacity:0 远卡仍被 GPU 合成 → Mac 触摸板滑动掉帧(2026-06-25)
      var vis = abs > 3.4 ? 'hidden' : 'visible';
      if (card._vis !== vis) { card.style.visibility = vis; card._vis = vis; }
      if (vis === 'hidden') return;                    // 远卡:省主线程字符串拼接 + style 写入
      var scale = Math.max(0.7, 0.98 - abs * 0.18);    // 中心卡基准 1.06→0.98 略缩(用户 2026-07-26:中心卡缩小一点,顶部离页码留空间);绕卡片中心缩放,上下同步留白仍居中
      card.style.transform =
        'translateX(' + (off * 240) + 'px) translateY(' + (abs * 24) + 'px) translateZ(' + (-abs * 150) + 'px) rotateY(' + (-off * 30) + 'deg) scale(' + scale + ')';
      // zIndex/opacity/pointerEvents 极少变 → 只在真变化时写,避免每帧样式重算(用户 2026-06-24 修切换顿挫)
      var z = 1000 - Math.round(abs * 10);
      if (card._z !== z) { card.style.zIndex = z; card._z = z; }
      var op = abs > 3.2 ? '0' : '1';
      if (card._op !== op) { card.style.opacity = op; card._op = op; }
      var pe = abs < 0.5 ? 'auto' : 'none';
      if (card._pe !== pe) { card.style.pointerEvents = pe; card._pe = pe; }
      var cur = abs < 0.5;   // 中心卡:显示签名/祝福语/落款,相邻卡淡出(缝隙不露半截文字)
      if (card._cur !== cur) { card.classList.toggle('is-current', cur); card._cur = cur; }
    });
    // 贺卡编辑面板:全程常驻(不再随滑动消失)——随时可改签名/分享当前聚焦卡(用户 2026-07-02)
    if (giftEditorEl) {
      var wantGift = hasGiftCard;
      if (giftShown !== wantGift) {
        giftEditorEl.classList.toggle('is-shown', wantGift);
        if (giftLeadEl) giftLeadEl.classList.toggle('is-shown', wantGift);   // 引导语与面板同进同出
        giftShown = wantGift;
      }
    }
    // 页码指示:当前第几张 / 共几张(缓存 idx,变了才写 DOM)
    if (counterEl && cards.length) {
      var ci = Math.max(0, Math.min(cards.length - 1, Math.round(p)));
      if (counterIdx !== ci) {
        var pad = function (x) { return x < 10 ? '0' + x : '' + x; };
        counterEl.textContent = pad(ci + 1) + ' / ' + pad(cards.length);
        counterIdx = ci;
      }
    }
  }
  function clamp() { pos.target = Math.max(0, Math.min(pos.max, pos.target)); }
  function snap() { pos.target = Math.max(0, Math.min(pos.max, Math.round(pos.target))); }
  var snapTimer = null;
  // ⚠️ 吸附后必须 kick():否则 rAF 已静止停了,改了 target 也不会动 → 卡半路(用户 2026-06-24 修不灵敏)
  function snapDebounced() { clearTimeout(snapTimer); snapTimer = setTimeout(function () { snap(); kick(); 安排预热(1500); }, 140); }   // 翻到别的卡 → 换一张分享图
  // rAF 惯性:current 平滑追 target;拖动中(isDown)用高插值紧跟手指,松手后慢惯性吸附
  // ⚠️ 静止即停 rAF(否则每帧重绘 3D 卡 + 毛玻璃背景,GPU 满载 → 卡顿/没反应);有输入再 kick() 唤醒(用户 2026-06-24 修流畅度)
  var 惯性 = null;   // 甩出去的滑行:{从, 到, 起, 时},按 easeOutCubic 走;为 null 时用原来的追赶缓动
  function tick() {
    var settled;
    if (惯性 && !isDown) {
      var 进 = Math.min(1, (performance.now() - 惯性.起) / 惯性.时);
      pos.current = 惯性.从 + (惯性.到 - 惯性.从) * (1 - Math.pow(1 - 进, 3));
      settled = 进 >= 1;
      if (settled) { pos.current = pos.target = 惯性.到; 惯性 = null; 安排预热(1500); }
    } else {
      var k = isDown ? 0.55 : 0.3;   // 松手缓动 0.2→0.3:翻卡更快到位、跟手不拖沓(用户 2026-07-11 反应慢)
      pos.current += (pos.target - pos.current) * k;
      settled = Math.abs(pos.target - pos.current) < 0.0006;
    }
    if (settled) pos.current = pos.target;
    layout();
    if (!settled || isDown) { raf = requestAnimationFrame(tick); }
    else { raf = null; }
  }
  function kick() { if (!raf) raf = requestAnimationFrame(tick); }
  // 全屏卡模块信息行:主机 X · 面盖 X · 皮套 X · 头带 X(照参考图,半包无面盖)
  function fsProductInfo(v) {
    try {
      var parts = [partColonLabel('host', getColor(v.host))];
      if (v.faceplate) parts.push(partColonLabel('faceplate', getColor(v.faceplate)));
      parts.push(partColonLabel('pad', getColor(v.earpad)));
      parts.push(partColonLabel('headband', getColor(v.headband)));
      return parts.join(' · ');
    } catch (e) { return ''; }
  }
  // 造一张"海报式"全屏卡(open 与下载共用):renderExploreCard + 重组 panel/foot/徽章
  function makePosterCard(v) {
    var wrap = document.createElement('div');
    wrap.innerHTML = renderExploreCard(v);
    var el = wrap.firstElementChild;
    var sb = (typeof scoreBuild === 'function') ? scoreBuild(v) : null;
    var nameZh = (typeof designName === 'function') ? designName(v) : '';
    var inner = el.querySelector('.preview-card__inner');
    var rating = el.querySelector('.explore-card__rating');
    var panel = document.createElement('div');
    panel.className = 'fs-card__panel';
    if (rating) panel.appendChild(rating);
    else if (v.form === 'halfear' && v.headband === 'solid-' + v.earpad) {
      var stdtag = document.createElement('div');
      stdtag.className = 'fs-card__stdtag';
      stdtag.textContent = 'HALF-EAR · STANDARD';
      panel.appendChild(stdtag);
    }
    if (inner) panel.appendChild(inner);
    var ptext = document.createElement('div');
    ptext.className = 'fs-card__panel-text';
    ptext.innerHTML =
      '<div class="fs-card__name">' + designNameEN(v) +
        (nameZh ? '<span class="fs-card__name-zh">' + nameZh + '</span>' : '') + '</div>' +
      '<div class="fs-card__info">' + fsProductInfo(v) + '</div>' +
      '<div class="fs-card__body-cn">' + designBodyCN(v, sb) + '</div>';
    panel.appendChild(ptext);
    var foot = document.createElement('div');
    foot.className = 'fs-card__foot';
    // foot 右侧右对齐竖区:英文块(右上,跟标题顶对齐) → 签名 → 红 logo(margin-top:auto 推右下角),三者右边对齐 logo 右边竖线,上下两层(用户 2026-06-29)
    foot.innerHTML =
      '<div class="fs-card__foot-l">' +
        '<div class="fs-card__title">' + designTitleEN(v) + '</div>' +
        '<div class="fs-card__subtitle">' + designSubtitleEN(v) + '</div>' +
      '</div>' +
      '<div class="fs-card__foot-r">' +
        '<div class="fs-card__body-en">' + designBodyEN(v, sb) + '</div>' +
        '<div class="fs-card__sigrow">' +
          '<div class="fs-card__sig' + (giftState.name ? '' : ' sig-empty') + '">' +
            '<span data-gift-out="name">' + escGift(giftState.name) + '</span></div>' +
          '<img class="fs-card__logo" src="' + LOGO_SRC + '" alt="MONIXIBI" crossorigin="anonymous">' +
        '</div>' +
      '</div>';
    el.appendChild(panel);
    el.appendChild(foot);
    return el;
  }
  // 拼排总览卡:把当前整套的全部戴法拼一张(≤4 四宫格 / >4 枚举墙),复用 adaptImg + 分层 preview(用户 2026-06-25)
  function montageCell(v) {
    var imgHost = adaptImg('host', v.host, v.form);
    var imgFp   = v.faceplate ? adaptImg('faceplate', v.faceplate, v.form) : 'none';   // 半包无面盖 → none 自然隐藏
    var imgEp   = adaptImg('earpad', v.earpad, v.form);
    var imgHb   = adaptImg('headband', v.headband, v.form);
    var epHex   = (typeof getColor === 'function') ? getColor(v.earpad).hex : '#ccc';
    var cell = document.createElement('div');
    cell.className = 'poster-cell';
    cell.innerHTML =
      '<div class="cell-bg"></div>' +
      '<div class="cell-img"><div class="preview-card__inner" ' +
        'style="--img-host:' + imgHost + ';--img-faceplate:' + imgFp + ';--img-earpad:' + imgEp + ';--img-headband:' + imgHb + ';--c-earpad-fb:' + epHex + ';">' +
        '<span class="preview-card__layer preview-card__layer--shadow"></span>' +
        '<span class="preview-card__layer preview-card__layer--earpad"></span>' +
        '<span class="preview-card__layer preview-card__layer--faceplate"></span>' +
        '<span class="preview-card__layer preview-card__layer--host"></span>' +
        '<span class="preview-card__layer preview-card__layer--headband"></span>' +
      '</div></div>';
    return cell;
  }
  var MONTAGE_TXT = {
    quad:   { title: 'MEET THE RAINBOW FAMILY.', sub: 'No two pairs alike.', body: 'Modular headphones you can re-dress on a whim. One price, a whole wardrobe of styles.' },
    matrix: { title: 'ONE HEADPHONE. ENDLESS STYLES.', sub: 'Almost no two Rainbow headphones are alike.', body: 'Modular headphones you can re-dress on a whim. One price, a whole wardrobe of styles.' },
  };
  function makeMontageCard(vs) {
    var list = (vs || []).filter(Boolean);
    var n = list.length;
    if (!n) return null;
    var isQuad = n <= 4;
    var tpl = isQuad ? 'quad' : 'matrix';
    var txt = MONTAGE_TXT[tpl];
    var card = document.createElement('div');
    card.className = 'explore-card fs-montage';   // 复用 coverflow 卡位 + 窗口化
    var poster = document.createElement('div');
    poster.className = 'poster';
    poster.setAttribute('data-template', tpl);
    // 四宫格右下 = 定制贺卡(花体名字 + 祝福语 + 换段);枚举墙保持产品正文
    var footHtml = isQuad
      ? '<div class="gift-name" data-gift-out="name">' + escGift(giftState.name) + '</div>' +
        '<div class="gift-msg" data-gift-out="msg">' + escGift(giftState.msg) + '</div>' +
        '<img class="gift-logo" src="' + LOGO_SRC + '" crossorigin="anonymous" alt="MONIXIBI">'
      : '<p class="poster-body">' + txt.body + '</p>' +
        '<div class="montage-giftcol">' +
          '<div class="montage-msg" data-gift-out="msg">' + escGift(giftState.msg) + '</div>' +
          '<div class="montage-sigrow">' +
            '<div class="montage-sig' + (giftState.name ? '' : ' sig-empty') + '"><span data-gift-out="name">' + escGift(giftState.name) + '</span></div>' +
            '<img class="montage-logo" src="' + LOGO_SRC + '" crossorigin="anonymous" alt="MONIXIBI">' +
          '</div>' +
        '</div>';   // 枚举墙底部:正文左 + 右侧竖排(祝福语上 + 签名/logo 下),2 套也有定制贺卡(用户 2026-07-01)
    poster.innerHTML =
      '<div class="poster-bg"></div>' +
      '<div class="poster-inner">' +
        '<header class="poster-head"><h1 class="poster-title">' + txt.title + '</h1>' +
          '<p class="poster-subtitle">' + txt.sub + '</p></header>' +
        '<div class="poster-grid"></div>' +
        '<footer class="poster-foot">' + footHtml + '</footer>' +
      '</div>';
    var grid = poster.querySelector('.poster-grid');
    if (isQuad) {
      list.slice(0, 4).forEach(function (v) { grid.appendChild(montageCell(v)); });
    } else {
      var cols = n <= 4 ? 2 : (n <= 9 ? 3 : 4);
      grid.style.gridTemplateColumns = 'repeat(' + cols + ', 1fr)';
      list.forEach(function (v) { grid.appendChild(montageCell(v)); });
      // 末尾深紫品牌格:占满末行剩余格
      var brand = document.createElement('div');
      brand.className = 'poster-cell poster-cell--brand';
      brand.innerHTML =
        '<div class="brand-cell-inner">' +
          '<div class="brand-cell-lines"><div>One pair\'s price.</div><div>A wardrobe of styles.</div></div>' +
        '</div>';   // 品牌格去掉 logo(移到底部),只留 slogan 文字(用户 2026-07-01)
      var rem = (n % cols === 0) ? cols : (cols - (n % cols));
      if (rem > 1) brand.style.gridColumn = 'span ' + rem;
      grid.appendChild(brand);
    }
    card.appendChild(poster);
    return card;
  }
  // 从原卡读已解析的层背景 url(原卡 CSS 变量 --img-* 完好),fetch dataURL 设到目标卡对应层。
  // ⚠️ dom-to-image clone 时会丢 CSS 变量 → 必须从原卡取 url 固化进 clone 的 inline(用户 2026-06-27)
  /* 2026-10-23 用户真机「点下载一直转、存不下来」:WebKit 实测 16 张卡 76 秒,其中 60 多秒在这里 ——
     总览卡一张就 fetch 了 80 次,可不同的图只有 ~8 张,同一张图被反复下载。
     改成:同一个网址只下载一次(存 Promise,并发请求也共用),一张卡里的各层并行转。
     失败的不缓存,下次还能重试。 */
  var 底图缓存 = {};
  function 底图转dataURL(url) {
    if (!底图缓存[url]) {
      底图缓存[url] = fetch(url, { mode: 'cors' })
        .then(function (resp) { return resp.blob(); })
        .then(function (blob) { return new Promise(function (r) { var fr = new FileReader(); fr.onload = function () { r(fr.result); }; fr.readAsDataURL(blob); }); })
        .catch(function (e) { delete 底图缓存[url]; throw e; });
    }
    return 底图缓存[url];
  }
  async function inlineLayerBgsFrom(src, dst) {
    var s = src.querySelectorAll('.preview-card__layer');
    var d = dst.querySelectorAll('.preview-card__layer');
    var 活 = [];
    for (var k = 0; k < s.length; k++) {
      var bg = getComputedStyle(s[k]).backgroundImage;
      // 第 66 轮:同类加固(见 preloadVariant 的 raw())。这里读的是 getComputedStyle,
      // 浏览器会把 background-image 归一成双引号,实际踩不到雷;但两种引号都认更稳,零行为变化。
      var m = bg && bg.match(/url\(\s*['"]?(.+?)['"]?\s*\)/);
      if (!m || !d[k]) continue;
      活.push((function (层) {
        return 底图转dataURL(m[1]).then(function (du) { 层.style.backgroundImage = 'url("' + du + '")'; }, function () { /* 跨域/失效图跳过 */ });
      })(d[k]));
    }
    await Promise.all(活);
  }
  // 用 dom-to-image 把卡渲成高清 PNG blob:用内置 scale 选项放大(浏览器原生渲染,所见即所得)。
  // ⚠️ 不能用 style transform:scale(3) 高清 — 它和 foreignObject+flex 冲突会丢 panel-text/foot 整块文字(用户 2026-06-27)
  /* 耳机层自己画(2026-10-23 真机):Safari 截图时画不出 SVG 里的背景图,存下来的卡耳机整块空白(先空画一遍也没用)。
     改成:截图前把所有 url() 背景层摘掉 → 截剩下的文字/底色 → 在画布上按原位置、contain 居中、透明度、椭圆遮罩
     一层层把耳机画回去。只依赖画布,所有浏览器结果一致。 */
  function 载图(src) { return new Promise(function (ok, bad) { var im = new Image(); im.onload = function () { ok(im); }; im.onerror = bad; im.src = src; }); }
  function 收集背景层(根el) {
    var 根 = 根el.getBoundingClientRect();
    var k = 根.width ? 根el.offsetWidth / 根.width : 1;   // 换回根节点自己的 CSS 像素(防祖先有缩放)
    var 层 = [];
    根el.querySelectorAll('*').forEach(function (el) {
      var cs = getComputedStyle(el);
      var m = cs.backgroundImage && cs.backgroundImage.match(/^url\(\s*['"]?(.+?)['"]?\s*\)$/);
      if (!m || cs.display === 'none' || cs.visibility === 'hidden') return;
      var r = el.getBoundingClientRect();
      if (!r.width || !r.height) return;
      var 罩 = cs.webkitMaskImage || cs.maskImage || '';
      层.push({ el: el, url: m[1], x: (r.left - 根.left) * k, y: (r.top - 根.top) * k, w: r.width * k, h: r.height * k,
                size: cs.backgroundSize, pos: cs.backgroundPosition.split(' '), op: parseFloat(cs.opacity) || 0,
                罩: /radial-gradient/.test(罩) ? (罩.match(/[\d.]+%/g) || []).map(parseFloat) : null });
    });
    return 层;
  }
  function 画层(ctx, im, l, S) {
    var iw = im.naturalWidth, ih = im.naturalHeight;
    if (!iw || !ih || !l.op) return;
    var f = l.size === 'cover' ? Math.max(l.w / iw, l.h / ih) : l.size === 'contain' ? Math.min(l.w / iw, l.h / ih) : 1;
    var dw = iw * f, dh = ih * f;
    var 位 = function (v, 余) { return /%$/.test(v) ? 余 * parseFloat(v) / 100 : (parseFloat(v) || 0); };
    var dx = l.x + 位(l.pos[0] || '50%', l.w - dw), dy = l.y + 位(l.pos[1] || l.pos[0] || '50%', l.h - dh);
    // 先画到一块小画布上做遮罩,再贴回主画布
    var c = document.createElement('canvas'); c.width = Math.ceil(l.w * S); c.height = Math.ceil(l.h * S);
    var g = c.getContext('2d');
    g.drawImage(im, (dx - l.x) * S, (dy - l.y) * S, dw * S, dh * S);
    if (l.罩 && l.罩.length >= 6) {   // radial-gradient(ellipse rx% ry% at cx% cy%, #000 a%, transparent b%)
      var rx = l.罩[0] / 100 * c.width, ry = l.罩[1] / 100 * c.height, cx = l.罩[2] / 100 * c.width, cy = l.罩[3] / 100 * c.height;
      g.globalCompositeOperation = 'destination-in';
      g.save(); g.translate(cx, cy); g.scale(1, ry / rx);
      var gr = g.createRadialGradient(0, 0, 0, 0, 0, rx);
      gr.addColorStop(Math.min(1, l.罩[4] / 100), 'rgba(0,0,0,1)'); gr.addColorStop(Math.min(1, l.罩[5] / 100), 'rgba(0,0,0,0)');
      g.fillStyle = gr; g.fillRect(-cx, -cy / (ry / rx), c.width, c.height / (ry / rx));
      g.restore();
    }
    ctx.globalAlpha = l.op;
    ctx.drawImage(c, l.x * S, l.y * S);
    ctx.globalAlpha = 1;
  }
  async function cardToBlob(node) {
    // 宽高必须明说(2026-10-23 真机):库自己去量的是它离线复制出来的那份节点,Safari 量不到 → SVG 不带宽高
    // → 按 300×150 的默认尺寸画,存下来的图只有左上角一小块,其余全白。电脑 Chrome 不受影响所以一直没发现。
    var w = node.offsetWidth, h = node.offsetHeight, S = 4;   // scale 3→4:下载图更高清(用户 2026-06-27)
    var 层 = 收集背景层(node);
    层.forEach(function (l) { l.旧 = l.el.style.getPropertyValue('background-image'); l.el.style.setProperty('background-image', 'none', 'important'); });
    var dataUrl;
    try { dataUrl = await window.domtoimage.toPng(node, { scale: S, bgcolor: '#ffffff', width: w, height: h }); }
    finally { 层.forEach(function (l) { if (l.旧) l.el.style.setProperty('background-image', l.旧); else l.el.style.removeProperty('background-image'); }); }
    var cv = document.createElement('canvas'); cv.width = Math.round(w * S); cv.height = Math.round(h * S);
    var ctx = cv.getContext('2d');
    ctx.drawImage(await 载图(dataUrl), 0, 0, cv.width, cv.height);
    for (var i = 0; i < 层.length; i++) {
      try {
        var src = /^data:/.test(层[i].url) ? 层[i].url : await 底图转dataURL(层[i].url);
        画层(ctx, await 载图(src), 层[i], S);
      } catch (e) { console.error('[下载图卡集] 画层失败:', 层[i].url.slice(0, 80), e); }
    }
    return await new Promise(function (r) { cv.toBlob(r, 'image/png'); });
  }
  // 下载图卡集:直接 clone 画廊里已渲染的卡(布局/字体/已应用样式都稳定),去掉 coverflow 变换,dom-to-image 浏览器原生渲染高清 PNG(用户 2026-06-27)
  // ⚠️ 必须 clone 现有卡,不能 makePosterCard 重新建 — 新建卡 dom-to-image 会丢 panel-text/foot 整块文字(clone 已渲染卡才稳定)
  /* 把画廊里每张卡渲成 PNG File(原 downloadGalleryCards 的出图循环原样搬出来,加了进度回调) */
  async function 渲染全部图卡(进度, 该停) {
    var vs = (typeof enumerate === 'function') ? enumerate() : [];
    var hasGift = vs.length && vs.length <= 4;
    var files = [];   // 先把每张卡渲成 File,收齐后统一分享/下载
    for (var i = 0; i < cards.length; i++) {
      if (该停 && 该停()) return null;   // 后台备图途中改了字 / 关了画廊 → 这一批作废
      if (进度) 进度(i + 1, cards.length);
      var src = cards[i];
      // clone 现有卡,整体覆盖 inline 清掉 coverflow 变换/窗口化(transform/visibility/opacity 等),铺成正屏直角卡
      var clone = src.cloneNode(true);
      clone.style.cssText = 'position:static;margin:0;transform:none;opacity:1;visibility:visible;box-shadow:none;border-radius:0;border:none;';
      var holder = document.createElement('div');
      holder.style.cssText = 'position:fixed;left:-10000px;top:0;background:#fff;padding:0;';
      var ex = document.createElement('div'); ex.className = 'fs-gallery' + (hasGift ? ' has-gift' : '');   // has-gift:单卡落款显示;不加 is-open:避免落款淡出规则
      ex.style.cssText = 'position:static;display:block;visibility:visible;opacity:1;transform:none;transition:none;background:transparent;pointer-events:none;';
      var tk = document.createElement('div'); tk.className = 'fs-gallery__track';
      tk.style.cssText = 'position:static;top:auto;left:auto;transform:none;transform-style:flat;';
      tk.appendChild(clone); ex.appendChild(tk); holder.appendChild(ex);
      document.body.appendChild(holder);
      await inlineLayerBgsFrom(src, clone);   // 耳机层背景:从原卡读 url 固化进 clone(dom-to-image 渲染前必做)
      if (document.fonts && document.fonts.load) { try { await document.fonts.load('32px "adelia"'); } catch (e) {} }
      await new Promise(function (r) { requestAnimationFrame(function () { r(); }); });   // 原来固定等 200ms,16 张白等 3 秒多;字体上一行已 await,排版只需一帧(2026-10-23 提速,清晰度不动)
      var blob = await cardToBlob(clone);
      document.body.removeChild(holder);
      if (!blob) continue;
      var fname;
      if (i === 0) fname = 'rainbow-00-overview.png';   // 第一张是拼排总览
      else { var v = vs[i - 1]; var nm = ((v && designNameEN(v)) || 'card').replace(/\s+/g, ''); fname = 'rainbow-' + String(i).padStart(2, '0') + '-' + nm + '.png'; }
      files.push(new File([blob], fname, { type: 'image/png' }));
    }
    return files;
  }
  /* ═══ 下载图卡集:点一下就存(2026-10-23 用户:不要点两下,图标上提示第几张就行)═══
     iOS 只在【点击后几秒内】允许弹系统分享面板,16 张卡渲不进这个窗口。所以:
       ① 画廊一打开就在后台悄悄把图渲好(安排备图)—— 收礼人看信那十几秒正好够;
       ② 点下载时图已备好 → 这一下里【一个 await 都没有】,直接开系统面板;
       ③ 点早了还没渲完 → 图标上显示「3/16」,渲完照样试一次开面板;
          iOS 真的拒了(等太久授权过期)才退成「图标变黑 + 再点一下」。
     缓存键带上搭配 + 张数 + 贺卡文字:改了任何一样,备好的图就作废。 */
  var 下载包 = { 键: null, files: null, 任务: null, 任务键: null, 号: 0, 进度: null, 等的按钮: null };
  function 下载键() {
    try { return encodeDesign() + '|' + cards.length + '|' + (giftState.name || '') + '|' + (giftState.msg || ''); }
    catch (e) { return String(Math.random()); }
  }
  function 标进度(btn, i, n) { if (!btn) return; btn.classList.add('is-prog'); btn.setAttribute('data-prog', i + '/' + n); }
  function 清进度(btn) { if (!btn) return; btn.classList.remove('is-prog', 'is-loading'); btn.removeAttribute('data-prog'); }
  // 开始(或接上正在进行的)一批备图;返回 files,中途作废返回 null
  function 开始备图() {
    var 键 = 下载键();
    if (下载包.files && 下载包.键 === 键) return Promise.resolve(下载包.files);
    if (下载包.任务 && 下载包.任务键 === 键) return 下载包.任务;
    var 号 = ++下载包.号;
    下载包.进度 = null;
    var 该停 = function () { return 下载包.号 !== 号 || 下载键() !== 键 || !overlay || !overlay.classList.contains('is-open'); };
    下载包.任务键 = 键;
    下载包.任务 = 渲染全部图卡(function (i, n) {
      下载包.进度 = [i, n];
      if (下载包.等的按钮) 标进度(下载包.等的按钮, i, n);
    }, 该停).then(function (files) {
      if (!files || 下载包.号 !== 号 || 下载键() !== 键) return null;
      if (files.length) { 下载包.files = files; 下载包.键 = 键; }
      return files;
    }, function (e) { console.error('[下载图卡集] 备图失败:', e); return null; }).finally(function () {
      if (下载包.号 === 号) { 下载包.任务 = null; 下载包.任务键 = null; }
    });
    return 下载包.任务;
  }
  // 画廊开着就在后台备图(只手机:电脑不受「点击后几秒」限制,不用提前做)
  var 备图表 = 0;
  function 安排备图(延迟) {
    clearTimeout(备图表);
    备图表 = setTimeout(function () {
      var isMobile = window.matchMedia && window.matchMedia('(max-width: 760px), (max-device-width: 760px)').matches;
      if (!isMobile || !navigator.canShare || typeof window.domtoimage === 'undefined') return;
      if (!overlay || !overlay.classList.contains('is-open') || !cards || !cards.length) return;
      开始备图();
    }, 延迟 || 3000);
  }
  // 进度提示:同一条提示反复改字,不像 galleryToast 那样每次叠一条新的
  var 进度提示el = null, 进度提示表 = 0;
  function 进度提示(msg, 停留) {
    if (!overlay) return;
    if (!msg && !进度提示el) return;   // 收起一条本来就没有的提示
    if (!进度提示el || !进度提示el.parentNode) {
      进度提示el = document.createElement('div'); 进度提示el.className = 'fs-gallery__toast';
      overlay.appendChild(进度提示el);
      var 新 = 进度提示el; requestAnimationFrame(function () { 新.classList.add('show'); });
    }
    进度提示el.textContent = msg;
    clearTimeout(进度提示表);
    进度提示表 = setTimeout(function () {
      var t = 进度提示el; 进度提示el = null;
      if (t) { t.classList.remove('show'); setTimeout(function () { if (t.parentNode) t.remove(); }, 300); }
    }, 停留 || 8000);
  }
  async function downloadGalleryCards(btn) {
    if (typeof window.domtoimage === 'undefined') { alert('截图库还在加载,请稍候或检查网络后重试'); return; }
    if (!cards || !cards.length) { alert('请先展开图卡集再下载'); return; }
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 760px), (max-device-width: 760px)').matches;
    var 能分享 = !!(isMobile && navigator.canShare);
    if (能分享) {
      // 图已备好 → 这里到 navigator.share 之间不能有任何 await
      if (下载包.files && 下载包.键 === 下载键() && navigator.canShare({ files: 下载包.files })) {
        btn.classList.remove('is-ready');
        try { await navigator.share({ files: 下载包.files, title: '我的 Rainbow 图卡集' }); }
        catch (e) { if (!e || e.name !== 'AbortError') { console.error('[下载图卡集] 系统面板打不开:', e); galleryToast(TR('err_download'), 3000); } }
        return;
      }
      /* 图还没备好(2026-10-23 用户第三版):点的是分享,就马上开系统分享面板(先带链接),不显示任何「下载进度」。
         后台接着备图,过几秒再点一次分享,面板里就有「保存 N 张图像」了。
         iOS 规定开面板时必须把图一起交进去,面板里点了什么网页也看不到,所以没法「先开面板、点保存时再做图」。 */
      开始备图();
      try { await navigator.share({ title: 'My Rainbow headphones', url: shareUrl() }); }
      catch (e) { if (!e || e.name !== 'AbortError') { console.error('[下载图卡集] 系统面板打不开:', e); galleryToast(TR('err_download'), 3000); } }
      return;
    }
    // 桌面 / 不支持文件分享 → 渲完逐张下载,进度同样写在图标上
    if (btn.classList.contains('is-prog')) return;
    标进度(btn, 0, cards.length);
    try {
      var all = await 渲染全部图卡(function (i, n) { 标进度(btn, i, n); });
      if (!all || !all.length) { alert(TR('err_gencard')); return; }
      for (var j = 0; j < all.length; j++) {
        var url = URL.createObjectURL(all[j]);
        var a = document.createElement('a'); a.href = url; a.download = all[j].name;
        document.body.appendChild(a); a.click(); document.body.removeChild(a);
        await new Promise(function (r) { setTimeout(r, 220); });
        URL.revokeObjectURL(url);
      }
    } catch (e) { console.error('[下载图卡集] 失败:', e); alert(TR('err_download')); }
    finally { 清进度(btn); }
  }
  // ===== 分享(方案A):Web Share API 带 DIY 图(手机)+ 桌面平台图标兜底(用户 2026-07-01)=====
  var SHARE_TITLE = 'My Rainbow headphones';
  var SHARE_TEXT = 'I designed my own Rainbow headphones 🌈 One pair, a whole wardrobe of styles. Design yours:';
  // 第 119 轮:分享链接带上 ?d=<设计短码>&by=<署名>,对方点开直接看到你配的这副(能加购、能改成自己的)。
  // 在这之前它只返回 location.href —— 对方打开是一个空白配置器,这条传播链是断的。
  // preview_theme_id 要剔掉:那是本地/预览调试用的,发出去对方根本没有预览权限,只会看到线上版本还一头雾水。
  function shareUrl() {
    try {
      var u = new URL(window.location.href);
      u.hash = '';
      /* 🔴 2026-08-28 改:preview_theme_id 【只在自己就在预览主题上时保留】。
         原来无条件删掉 —— 立意是"别把草稿主题发给真客人",没错;
         但副作用是【横版还没发布之前,分享功能根本没法自测】:
         链接永远落到已发布的竖版首页,而那个版本里没有分享落地代码(实测线上首页搜不到 来自分享),
         于是点开就是一张普通首页,既不是你在编的模板,也不会自动弹配置器 —— 用户 2026-08-28 报的正是这个。
         改成条件保留后是自限的:你在预览主题上分享 → 链接带 id,对方看到的和你一样;
         真客人在正式站上分享 → 地址栏本来就没这个参数 → 链接天然干净。不需要以后回来删。 */
      if (!u.searchParams.get('preview_theme_id')) u.searchParams.delete('preview_theme_id');
      // ⚠️ lang 也必须剔掉(第 123 轮):它是【本地测试用的语言强制开关】,
      // 跟着链接发出去会把收礼人的语言按死 —— 台湾朋友点开却是一屏英文。
      // 语言该由 Shopify 按访客 IP 路由的市场决定,不是由发链接的人决定。
      u.searchParams.delete('lang');
      u.searchParams.set('d', encodeDesign());
      // ⚠️ 礼物卡的 Name 是【收礼人】(面板原话 Put their name on it),不是设计者 ——
      // 第 119 轮写成 by=(谁配的)是把语义搞反了,第 121 轮改成 to=(配给谁)。
      var 名 = (giftState && giftState.nameEdited && giftState.name || '').trim();
      u.searchParams.delete('by');
      if (名) u.searchParams.set('to', 名.slice(0, 24)); else u.searchParams.delete('to');
      // 祝福语:预设的只带序号(省地方),用户自己写的才带原文
      var 语 = (giftState && giftState.msg || '').trim();
      var 预设序 = GIFT_MSGS.indexOf(语);
      if (!语) u.searchParams.delete('m');
      else if (预设序 >= 0) u.searchParams.set('m', String(预设序));
      else u.searchParams.set('m', '~' + encodeURIComponent(语.slice(0, 90)));
      // 意图:只有点过标签才带 t —— 没点就是"单纯给人看",不该假装是送礼
      if (giftState && giftState.tagPicked) u.searchParams.set('t', String(giftState.msgIdx));
      else u.searchParams.delete('t');
      return u.toString();
    } catch (e) { return window.location.href; }
  }
  // 把当前聚焦卡渲成 PNG blob(复用下载流程:clone→固化层背景→dom-to-image)
  async function cardToShareBlob(src) {
    if (typeof window.domtoimage === 'undefined' || !src) return null;
    var clone = src.cloneNode(true);
    clone.style.cssText = 'position:static;margin:0;transform:none;opacity:1;visibility:visible;box-shadow:none;border-radius:0;border:none;';
    var holder = document.createElement('div');
    holder.style.cssText = 'position:fixed;left:-10000px;top:0;background:#fff;padding:0;';
    var ex = document.createElement('div'); ex.className = 'fs-gallery' + (hasGiftCard ? ' has-gift' : '');
    ex.style.cssText = 'position:static;display:block;visibility:visible;opacity:1;transform:none;transition:none;background:transparent;pointer-events:none;';
    var tk = document.createElement('div'); tk.className = 'fs-gallery__track';
    tk.style.cssText = 'position:static;top:auto;left:auto;transform:none;transform-style:flat;';
    tk.appendChild(clone); ex.appendChild(tk); holder.appendChild(ex);
    document.body.appendChild(holder);
    try {
      await inlineLayerBgsFrom(src, clone);
      if (document.fonts && document.fonts.load) { try { await document.fonts.load('32px "adelia"'); } catch (e) {} }
      await new Promise(function (r) { setTimeout(r, 200); });
      return await cardToBlob(clone);
    } finally { document.body.removeChild(holder); }
  }
  // 主分享:优先 Web Share 带图片文件(手机原生面板→IG/TikTok/微信…);退而带链接;都不支持则提示用图标排
  // 是否移动设备(手机/平板):这些设备的 Web Share 文件由系统托管,不碰桌面 Chrome"提前回收临时文件→AirDrop 卡死"的坑
  function isMobileDevice() {
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || (navigator.maxTouchPoints > 1 && /Macintosh/.test(navigator.userAgent));
  }
  /* ═══ 分享图【预热】(2026-08-27)══════════════════════════════════════
     用户实机取证:点分享 → 灰一会 → 弹出 `NotAllowedError / NotAllowedError`。
     两步全被拒,原因是同一个:
       iOS 只在【用户点击后的一小段授权窗口】内允许调 navigator.share / clipboard,
       而原来的代码先 `await cardToShareBlob()` 花 1~3 秒把图卡渲染成 PNG,
       等它回来时窗口早过了 —— 分享被拒,退回复制链接【也】被拒(剪贴板同一规矩)。
     所以【缩短渲染时间】治不了本,必须让点击那一刻【图已经在手上】。

     做法:提前把图渲好存着。触发点 = 打开画廊 / 改贺卡文字 / 翻卡,各自防抖。
     ⚠️ 这【不增加总工作量】:原来每点一次分享就渲一次,现在是每次开画廊渲一次,
        点几次分享都用同一张。用户刚反馈过手机发烫,所以这点必须算清楚才敢加。
     ⚠️ 缓存键带上卡片序号和贺卡文字 —— 换了卡或改了字,旧图就作废,不能发错图。 */
  var 图缓存 = { 键: null, file: null, 忙: false };
  function 图键() {
    var idx = Math.max(0, Math.min(cards.length - 1, Math.round(pos.current)));
    return idx + '|' + (giftState.name || '') + '|' + (giftState.msg || '');
  }
  async function 预热图() {
    if (图缓存.忙) return;
    var 键 = 图键();
    if (图缓存.键 === 键 && 图缓存.file) return;      // 已经热好了
    图缓存.忙 = true;
    try {
      var idx = Math.max(0, Math.min(cards.length - 1, Math.round(pos.current)));
      var blob = await cardToShareBlob(cards[idx]);
      // 渲染期间用户可能又改了字/翻了卡 —— 那这张就作废,别缓存成错的
      if (blob && 图键() === 键) 图缓存 = { 键: 键, file: new File([blob], 'my-rainbow.png', { type: 'image/png' }), 忙: false };
      else 图缓存.忙 = false;
    } catch (e) { 图缓存.忙 = false; }
  }
  var 预热表 = 0;
  function 安排预热(延迟) {
    clearTimeout(预热表);
    预热表 = setTimeout(function () {
      // 画廊没开着就不做 —— 没人会在关着的时候点分享
      // 收礼人那一屏没有带图分享按钮(只有复制链接),不渲,省得收礼人手机白白发烫
      if (overlay && overlay.classList.contains('is-open') && !overlay.classList.contains('is-received')) 预热图();
    }, 延迟 || 1500);
  }

  async function shareCurrentCard(btn) {
    btn.classList.add('is-loading');
    try {
      // 手机:Web Share 带图 + 链接,直发 IG/TikTok/微信。图是给人看的,链接才是能下单的那个。
      if (isMobileDevice() && navigator.canShare) {
        /* 🔴 这一段里【一个 await 都不能有】—— 有了授权窗口就过期,又变回 NotAllowedError。
           图热好了就带图发;没热好【也不等】,先把系统面板开起来(只带链接),
           顺手安排一次预热,下次点就有图了。宁可这次少一张图,也不能整个按钮点不动。 */
        var 有图 = 图缓存.file && 图缓存.键 === 图键();
        if (有图 && navigator.canShare({ files: [图缓存.file] })) {
          await navigator.share({ files: [图缓存.file], title: SHARE_TITLE, text: SHARE_TEXT, url: shareUrl() });
          return;
        }
        安排预热(0);
        await navigator.share({ title: SHARE_TITLE, text: SHARE_TEXT, url: shareUrl() });
        return;
      }
      // 桌面:复制链接。第 119 轮改的 —— 原来是下载 PNG,和下面的「下载图卡集」职责完全重叠,
      // 用户直接问「那分享的意义是什么」。现在链接能还原整副设计了,复制链接才是真的"分享"。
      // (Mac Chrome 的 Web Share 有"提前回收临时文件→AirDrop 卡死"的坑,桌面本来就不能走系统分享)
      var u = shareUrl();
      if (navigator.clipboard && navigator.clipboard.writeText) await navigator.clipboard.writeText(u);
      galleryToast(TR('share_link_copied'));
    } catch (e) {
      /* 🔴 2026-08-27:原来这里整句是「catch 里只写一行注释,什么都不做」。
         ⚠️ 写这段注释时踩过一次:原文照抄了那行带 星斜杠 的注释,
            嵌套的结束符把整段注释提前关掉,后面的中文被当代码解析 →
            `SyntaxError: Unexpected reserved word`,整个模块 JS 全挂、按钮点了没反应。
            **块注释里永远不要出现结束符**,要引用就改写成文字描述。
         用户实机反馈「点分享,灰一下,什么反应都没有」—— 就是它:
         上面 `await cardToShareBlob()` 要花 1~3 秒渲染图片,而 iOS 要求
         navigator.share 必须在【点击后的短暂授权窗口】内调用,过期就抛 NotAllowedError;
         错误被这句吞掉后,既不提示、也不退回复制链接,按钮等于是死的。
         现在改成:用户自己取消 → 安静;其它任何失败 → 必须给出路 + 必须有可见反馈。
         ⚠️ TODO(临时):toast 里带了错误名,是为了让用户实机点一次就能告诉我真实原因。
            确认后把 `+ '(' + 名 + ')'` 那段删掉。真正的修法是【提前把图片渲染好】,
            让点击那一刻不用等 —— 那是下一步,不在本补丁里。 */
      var 名 = (e && e.name) || '未知';
      if (名 === 'AbortError') {
        /* 用户在系统面板上自己点了取消,这是正常操作,不打扰 */
      } else {
        /* ⚠️ 提示语必须【等复制真成了再说"已复制"】。
           上一版无论成败都先拼好「链接已复制」,结果用户实机看到的是
           `Link copied …(NotAllowedError) / NotAllowedError` —— 两步全失败了却还说复制成功,
           这比不提示更糟(用户会去粘贴,粘出来是别的东西)。 */
        var u2 = shareUrl();
        var 成 = false;
        try {
          if (navigator.clipboard && navigator.clipboard.writeText) { await navigator.clipboard.writeText(u2); 成 = true; }
        } catch (e2) { 成 = false; }
        if (!成) {
          /* 老办法再试一次:clipboard API 和 navigator.share 受同一个授权窗口管,
             过期时会一起被拒(实测两个都是 NotAllowedError);
             execCommand 走的是另一条路,窗口过期后往往还能成。 */
          try {
            var ta = document.createElement('textarea');
            ta.value = u2; ta.style.cssText = 'position:fixed;left:-9999px;top:0;';
            document.body.appendChild(ta); ta.select(); ta.setSelectionRange(0, u2.length);
            成 = document.execCommand('copy');
            document.body.removeChild(ta);
          } catch (e3) { 成 = false; }
        }
        galleryToast(成 ? TR('share_link_copied') : TR('share_failed'), 成 ? 1600 : 5000);
      }
    }
    finally { btn.classList.remove('is-loading'); }
  }
  // 是否本地/离线环境(localhost 等):公网平台抓不到本地链接 → 分享跳转要拦截
  function isLocalEnv() {
    return /^(localhost|127\.0\.0\.1|0\.0\.0\.0|::1)$/.test(location.hostname) || location.protocol === 'file:';
  }
  // 桌面平台图标:各平台分享 URL(只带链接+文案,图靠上面 Web Share 带)
  function shareVia(platform) {
    if (platform === 'copy') {
      var done = function () { galleryToast(TR('share_link_copied')); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(shareUrl()).then(done, done);
      else done();
      return;
    }
    // 本地环境:localhost 链接平台服务器抓不到(Pinterest/FB 报"非有效网址")→ 拦截提示,上线真域名自动恢复跳转(用户 2026-07-01)
    if (isLocalEnv()) { galleryToast(TR('share_local_env')); return; }
    var u = encodeURIComponent(shareUrl());
    var t = encodeURIComponent(SHARE_TEXT);
    var map = {
      pinterest: 'https://www.pinterest.com/pin/create/button/?url=' + u + '&description=' + t,
      facebook: 'https://www.facebook.com/sharer/sharer.php?u=' + u,
      x: 'https://twitter.com/intent/tweet?text=' + t + '&url=' + u,
      email: 'mailto:?subject=' + encodeURIComponent(SHARE_TITLE) + '&body=' + t + '%20' + u
    };
    if (!map[platform]) return;
    if (platform === 'email') { window.location.href = map[platform]; return; }
    window.open(map[platform], '_blank', 'noopener,noreferrer,width=640,height=620');
  }
  // 画廊内轻提示(复制成功等)
  /* 停留时长可选:默认 1.6 秒(复制成功这种一眼扫过就行)。
     2026-08-27 加第二个参数 —— 分享失败那条要报错误名给用户截图,
     1.6 秒根本来不及看清(用户实机截了一张,提示已经消失了)。 */
  function galleryToast(msg, 停留) {
    if (!overlay) return;
    var t = document.createElement('div'); t.className = 'fs-gallery__toast'; t.textContent = msg;
    overlay.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('show'); });
    setTimeout(function () { t.classList.remove('show'); setTimeout(function () { if (t.parentNode) t.remove(); }, 300); }, 停留 || 1600);
  }
  // 手机模态:按 stage 实际可用高度自适应缩放整叠 coverflow(卡片固定 580px,屏高随设备变 → 固定 scale 会在短屏被裁)。上限 .82 防大屏过大(用户 2026-07-10 稳定性重构)
  /* 🔴 2026-08-27 改「整体上移 + 底部露出渐变底」(用户红框标注)。
     ── 改之前的实测(scripts/_diag-gallery-gaps.mjs,390×844)──
       页码底40 →(51)→ 图卡顶91 …… 图卡底598 →(41)→ 面板顶639 …… 买按钮底834 →(10)→ 屏幕底
       卡片区 stage 高 589,而图卡本身只有 506 —— **里面上下各有 41px 的空气**。
       那 82px 正是用户圈的两段。把它压掉塞到底部,图卡一点都不用变小。

     ── 为什么不能只改 CSS ──
       stage 是 `flex:1`,会把所有剩余空间吃干净;而 fit 又是【按 stage 高度】算的,
       所以:加大底部内边距 → stage 变矮 → 图卡跟着缩(实测会从 506 掉到 453)。
       死结在于「卡片大小」和「卡片区高度」互相依赖。
     ── 解法:把这两件事拆开 ──
       ① fit 改从【兄弟节点】倒推可用高度(面板 + 买按钮 + 内边距),**不再读 stage.clientHeight**
          —— 这样下面把 stage 改矮,也不会反过来把卡片缩小(否则会陷入越算越小的死循环)。
       ② stage 不再吃满,只占「图卡实际高度 + 上下各 18px」,剩下的自然落到底部 = 渐变底露出来。 */
  /* 上下不等值(2026-08-28):用户要「页码胶囊跟图卡再贴近一点」,但图卡大小不许变。
     上留白 18 → 6,图卡整体上移 12px;下留白保持 18,所以「图卡 → Gift Card 面板」那段不受影响。
     省下的 12px 自然落到底部渐变带。
     ⚠️ 6 不是所见即所得:coverflow 给中心卡额外套了约 0.98 的变换,视觉留白其实是 11px。
     ⚠️ 下限卡在关闭 X(底边恒在 y=42):上留白 6 时图卡顶离 X 还有 9.2px,再小就贴上去了。 */
  /* 安卓微信的字体放大关不掉(2026-08-28 配套 iOS 那条 CSS 修复):
     安卓微信用的是自家 X5/XWeb 内核,CSS 的 text-size-adjust 对它无效,
     只能调微信自己的桥接口把「字体大小」设置拉回标准档。iOS 那边由 CSS 负责,这里只兜安卓。
     ⚠️ 用户中途去微信设置里改字号会再触发一次,所以还要监听 menu:setfont 把它拉回来。 */
  (function 关掉安卓微信字体缩放() {
    if (!/MicroMessenger/i.test(navigator.userAgent)) return;
    function 归位() {
      try {
        WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 });
        WeixinJSBridge.on('menu:setfont', function () {
          try { WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 }); } catch (e) { console.error('[DIY] 微信字号复位失败', e); }
        });
      } catch (e) { console.error('[DIY] 微信字号复位失败', e); }
    }
    if (typeof WeixinJSBridge === 'object' && WeixinJSBridge && typeof WeixinJSBridge.invoke === 'function') 归位();
    else document.addEventListener('WeixinJSBridgeReady', 归位, false);
  })();

  var 卡片上留白 = 6;
  /* 下留白 18 → 10(2026-08-28 用户「Gift Card 往上挪一点,离图卡更近」):
     缝 23.2 → 15.2px。10 不是拍脑袋 —— 像素扫过图卡底那圈投影的衰减:
       离卡底 3px 时还很浓、8px 减半、【15px 基本看不出】、22px 才彻底没。
     原来的 23.2 等于「等投影完全散干净才放面板」,所以看着远;15.2 正好落在
     投影已经淡到看不见、又还没被面板边压住的位置,两块贴近了但分界还在。
     ⚠️ 别再往下调:到 11px 时 320 窄屏的缝(8.7)会小于面板自己的下边距(9),
        面板会从「独立一块」变成「粘在图卡屁股上」,层次反而乱。 */
  var 卡片下留白 = 10;
  function fitCard() {
    if (!modalMobile || !overlay) return;
    var stage = overlay.querySelector('.fs-gallery__stage');
    var track = overlay.querySelector('.fs-gallery__track');
    if (!stage || !track) return;

    // 可用高 = 模态内容区 − 贺卡面板(含外边距) − 加购按钮。不读 stage 自己的高度,见上面 ①
    var cs = getComputedStyle(overlay);
    var 内容高 = overlay.clientHeight - parseFloat(cs.paddingTop || 0) - parseFloat(cs.paddingBottom || 0);
    var 占 = 0;
    var 面板 = overlay.querySelector('.fs-gift-editor');
    if (面板) {
      var ms = getComputedStyle(面板);
      占 += 面板.getBoundingClientRect().height + parseFloat(ms.marginTop || 0) + parseFloat(ms.marginBottom || 0);
    }
    var 买 = overlay.querySelector('.fs-gallery__actions');
    if (买) 占 += 买.getBoundingClientRect().height;
    var sh = 内容高 - 占;
    if (!(sh > 120)) { sh = stage.clientHeight; }        // 兜底:量不到就退回老办法,别把卡片算没
    if (!sh) return;

    var fit = Math.min(0.90, (sh * 0.93) / 615);   // 615 = 中心卡自然显示高;上限 .85→.90 + 留白收窄 → 图卡再向上放大一点,顶部更饱满(用户 2026-07-12)
    track.style.transform = 'scale(' + fit + ')';

    /* 卡片缩放已定,量出它【真实渲染高】再决定 stage 多高。
       ⚠️ 必须量渲染后的 rect,不能拿 615*fit 去算 —— 实测 615×0.891=548,而卡片实际只有 506,
          615 那个常数和卡片元素的真实高度并不相等,拿它算会多留 40 多px 空气。 */
    /* ⚠️ 这里【不能用 getBoundingClientRect】。fitCard 是在 `requestAnimationFrame` 里紧跟
       open() 调的,那时卡片的入场动画(staggerCardsIn / .fs-card-in)还在播 ——
       量到的是动画中途的高度(实测 460),而落定后是 512,于是 stage 被设成 496、比卡片还矮,
       卡片上下各溢出 8px:顶到页码、又压住下面的面板。
       正确做法:用【布局高度 offsetHeight】(不含任何 transform)乘上刚设好的【永久缩放 fit】。
       临时动画不影响 offsetHeight,所以什么时候量都一样。
       ⚠️ 也别用 615 那个常数去算:实测 615×0.891=548,而卡片实际只有 506,两者并不相等。 */
    var 卡 = track.querySelector('.explore-card.is-current') || track.querySelector('.explore-card');
    var 卡高 = 卡 ? 卡.offsetHeight * fit : 0;
    if (卡高 > 60) {
      stage.style.flex = '0 0 auto';
      stage.style.height = Math.round(卡高 + 卡片上留白 + 卡片下留白) + 'px';
      /* 上下留白不再相等 → 不能再靠 CSS 的 top:50% 居中(那只在上下等值时才对)。
         卡片 CSS 是 `top:0; height:580; margin-top:-290`,即【卡片中心 = track 原点】,
         所以把原点摆到 (上留白 + 卡高/2),卡顶就正好落在 stage 顶 + 上留白。
         ⚠️ 关闭时必须连这行内联 top 一起清掉(见 close 里清 transform 那处),否则残留到桌面。 */
      track.style.top = Math.round(卡片上留白 + 卡高 / 2) + 'px';

      /* 2026-10-23 用户微信截图:收礼人页底部「加入购物车」被切掉半截。
         上面的预算漏了买按钮的 margin-top(23)和面板外的间隙,微信还会把字放大让信变高 ——
         预算怎么算都会有漏项,所以排完再【量一次真实底边】:超出多少,卡片就缩多少。
         用 offsetTop(布局坐标)不用 rect:画廊开场带 scale(.9→1) 过渡,rect 是动画中间值。 */
      if (买) {
        for (var 回 = 0; 回 < 2; 回++) {
          var 底线 = overlay.clientHeight - parseFloat(cs.paddingBottom || 0);
          var 超 = 买.offsetTop + 买.offsetHeight - 底线;
          if (!(超 > 0.5) || 卡高 - 超 < 120) break;   // 放得下就不动;真缩到 120 以下宁可让它超出,别把图卡缩没
          fit = fit * (卡高 - 超) / 卡高;
          卡高 = 卡.offsetHeight * fit;
          track.style.transform = 'scale(' + fit + ')';
          stage.style.height = Math.round(卡高 + 卡片上留白 + 卡片下留白) + 'px';
          track.style.top = Math.round(卡片上留白 + 卡高 / 2) + 'px';
        }
      }
    }

    /* ═══ 毛玻璃底边(2026-09-15 用户要求)═══════════════════════════════
       用户原话:「毛玻璃底部的位置要在按钮的上面,也就是在写贺卡的下面……
                 毛玻璃在写贺卡跟分享这一个内容块的下面 20px 这里」。
       也就是:玻璃底边 = 礼卡面板底 + 20,买按钮【露在玻璃外面】。

       为什么在 fitCard 里算而不是写死 CSS:
         礼卡面板的高度随视口、随祝福语行数变(320 窄屏会多一行),
         写死的话换个机型玻璃底边就不在面板下方 20px 了。
       ⚠️⚠️ 必须【延到下一帧】再量,不能在这里直接量:
          本函数刚刚改了 stage 的 height,而礼卡面板(order:2)排在 stage 后面,
          位置要等这次布局结算完才是最终值;而且画廊开场还带 scale(.9→1) 的过渡,
          期间量到的是动画中间态。第一版就是直接量的,算出 28px(正确值是 125px)——
          差了整整一个买按钮的高度,玻璃底边压根没挪到贺卡下面。 */
    排期算玻璃底();
  }

  /* 玻璃底边:独立成函数,因为要在【多个时机】各算一次 ——
     fitCard 之后(下一帧)、画廊开场动画结束后、resize 之后。
     幂等,多算几次没副作用。 */
  var 玻璃底定时组 = [];
  function 排期算玻璃底() {
    /* 🔴 为什么要算【三次】而不是一次:
       只在 fitCard 后延一帧算过一版,实测算出 28px(正确值 125px)—— 差了整整一个买按钮。
       原因是那一刻布局还没定下来:画廊开场带 scale(.9→1) 过渡(420ms),
       卡片还有 staggerCardsIn 错峰入场,礼卡面板的最终位置要等这些都落定。
       所以铺三个时间点:下一帧(16) / 过渡中段(220) / 全部动画结束后(650)。
       函数幂等,多算几次只是重复写同一个值,没有副作用。 */
    玻璃底定时组.forEach(function (t) { clearTimeout(t); });
    玻璃底定时组 = [16, 220, 650].map(function (d) { return setTimeout(算玻璃底, d); });
  }
  function 算玻璃底() {
    try {
      if (!overlay || !overlay.classList.contains('is-open')) return;
      var 面板2 = overlay.querySelector('.fs-gift-editor');
      if (!面板2) return;
      var r2 = 面板2.getBoundingClientRect();
      if (!r2.height) return;                       // 还没排版出来,等下一个时间点
      var 距屏底 = Math.round((window.innerHeight || overlay.clientHeight) - (r2.bottom + 20));
      /* 夹在 [10, 视高一半]:面板万一算出异常值,也不让玻璃缩成负数或吃掉半屏 */
      距屏底 = Math.max(10, Math.min(距屏底, Math.round((window.innerHeight || 800) / 2)));
      overlay.style.setProperty('--fs-glass-bottom', 距屏底 + 'px');
    } catch (e) {}
  }
  /* ═══ 收礼人模式(第 122 轮)════════════════════════════════════════════
     同一屏两种人:配的人在这里【填】,收到的人只是【读】。
     收到的人多半是从微信/IG 点进来的新客 —— 给他一个表单他只会困惑,
     所以把左边整块从"编辑器"换成"一封信":谁给你的、写了什么、为什么是这个颜色。

     行动按钮由【意图】决定,意图来自分享时点的那个关系标签:
       送人   —— 不给购买按钮。让收礼人自己掏钱买自己的礼物,本身就说不通(用户 2026-08-10 指出)。
                 给一个好奇心出口就够:他记住这个牌子、逛一圈,这一趟就值了。
       想要   —— 点的是「送自己」,那这条链接就是心愿单,看的人才是掏钱那位 → 「送 TA 这一副」。
       给人看 —— 没点标签,单纯炫耀/种草 → 「我也想配一副」。 */
  function 收礼人信息() {
    if (typeof 来自分享 === 'undefined' || !来自分享) return null;
    var 语 = 来自分享.祝福语原文;
    if (!语 && 来自分享.祝福语序号 >= 0) 语 = GIFT_MSGS[来自分享.祝福语序号] || '';
    return { 名: 来自分享.收礼人 || '', 语: 语, 意图: 来自分享.意图 };
  }

  /* 这一套里有哪些零件,按部件分行列全 —— 每行可能不止一个颜色。
     第 122/123 轮这里只列【当前这一副】的 4 件,可这一盒物理上是:
     主机 ×1(共享)+ 面盖 ×2 + 全包皮套 ×2 + 设计款头带 ×2。
     收礼人看着右边 16 张图卡在转、左边只写一副,当然会问「怎么只显示了一种」(用户 2026-08-11)。
     取值范围必须跟 enumerate() 用的那几件【完全一致】(builds 前两副),
     否则左边说的和右边画的又对不上 —— 那才是真正让人摸不着头的地方。 */
  function 零件池() {
    var 找 = function (池, slug) { for (var i = 0; i < 池.length; i++) if (池[i].slug === slug) return 池[i]; return null; };
    var 词 = PARTW[LOCALE] || PARTW.en;
    var 副们 = state.builds.slice(0, 2);
    // 同色只列一次:两副挑了同一个面盖时,写两遍「星空银 · 星空银」是噪音
    var 取 = function (键, 找法) {
      var 见 = {}, 出 = [];
      副们.forEach(function (b) {
        var s = b && b[键]; if (!s || 见[s]) return;
        var o = 找法(s); if (!o) return;
        见[s] = 1; 出.push({ 名: dispName(o) });
      });
      return 出;
    };
    var h = 找(HOSTS, state.base.host);
    var 行 = [];
    /* 第 128 轮:零件图整排拿掉,只留文字(用户 2026-08-11「这些图标去掉,只剩下文字,排版整齐高级一点」)。
       第 126/127 轮那套实物缩略图(面盖/皮套/头带各自抠图 + 主机三层合成整机)已删 ——
       要恢复的话:给每项带回 { 图: o.image } 和主机的三层 adaptImg,渲染处配 .fs-letter__thumb。
       现在这里只需要名字,色值/图都不再用。 */
    if (h) 行.push({ 部: 词.host, 项: [{ 名: dispName(h) }] });
    var 面 = 取('faceplate', function (s) { return 找(FACEPLATES, s); });
    var 皮 = 取('earpad',    function (s) { return 找(EARPADS, s); });
    var 带 = 取('headband',  function (s) { return HEADBAND_MAP[s]; });
    if (面.length) 行.push({ 部: 词.faceplate, 项: 面 });
    if (皮.length) 行.push({ 部: 词.pad || 词.earpad, 项: 皮 });
    if (带.length) 行.push({ 部: 词.headband, 项: 带 });
    return 行;
  }
  /* 一句人话把零件和右边那一叠图卡接上 —— 标题只说了「有什么」,
     这句回答「所以呢」:这几件东西本身就能换出这么多种样子。
     数字直接取 enumerate() 的长度,不写死 —— 配 1 副和配 2 副数量差很多,写死必错。 */
  function 换出几种() {
    try {
      var n = (typeof enumerate === 'function') ? enumerate().length : 0;
      return n > 1 ? TR('recv_count').replace('{n}', String(n)) : '';
    } catch (e) { return ''; }
  }

  function 装收礼人信() {
    var 信息 = 收礼人信息();
    var box = overlay && overlay.querySelector('.fs-gift-editor');
    if (!信息 || !box) return false;
    overlay.classList.add('is-received');
    if (信息.意图 === '送人') overlay.classList.add('is-gifted');   // 这个类负责把右下角的购买按钮收起来
    /* 2026-10-23:图卡上的落款/祝福语也要换成链接里带来的。原来收礼人看到的是配的人那边的
       默认占位名「Alex」+ 默认祝福语 —— 对方没填名字,收礼人却看到一个叫 Alex 的人(用户微信截图)。
       链接没带名字就留空,syncGiftCard 会把空名字的落款整个藏掉。 */
    giftState.name = 信息.名 || '';
    giftState.msg = 信息.语 || '';
    syncGiftCard();

    var 件 = 零件池();
    var 关系 = 换出几种();
    var 主 = 信息.意图 === '想要' ? 'recv_cta_want' : (信息.意图 === '送人' ? '' : 'recv_cta_mine');
    var esc = function (t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); };

    box.innerHTML =
      '<div class="fs-letter">' +
        '<div class="fs-letter__eyebrow">' + TR(信息.意图 === '想要' ? 'recv_eyebrow_want' : (信息.意图 === '送人' ? 'recv_eyebrow_gift' : 'recv_eyebrow_show')) + '</div>' +
        (信息.名 ? '<div class="fs-letter__to">' + esc(信息.名) + '</div>' : '') +
        (信息.语 ? '<div class="fs-letter__msg">' + esc(信息.语) + '</div>' : '') +
        (件.length ? '<div class="fs-letter__hr"></div>' +   /* 「这一套里的零件」小标题 2026-10-23 删:四格清单本身一看就是清单,省一行 */
          /* 规格表式排印(第 128 轮):左列部件名当小字距标签,右列色名,同部件多件用「·」串起来。
             不用图不用色块 —— 图卡自己那行「Host: Desert Yellow · Faceplate: Starry Silver ...」
             就是这个排法,信和图卡这下是同一种语言了。 */
          '<div class="fs-letter__parts">' + 件.map(function (x) {
            return '<div class="fs-letter__part"><em class="fs-letter__partname">' + esc(x.部) + '</em>' +
                   '<span class="fs-letter__vals">' +
                     x.项.map(function (v) { return '<span class="fs-letter__vname">' + esc(v.名) + '</span>'; })
                          .join('<i class="fs-letter__sep">·</i>') +
                   '</span></div>';
          }).join('') + '</div>' +
          (关系 ? '<div class="fs-letter__rel">' + esc(关系) + '</div>' : '') : '') +
        '<div class="fs-letter__actrow">' +   /* 主行动 + 转发并成一行(2026-10-23 省高度给图卡) */
        (主 ? '<button class="fs-letter__cta" type="button" data-recv="go">' + TR(主) + '</button>'
            : '<button class="fs-letter__link" type="button" data-recv="go">' + TR('recv_link_explore') + '</button>') +
        '<div class="fs-letter__fwd">' +
          '<span>' + TR('recv_fwd') + '</span>' +
          '<button class="fs-share-ico" data-share="copy" type="button" aria-label="' + TR('recv_fwd') + '" title="' + TR('recv_fwd') + '">' + ICON_LINK + '</button>' +
          /* 下载图卡集(2026-10-23 用户截图标注):跟链接图标同款,排在最右。复用配的人那边的 downloadGalleryCards */
          '<button class="fs-share-ico fs-letter__dl" type="button" aria-label="' + TR('download_lookbook') + '" title="' + TR('download_lookbook') + '">' + ICON_DL.replace('<svg ', '<svg class="ico-d" ') + ICON_IOS_SHARE.replace('<svg ', '<svg class="ico-m" ') + '</button>' +
        '</div>' +
        '</div>' +
      '</div>';

    /* 点主行动:一律【关掉画廊回到配置器】,而不是直接跳付款。
       这一副已经在配置器里躺好了(短码进站时就还原了),让他先玩起来 ——
       DIY 这种东西,玩过的人比直接看到价格的人愿意买得多。 */
    var go = box.querySelector('[data-recv="go"]');
    if (go) go.addEventListener('click', function () {
      close();
      var 台 = document.querySelector('.diy-stage');
      if (台) window.scrollTo(0, Math.max(0, window.scrollY + 台.getBoundingClientRect().top - 130));
    });
    var cp = box.querySelector('[data-share="copy"]');
    if (cp) cp.addEventListener('click', function () { shareVia('copy'); });
    var dl = box.querySelector('.fs-letter__dl');
    if (dl) dl.addEventListener('click', function (e) { e.stopPropagation(); downloadGalleryCards(dl); });
    return true;
  }

  function open() {
    if (!overlay) build();
    // 手机端:把画廊挂到 body 用 position:fixed 真钉视口(mirror-frame 有 transform 祖先会把 fixed 困成 absolute→覆盖整个高页面、bottom 跑到文档底)。桌面仍挂 mirror-frame 内(手机壳模态)(用户 2026-07-10)
    modalMobile = !!(window.matchMedia && window.matchMedia('(max-width: 760px), (max-device-width: 760px)').matches);
    var wantParent = modalMobile ? document.body : frame;
    if (overlay.parentElement !== wantParent) wantParent.appendChild(overlay);
    // 下载按钮:手机端移进分享行最右(变小图标),桌面端移回 actions(右下角)(用户 2026-07-11)
    var dlBtn = overlay.querySelector('.fs-gallery__download');
    var shareRow = overlay.querySelector('.fs-share-row');
    var actionsEl = overlay.querySelector('.fs-gallery__actions');
    if (dlBtn) {
      var dlHome = modalMobile ? shareRow : actionsEl;
      if (dlHome && dlBtn.parentElement !== dlHome) dlHome.appendChild(dlBtn);
    }
    // 加入购物车长条:填当前价格(读主页面 CTA 价格)
    if (modalMobile) {
      var priceEl = overlay.querySelector('.fs-buy-price');
      var mainPrice = (document.querySelector('.cta-bar__price-amount') || {}).textContent;
      if (priceEl) priceEl.textContent = mainPrice ? (' · ' + mainPrice.trim()) : '';
    }
    // 稳定性重构(用户 2026-07-10):打开时锁死背后长页面滚动 + 隐藏背景不绘制
    //   → 消除"背景在模态后面还能滚 → 画面发晃 + 手势打架 + Safari 每帧重绘卡顿"
    if (modalMobile) {
      savedScrollY = window.scrollY || document.documentElement.scrollTop || 0;
      document.documentElement.classList.add('fs-modal-lock');
      // 键盘避让:改由 viewport meta 的 interactive-widget=resizes-content 原生处理(键盘弹起 iOS 自动缩小 layout viewport → 100dvh 的模态自动压到键盘正上方,加购贴键盘无空白)。撤掉原手动 visualViewport 干预(真机没生效还露白)(用户 2026-07-11)
      window.addEventListener('resize', fitCard);   // 键盘/旋转导致视口(dvh)变化时重算图卡自适应缩放,保持和谐
    }
    var vs = (typeof enumerate === 'function') ? enumerate() : [];
    if (vs.length && typeof renderExploreCard === 'function') {
      // 全屏卡 = 海报式(浅米灰 panel + 下方标题区),用公共函数造,与下载完全一致
      track.innerHTML = '';
      var montage = makeMontageCard(vs);            // 拼排总览(≤4 四宫格 / >4 枚举墙)作第一张
      if (montage) track.appendChild(montage);
      vs.forEach(function (v) { if (v) track.appendChild(makePosterCard(v)); });
    } else {
      var src = document.getElementById('explore-carousel');
      track.innerHTML = src ? src.innerHTML : '';
    }
    cards = Array.prototype.slice.call(track.querySelectorAll('.explore-card'));
    cards.forEach(function (c) { c.classList.remove('is-current'); });
    pos.max = Math.max(0, cards.length - 1);
    pos.current = pos.target = 0;   // 打开停在拼排总览(第一张)
    counterIdx = -1;                // 强制页码首帧刷新
    // 贺卡:1 套(四宫格)/ 2 套(枚举墙)都可定制贺卡 → 决定右侧面板是否可现(用户 2026-07-01)
    hasGiftCard = !!(vs && vs.length);
    overlay.classList.toggle('has-gift', hasGiftCard);
    syncGiftCard();                                       // 把当前 giftState 写到新建的所有单卡落款
    giftShown = false;
    if (giftEditorEl) {
      giftEditorEl.classList.remove('is-shown');
      if (giftLeadEl) giftLeadEl.classList.remove('is-shown');
      var ni = giftEditorEl.querySelector('[data-gift-in="name"]'); if (ni) ni.value = giftState.name || '';
      var mi = giftEditorEl.querySelector('[data-gift-in="msg"]'); if (mi) mi.value = giftState.msg || '';
    }
    // 同步买按钮禁用态:主 #add-to-cart 不可买(配置没完成)时画廊买按钮也变灰
    layoutGiftLead();
    var buy = overlay.querySelector('.fs-gallery__buy');
    if (buy) buy.classList.toggle('is-disabled', !!(document.getElementById('add-to-cart') || {}).disabled);
    // ⚠️ 顺序关键(用户 2026-07-27 修穿帮):先藏背后配置 UI,强制提交渲染,再让画廊淡入。
    //    否则画廊 opacity 慢淡入的头 ~0.1s 里它还半透明,而背后 app-shell 隐藏晚 1 帧仍painted
    //    → 配置 UI(Add Kit/头带色选)透过半透明画廊漏出 0.几秒。抢先藏 + reflow flush 保证画廊淡入时背后只剩彩虹底
    var _hookC = readHookCenter();                           // ⚠️ 必须在加 .diy-fs-open 之前:之后 hook 条被 clip,量不到
    var _prep = prepareOpen(_hookC);                         // 见下:假开合一次量准 padding 补偿 + 缩放原点
    document.documentElement.classList.add('diy-fs-open');   // 真跑:横幅高度收起 + outer padding 同步过渡(.42s 同曲线)
    if (_prep.padTarget != null) {                           // 补偿写成【目标值】,跟着同一条过渡从起态滑过去
      var _o = document.querySelector('.diy-outer');
      if (_o) _o.style.paddingBottom = _prep.padTarget.toFixed(2) + 'px';
    }
    lockOuterHeight(_prep.lockH);                            // 过渡期间锁住外壳总高,下方内容一动不动
    void document.documentElement.offsetHeight;              // 强制样式/绘制提交:app-shell 这一帧就真的消失,不留残影
    staggerCardsIn();                                        // 卡片错峰入场,跟整块收缩同时起跑
    装收礼人信();                                            // 分享来的访客:左边那块从编辑器换成一封信
    overlay.classList.add('is-open');                        // 再淡入画廊(此刻背后只剩 diy-stage 彩虹底)
    安排备图(300);   // 开画廊就在后台把下载图备好 —— 点下载才能一下就弹出「存储图像」
    安排预热(1200);   // 开画廊就把分享图渲好备着 —— 点分享那一刻不能再等(见 预热图 的说明)
    kick();
    if (modalMobile) requestAnimationFrame(fitCard);   // 布局稳定后按 stage 高度自适应缩放卡片
  }
  // ⚠️ 消除图卡集开合时的「先跳后漂」(2026-08-04 用户拍板)
  //    病因:.diy-fs-open 同时触发两件速度不同的事 ——
  //      ① .diy-hero-banner{display:none} 【瞬时】(display 本来就不可过渡)→ 面板一帧内上跳 ~146px
  //      ② .diy-outer 的 padding-top 48→194 走 .5s 过渡 → 面板再花半秒慢慢滑回来
  //    于是画廊「先冒在上面,再往下漂」。修法:让这一次 padding 变化【不过渡】,
  //    跟 display:none 落在同一帧,中间没有任何可看的过程。
  //    (原 transition:padding 是给旧折叠功能用的,第 68 轮改盖子方案后模块永久展开,
  //     那条规则已失效 —— 保留它只为不动老代码,这里用 inline transition:none 精准压制这一次)
  // ① 让画廊从【你点的那条 hook 条】长出来,而不是从屏幕正中凭空涨大(2026-08-04 第 75 轮)
  //    依据 emilkowalski/skill「transform-origin Positioning: 动态设定原点,让浮层从触发元素处缩放」。
  //    修前 transform-origin 是默认的 center,而 hook 条在列 4 偏右 → 手指位置和动作起点是断开的。
  //    ⚠️ 必须【两步】做,不能一次算完:
  //       hook 条只在加 .diy-fs-open【之前】量得到(之后 app-shell 被 clip 掉);
  //       而画廊是在加 class【之后】的位置放大的 —— 那时 overlay 已经下移了约 74px(padding 48→122)。
  //       用展开前的盒去算百分比,原点就会偏掉整整一个位移量(第 75 轮第一版就栽在这)。
  //       正解:展开前只记 hook 条的【视口坐标】,展开后再拿它对新的 overlay 盒换算成百分比。
  function readHookCenter() {
    var hook = document.getElementById('explore-hook') || document.querySelector('.explore__hook');
    if (!hook) return null;
    var r = hook.getBoundingClientRect();
    if (!r.width || !r.height) return null;               // 已被藏(如从别处触发)→ 保持上次的原点
    return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
  }
  //    ⚠️⚠️ 第二个坑:【祖先 .diy-stage 自带 scale(.85)】。
  //       hook 条给的是【视口坐标】,而 transform-origin 要的是【自身布局坐标】——
  //       两者之间差了一个累积父级缩放。直接拿视口坐标当布局坐标用,原点就会偏。
  //       解法:先把自身 transform 摘掉量一次,此时 rect宽/offsetWidth 就是纯父级缩放 sp,
  //       再把视口距离除以 sp 换算回布局单位。(别去心算 .85×.90 之类,量出来最稳)
  function applyGalleryOrigin(c) {
    if (!overlay || !c) return;
    var prevTn = overlay.style.transition, prevTr = overlay.style.transform;
    overlay.style.transition = 'none';                    // 量的时候别让改 origin/transform 触发过渡
    overlay.style.transform = 'none';                     // 摘掉自身缩放 → 剩下的就是纯父级缩放
    var r = overlay.getBoundingClientRect();
    var w = overlay.offsetWidth, h = overlay.offsetHeight;   // offset 尺寸不受任何 transform 影响 = 布局盒
    if (w && h) {
      var sp = r.width / w || 1;                          // 累积父级缩放(.diy-stage 的 .85 等)
      overlay.style.transformOrigin = ((c.x - r.left) / sp).toFixed(2) + 'px ' +
                                      ((c.y - r.top)  / sp).toFixed(2) + 'px';
    }
    overlay.style.transform = prevTr || '';               // 还给 CSS(未开=scale(.90),开=scale(1))
    void overlay.offsetHeight;                            // 提交后再还回过渡,避免这次改动被动画掉
    overlay.style.transition = prevTn || '';
  }

  // ③ 卡片错峰入场:中心卡先落位,两侧按距离依次跟上(CSS 侧 @keyframes fs-card-in)
  var staggerT = null;
  function staggerCardsIn() {
    clearStagger();
    if (!cards || !cards.length) return;
    var p = pos.current, maxStep = 0;
    cards.forEach(function (card, i) {
      var abs = Math.abs(i - p);
      if (abs > 3.2) return;        // ⚠️ 远卡本该 opacity:0,加了 animation 会把它顶出来(见 CSS 侧注释)
      var step = Math.round(abs);
      if (step > maxStep) maxStep = step;
      card.style.setProperty('--fs-i', step);
      card.classList.add('fs-card-in');
    });
    // 动画跑完就摘 class:blur/animation 不留任何持续开销,也不影响之后的拖拽 layout()
    staggerT = setTimeout(clearStagger, 340 + maxStep * 45 + 120);
  }
  function clearStagger() {
    if (staggerT) { clearTimeout(staggerT); staggerT = null; }
    if (!cards) return;
    cards.forEach(function (c) { c.classList.remove('fs-card-in'); c.style.removeProperty('--fs-i'); });
  }

  // ⚠️ 第 76 轮重写(用户:「整块直接马上变过去,有点钝感」)
  //    第 74 轮的做法是「掐掉过渡、一帧到位」—— 那是在【横幅 display:none 瞬变】的前提下的正解:
  //    一个瞬时 + 一个 .5s 且方向相反,只会先跳后漂。现在横幅也能平滑收了,前提没了,该让它们一起跑。
  //
  //    但加了过渡后,第 74 轮「加完 class 立刻量」的算法就失效了 —— 那时量到的是【起态】,全是错的。
  //    解法:先【无过渡地跳到终态】量一次(padding 补偿 + 画廊缩放原点),回滚,再带过渡真跑。
  //    整段在同一个 JS 同步块内完成,浏览器只在最后提交一次绘制,用户看不到这次「假开合」。
  var BANNER_DUR = 420;                                          // 与 CSS 三条过渡(.42s)保持一致
  var bnT = null;
  function prepareOpen(hookC) {
    var outer = document.querySelector('.diy-outer');            // 本地独立版没有 outer,退化成只算原点
    var bn = document.querySelector('.diy-hero-banner');
    var root = document.documentElement;
    // ⚠️ h0 必须在【碰任何东西之前】量:后面挂 .dhb-collapsing / 钉 height 都可能影响布局,
    //    量晚了拿到的就不是用户此刻看到的那个高度,补偿就补错了(第 76 轮踩过)。
    var h0 = outer ? outer.getBoundingClientRect().height : 0;   // 起态总高(要守住的值)
    // 横幅高度身兼两职:① 喂给 CSS 的 padding 公式(平分给上下,见 var(--diy-banner-half))
    //                  ② 作为 height 过渡的起始值 —— height:auto 不可过渡,必须钉成实测 px
    if (bn) {
      // ⚠️⚠️ 横幅高度有【两个值】,分别喂给两个处于不同坐标系的用途,绝不能混用:
      //    祖先 .diy-stage 带 scale(.85),所以横幅有两个高度 —— 布局 174 / 视觉 147.9。
      //      · bn.style.height  作用在【被缩放的元素自身】→ 吃布局单位 → 174
      //      · --diy-banner-half 作用在【未缩放的外壳 .diy-outer 的 padding】上,
      //        它要补偿的是 stage【视觉】高度的变化(758.2→610.3,差 147.9)→ 73.95
      //    两版都栽过:首版两处都用 147.9(居中对了、height 钉矮 26.1px,关闭收尾弹回真值 → 最后一帧跳 22px);
      //    次版两处都用 174(height 对了、padding 多补 13.05 → 画廊整体偏低 13.1px)。
      //    ⚠️ 那个反复出现的 26.1px 从来不是「margin 折叠」——就是 174 与 147.9 之差,别再往 BFC 上归因。
      var br = bn.getBoundingClientRect();
      var bsp = bn.offsetWidth ? (br.width / bn.offsetWidth) : 1;   // 累积父级缩放
      var bhLayout = bsp ? (br.height / bsp) : br.height;           // 布局高 → height 过渡起点
      var bhVisual = br.height;                                     // 视觉高 → 外壳 padding 补偿
      if (bhLayout > 0) {
        root.style.setProperty('--diy-banner-half', (bhVisual / 2) + 'px');
        bn.style.height = bhLayout.toFixed(2) + 'px';
        bn.classList.add('dhb-collapsing');                      // 挂上 transition + 临时裁切(clip-path)
      }
    }
    var tnO = outer ? outer.style.transition : '', tnB = bn ? bn.style.transition : '';
    if (outer) { outer.style.transition = 'none'; outer.style.paddingBottom = ''; }
    if (bn) bn.style.transition = 'none';
    root.classList.add('diy-fs-open');                           // ← 假装已经展开
    var padTarget = null;
    if (outer) {
      void outer.offsetHeight;
      // 见第 74 轮:padding 算对了总高仍会掉 ~26px(.diy-stage 的负 margin 在 flex 交叉轴上的
      // 贡献,展开前后并不相等)。不反推公式(换 viewport 就可能不成立),实测多少补多少。
      var d = h0 - outer.getBoundingClientRect().height;
      if (Math.abs(d) > 0.5) padTarget = parseFloat(getComputedStyle(outer).paddingBottom) + d;
      window.__diyPadDbg = { 起态总高: h0, 终态总高: outer.getBoundingClientRect().height, 差: d, 目标padB: padTarget };
    }
    applyGalleryOrigin(hookC);                                   // 原点也必须在终态量:此时 overlay 位置才是最终的
    root.classList.remove('diy-fs-open');                        // 回滚到起态,准备带过渡真跑
    // ⚠️ 回滚时必须把 inline padding 也清掉 —— inline 优先级高于 CSS 规则,留着的话起态就是错的,
    //    真跑时「起点==终点」→ 根本不会产生过渡。补偿改为在 add class 之后当【目标值】写入。
    if (outer) { outer.style.paddingBottom = ''; void outer.offsetHeight; outer.style.transition = tnO || ''; }
    if (bn) { void bn.offsetHeight; bn.style.transition = tnB || ''; }
    return { padTarget: padTarget, lockH: h0 };
  }

  // 过渡期间把外壳高度锁死。
  // 为什么必须锁:那 26.1px 的 margin 折叠差是【离散】的(某一帧突然折叠),而 padding 是【连续】过渡的,
  // 两者对不齐 → 过程中总高会先掉 25px 再回来,下方 Shop the Look 跟着抖一下。
  // 起点和终点都是 902(终态由 padding 补偿保证),所以过渡期间用 min-height 兜住即可,
  // 内部怎么折叠都不外溢。过渡跑完就解锁,不留死高度(响应式/内容变化仍能自适应)。
  var lockT = null;
  function lockOuterHeight(px) {
    var outer = document.querySelector('.diy-outer');
    if (!outer || !px) return;
    outer.style.minHeight = px.toFixed(2) + 'px';
    clearTimeout(lockT);
    lockT = setTimeout(function () { outer.style.minHeight = ''; }, BANNER_DUR + 90);
  }
  function beginClose() {
    var outer = document.querySelector('.diy-outer');
    if (outer) {
      lockOuterHeight(outer.getBoundingClientRect().height);     // 关闭同样会经历那次离散折叠,一样要锁
      outer.style.paddingBottom = '';                            // 清掉补偿 → 带过渡回落到 CSS 的 96px
    }
    var bn = document.querySelector('.diy-hero-banner');
    clearTimeout(bnT);
    bnT = setTimeout(function () {                               // 收尾必须等过渡跑完,否则把动画掐断
      if (bn) { bn.classList.remove('dhb-collapsing'); bn.style.height = ''; }   // 还原成 auto + 恢复光晕溢出
    }, BANNER_DUR + 90);
  }

  function close() {
    clearStagger();                                             // 半路关掉:别让入场动画残留 blur/opacity
    if (overlay) overlay.classList.remove('is-open');
    document.documentElement.classList.remove('diy-fs-open');   // 关画廊:横幅高度长回来 + padding 同步回落
    beginClose();                                               // 清补偿(带过渡回落)+ 排好收尾清理
    if (raf) { cancelAnimationFrame(raf); raf = null; }
    // 关键修复:coverflow 的 layout() 给中心卡写死 inline visibility:visible + pointerEvents:auto(窗口化),关闭时会盖过外层容器的 hidden/none → 卡片残留成"隐形但拦点击的膜"盖住主页(图卡集点不开、按钮迟钝)。关闭时清掉这两行 inline,让卡片跟随 overlay 一起隐藏/穿透(用户 2026-07-12)
    if (cards && cards.length) cards.forEach(function (c) { c.style.visibility = ''; c.style.pointerEvents = ''; c._vis = c._pe = null; });
    // 关闭:解锁背景滚动 + 恢复背景可见 + 回到原滚动位置
    if (document.documentElement.classList.contains('fs-modal-lock')) {
      document.documentElement.classList.remove('fs-modal-lock');
      window.removeEventListener('resize', fitCard);
      if (overlay) {
        overlay.style.height = ''; overlay.style.bottom = ''; overlay.style.top = '';   // 清任何遗留 inline(现由 CSS 100dvh 管)
        var tk = overlay.querySelector('.fs-gallery__track'); if (tk) { tk.style.transform = ''; tk.style.top = ''; }   // 清自适应缩放 + 上留白定位,避免残留到桌面(桌面靠 CSS top:50%)
      }
      window.scrollTo(0, savedScrollY);
    }
  }
  // 列4 图卡右上角 ⛶ 图标点击 → 进全屏(事件委托,图卡是动态渲染的)
  var carousel = document.getElementById('explore-carousel');
  if (carousel) carousel.addEventListener('click', function (e) {
    // 整卡可点展开(不只放大按钮):点卡本身无切换行为,切换靠左右箭头(用户 2026-07-07)
    if (e.target.closest('[data-explore-zoom]') || e.target.closest('.explore-card')) { e.stopPropagation(); open(); }
  });
  var exploreHook = document.getElementById('explore-hook');
  if (exploreHook) exploreHook.addEventListener('click', function (e) { e.stopPropagation(); open(); });

  /* 分享链接进来的访客:直接把这一屏打开(第 122 轮 · 用户「直接用这个页面给他就行」)。
     在这之前是落到首页、要自己往下翻两屏再点开 —— 收礼人不可能有这个耐心和认知。
     延时 700ms 而不是立刻:图卡要先渲染好、盖子要先开完,否则打开的是一屏空的。 */
  if (typeof 来自分享 !== 'undefined' && 来自分享) setTimeout(function () { open(); }, 700);
})();



(function () {
  var stage = document.querySelector('.diy-stage');
  var wrap  = stage && stage.querySelector('.diy-collapse');
  var frame = wrap && wrap.querySelector('.mirror-frame');
  var btn   = document.querySelector('.diy-hero-banner .dhb-btn');
  if (!stage || !wrap || !frame || !btn) return;

  /* ═══════════════════════════════════════════════════════════════════════════
     🔴 第 66 轮(2026-08-03 用户拍板)· 开合功能【整体停用】,模块永久展开。

     为什么停用 —— 用户原话:「我感觉可能是我们之前反复做的一些工作,导致到一些展开和
     收缩的细节一直做错了,现在一错再错一直改不过来」。查证后确认这个判断是对的:

       ① **线上真实访客从来没跑过我们改的这套东西**。
          `var FLIP = /[?&]flip=1/.test(location.search)` —— 第 47~65 轮所有工作
          (冻结/抽屉/延迟拆层/宽度接管…)只在网址带 ?flip=1 时才生效,
          普通访客走的是老的 collapse() 高度动画那条路。
       ② 模块里同时活着 **三套开合实现**:collapse()(线上默认)/ collapseSnap()(?snap=1)
          / collapseFlip()(?flip=1),外加 **15 个诊断开关**
          (flip/snap/nowa/nokeep/nosplit/nodrawer/noline/bf/nolift/nosib/nolayer/
           nowidth/nopre/nofx/nobgfix)。
       ③ 三套实现叠在一起互相打架,我们一直在其中一条上打补丁 → 越改越回不去。

     现在的处置(用户方案):先把开合关掉、模块永久摊开 → 在这个干净状态下体检 →
     体检干净后再从零重新设计开合动画。
     **暂不删死代码**:此刻大动刀会把「老 bug」和「新引入的 bug」混在一起,体检就失去意义。
     三套实现与 15 个开关都还在文件里,只是不再被执行,留到重做开合时一次性清理。

     🔄 重新启用 = 把下面这行改回 true(其余代码原封未动)。
     ═══════════════════════════════════════════════════════════════════════════ */
  /* 第 68 轮:开合回归,但走全新的「盖子」实现(见文件末尾 ⑳ 段)。
     第 129 轮(2026-08-12):独立 DIY 页面(/pages/design)上关掉开合 —— 那个页面的全部内容
     就是配置器,收起来只剩一条流光带、下面是 footer,用户会以为页面坏了。
     __DIY_STANDALONE__ 由 section 的 liquid 在 template.suffix == 'diy' 时输出;
     本地静态版没有它 = undefined,行为一点不变。
     ⚠️ 光挡住点击不够,还要撤掉横幅上那个箭头(CSS .diy-no-toggle)——
        按钮点不动却还画着「↑」,比没有箭头更像坏了。 */
  var TOGGLE_ENABLED = window.__DIY_STANDALONE__ !== true;
  if (!TOGGLE_ENABLED) {
    var _outerNT = document.querySelector('.diy-outer');
    if (_outerNT) _outerNT.classList.add('diy-no-toggle');
  }

  var busy = false;                                    // 动画期间忽略连点,防两个过渡打架
  btn.setAttribute('aria-expanded', 'false');

  /* ⚠️ 初始态必须在这里定,不能留在文件末尾(原来在那儿)——
     下面第 ⑲ 段的资源预热判断 `if (stage.classList.contains('diy-expanded')) hotAssets()`
     就在几十行之后执行,类名晚挂上的话它会走进「等 hover」分支,
     结果永久展开的模块要等鼠标碰到横幅才加载 81 张图和 WebGL。
     .diy-warm 一并挂:CSS ⑲ 段在「折叠且未 .diy-warm」时把 81 张图的 background-image 掐成 none
     来给首屏提速,不再有折叠态就必须直接放行。
     ?diy=fold 保留 —— 重做开合时要用它看折叠态那条流光带。

     🔄 第 102 轮反转:这三个类现在【写死在 .diy-stage 的 HTML 里】(见上面 stage 标签的注释),
        所以这里从「默认不挂、非 fold 才挂」反过来变成「默认已挂、是 fold 才摘」。
        classList.add 依然保留(幂等)—— 万一哪天 HTML 那边被改回去,这里还能兜底,不会静默失效。 */
  if (/[?&]diy=fold(&|$)/.test(location.search)) {
    stage.classList.remove('diy-expanded', 'diy-open-done', 'diy-warm');
    btn.setAttribute('aria-expanded', 'false');
  } else {
    /* 🔴 2026-08-20:`diy-warm` 从这里【拿掉】。
       它是「放行 112 张配置器背景图」的开关。这行兜底会在解析阶段无条件挂上它,
       于是不管 HTML 里写没写、build 有没有去掉,闸门都被重新打开 ——
       这是同一个问题坑掉的第四处(前三:CSS 闸门选择器、hotAssets 的判断、HTML 写死的 class)。
       ⚠️ diy-expanded / diy-open-done 仍然留着兜底 —— 它们决定的是【布局形态】,
          必须在解析阶段就定,晚挂会首屏跳变(第 102 轮的原始理由,依然成立)。
          而 diy-warm 决定的是【要不要现在下载图片】,那件事应该等 warmAssets() 按时机放行。 */
    stage.classList.add('diy-expanded', 'diy-open-done');   // 幂等兜底(不含 diy-warm,理由见上)
    btn.setAttribute('aria-expanded', 'true');
  }

  /* ---- 手机:DIY 展开时藏掉模板底部菜单栏(Home/Menu/Cart 那条 nav.mobile-dock),让配置器整块呈现(用户 2026-09-18)----
     本段有 6 处写 aria-expanded(点横幅 / FAB / 盖子预置 / 分享落地…),不逐处插;用 MutationObserver 盯这一个属性,
     任何路径都同步到 html.diy-open。CSS 在样式段「.diy-fs-open .app-shell」旁。独立页永远展开 → 永远藏。 */
  /* ---- 真机探针(2026-09-18):网址带 ?diyprobe=1 时,在屏幕左上角打一块数字面板,把关键元素的左右边 / margin / zoom / 视口高
     直接画在屏幕上,截模拟器或真机截图就能读。原因:同一套 CSS,Playwright 的 Chromium / WebKit 量出来 DIY 卡 37→353,
     iOS Safari 真机却是 43→347(用户报「毛玻璃变窄」)——只靠无头浏览器验不出 iOS 的差异,又没法在 iOS 上跑脚本。
     不带参数时这段什么都不做。 */
  if (/[?&]diyprobe=1/.test(location.search)) (function 真机探针() {
    var 板 = document.createElement('pre');
    板.style.cssText = 'position:fixed;top:60px;left:6px;z-index:2147483647;margin:0;padding:6px 8px;background:rgba(255,255,255,.96);color:#000;font:11px/1.35 Menlo,monospace;border:1px solid #000;pointer-events:none;max-width:96vw;white-space:pre-wrap';
    document.body.appendChild(板);
    var 项 = [['预览卡', '.preview__framed'], ['DIY卡', '.kit__list > li.kit-item--build'], ['魔尼卡', '.kit__list > li.kit-item--moni-strap'], ['.kit', '.col--kit .kit'], ['kit__list', '.col--kit .kit__list'], ['面盖chip1', '.slot-row[data-slot="faceplate"] .picker-chip'], ['面盖chip2', '.slot-row[data-slot="faceplate"] .picker-chip:nth-of-type(2)'], ['图卡集玻璃', '.col--explore .explore.glass-card'], ['舞台', '.diy-stage'], ['外框', '.mirror-frame'], ['箭头←', '.picker-strip__arrow--prev'], ['箭头→', '.picker-strip__arrow--next'], ['AddKit', '.kit-add-slot']];
    /* 量 100vw 在页面放大时到底等于几:塞一个 width:100vw 的隐形元素读它的宽(怀疑 iOS 放大后 vw 与 innerWidth 脱钩) */
    var 尺 = document.createElement('div'); 尺.style.cssText='position:fixed;top:-9999px;left:0;width:100vw;height:1px;pointer-events:none;display:block!important'; 尺.textContent='\u200b'; /* Concept 主题会 display:none 所有空 div,塞个零宽字符保命 */ document.body.appendChild(尺);
    function 读() {
      var 行 = ['视口 ' + innerWidth + 'x' + innerHeight + ' 100vw=' + 尺.getBoundingClientRect().width.toFixed(1) + ' docW=' + document.documentElement.clientWidth + ' vv ' + (visualViewport ? Math.round(visualViewport.width) + 'x' + Math.round(visualViewport.height) + ' s' + visualViewport.scale.toFixed(2) : '-') + ' dpr ' + devicePixelRatio + ' UA ' + (navigator.userAgent.match(/OS \d+_\d+|Version\/[\d.]+/g) || []).join(' ')];
      项.forEach(function (it) { var e = document.querySelector(it[1]); if (!e) { 行.push(it[0] + ' ∅'); return; } var r = e.getBoundingClientRect(), c = getComputedStyle(e); 行.push(it[0] + ' ' + r.left.toFixed(1) + '→' + r.right.toFixed(1) + ' w' + r.width.toFixed(1) + ' ml' + c.marginLeft + ' pl' + c.paddingLeft + (c.zoom && c.zoom !== '1' ? ' zoom' + c.zoom : '')); });
      板.textContent = 行.join('\n');
    }
    /* 布局宽(offsetWidth,不受 iOS「zoom 里 rect 是未缩放坐标」怪癖影响)+ 头带行 scrollLeft 抖动计数(2026-09-19 iPad 排查) */
    var 抖 = { n: 0, min: Infinity, max: -Infinity, last: null, t: Date.now() };
    document.addEventListener('scroll', function (e) { var r = e.target; if (!r || !r.classList || !r.classList.contains('picker-row')) return; var v = r.scrollLeft; if (抖.last !== null && Math.abs(v - 抖.last) > 0.5) 抖.n++; 抖.last = v; 抖.min = Math.min(抖.min, v); 抖.max = Math.max(抖.max, v); }, true);
    var 读0 = 读;
    读 = function () {
      读0();
      var ow = function (sel) { var e = document.querySelector(sel); return e ? e.offsetWidth : '∅'; };
      var row = document.querySelector('[data-slot="headband"] .picker-row');
      var st = document.querySelector('.diy-stage'); var cs = st ? getComputedStyle(st) : null;
      板.textContent += '\n--- 布局宽(offsetWidth) ---'
        + '\n舞台 ' + ow('.diy-stage') + ' 列2 ' + ow('.col--kit') + ' .kit ' + ow('.col--kit .kit') + ' kit__list ' + ow('.col--kit .kit__list') + ' DIY卡 ' + ow('.kit__list > li.kit-item--build')
        + '\n面盖行 ' + ow('.slot-row[data-slot="faceplate"] .slot-row__chips') + ' 面盖chip ' + ow('.slot-row[data-slot="faceplate"] .picker-chip') + ' 头带row ' + ow('[data-slot="headband"] .picker-row') + ' strip__main ' + ow('.picker-strip__main')
        + '\n舞台 transform ' + (cs ? cs.transform.slice(0, 28) : '-') + ' scale变量 ' + (st ? st.style.getPropertyValue('--diy-tablet-scale') : '-') + ' mb ' + (st ? st.style.marginBottom : '-')
        + '\n头带 scrollLeft ' + (row ? row.scrollLeft.toFixed(1) : '∅') + ' 抖动 ' + 抖.n + ' 次/' + ((Date.now() - 抖.t) / 1000).toFixed(0) + 's 区间 ' + (isFinite(抖.min) ? 抖.min.toFixed(1) + '~' + 抖.max.toFixed(1) : '-');
    };
    var 冻结 = false; 读(); setInterval(function () { if (!冻结) 读(); }, 1000);
    // 探针模式自动掀盖子(iPad 模拟器里没法替用户点)
    setTimeout(function () { var b = document.querySelector('.diy-hero-banner .dhb-btn'); if (b && b.getAttribute('aria-expanded') !== 'true') b.click(); }, 1500);
    // &hbmid=1:开盖 4s 后自己把头带行滚到半路(非 chip 整数倍),抖动计数归零 —— 机器自己造「手指停在半路」这个触发条件,不靠人拖
    // &hit=1:开盖 4s 后,在每个面盖色块 getBoundingClientRect 的中心打一个 fixed 红点(fixed 在 zoom/scale 之外 = 真屏幕坐标),
    //   并报告 elementFromPoint(中心) 命中的是谁 —— 红点不落在色块上 = rect 与像素错位;命中不是该色块 = 点击会失灵(2026-09-19 iPad 点色块没反应)
    if (/[?&]hit=1/.test(location.search)) setTimeout(function () {
      var chips = document.querySelectorAll('.slot-row[data-slot="faceplate"] .picker-chip');
      var 报 = [];
      chips.forEach(function (c, i) {
        var r = c.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + r.height / 2;
        var dot = document.createElement('div'); dot.textContent = '\u200b';
        dot.style.cssText = 'position:fixed;left:' + (cx - 4) + 'px;top:' + (cy - 4) + 'px;width:8px;height:8px;border-radius:50%;background:red;z-index:2147483646;pointer-events:none;display:block!important';
        document.body.appendChild(dot);
        var 谁 = function (x, y) { var h = document.elementFromPoint(x, y); var hc = h && h.closest && h.closest('.picker-chip'); return hc ? (hc === c ? '自己✓' : '别的chip✗') : (h ? h.tagName + '.' + String(h.className).slice(0, 14) + '✗' : '∅'); };
        // 两个坐标都问:rect 原值 / ×0.93(iOS 把 zoom 那层丢了,画出来的位置 = rect×zoom)
        报.push('chip' + (i + 1) + ' rect(' + cx.toFixed(0) + ',' + cy.toFixed(0) + ')→' + 谁(cx, cy) + '  ×.93(' + (cx * 0.93).toFixed(0) + ',' + (cy * 0.93).toFixed(0) + ')→' + 谁(cx * 0.93, cy * 0.93));
      });
      // 代码直接点第 3 个色块:选中变了 = 处理函数没问题,问题只在「触摸命中」
      var c3 = chips[2], 前 = document.querySelector('.slot-row[data-slot="faceplate"] .picker-chip[aria-pressed="true"], .slot-row[data-slot="faceplate"] .picker-chip.is-selected');
      var 前名 = 前 ? (前.dataset.pick || 前.textContent.trim().slice(0, 12)) : '?';
      if (c3) c3.click();
      setTimeout(function () {
        var 后 = document.querySelector('.slot-row[data-slot="faceplate"] .picker-chip[aria-pressed="true"], .slot-row[data-slot="faceplate"] .picker-chip.is-selected');
        var 后名 = 后 ? (后.dataset.pick || 后.textContent.trim().slice(0, 12)) : '?';
        板.textContent += '\n代码 click() chip3:选中 ' + 前名 + ' → ' + 后名 + (前名 !== 后名 ? ' ✓处理正常' : ' ✗没变');
      }, 800);
      板.textContent += '\n--- 命中测试 ---\n' + 报.join('\n');
      // 真实触摸流水:捕获阶段记 touchstart/touchend/pointerdown/pointerup/click 的目标与坐标(最近 8 条),看用户那一下到底被谁吃了
      var 流水 = [], 流水板 = document.createElement('pre');
      流水板.style.cssText = 板.style.cssText + ';top:auto;bottom:8px;left:6px;max-height:34vh;overflow:hidden;background:rgba(255,250,200,.97)';
      document.body.appendChild(流水板);
      var 名 = function (el) { if (!el || !el.tagName) return '∅'; var c = el.closest && el.closest('.picker-chip'); return (c ? 'chip[' + (c.dataset.pick || '') + ']/' : '') + el.tagName + '.' + String(el.className).slice(0, 22); };
      ['touchstart', 'touchend', 'touchcancel', 'pointerdown', 'pointerup', 'pointercancel', 'click'].forEach(function (t) {
        document.addEventListener(t, function (e) {
          var pt = e.touches && e.touches[0] || e.changedTouches && e.changedTouches[0] || e;
          流水.push((performance.now() / 1000).toFixed(1) + 's ' + t + ' @(' + Math.round(pt.clientX || 0) + ',' + Math.round(pt.clientY || 0) + ') → ' + 名(e.target) + (e.defaultPrevented ? ' [已preventDefault]' : ''));
          if (流水.length > 8) 流水.shift();
          流水板.textContent = '--- 触摸流水(最近 8 条)---\n' + 流水.join('\n');
        }, true);
      });
      流水板.textContent = '--- 触摸流水:请点一下面盖色块 ---';
      冻结 = true;   // 冻结面板,别把结果刷掉
    }, 6000);
    // &folder=1(2026-09-21):5s 后自己打开「Add Kit 2」文件夹并把它滚到屏中,面板追加 iOS 真正算出来的 li clip-path / kit__list z-index / 新规则在不在样式表里
    if (/[?&]folder=1/.test(location.search)) setTimeout(function () {
      var btn = document.querySelector('.folder-add'); if (!btn) { 板.textContent += '\n[folder] 没有 Add Kit 2 按钮'; return; }
      var f = btn.querySelector('.folder'); f.classList.add('open'); 冻结 = true;
      // 触屏上纸片是 6.2s 循环动画在飞(压过 .open),要看飞出态得把动画定格在飞出相位(同 _verify-folder-paper-top.mjs)
      if (getComputedStyle(btn.querySelector('.paper-3')).animationName !== 'none') { var 钉 = document.createElement('style'); 钉.textContent = '.folder-add .paper, .folder-add .folder__front, .folder-add .folder-label { animation-delay: -2.2s !important; animation-play-state: paused !important; }'; document.head.appendChild(钉); }
      // iOS 加载期程序化滚动会被按回去:每秒滚一次,直到按钮真在屏中(最多 20 次)
      var 次 = 0, 滚 = setInterval(function () { var r = btn.getBoundingClientRect(); if ((r.top > innerHeight * 0.3 && r.bottom < innerHeight * 0.7) || ++次 > 20) { clearInterval(滚); 量(); return; } document.scrollingElement.scrollTop += r.top + r.height / 2 - innerHeight / 2; }, 1000);
      function 量() { setTimeout(function () {
        var li = btn.closest('li'), list = btn.closest('.kit__list'), p3 = btn.querySelector('.paper-3'), r = p3.getBoundingClientRect(), lr = li.getBoundingClientRect();
        var 有规则 = false; try { Array.prototype.forEach.call(document.styleSheets, function (ss) { try { Array.prototype.forEach.call(ss.cssRules, function (ru) { var walk = function (x) { if (x.cssRules) Array.prototype.forEach.call(x.cssRules, walk); else if (x.selectorText && x.selectorText.indexOf('folder.open') > -1 && x.style.clipPath) 有规则 = true; }; walk(ru); }); } catch (e) {} }); } catch (e) {}
        var top = document.elementsFromPoint(r.left + r.width / 2, r.top + 3)[0];
        板.textContent += '\n--- folder ---\nli clip-path ' + getComputedStyle(li).clipPath + '\nkit__list z ' + getComputedStyle(list).zIndex + '  规则在样式表 ' + 有规则
          + '\n纸3 top ' + r.top.toFixed(0) + ' li top ' + lr.top.toFixed(0) + ' 纸3顶端命中 ' + (top ? top.tagName + '.' + String(top.className).split(' ')[0] : '∅')
          + '\nopen类 ' + f.classList.contains('open') + ' 滚了 ' + 次 + ' 次 scrollY ' + Math.round(scrollY) + ' UA ' + navigator.userAgent.slice(-40);
        板.style.top = 'auto'; 板.style.bottom = '0'; 板.style.maxHeight = '22vh'; 板.style.overflow = 'hidden'; 板.style.fontSize = '9px';   // 量完让开,别挡住文件夹给截图看
        板.textContent = 板.textContent.split('--- folder ---')[1] || 板.textContent;
      }, 600); }
    }, 5000);
    // &fsopen=1:开盖 4s 后自动打开图卡集(验 iPad 上图卡层的比例)
    if (/[?&]fsopen=1/.test(location.search)) setTimeout(function () { var h = document.querySelector('.explore__hook'); if (h) h.click(); }, 5500);
    var hbm = location.search.match(/[?&]hbmid=(\d+)/); if (hbm) setTimeout(function () {
      var row = document.querySelector('.picker-strip__main .picker-row') || document.querySelector('.picker-row');
      if (!row) return;
      row.scrollLeft = Math.round((row.scrollWidth - row.clientWidth) / 2) + (parseInt(hbm[1], 10) || 37);   // hbmid=<偏移 px>
      setTimeout(function () { 抖.n = 0; 抖.min = Infinity; 抖.max = -Infinity; 抖.t = Date.now(); }, 1200);   // 给初次归位 1.2s,之后再数才算「抖」
    }, 5500);
  })();

  /* 电脑端「放大不缩」的自检标记(2026-09-19):告诉 scripts/check-overflow.mjs「有鼠标 + 视口 761~1439 时舞台故意出屏」。
     不能写在 HTML 开标签上 —— build-section.py 拿那一行原文当锚点抽 DOM,改一个字符就失配。值必须与 CSS 里那条 @media 一字不差。 */
  stage.setAttribute('data-overflow-intended', '(hover: hover) and (pointer: fine) and (min-width: 761px) and (min-device-width: 761px) and (max-width: 1583px)');

  /* 手机「放大不缩、能左右拖」(2026-09-21,CSS 见「手机「放大不缩、能左右拖」」那段):
     只认 iPhone(UA 含 iPhone):iPad 分屏时视口也会窄于 screen.width,但那不是放大,不能钉;
     Android Chrome 的 screen.width 会跟着放大一起缩,检测不到就等于不生效(无害)。
     设备宽按方向取 screen 的短边 / 长边(iOS 的 screen.* 不随转屏交换)。 */
  /* ===== 一整块底(2026-09-23 用户拍板)=====
     预览卡 + DIY 卡合成一张卡:两张卡自己不画背景,由 DIY 卡的 ::before 从预览卡顶一直铺到 DIY 卡底。
     这里只做一件事:量出「DIY 卡顶」比「预览卡顶」低多少,换算成 ::before 要往上延伸的长度写进 --pk-up,
     量成功才给 <html> 加 .pk-fused(CSS 那边只有加了类才切换,JS 挂了就保持原来的两张卡)。
     ⚠️ 两个坑:① ::before 在 .kit 的 zoom:.93 里,写进去的长度会 ×.93 落地 → 必须先除以 zoom;
        ② iOS 上 zoom 内元素的 getBoundingClientRect 是【未缩放】坐标,不能拿它跨 zoom 边界比 →
        改用「.kit 自己的 rect(它不在 zoom 内层)+ li 相对 .kit 的 offsetTop × zoom」来算 DIY 卡的视觉顶。 */
  (function 一整块底() {
    var 手机 = window.matchMedia && window.matchMedia('(max-width: 760px), (max-device-width: 760px)');
    var 定时 = 0;
    /* ⚠️ 2026-09-23 真机翻车记录:第一版用「kit.rect.top + li 相对 kit 的 offsetTop × zoom」算 DIY 卡视觉顶,
       无头两内核全绿,iPhone 16e 上却把底铺过了头(盖住 One Headphone 那一屏)。
       跨 zoom 边界的坐标换算在 iOS 上不可信(rect 有时是未缩放坐标)。
       现在改成:只用【不在 zoom 里】的两个元素的 rect 相减,zoom 一次都不参与;
       DIY 卡底则用它外面那层不带 zoom 的盒子。开关默认关,带 ?pkfuse=1 才开,真机验过再放开。 */
    var 开关 = !/[?&]pkfuse=0/.test(location.search);   /* 默认开;真机排查时可用 &pkfuse=0 临时关掉 */
    function 探针(文) {
      if (!/[?&]pkprobe=1/.test(location.search)) return;
      var d = document.getElementById('pk-probe');
      if (!d) { d = document.createElement('div'); d.id = 'pk-probe'; d.style.cssText = 'position:fixed;left:0;right:0;top:0;z-index:2147483647;background:#000;color:#0f0;font:11px/1.35 monospace;padding:6px;white-space:pre-wrap'; document.body.appendChild(d); }
      d.textContent = 文;
    }
    function 量() {
      var 上 = document.querySelector('.app-shell--h .col--preview .preview__framed');
      var kit = document.querySelector('.app-shell--h .col--kit .kit');
      var li = document.querySelector('.app-shell--h .col--kit .kit__list > li.kit-item--build');
      var 根 = document.documentElement;
      if (!上 || !kit || !li || !手机 || !手机.matches || getComputedStyle(上).display === 'none') {
        探针('未量:上=' + !!上 + ' kit=' + !!kit + ' li=' + !!li + ' 手机=' + !!(手机 && 手机.matches));
        根.classList.remove('pk-fused'); return;
      }
      var z = parseFloat(getComputedStyle(kit).zoom) || 1;
      var colKit = kit.parentElement;
      var 上r = 上.getBoundingClientRect(), lr = li.getBoundingClientRect(), cr = colKit.getBoundingClientRect();
      function 布局顶(el) { var t = 0, n = el; while (n) { t += n.offsetTop; n = n.offsetParent; } return t; }
      var L_li = 布局顶(li), L_kit = 布局顶(kit), 内偏 = L_li - L_kit;
      var D = cr.top + kit.offsetTop + 内偏 * z - 上r.top;
      /* 🔴 求「DIY 卡顶比预览卡顶低多少(视觉像素)」。两条路都踩过坑,只有 D 两个引擎都对:
         ✗ 祖先 rect + offsetTop 一路累加:offsetParent 链不停在 .kit(它没定位),会累加到 body —— 该 245 算成 1122,
           真机整块底铺过头、盖住上面一屏(2026-09-23 第一次翻车)。
         ✗ 直接 li.rect.top − 上卡.rect.top:iOS 上 zoom 子树的 rect 是【未缩放】坐标(实测 rect/offsetWidth=0.999,
           而无头两内核是 0.93)→ 真机算出 316.7、无头 244.9,差 70px(第二次翻车)。
         ✓ D:只在【同一坐标系】内相减 —— colKit(zoom 外)的 rect 起底,加 kit 在它里面的 offsetTop(zoom 外,实值),
           再加「li 相对 kit 的布局偏移 × zoom」(两个 offsetTop 累加值相减,消掉坐标系差异)。
           实测真机 243.6 / 无头 242.8,而上卡底 949 vs 视觉顶 947.6 → 重叠 1.4px,合理。 */
      var 视觉差 = D;
      var up = 视觉差 / z;   /* ::before 在 zoom 里,写进去会 ×zoom 落地,所以先除回去 */
      探针('V2 zoom=' + z + ' 比=' + (lr.width / li.offsetWidth).toFixed(3)
        + '\n上卡top=' + 上r.top.toFixed(1) + ' h=' + 上r.height.toFixed(1) + ' 底=' + (上r.top + 上r.height).toFixed(1)
        + '\ncolKit.top=' + cr.top.toFixed(1) + ' kit.offTop=' + kit.offsetTop + ' 内偏=' + 内偏
        + '\nA rect差=' + 视觉差.toFixed(1) + '   D 公式=' + D.toFixed(1)
        + '\n开关=' + 开关);
      if (!开关) { 根.classList.remove('pk-fused'); return; }
      if (!isFinite(up) || up <= 0 || up > 2000) { 根.classList.remove('pk-fused'); return; }
      /* 2026-10-22:写在 li 的父层 .kit__list 上(CSS 变量会继承给 li::before)。
         换主机颜色时 li 会被整个重画,写在 li 上的值跟着丢,底板就只剩 DIY 卡那一截;父层不会被重画。 */
      li.parentElement.style.setProperty('--pk-up', up.toFixed(2) + 'px');
      根.classList.add('pk-fused');
    }
    function 排队() { clearTimeout(定时); 定时 = setTimeout(量, 80); }
    function 装() {
      var 上 = document.querySelector('.app-shell--h .col--preview .preview__framed');
      var li = document.querySelector('.app-shell--h .col--kit .kit__list > li.kit-item--build');
      if (!上 || !li) { setTimeout(装, 400); return; }
      量();
      if (window.ResizeObserver) {
        var ro = new ResizeObserver(排队);
        ro.observe(上); ro.observe(li);
        // ⚠️ 只观察这两个元素不够:两者【尺寸没变但间距变了】(开合动画、加第 2 套、图卡展开)RO 不会触发 →
        //    再观察外壳,整块高度一变就重算。
        var 壳 = document.querySelector('.app-shell--h'); if (壳) ro.observe(壳);
      }
      // 2026-10-22:li 被重画(换主机颜色等)时重新量一次 —— 新 li 位置可能变了,RO 也还盯着旧的那个
      if (window.MutationObserver && li.parentElement) {
        new MutationObserver(排队).observe(li.parentElement, { childList: true });
      }
      addEventListener('resize', 排队);
      addEventListener('orientationchange', 排队);
      if (手机 && 手机.addEventListener) 手机.addEventListener('change', 排队);
      document.fonts && document.fonts.ready && document.fonts.ready.then(排队);
      [400, 1200, 2600].forEach(function (t) { setTimeout(量, t); });   // 图片 / 展开动画之后再补量
    }
    if (document.readyState === 'loading') addEventListener('DOMContentLoaded', 装); else 装();
    /* 真机验收用:&pkscroll=1 时持续把接缝顶到屏幕中间(页面的回顶守卫只认真实输入,会把程序化滚动按回去,
       所以要反复滚而不是滚一次)。只在带这个参数时生效,正常访问一行都不跑。 */
    if (/[?&]pkscroll=1/.test(location.search)) {
      var 滚次 = 0;
      setInterval(function () {
        var 上 = document.querySelector('.app-shell--h .col--preview .preview__framed');
        if (!上) return;
        var r = 上.getBoundingClientRect(), 差 = r.bottom - innerHeight / 2;
        var se = document.scrollingElement || document.documentElement;
        var 前 = se.scrollTop;
        se.scrollTop = 前 + 差;
        window.scrollBy(0, 0);
        滚次++;
        var d = document.getElementById('pk-scroll-probe');
        if (!d) { d = document.createElement('div'); d.id = 'pk-scroll-probe'; d.style.cssText = 'position:fixed;left:0;right:0;bottom:0;z-index:2147483647;background:#000;color:#ff0;font:11px/1.3 monospace;padding:4px'; document.body.appendChild(d); }
        d.textContent = '滚' + 滚次 + ' 前=' + Math.round(前) + ' 目标差=' + Math.round(差) + ' 后=' + Math.round(se.scrollTop) + ' 接缝y=' + Math.round(r.bottom) + ' 视口=' + innerHeight;
      }, 250);
    }
  })();

  (function 手机放大钉宽() {
    var html = document.documentElement;
    if (!/iPhone/.test(navigator.userAgent)) return;
    var mq = matchMedia('(hover: none) and (pointer: coarse) and (max-device-width: 760px)');
    function apply() {
      if (!mq.matches) { html.classList.remove('diy-phone-zoomed'); html.style.removeProperty('--diy-phone-pin'); return; }
      var 竖 = matchMedia('(orientation: portrait)').matches;
      var 设备宽 = 竖 ? Math.min(screen.width, screen.height) : Math.max(screen.width, screen.height);
      var 视口 = html.clientWidth;
      var 放大了 = 设备宽 - 视口 > 4 && 设备宽 / 视口 < 3.5;   // 上限 3.5:Safari 页面放大最大 300%
      html.classList.toggle('diy-phone-zoomed', 放大了);
      if (放大了) html.style.setProperty('--diy-phone-pin', 设备宽 + 'px'); else html.style.removeProperty('--diy-phone-pin');
    }
    apply();
    addEventListener('resize', apply);
    addEventListener('orientationchange', function () { apply(); setTimeout(apply, 300); setTimeout(apply, 800); });
    mq.addEventListener ? mq.addEventListener('change', apply) : mq.addListener(apply);
    /* 2026-09-21 用户:从 115% 缩回 100% 再往下缩,舞台「靠左缩小、右边留空」—— iOS 改页面缩放时不一定发 resize,
       放大态标记没撤,舞台还钉着 366 靠左 12。补两道:visualViewport 的 resize + 每 500ms 对一次 clientWidth(两次读、零开销),变了才重算。
       撤掉标记后舞台回到 min(1560, 100vw − 24) 且 margin-inline auto —— 铺满、居中,左右都不留空。 */
    if (window.visualViewport) visualViewport.addEventListener('resize', apply);
    var 上次宽 = html.clientWidth;
    setInterval(function () { var w = html.clientWidth; if (w !== 上次宽) { 上次宽 = w; apply(); } }, 500);
  })();

  /* iPad「电脑版等比缩小」(2026-09-19):算缩放比写进 --diy-tablet-scale,并把 transform 缩掉的高度用负 margin-bottom 收回。
     transform 不改布局占位:不收回的话舞台下面会留一大块空。ResizeObserver 盯舞台高度(开合会变),resize 盯屏宽(转屏)。
     只在触屏 + 761~1583 生效;离开区间就清掉 inline,让 CSS 自己接管。 */
  (function 平板等比缩放() {
    var mq = matchMedia('(hover: none) and (pointer: coarse) and (min-width: 761px) and (min-device-width: 761px) and (max-width: 1583px)');
    var 上限 = 0.85;   // = 电脑版 glass 的 scale,iPad 别比电脑还大
    function apply() {
      // 图卡展开(diy-fs-open)不退出:画廊贴在舞台里,要跟舞台一起按电脑比例缩(用户 2026-09-19)
      if (!mq.matches || document.documentElement.classList.contains('diy-overlay-open')) {
        stage.style.removeProperty('--diy-tablet-scale'); stage.style.marginBottom = ''; stage.style.marginLeft = ''; stage.style.marginTop = ''; return;
      }
      // 除了「宽度装得下」,再加一条「高度别顶天立地」(用户 2026-09-19:横屏占屏高 81% 压得满满当当)。
      // 2026-09-20 用户两次要「宽屏再宽」→ 上限放到 82%,横屏就由「宽度装得下」说了算(1156 = 屏宽 − 24,已是天花板)。
      // 这条现在只当兜底:屏幕特别扁时才生效。竖屏本来才占 39%,永远不生效。
      var 目标占屏高 = 0.82;
      // 布局高按「配置器展开态」记一次,开图卡集时沿用 —— 否则画廊高度不同会让比例跳一下,整块忽大忽小
      var 布局高 = stage.offsetHeight || 892;
      if (!document.documentElement.classList.contains('diy-fs-open')) stage.__diyBaseH = 布局高;
      else 布局高 = stage.__diyBaseH || 布局高;
      var s = Math.min(上限, (document.documentElement.clientWidth - 24) / 1560,
                       (document.documentElement.clientHeight * 目标占屏高) / 布局高);
      // 收敛:展开动画期间布局高一直在涨,算完就不管会定在半路的值(实测动画中 700 → 结束 892,比例差 0.08)。
      // 高度和上次不一样就 250ms 后再算一次,稳定了自然停,不会空转。
      if (stage.__diyLastH !== 布局高) { stage.__diyLastH = 布局高; clearTimeout(stage.__diyReflow); stage.__diyReflow = setTimeout(apply, 250); }
      stage.style.setProperty('--diy-tablet-scale', s.toFixed(4));
      // 缩完要挪回正中间(用户 2026-09-19:横屏缩小后贴着左边、右边空一大截)。
      // scale 的原点是 top left、布局宽仍是 1560,所以居中只能自己算左边距;装不下时退回 12。
      var 视觉宽 = 1560 * s;
      stage.style.marginLeft = Math.max(12, (document.documentElement.clientWidth - 视觉宽) / 2).toFixed(1) + 'px';
      // 渐变底的上下留白也按同一比例缩(用户 2026-09-20「配置器往上移」):它是 .diy-outer 的 padding,
      // 不跟着缩就恒定 72px,整块缩小后显得头重脚轻。用负 margin 吃掉多出来的那部分,渐变底顶边位置不动。
      var 底板 = stage.closest('.diy-outer');
      var 上白 = 底板 ? parseFloat(getComputedStyle(底板).paddingTop) || 0 : 0;
      var 下白 = 底板 ? parseFloat(getComputedStyle(底板).paddingBottom) || 0 : 0;
      // 2026-09-20 用户「渐变块上下各加高」:缩完的留白(横屏约 24 / 50)太紧,上下各补 28px,渐变底随之长高 56px。
      var 加高 = 28;
      stage.style.marginTop = (加高 - 上白 * (1 - s)).toFixed(1) + 'px';
      stage.style.marginBottom = (加高 - (stage.offsetHeight * (1 - s) + 下白 * (1 - s))).toFixed(1) + 'px';   // offsetHeight = 布局高,不受 transform 影响
    }
    apply();
    addEventListener('resize', apply);
    mq.addEventListener ? mq.addEventListener('change', apply) : mq.addListener(apply);
    // 真 iPad 转屏(用户 2026-09-19 iPadOS 26 模拟器):resize 那一刻 clientWidth 有时还是旧宽,算出来仍是竖屏的 0.51,之后没人再算 → 横屏只有 797 宽。
    // 无头两内核复现不出。补三道保险:根元素 ResizeObserver(宽度真变了才触发)/ orientationchange 后延时补算 / 方向 media query 变化。
    var 补算 = function () { apply(); setTimeout(apply, 300); setTimeout(apply, 800); };
    addEventListener('orientationchange', 补算);
    try { var omq = matchMedia('(orientation: portrait)'); omq.addEventListener ? omq.addEventListener('change', 补算) : omq.addListener(补算); } catch (e) {}
    try { new ResizeObserver(apply).observe(document.documentElement); } catch (e) {}
    try { new ResizeObserver(apply).observe(stage); } catch (e) { console.error('[DIY] 平板缩放 ResizeObserver 不可用', e); }
    try { new MutationObserver(apply).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] }); } catch (e) {}   // 浮层开关
  })();

  (function 同步底栏标记() {
    var 同步 = function () {
      var 开 = btn.getAttribute('aria-expanded') === 'true';
      document.documentElement.classList.toggle('diy-open', 开);
      if (!开) document.documentElement.classList.remove('diy-dock-hide');   /* 别的路径(FAB / 分享落地…)收起时也兜底摘掉 */
    };
    同步();
    try { new MutationObserver(同步).observe(btn, { attributes: true, attributeFilter: ['aria-expanded'] }); }
    catch (e) { console.error('[DIY] 底栏标记观察失败,菜单栏不会跟着藏', e); }
  })();

  /* ---- ⑲ 首屏提速:折叠态延后加载配置器资源(用户 2026-07-30)----
     CSS ⑲ 段在折叠且未 .diy-warm 时把 81 张图的 background-image 掐成 none;
     hook-fx 那块 WebGL 也在等 'diy:warm' 事件才建上下文(它在幕布里,折叠时看不见)。
     这里统一决定「什么时候解冻」:
       ① 用户点开   —— 必须立刻
       ② 鼠标靠近带子 —— 有点开意图,提前热身
       ③ 页面空闲兜底 —— 用户一直不点也别一直不加载,免得他真点时现下载
     解冻只做一次。*/
  var warmed = false, hotted = false;
  function warmAssets() {                              // 第一级:放行图片(纯网络,不占主线程)
    if (warmed) return;
    warmed = true;
    stage.classList.add('diy-warm');                   // 放行 CSS 里被掐掉的 background-image
  }
  function hotAssets() {                               // 第二级:放行幕布里的 WebGL(会编译着色器 = 主线程长任务)
    warmAssets();
    if (hotted) return;
    hotted = true;
    document.dispatchEvent(new Event('diy:hot'));
  }
  /* 🔴 2026-08-20 修:原来写的是 `if (stage.classList.contains('diy-expanded'))`,
     意思是「进站就展开的版本不用等,立刻放行资源」。
     但第 66 轮之后模块**永久挂着 .diy-expanded**(HTML 里写死),这个判断恒为真 ——
     于是【店铺版收起态也当场放行】,112 张配置器背景图在首屏全量下载,
     同时挂上 .diy-warm 把 CSS 那道省流量闸门也一并架空。
     这是同一个死条件坑掉的第三处(前两处:那批 :has(:not(.diy-expanded)) 死码、CSS 闸门本身)。
     ── 正确的判断是「这个页面有没有盖子」──────────────────────────
     有盖子 = 用户首屏看到的是收起态 = 该等触发再加载;
     没盖子 = 本地工作页 / 独立页 /pages/design,进站就是全开的配置器 = 立刻加载。
     ⚠️ 盖子类由解析阶段的内联脚本挂,早于这里执行(实测首帧就已挂上),所以这么判是可靠的。 */
  var 有盖子 = !!document.querySelector('.diy-cover-closed');
  if (stage.classList.contains('diy-expanded') && !有盖子) {
    hotAssets();                                       // 进站就全开(本地工作页 / 独立页),不用等
  } else {
    var banner = document.querySelector('.diy-hero-banner');
    /* 鼠标移到带子上 = 有点开意图 → **只放图**(纯网络请求,基本不占主线程)。
       ⚠️ 这里绝不能顺手把 WebGL 也放了:2026-07-30 用户反馈「鼠标移过去再点,顿挫很严重」,
       原因就是悬停瞬间开始拉 ogl(外网 1.1s)+ 编译着色器(130ms 长任务),
       用户紧接着点击,展开动画正好压在这堆活上面跑。
       WebGL 改到展开动画**跑完之后**再初始化(见 expand 的收尾),动画期间主线程干干净净。*/
    /* 🔬 第 59 轮诊断开关:&nowidth=1 → 给 stage 挂 .diy-nowidth,把 width 从过渡里摘掉
       (宽度瞬时到位)。用于验证「width 被动画 = 每帧整棵子树重排重绘」是否就是闪白病根。详见 CSS 侧注释。 */
    if (/[?&]nowidth=1/.test(location.search)) stage.classList.add('diy-nowidth');
    if (/[?&]noline=1/.test(location.search)) stage.classList.add('diy-noline');   // 第 63 轮:关掉发丝线补强,用于 A/B 对照
    if (banner) banner.addEventListener('pointerenter', warmAssets, { once: true });
    // 悬停即提升下方图层:把建层开销挪到点击之前,动画期间就只剩 GPU 位移(2026-07-30)
    /* 第 57 轮加 warmMeasure:把 flipMeasure 的 36ms 样式重算挪到 hover 时付掉(见 warmMeasure 注释)。
       放在 liftSiblings/preloadBelow 之后,顺序无所谓 —— 三件都是「趁空闲提前把贵活干了」。 */
    if (banner) banner.addEventListener('pointerenter', function () { liftSiblings(true); preloadBelow(); warmMeasure(); });
    // 谁都没碰时的兜底:压到 5s 以后,那时用户早看完首屏了,一次 60ms 的编译不影响体感
    setTimeout(function () {
      (window.requestIdleCallback || function (f) { return f(); })(hotAssets, { timeout: 3000 });
    }, 5000);
    // 空闲兜底。⚠️ 不能只用 requestIdleCallback:主线程一空它立刻就回调,实测 87ms 就解冻了,
    // 等于白延后。必须 load 之后再压一段固定延时,把这 1.2MB 让给主题自己的图和字体先跑。
    var idleWarm = function () {
      setTimeout(function () {
        (window.requestIdleCallback || function (f) { return f(); })(warmAssets, { timeout: 2000 });
      }, 900);
    };
    if (document.readyState === 'complete') idleWarm();
    else window.addEventListener('load', idleWarm, { once: true });
  }


  // 幕布高度 0/auto 都无法直接过渡 → 每次开合前先实测出一个像素目标值写进 --diy-open-h。
  // 折叠态下配置框本体仍是原尺寸(只是被幕布裁掉),所以这里量得到真实高度。
  function setTargetH(px) { stage.style.setProperty('--diy-open-h', px + 'px'); }

  /* ---- 展开后自动把模块滚到视口中央(用户 2026-07-29:「点开之后默认上下居中」)---- */

  var scroller = document.scrollingElement || document.documentElement;
  var SNAP_COLLAPSE = /[?&]snap=1/.test(location.search);   // 试用方案③:内容原地淡出+一次性归位
  var GAP = 16;                                        // 模块顶边与导航底边之间留多少呼吸位(用户 2026-07-29 拍板 16px)
  var headerCache = -1;                                // headerH 要查询布局,一次动画里只算一次

  // 线上主题有吸顶导航,模块顶边要停在它下沿,不能被它盖住。
  // 用 elementsFromPoint 取「视口最顶端那一摞元素」里position 是 fixed/sticky 的那个 ——
  // 比按 class 名猜可靠得多:主题的吸顶元素可能叫 <sticky-header> 之类,名字里未必有 header;
  // 反过来模块内部第一列就有个 <header class="hero">,按名字猜会误伤(它不是吸顶的,靠 position 排除)。
  function headerH() {
    if (headerCache >= 0) return headerCache;
    var best = 0;
    [window.innerWidth / 2, 40, window.innerWidth - 40].forEach(function (x) {
      (document.elementsFromPoint(x, 2) || []).forEach(function (el) {
        var cs = getComputedStyle(el);
        if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
        var r = el.getBoundingClientRect();
        if (r.top <= 2 && r.height > best && r.height < 260) best = r.height;   // <260 挡掉整页级的 fixed 容器
      });
    });
    return (headerCache = best);
  }
  window.addEventListener('resize', function () { headerCache = -1; 导航缓存 = -1; });

  /* 吸顶导航的【自然高度】—— 不管它此刻是不是滑上去藏起来了。
     ⚠️ 和 headerH() 的区别，以及为什么必须有这一个:
        headerH() 用 elementsFromPoint 只认「此刻真的贴在屏幕顶端」的元素。
        页面往下滚时主题会把导航收起来,这时它返回 0。
        展开的落点如果按 0 算,模块就停在离屏幕顶 16px;可是主题的规则是
        【往回滚一点就把导航放下来】(2026-09-15 实测:回滚 15px 就触发),
        53px 高的导航一盖,正好把那 16px 空隙 + 模块顶部 37px 的渐变带全吃掉 ——
        用户看到的就是「毛玻璃直接顶住白色顶栏、没有空隙」。
        所以落点必须按【自然高度】预留位置:导航来也好、不来也好,模块位置都不动。
     代价(用户 2026-09-15 已知悉并接受):导航藏着的时候,模块上方会多出一条空白带。
        换来的是「模块的位置永远固定」。 */
  var 导航缓存 = -1;
  function 导航自然高() {
    if (导航缓存 >= 0) return 导航缓存;
    var 高 = 0;
    ['sticky-header', '#shopify-section-header', '.header-wrapper', 'header.header', 'header'].some(function (s) {
      var e = document.querySelector(s);
      if (e && e.offsetHeight > 30 && e.offsetHeight < 260) { 高 = e.offsetHeight; return true; }
      return false;
    });
    return (导航缓存 = Math.max(高, headerH()));
  }

  // 模块顶边贴住导航下沿(用户 2026-07-29 拍板;之前是上下居中,改成顶部对齐)
  //   grow = 文档接下来还会长高多少(提前发起滚动时文档还没变高,不补上这段会被夹住滚不到位)
  function wantedY(hostTopAbs, hostH, grow) {
    var y = hostTopAbs - headerH() - GAP;
    var max = Math.max(0, scroller.scrollHeight + (grow || 0) - window.innerHeight);
    return Math.max(0, Math.min(y, max));
  }

  function host() { return document.querySelector('.diy-outer') || stage; }

  /* 🔴 把模块下方的兄弟区块提前提升为独立合成层(2026-07-30,真机诊断数据驱动)
     真机数据(用户 120Hz 高刷屏,收起时):最长一帧 95ms、8 帧掉帧,但【长任务 0 个 / 0ms】
     → JS 一次都没阻塞主线程,那 95ms 全是浏览器在【画】。
     这解释了为什么之前所有 JS 方向的优化(挪 setSize / 换毛玻璃 / 去全局广播 / 放慢动画)统统无效。
     机制:开合让文档高度变化 660px,下方整页内容被推着移动;它们不是独立图层,
     每移动一次浏览器就要把几千像素的图文【重新光栅化】一遍,来不及就露白 = 用户说的「闪」。
     高刷屏每帧预算只有 8.3ms(120Hz),比 60Hz 的 16.7ms 更容易掉帧,所以用户比我更容易看到。
     修法:给下方兄弟加 will-change:transform 提升为合成层,移动时只是 GPU 挪一张已画好的位图,
     不再重画。图层创建本身也有开销,所以【提前到鼠标悬停时】做,不占动画的帧。
     ⚠️ 跳过 fixed/sticky 元素 —— will-change 会给它们造包含块,导致定位错乱。
     🔄 关掉对比:网址加 &nolayer=1 */
  var lifted = [], liftTimer = 0;
  var NO_LAYER = /[?&]nolayer=1/.test(location.search);
  var NO_LIFT  = /[?&]nolift=1/.test(location.search);   // 第 56 轮:关掉 FLIP 路径的预提层,用于 A/B 对照
  /* 第 60 轮的「横幅冻结」第 63 轮起【默认关闭】。
     它把横幅宽度在动画第一帧就钉到【目标 px】,与第 63 轮新加的 stage 宽度过渡直接冲突:
     stage 平滑 1728→1560 的过程中,横幅却已经是 1560 —— 两侧会各露出 84px 的玻璃底。
     而且它当初要解决的「每帧重排」已被第 61/62 轮从根上修掉(病灶在起点帧和收尾帧,不在动画中段),
     用户实测也确认它无效。🔄 想再开:网址加 &bf=1 */
  var NO_BANNER_FREEZE = !/[?&]bf=1/.test(location.search);
  var NO_KEEP_LAYER    = /[?&]nokeep=1/.test(location.search); // 第 61 轮:提交帧照旧删 transform(= 旧行为),用于 A/B 对照
  var NO_SPLIT         = /[?&]nosplit=1/.test(location.search); // 第 62 轮:起点帧不拆分(= 旧行为),用于 A/B 对照
  var NO_WIDTH_ANIM    = /[?&]nowa=1/.test(location.search);   // 第 63 轮:宽度不走 px 过渡(= 旧的瞬间跳变),用于 A/B 对照
  var NO_DRAWER        = /[?&]nodrawer=1/.test(location.search); // 第 65 轮:关掉遮罩抽屉(内容不位移),用于 A/B 对照
  /* 第 63 轮:拆层延迟可调(&td=200 / &td=0)。默认仍是第 47 轮定的 600ms。 */
  var TEARDOWN_MS      = (function () {
    var m = /[?&]td=(\d{1,5})/.exec(location.search);
    return m ? parseInt(m[1], 10) : 600;
  })();
  function liftSiblings(on) {
    /* ✅ 第 56 轮(2026-08-01)闪白病根定案 —— FLIP 路径【恢复】预提层(原来这里是 `|| FLIP` 直接跳过)。

       A/B 取证(用户 19:37 对照组 / 19:38 诊断组两段录屏,逐帧亮度差分 + 关键帧目检):
         · A 对照组(现状)      :35 处单帧尖峰、34 次相邻帧跳变>3,且呈 +10/-13/+13/-7 连续来回抖 = 闪
         · B 诊断组(nosib=1)   :只剩 12 处,全是成对 ±15 且恰好 6 对 = 6 次开合的硬跳;
                                 帧上实证该时刻 5 张 Instagram 图完整渲染、零缺失 → 不是闪
       → 闪白 = flipMove 的 translate3d 在【动画第一帧】才把每个兄弟 section 提成合成层。
         装满大图的 Shop the Look 要把所有【已解码】的图重新光栅化成新纹理,
         高负载机器一帧内做不完 → 该层空白出帧。
         (关键判据:图片是「空白→完整→又空白→又完整」来回切换 —— 若如 7-31 所猜是懒加载没下载完,
          图一旦出现就不会再消失。故排除加载问题,坐实是【已解码内容被反复重新光栅化】。)

       原注释「提层反而更差 61ms vs 55ms」是在【非 FLIP 的高度动画路径】上测的 —— 那条路不走 transform,
       提层自然白搭。但 FLIP 路径下 translate3d 无论如何都会提层:与其在动画第一帧现场建层,
       不如 hover 时提前建好,把光栅开销挪到「没有动画在跑」的时刻付掉。这是时机问题,不是要不要提层的问题。
       🔄 关掉对比:网址加 &nolift=1 */
    if (NO_LAYER || (FLIP && NO_LIFT)) return;
    try {
      clearTimeout(liftTimer);
      if (on) {
        /* 每次都重新扫描,不能用「已提升过就 return」跳过 ——
           宿主页面有懒加载区块时结构会变,跳过会漏掉后来才出现的区块(2026-07-30 实测发现)。
           重复设同一个值浏览器会忽略,幂等无副作用。*/
        var sec = host().closest('.shopify-section') || host();
        var now = [];
        for (var e = sec.nextElementSibling; e; e = e.nextElementSibling) {
          if (e.nodeType !== 1) continue;
          var cs = getComputedStyle(e);
          if (cs.position === 'fixed' || cs.position === 'sticky') continue;
          if (e.style.willChange !== 'transform') e.style.willChange = 'transform';
          now.push(e);
        }
        lifted.forEach(function (o) { if (now.indexOf(o) < 0) o.style.willChange = ''; });  // 已移除的清干净
        lifted = now;
      } else {
        lifted.forEach(function (e) { e.style.willChange = ''; });
        lifted.length = 0;
      }
    } catch (err) { /* 宿主结构异常不影响开合主流程 */ }
  }
  function dropSiblingsLater(ms) {                       // 动画完别马上销毁图层,留一会儿防连点
    clearTimeout(liftTimer);
    liftTimer = setTimeout(function () { liftSiblings(false); }, ms || 2000);
  }

  /* 🔴 提前把「收起时即将露出的那一屏」的图片加载并解码好(2026-07-31)
     用户提示「从整个网页这边查」后才意识到的整页级原因:
     收起时视口下方露出 660px,宿主主题那片区域(Shop the Look 的 Instagram 图、产品图)
     大多是 loading="lazy" —— 它们【进入视野时才开始下载】,下载解码完之前就是空白 = 用户说的「闪」。
     这解释了此前所有对不上的地方:
       · 本地测试页没有这些图 → 我永远复现不了
       · 长任务恒为 0 → 图片下载/解码本就不占主线程,再怎么优化 JS 都没用
       · 图层提升/改曲线/放慢 → 优化的是「画」,而问题是「图还没来」
     修法:悬停时 + 展开完成后,把那一屏的懒加载图片改成立即加载,并调 decode() 预解码,
     等真正收起时它们已经就位。只覆盖下方一屏,不会浪费带宽。
     🔄 关掉对比:网址加 &nopre=1 */
  var NO_PRELOAD = /[?&]nopre=1/.test(location.search);
  function preloadBelow() {
    if (NO_PRELOAD) return;
    try {
      var vh = window.innerHeight;
      document.querySelectorAll('img').forEach(function (im) {
        var r = im.getBoundingClientRect();
        if (r.bottom < vh - 60 || r.top > vh + 900) return;   // 只管视口下沿往下一屏
        if (im.loading === 'lazy') im.loading = 'eager';
        if (im.dataset && im.dataset.src && !im.getAttribute('src')) im.src = im.dataset.src;
        if (im.dataset && im.dataset.srcset && !im.getAttribute('srcset')) im.srcset = im.dataset.srcset;
        if (im.decode) im.decode().catch(function () {});      // 预解码:进视野时不用再等
      });
    } catch (e) { /* 宿主图片结构异常不影响开合 */ }
  }

  // 解 cubic-bezier(x1,y1,x2,y2):要让滚动和幕布长高走同一条曲线,不能拿 easeInOutCubic 之类凑
  function bezier(x1, y1, x2, y2) {
    var cx = 3 * x1, bx = 3 * (x2 - x1) - cx, ax = 1 - cx - bx;
    var cy = 3 * y1, by = 3 * (y2 - y1) - cy, ay = 1 - cy - by;
    return function (x) {
      var t = x;                                        // 牛顿迭代反解参数 t,5 次足够
      for (var i = 0; i < 5; i++) {
        var e = ((ax * t + bx) * t + cx) * t - x;
        if (Math.abs(e) < 1e-4) break;
        var d = (3 * ax * t + 2 * bx) * t + cx;
        if (Math.abs(d) < 1e-6) break;
        t -= e / d;
      }
      return ((ay * t + by) * t + cy) * t;
    };
  }
  var EASE = bezier(.4, 0, .2, 1);                      // 必须与 CSS 变量 --diy-open-ease 同一条曲线(标准 ease-out)
  var scrollSeq = 0;                                    // 递增令牌:用户中途自己滚了就作废这次动画

  // 自己驱动而不是用原生 scrollTo({behavior:'smooth'}):
  //   原生时长由浏览器按距离自定,641px 实测跑了 900ms,比 500ms 的长高慢一截 ——
  //   末尾 400ms 只有页面在滑、模块早不动了,看着就是「长完又挪了一下」。
  //   (原先担心的每帧写 scrollTop 掉帧,归因后是「展开后的模块整个进视口」的固有渲染成本,与滚动无关)
  function animScroll(to, dur, easeFn) {
    var fn = easeFn || EASE;                            // 第 53 轮:可传自定义曲线(收起要与主动画同曲线,不传=原行为)
    var from = scroller.scrollTop;
    if (Math.abs(to - from) < 2) return;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) { scroller.scrollTop = to; return; }
    var me = ++scrollSeq, t0 = performance.now();
    var evs = ['wheel', 'touchstart', 'keydown'];
    function bail() { scrollSeq++; }                    // 用户自己滚 → 立刻让位,不跟他抢
    function off() { evs.forEach(function (e) { window.removeEventListener(e, bail); }); }
    evs.forEach(function (e) { window.addEventListener(e, bail, { once: true, passive: true }); });
    /* 🔴 每一帧的位移不足 1px 就【这一帧不写】(2026-09-15,用户报「顶栏极快地向下弹了一下」)。
       Concept 主题吸顶导航的判断逻辑(读它的 StickyHeader 源码):
           scrollTop > this.currentScrollTop ? 加 header-hidden : 移除 header-hidden
       —— **相等也走「显示」那一支**。
       而缓动曲线的尾段每帧只挪不到 1px,scrollTop 取整后会出现「这一帧和上一帧一样」,
       主题就当成「用户往上滚了」,把顶栏放下来;下一帧又滚了,再收回去。
       实测:835ms 和 845ms 两帧 scrollY 都是 1087,顶栏紧接着在 853ms 开始下滑 ——
       0.5s 的过渡只播了一点点就被打断,肉眼就是「闪了一下」。
       不写这一帧 = 不派 scroll 事件 = 主题的 handler 根本不会被调用,从根上消掉误判。
       ⚠️ 别改成「补足 1px」:那会让落点偏掉。跳过即可,下一帧自然会追上。 */
    var 上次写 = from;
    (function step(now) {
      if (me !== scrollSeq) { off(); return; }
      var t = Math.min(1, (now - t0) / dur);
      var v = from + (to - from) * fn(t);
      if (t < 1 && Math.abs(v - 上次写) < 1) { requestAnimationFrame(step); return; }
      上次写 = v;
      scroller.scrollTop = v;
      if (t < 1) requestAnimationFrame(step); else off();
    })(t0);
  }

  // 按当前真实几何滚到位(用在动画结束后的校正 / 收起后的补救)
  function recenter(dur) {
    var r = host().getBoundingClientRect();
    animScroll(wantedY(r.top + scroller.scrollTop, r.height), dur || 360);
  }

  function expand() {
    busy = true;                                       // 立刻锁上,别等下一帧,否则有 1 帧空窗能连点
    warmAssets();                                      // 图立刻放行(要用来渲染);WebGL 留到动画跑完再说
    // 幕布目标高 + 滚动落点,都在动画开始前一次量准。
    // 手法:同一帧内先假装展开量一把再还原 —— 中间没有 paint,所以不会闪。
    //   · 幕布高必须量 wrap 自己(height:auto 时的自然高),不能拿 frame 的高:
    //     frame 有 margin-top(-12px)不计入 getBoundingClientRect().height,
    //     用 frame 高当目标会让幕布比内容高 12px,动画末尾交回 height:auto 时「啪」地缩一下。
    //   · 落点早先用「折叠高 + 幕布目标高」估,差了 outer 恢复的 padding 约 20px,
    //     结果收尾又补一次平滑滚,最后 19px 爬了 575ms,整体 1.4s 才停。
    var hr = host().getBoundingClientRect();
    stage.classList.add('diy-expanded', 'diy-open-done');
    var openH    = host().getBoundingClientRect().height;
    var curtainH = wrap.getBoundingClientRect().height;
    stage.classList.remove('diy-expanded', 'diy-open-done');
    void host().offsetHeight;                          // 强制还原后的布局落地,免得残留影响下面的过渡起点
    setTargetH(curtainH);
    var estY = wantedY(hr.top + scroller.scrollTop, openH, openH - hr.height);
    liftSiblings(true);                                // 兜底:没经过 hover 也要提层
    window.__diyFxPause = true;                        // 冻结丝带 + 暂停画布重建,把这半秒让给展开动画
    stage.classList.add('diy-animating');              // 先降级(关毛玻璃 + 停丝带渲染)
    btn.setAttribute('aria-expanded', 'true');
    // 隔一帧再启动过渡:降级的样式重算和过渡的第一帧分开,否则第一帧要一次干完两件事(实测长帧 60ms+)
    requestAnimationFrame(function () {
      stage.classList.add('diy-expanded');
      animScroll(estY, 500);                           // 与幕布同时长、同曲线 → 观感是一个动作
      // 收尾的三件重活分三帧做:挤在同一帧时实测动画结束后连着 600ms 掉到 42~50ms/帧(用户说的「最后顿一下」)
      afterAnim(function () {
        stage.classList.add('diy-open-done');          // 帧 A:交回 height:auto,之后窗口缩放自适应
        stage.style.removeProperty('--diy-open-h');
        requestAnimationFrame(function () {
          stage.classList.remove('diy-animating');     // 帧 B:恢复毛玻璃(16 处 backdrop-filter 一次性重建,最重)
          window.__diyFxPause = false;                 // 丝带恢复流动,并补一次 setSize 把分辨率对回来
          requestAnimationFrame(function () {
            /* 帧 C:通知重算尺寸(画廊靠实测尺寸)。
               ⛔ 这里【绝不能】用 window.dispatchEvent(new Event('resize')) —— 那是全局广播,
               会把宿主 Shopify 主题里所有监听 resize 的组件一起唤醒,整页重排重绘一次,
               是「展开/收起末尾整页白一帧」最可疑的来源(2026-07-30)。
               本模块真正需要它的只有画廊居中一件事;模块内的 WebGL 画布走 ResizeObserver,
               本来就不依赖这个广播。所以改成只有自己人听得见的局部事件。*/
            window.dispatchEvent(new CustomEvent('diy:relayout'));
            // 帧 C:上一行的 resize 会让画廊重排、模块高度再变几十 px(实测 54px),
            // 这个变化在点击那一刻测不出来 → 这里按真实几何补一次短程沉降
            recenter(300);
            // 动画彻底跑完、页面安静下来,再去拉 ogl / 编译着色器(130ms 级长任务)。
            // 放在动画之前或悬停时都会跟展开动画抢主线程 = 用户说的「顿挫」(2026-07-30)
            setTimeout(function () {
              (window.requestIdleCallback || function (f) { return f(); })(hotAssets, { timeout: 2000 });
            }, 400);
            preloadBelow();                              // 为「收起」提前备好下方那一屏的图
            dropSiblingsLater(2000);                     // 释放图层(延后,防连点又要重建)
          });
        });
      });
    });
  }

  function collapse() {
    busy = true;
    var curtainH = wrap.getBoundingClientRect().height;
    setTargetH(curtainH);                              // 先把 auto 钉回当前像素值,否则无起点无法过渡
    stage.classList.remove('diy-open-done');

    /* 🔴 收起也必须【主动平滑滚动】,不能留给浏览器硬夹(2026-07-30 用户反馈「收回来时闪得更严重」)
       原来展开和收起是不对称的:
         展开 → animScroll 主动滚到位(受控、平滑)
         收起 → 不滚,等文档变矮后【浏览器每帧强行把 scrollTop 往回拽】,跑偏了再 recenter 补救
       文档一下矮 660px,这种被动、不可预测的反向滚动最容易让光栅化跟不上 → 整页白一帧,
       且比展开更严重(展开是我主动向下滚,浏览器能跟上;收起是被硬拽,方向还相反)。
       修法:同一帧内假收起量一把,算出「浏览器最终会夹到哪」,然后主动平滑滚过去。
       落点与原来完全一致(就是浏览器会夹到的值),只把过程从「被硬拽」换成「受控滑行」。*/
    var hr = host().getBoundingClientRect();
    stage.classList.remove('diy-expanded');            // 假收起
    stage.style.removeProperty('--diy-open-h');
    var closedH = host().getBoundingClientRect().height;
    stage.classList.add('diy-expanded');                // 立刻还原(同帧内,无 paint,不会闪)
    setTargetH(curtainH);
    void host().offsetHeight;
    var shrink   = Math.max(0, hr.height - closedH);   // 文档将要矮掉多少
    var maxAfter = Math.max(0, scroller.scrollHeight - shrink - window.innerHeight);
    var targetY  = Math.min(scroller.scrollTop, maxAfter);   // 浏览器最终会夹到的位置

    liftSiblings(true);                                // 兜底:同 expand
    window.__diyFxPause = true;                        // 同 expand:动画期间冻结丝带
    stage.classList.add('diy-animating', 'diy-collapsing');   // collapsing:把收起放慢到 .8s(见 CSS)
    void wrap.offsetHeight;                            // 强制回流,让上面那个像素起点先生效
    requestAnimationFrame(function () {
      stage.classList.remove('diy-expanded');
      btn.setAttribute('aria-expanded', 'false');
      if (targetY < scroller.scrollTop - 1) animScroll(targetY, 800);  // 只在真会被夹时才滚,与幕布同时长同曲线
      afterAnim(function () {
        stage.style.removeProperty('--diy-open-h');
        stage.classList.remove('diy-collapsing');      // 放慢只作用于本次收起,别影响下次展开
        requestAnimationFrame(function () {
          stage.classList.remove('diy-animating');     // 同上:恢复毛玻璃单独占一帧
          window.__diyFxPause = false;
          // 兜底:万一预测有偏差、带子仍被顶出视口,才补一次(正常情况下不会触发)
          var r = host().getBoundingClientRect();
          if (r.top < headerH() || r.bottom > window.innerHeight) recenter();
          dropSiblingsLater(2000);
        });
      }, 800);                                         // 兜底按放慢后的 .8s 算
    });
  }

  /* 🔬 方案③(2026-07-30,&snap=1 试用):内容先原地淡出,再一次性归位。
     动机:收起时视口下方露出 660px【从没画过】的新内容,是首次绘制;
     只要「下方内容持续移动 0.8 秒」,浏览器就得连续画 0.8 秒,画不完就闪。
     图层提升 / 改曲线 / 放慢都只能摊薄,消除不了(真机数据 最长帧 95→60→76ms,已到头)。
     本方案改变前提:
       阶段一 内容在【原地】淡出 —— 只动 opacity/transform(GPU),幕布高度钉住不变,
              下方内容【完全不动】,浏览器不用画任何新东西;
       阶段二 淡完后【一帧内】把高度收掉 —— 下方内容只移动一次,浏览器只画一次,
              不给它连续画的机会。
     代价:下方内容那一次上移是瞬间的,会看到一次「跳」。但那是一次干净的位置变化,
     不是断续的白块。用户对比后决定是否设为默认。*/
  function collapseSnap() {
    busy = true;
    setTargetH(wrap.getBoundingClientRect().height);   // 钉住高度 → 淡出期间下方内容不动
    stage.classList.remove('diy-open-done');
    liftSiblings(true);
    window.__diyFxPause = true;
    stage.classList.add('diy-animating', 'diy-snap-fading');
    btn.setAttribute('aria-expanded', 'false');
    setTimeout(function () {
      stage.classList.add('diy-snap-now');             // 关掉所有过渡,下面几行要在同一帧落地
      stage.classList.remove('diy-expanded');
      stage.style.removeProperty('--diy-open-h');
      void stage.offsetHeight;                          // 强制立刻落地,别拖到下一帧
      requestAnimationFrame(function () {
        stage.classList.remove('diy-animating', 'diy-snap-fading', 'diy-snap-now');
        window.__diyFxPause = false;
        busy = false;
        dropSiblingsLater(2000);
        var r = host().getBoundingClientRect();
        if (r.top < headerH() || r.bottom > window.innerHeight) recenter();
      });
    }, 300);                                            // 与 CSS 的 .28s 淡出对齐,留一点余量
  }

  /* ═══ FLIP 开合(2026-07-31,&flip=1)══════════════════════════════════════════
     原理与证据见 CSS 里的同名大段注释。核心一句话:
       幕布高度动画照跑,但 section 外壳高度被钉死 → 这个变化传不到页面下方;
       下方内容改由 transform 搬运(纯合成层)。整页只重排 1 次而不是 48 次。 */
  var FLIP = /[?&]flip=1/.test(location.search);
  /* 底色画布尺寸修正(2026-07-31 转正为默认,用户拍板)。
     把渐变画布的高度钉在【展开态高度】,收起时只是从下面裁掉一截 ——
     折叠态带子看到的就是展开态最顶上那一条,颜色与展开时完全一致,右侧那抹绿永远不会露出来。
     留 &nobgfix=1 关掉,方便回头对照。*/
  var BGFIX = !/[?&]nobgfix=1/.test(location.search);

  /* 量一次展开态的模块高度,写进 --diy-bg-h。
     只用 flipMeasure 的【冻结块】那半段(diy-measure 把全子树过渡冻死 → 类名一挂一摘不会触发任何动画),
     所以在页面刚加载、还没有任何交互时调用也是安全的。*/
  function syncBgCanvas() {
    if (!BGFIX) return;
    try {
      var secEl = host().closest('.shopify-section') || host();
      var wasOpen = stage.classList.contains('diy-expanded');
      var hadDone = stage.classList.contains('diy-open-done');
      secEl.classList.add('diy-measure');
      stage.classList.add('diy-expanded', 'diy-open-done');
      var h = host().offsetHeight;
      stage.classList.remove('diy-expanded', 'diy-open-done');
      if (wasOpen) stage.classList.add('diy-expanded');
      if (hadDone) stage.classList.add('diy-open-done');
      void host().offsetHeight;
      secEl.classList.remove('diy-measure');
      if (h > 0) host().style.setProperty('--diy-bg-h', Math.round(h) + 'px');
    } catch (e) {}
  }

  /* ❌ 第 54 轮的 glassBox()/setGlassClip()(代理玻璃裁切几何)已于第 55 轮删除 ——
     连同它服务的 .diy-outer::after 代理层一起撤除,详见 CSS 侧同轮注释。
     一句话:模糊本身被证明是视觉零效果的纯开销,直接删掉即可,不需要「把模糊搬到别处再用裁切驱动形状」
     这套机制;而这套机制自身还引入了展开时顶部横幅缺玻璃的 bug 和更重的每帧开销。 */

  // 收集模块下方所有会被顶上/推下的兄弟块,并记住它们原本的 inline 样式(结束时原样还回去)。
  // 跳过 fixed / sticky:给它们上 transform 会把它们变成包含块,定位当场错乱。
  function flipCollect() {
    /* 🔬 诊断开关(第 56 轮,2026-08-01):网址加 &nosib=1 → 不收集任何兄弟块,
       于是 flipMove 不会给它们写 translate3d,它们全程不提合成层、不做位移动画。

       要验证的假设:闪白的真正原因是【兄弟块被逐个提成合成层】。
       取证依据(用户 19:11 录屏逐帧):闪白帧里跟着一起空的,除了模块内的流光画布,
       还有模块【外面】那面 Instagram 图片墙(Shop the Look,一个独立 section) ——
       它跟玻璃/模糊毫无关系,却和流光在同一帧一起白。
       且序列是「空 → 完整 → 又空 → 又完整」,若是 7-31 猜的懒加载没下载完,
       图一旦出现就不会再消失 → 排除加载问题,指向【已解码的图被反复重新光栅化】。
       translate3d 本身就会提合成层(即使这里没写 will-change),给一个装满大图的 section
       提层 = 要把所有解码后的图重新光栅化成新纹理,高负载机器一帧内做不完 → 该层空白出帧。

       ⚠️ 代价:开着这个开关时,收起过程中下方内容不会跟着平滑上移,会在结束时硬跳一下
       (FLIP 本来就是为消除这个跳)。**纯诊断用,不是最终方案。**
       判读:闪白消失 → 假设成立,针对提层设计正式解法;
             明显减轻但仍有 → 同时提层的大纹理总量超预算(假设2);
             毫无变化 → 假设1、2 均排除,转查文档高变化+滚动修正(假设3)。 */
    if (/[?&]nosib=1/.test(location.search)) return [];
    var sec = host().closest('.shopify-section') || host();
    var out = [];
    for (var e = sec.nextElementSibling; e; e = e.nextElementSibling) {
      if (e.nodeType !== 1) continue;
      var cs = getComputedStyle(e);
      if (cs.position === 'fixed' || cs.position === 'sticky' || cs.display === 'none') continue;
      out.push({ el: e, tr: e.style.transform, tn: e.style.transition, wc: e.style.willChange });
    }
    return out;
  }
  // y=位移像素;dur=0 表示立刻生效(不过渡),用来摆 FLIP 的「起点」
  function flipMove(list, y, dur, ease) {
    list.forEach(function (o) {
      // 不加 will-change:translate3d 本身就会提合成层,再加一道只是白白多占显存 +
      // 多一次图层建立开销(真机对照:提层组 61ms vs 不提层组 55ms,提层反而更差)
      // 兄弟块在 .diy-stage 外面,CSS 变量靠 :root 那条继承;带 fallback 防宿主主题重置
      o.el.style.transition = dur
        ? ('transform ' + dur + 'ms ' + (ease || 'var(--diy-open-ease, cubic-bezier(.4, 0, .2, 1))')) : 'none';
      o.el.style.transform  = 'translate3d(0,' + y + 'px,0)';
    });
  }
  /* ❄️ 把配置器整块「冻结」—— 本轮的核心手法(2026-07-31,真机录屏逐帧定罪)。
     证据:收起过程中有整整一帧,配置器区域是【纯白】的(下一帧又完整回来)。
     那 660px 里有 81 张图 + 16 处毛玻璃 + WebGL 画布 + GSAP 元素,
     只要动画期间它的几何还在变,浏览器就得反复重画这一整块,来不及就交白 = 用户看到的「闪」。

     手法:动画开始的那一帧,把幕布改成【绝对定位 + 固定尺寸】,并把外壳高度钉住。
     于是整段动画里配置器的位置和尺寸【一个像素都不动】,浏览器一次都不用重画它;
     真正在动的只有下方内容的 transform(纯合成层,GPU 搬运)。
     视觉完全一致 —— 因为「幕布从下往上收」和「下方内容从下往上盖」,
     那条分界线的移动速度是同一条曲线,肉眼分不出是谁在动。 */
  function freezeCurtain(geom) {
    var outer = host();
    var save = {
      wPos: wrap.style.position, wTop: wrap.style.top, wLeft: wrap.style.left, wTrans: wrap.style.transition,
      wWidth: wrap.style.width, wHeight: wrap.style.height, wZ: wrap.style.zIndex, wBox: wrap.style.boxSizing,
      wOF: wrap.style.overflow, wML: wrap.style.marginLeft,
      oHeight: outer.style.height, oBox: outer.style.boxSizing, oTrans: outer.style.transition,
      outer: outer
    };
    /* ⚠️ 一律用 offsetTop/offsetWidth 这类【布局值】,绝不能用 getBoundingClientRect()。
       section 版的 .diy-stage 上有 transform: scale(0.85),rect 是缩放【之后】的屏幕值,
       拿它去设 width/height/top 这些布局属性会整体差 1/0.85 倍 —— 实测幕布被压到 907px,
       内部四列当场重新排版(视觉上字突然变大)。*/
    /* 冻结前先把幕布自己的 height 过渡关掉。
       前面那几次「假开合」测量会留下一条在途的 height 过渡,不关的话我们钉的固定值
       会被当成新目标继续过渡过去 —— 实测冻结后高度仍从 718 一路滑到 660,冻了个寂寞。*/
    wrap.style.transition = 'none';
    /* stage 的 position:relative 与横幅的 relative+z-index:2 已改为 CSS 永久生效(第 47 轮),
       这里不再动态加减 —— 提交帧不碰层叠关系,是收尾闪一帧的根治之一。 */
    // 先钉外壳高度,否则幕布脱离文档流后外壳会塌成一条带子,背景渐变跟着缩掉
    outer.style.boxSizing = 'border-box';
    outer.style.height = ((geom && geom.outerH) || outer.offsetHeight) + 'px';
    /* 有 geom 就用【展开终态】的几何(展开方向必须这样:起点帧时横幅/内边距都还在过渡中途,
       现场量到的没有一个是终值,照着量会在收尾帧差出几十 px —— 就是「最后动一下」)。
       没有 geom 就用现场值(收起方向:模块本来就已经稳定在展开终态)。*/
    var ot = geom ? geom.top    : wrap.offsetTop;      // 必须在 stage 变成定位元素之后再读
    var ol = geom ? geom.left   : wrap.offsetLeft;
    var ow = geom ? geom.width  : wrap.offsetWidth;
    var ohh = geom ? geom.height : wrap.offsetHeight;
    wrap.style.boxSizing = 'border-box';
    wrap.style.overflow = 'hidden';                    // 冻结期间必须裁切,否则脱流后内容会溢出盖到下方内容上
    wrap.style.position = 'absolute';
    wrap.style.top    = ot + 'px';
    /* 🔴 水平方向钉【中心】,不钉左边(第 50 轮,用户 2026-07-31 宽屏截图):
       宽屏上 stage 宽度在开合中会动画(展开 1560 ↔ 收起全出血),1280 窄屏两态同宽测不出。
       钉死 left 的话,幕布会跟着 stage 左缘整体左移 —— 左边贴死、多出来的宽度全堆右边,
       就是用户圈的「只有右边在增加空间」。
       改钉中心:left:50%(以 stage 宽度为基准,随宽度动画走)+ 负半宽外边距 →
       幕布中心恒等于 stage 中心(= 视口中心,margin auto 居中不动)→
       幕布视觉上纹丝不动,带子向两侧对称变宽。ol 仍保留给垂直/回退语义。 */
    wrap.style.left = '50%';
    wrap.style.marginLeft = -(ow / 2) + 'px';
    wrap.style.width  = ow + 'px';
    wrap.style.height = ohh + 'px';
    void ol;                                           // 中心钉法后水平不再用 ol,保留变量避免歧义
    /* 横幅要盖在幕布之上:幕布已经钉在展开终位,而横幅还在从「全宽带子」缩成「内嵌卡片」,
       不抬 z-index 的话幕布会把横幅还没缩完的那部分压住露馅。
       抬上去之后,横幅收缩的过程正好【逐渐让出】幕布顶部 —— 观感就是内容从横幅下面长出来。
       (第 47 轮起 relative + z-index:2 由 CSS 永久生效,这里不再动态加减 ——
        解冻帧还原 z-index 会触发横幅子树重新分层,正是收尾闪一帧的成因之一) */
    void wrap.offsetHeight;                            // 让固定值立刻落地,再把过渡还回去
    wrap.style.transition = save.wTrans;
    return save;
  }
  function thawCurtain(save) {
    if (!save) return;
    /* 解冻这一帧必须【关掉幕布自己的 height 过渡】。
       解冻时 diy-expanded 早已摘掉,CSS 说 height:0,若过渡还在,幕布会在动画结束【之后】
       再花 0.5 秒慢慢缩到 0 —— 那 0.5 秒里文档高一路在变,等于把原来的病根挪到了收尾之后
       (实测尾巴 450ms,下方内容跟着来回动)。设 none → 强制回流 → 再还原,一帧内落地。*/
    wrap.style.transition = 'none';
    wrap.style.position = save.wPos; wrap.style.top = save.wTop; wrap.style.left = save.wLeft;
    wrap.style.marginLeft = save.wML;
    wrap.style.width = save.wWidth; wrap.style.height = save.wHeight; wrap.style.zIndex = save.wZ;
    wrap.style.boxSizing = save.wBox; wrap.style.overflow = save.wOF;
    save.outer.style.height = save.oHeight; save.outer.style.boxSizing = save.oBox;
    save.outer.style.transition = save.oTrans;
    void wrap.offsetHeight;                            // 让 height:0 在这一帧就落地
    wrap.style.transition = save.wTrans;
  }

  /* 提交帧只还原【几何】(transform/transition 必须与解锁高度同帧原子抵消);
     will-change 的清理 = 拆合成层 = 重新光栅,不属于几何,挪到安静时刻(见 scheduleTeardown)。

     ✅ 第 61 轮(2026-08-02)—— 补上第 47 轮"延迟拆层"漏掉的最后一件事。
     取证(用户 00:11 录屏,25fps 逐帧 + 横幅流光带 p95 饱和度序列):
       收起①  f28 起 → **f33 闪** → f34 稳定
       收起②  f116 起 → **f119 闪** → f120 稳定
     两次都精确落在【动画的最后一帧 = 本函数所在的提交帧】,而且"消失的东西"每次不同:
       f119 高清裁剪:流光画布 / Logo / "Design Your Rainbow" / "build your own" / 箭头 全没,
                     但 .dhb-glow-bg 渐变、.dhb-glass、.dhb-btn 的圆角底框【都在】,图片墙完好;
       f033        :流光没了 + Instagram 图片墙前两张变白框,横幅文字反而还在。
     同一帧、随机的受害者、丢的全是"需要从零光栅化的内容"(画布纹理 / 字形 / 解码图),
     留下的全是合成器能廉价画出的纯 CSS 框底 —— 这是**光栅饥饿**,
     不是某个 CSS 属性算得慢(第 55~60 轮全在错误方向上:玻璃 / 图层预热 / WebGL 缓冲 / 横幅宽度)。

     谁在提交帧制造了这笔重活:就是本函数原来那句 `transform = o.tr || ''` ——
     把下方每个兄弟 section 的 translate3d 整个删掉 = 合成层当场销毁 =
     Shop the Look 那 39 张图必须在这一帧重新光栅化进父层。

     修法:提交帧只把位移归零到【等价的恒等变换】translate3d(0,0,0) —— 几何与原来那句
     完全一致(动画终点本来就是 0 位移),但合成层【继续活着】,一个像素都不用重画。
     真正的删除挪到 600ms 后的安静时刻(runTeardown),那时页面静止,合成器可以等纹理备齐再换帧。
     ⚠️ 不加 will-change:translate3d 本身就保住层了,加了反而多占显存(见 flipMove 的实测注释)。
     🔄 关掉对比:网址加 &nokeep=1 */
  function flipRestore(list) {
    list.forEach(function (o) {
      if (NO_KEEP_LAYER) { o.el.style.transition = o.tn || ''; o.el.style.transform = o.tr || ''; return; }
      o.el.style.transition = 'none';
      o.el.style.transform  = 'translate3d(0,0,0)';
    });
  }

  /* 🧊 延迟拆层(第 47 轮,收尾闪一帧根治之二):
     动画收尾的提交帧原来同时干三件事:兄弟块 will-change 清空、stage 大合成层拆掉(摘
     .diy-animating)、幕布/外壳还原 —— 图层树大洗牌 + 全页重光栅挤在出帧截止时间内,
     高负载机器上纹理备不齐就出帧,横幅子树(WebGL 画布/毛玻璃/渐变文字)空一帧 = 闪。
     现在拆层推迟到结束 600ms 后:那时页面完全静止,合成器可以等新纹理备齐再换帧,
     拆层前后像素一模一样,不可能闪。新动画若在 600ms 内开始,先同步兑现掉
     (remove 后马上会重新 add,同帧内类名净变化为零,不产生任何重绘)。 */
  var pendingTeardown = null;
  function runTeardown() {
    if (!pendingTeardown) return;
    var t = pendingTeardown; pendingTeardown = null;
    clearTimeout(t.tm);
    /* 第 61 轮:兄弟块的 transform / transition 也在这里才真正删掉(见 flipRestore 注释)。
       此刻页面完全静止,translate3d(0,0,0) → 无 transform 的像素结果一模一样,
       合成器可以从容拆层、等纹理备齐再换帧,不可能闪。 */
    t.sibs.forEach(function (o) {
      o.el.style.willChange = o.wc || '';
      if (!NO_KEEP_LAYER) { o.el.style.transform = o.tr || ''; o.el.style.transition = o.tn || ''; }
    });
    if (t.bnrEl) t.bnrEl.style.width = t.bnrW0 || '';   // 第 60 轮:还原横幅冻结的 inline width
    /* 第 63 轮:交还 width 给 CSS。此刻动画早已跑完,inline px 与 CSS 算出来的是同一个值,视觉零变化。
       放在提交帧还原会当场触发一次整块重排 —— 正是第 61/62 轮要消灭的东西。 */
    stage.style.width = t.stW0 || '';
    stage.classList.remove('diy-animating');
    stage.classList.remove('diy-collapsing');   // 第 52 轮:收起的放慢类也在安静时刻才摘(见 collapseFlip.commit 注释)
    /* 第 51 轮:清理展开镜像留下的 mirror-frame inline 样式(终值与默认完全一致,视觉零变化;
       此刻过渡早已跑完 —— 展开揭开 500ms + 提交后 600ms 才到这里)。*/
    var mf = wrap.querySelector('.mirror-frame');
    if (mf) { mf.style.transition = ''; mf.style.opacity = ''; mf.style.transform = ''; }
  }
  function scheduleTeardown(sibs, bnrEl, bnrW0, stW0) {
    /* 第 60 轮:横幅冻结的 inline width 也在这个「安静时刻」还原 ——
       此刻动画早已跑完,stage 已在目标宽度,横幅回到 width:100% 得到的是同一个值,视觉零变化。
       放在提交帧还原会当场触发一次横幅子树重排,正是本轮要消灭的东西。 */
    /* 第 63 轮·④:拆层延迟做成可调(&td=N,单位 ms)。
       这 600ms 是第 47 轮为了防「收尾闪一帧」加的,但第 61/62 轮已经从根上修掉了收尾帧与起点帧,
       它可能已经是历史包袱 —— 而且它正是「收起后两边竖线还赖一小会」的头号嫌疑:
       拆层前屏幕上显示的是【旧贴图】,拆层那一刻才按新几何重画,残影才消失。
       用 &td=200 / &td=0 实测,不闪就可以调短或去掉。 */
    pendingTeardown = { sibs: sibs, bnrEl: bnrEl, bnrW0: bnrW0, stW0: stW0,
                        tm: setTimeout(runTeardown, TEARDOWN_MS) };
  }

  /* 🛡️ 主题头部守卫(第 48 轮,守卫 + 取证一体):
     18:10 视频逐帧铁证:收尾闪帧 = 主题吸顶头部整条消失一帧 + 头部以下内容干净下移 ~36px,
     两者被同一件事统一解释 —— `.header-scrolled` 类被瞬时摘除:
       ① 主题 CSS `.header-scrolled .header { position: fixed }`,类一摘,里层头部失去 fixed
          → 瞬移回页顶自然流位置(早滚出视口)= 整条消失 ✓
       ② 类一摘头部外壳 padding 从 0.75 倍回到 1 倍 → 外壳变高 → 下方全部内容下移 ✓
     主题里摘这个类的代码只有一处:StickyHeader 的节流滚动回调,条件是
     「scrollY < 页顶阈值(≈150px)」—— 正常只该在滚回页首时发生;闪的时候页面在中段,
     说明某个瞬间 scrollY 被读出了异常低值(收尾提交帧文档骤矮 + 滚动夹取的竞态窗口)。
     守卫:MutationObserver 的回调在【绘制之前】执行 —— 类若在 scrollY 仍远高于阈值(>400,
     任何主题配置下合法阈值都到不了这个数)时被摘,当帧原样加回,错误状态永远上不了屏幕。
     同时计数到 window.__diyHeaderGuardHits + console.warn —— 命中即证实机制;
     若守卫零命中而闪依旧,则铁证排除类机制,下一步走头部图层固化路线。
     独立版页面没有 .header-section,整段自动不生效。 */
  (function () {
    var hs = document.querySelector('.header-section');
    if (!hs || !window.MutationObserver) return;
    window.__diyHeaderGuardHits = 0;
    /* 合法摘类界限:主题公式 = 头部页面绝对位置 + 头部高 ± 滞回 ≈ ≤170px。取常量 280:
       稳压一切合法阈值,又低于任何「模块在视口内」的滚动位置。
       ⚠️ 不能用 hs.offsetTop 动态算 —— sticky 元素吸附时 offsetTop 返回吸附后位置(随滚动涨),
       界限会永远追着 scrollY 跑,守卫形同虚设(单元测试抓出来的坑)。 */
    new MutationObserver(function () {
      if (!hs.classList.contains('header-scrolled') && window.scrollY > 280) {
        hs.classList.add('header-scrolled');   // 只守核心类;header-nav-scrolled 仅影响导航样式微调,误摘无闪感
        window.__diyHeaderGuardHits++;
        try { console.warn('[diy] header-scrolled 在 scrollY=' + Math.round(window.scrollY) + ' 被摘除,已当帧恢复(累计 ' + window.__diyHeaderGuardHits + ')'); } catch (e) {}
      }
    }).observe(hs, { attributes: true, attributeFilter: ['class'] });
  })();

  /* 一次 FLIP 开合。核心只有一句:
       **幕布的高度动画原封不动照跑,但 section 外壳的高度被钉死,
         于是这个高度变化传不到页面下方去** —— 下方内容改由 transform 搬运(纯合成层)。
     所以视觉和旧实现【完全一致】(用户原本就认可那个动效),只是把
     「每帧整页重排重绘」换成了「每帧只重排 section 内部 + GPU 搬下方内容」。

     ⛔ 试过、失败、别再走的弯路:用 clip-path 裁切来做「模块可见高度」的过渡。
        Chrome 对 clip-path 动画多数情况【不走 GPU】,裁到 section 上等于把整个模块
        (含 WebGL 画布 + 四列配置器)拖进逐帧重绘,真机反馈「闪得更严重」。 */
  function flipRun(opts) {
    busy = true;
    runTeardown();               // 上一次开合的延迟拆层若还没执行,先同步兑现(见 scheduleTeardown 注释)
    var dur = opts.dur;
    var sibs = flipCollect();
    var sec = host().closest('.shopify-section') || host();
    var secH0 = sec.style.height, secB0 = sec.style.boxSizing;
    /* 关掉浏览器的滚动锚定(scroll anchoring)。它会在「视口内某个锚点上方的内容尺寸变了」时
       偷偷调 scrollTop 帮你稳住画面 —— 平时是好事,但这里模块内部一直在变形,
       它会一路把页面拉走。文档高由我们自己钉死,不需要它插手。*/
    var anchorEl = document.documentElement, anchor0 = anchorEl.style.overflowAnchor;
    anchorEl.style.overflowAnchor = 'none';
    stage.classList.add('diy-animating');
    window.__diyFxPause = true;

    /* ✅ 第 63 轮·① 修「展开时宽度一下子跳到位」(2026-08-02,用户反馈 + 逐帧实测)。
       实测(真机 rAF 采样):点击那一帧 stage 的屏上宽度 1728 → 1560 一帧到位,
       而同一条 transition 里的 transform(scale 1→.85)却正常跑满 500ms。

       病根:两个状态的 width 值【类型不同,浏览器插值不了】——
         折叠态 `:root:root .diy-stage:not(.diy-expanded) { width: 100% }`  ← 百分比
         展开态 `.diy-stage { width: min(1560px, calc(100vw - 24px)) }`      ← 绝对长度
       百分比在计算值阶段不解析成 px,与 min()/calc() 之间没有可插值的公共表示 → 直接跳变。
       transform 没这个问题,所以只有它在动 —— 现象与实测完全对得上。

       修法:动画期间用 inline px 接管 width,起点写【当前 px】、播放帧写【目标 px】,
       px→px 一定能插值。终态由 runTeardown 清掉 inline,交还 CSS,视觉零变化。
       ⚠️ 用 offsetWidth 而不是 getBoundingClientRect().width —— section 版 .diy-stage 上有
       scale(.85),rect 是缩放【之后】的屏幕值,拿它去写 width 会整体差 1/0.85 倍。
       🔄 关掉对比:网址加 &nowa=1 */
    var stW0 = stage.style.width;
    if (!NO_WIDTH_ANIM) stage.style.width = stage.offsetWidth + 'px';

    /* ❄️ 第 60 轮·横幅冻结(方案三) —— 补上现有架构里的一个明显遗漏。
       收起时幕布(配置器主体)早就被 freezeCurtain 冻住了(position:absolute + 固定 px),
       **横幅却没有**:`.diy-stage > .diy-hero-banner { width: 100% }` 让它每帧跟着 stage 宽度变,
       于是它内部的 .dhb-card / .dhb-glass / .dhb-btn(width: min(270px, 82%) 是父级百分比)
       以及按钮里的两行文字**每帧重新排版、重新折行**。闪白帧里消失的正是这棵子树
       (流光画布 + 玻璃 + 按钮文字一起没,连文字都没了 ⇒ 是重排重绘,不是图层问题)。

       用户 22:28 那段「同一次录制内先中文后英文」的对照是最直接的证据:
       中文(浏览器整页翻译)5 次收起流光强度全程平滑单调下降、无凹陷;
       英文原文第 7 次收起出现 0.23 → **0.06** → 0.12 的单帧凹陷(帧 484 目检确认是真闪)。
       英文要跑断词算法、单词长、字符数多约 40%,每帧折行开销比中文大一个量级 ——
       **直接证明瓶颈是「宽度动画导致的每帧文字重排」**。

       修法:动画期间把横幅宽度钉成【目标态的 px 值】,它内部就不再有任何尺寸驱动的重排。
       stage 自身的宽度过渡保留(观感不变),只是横幅提前到位。
       🔄 关掉对比:网址加 &nobf=1 */
    var bnrEl = stage.querySelector('.diy-hero-banner');
    var bnrW0 = bnrEl ? bnrEl.style.width : null;
    if (bnrEl && !NO_BANNER_FREEZE) {
      var tw = opts.opening ? opts.bannerOpenW : opts.bannerClosedW;
      if (tw > 0) bnrEl.style.width = tw + 'px';
    }

    // ── 起点帧(无过渡):锁高度 + 摆好下方内容的位移起点,肉眼零变化
    /* 🔒 钉死的必须是 .shopify-section —— 这一层才直接决定文档高(不是 .diy-outer)。
       钉的值是【展开态高度】,展开时相当于先把位置腾出来、再用 transform 把下方内容拉回原位。
       box-sizing 写成 border-box,保证写进去的数字就是最终占位高度。*/
    /* 顺序很重要(2026-07-31 用户反馈「最后还会动一下」后重排):
         ① start() 先把模块切到目标形态,并把所有【会让模块高度再变一次】的活当场干完
            (展开时的画廊居中就是典型:旧代码放在动画结束后做,模块高度再变几十 px,
             用户看到的就是「延展到最后突然动一下」)。
         ② 这时候现场量 section 的真实高度并锁死 —— 用现场值而不是预估值,
            后面就不会再有对不上的差额需要在收尾帧补。
         ③ 位移量也用现场值算。
         ④ 最后才冻结幕布,冻的是【已经稳定下来】的几何。 */
    opts.start();
    void wrap.offsetHeight;
    /* section 锁定值同样要用【展开终态】的高度(flipMeasure 冻结块量的),
       不能用起点帧现场量的 —— 起点帧横幅还没缩完,现场值会大 58px,
       收尾解锁时文档高就得再跳这 58px。*/
    var secLock = opts.secOpen != null ? opts.secOpen : sec.offsetHeight;
    var delta   = Math.max(0, secLock - opts.secClosed);   // 文档在这次开合里的真实变化量
    sec.style.boxSizing = 'border-box';
    sec.style.height = secLock + 'px';
    flipMove(sibs, opts.opening ? -delta : 0, 0);

    /* ✅ 第 65 轮·遮罩抽屉(方案 A)的起点帧 —— 与 flipMove 紧挨着写,不是巧合:
       抽屉用的 delta 就是下方内容用的**同一个 delta**,时长/缓动也取自同一组 opts,
       所以两者是【结构上同步】,不是「碰巧调成一样的数值」。
       这正是前几轮「不丝滑」的根 —— 以前内容缩淡走自己的 .55s 曲线,与位移叠加出速度拐点。

       几何(真机实测值,收起方向):槽口固定在 top=278,抽屉高 677,遮盖线从 1008 上推到 348。
       抽屉底边与遮盖线之间本来就有约 53px 的常量间距(stage 自身的下留白),
       两者同速上移 → 这个间距保持恒定,**不会新开缝**;
       抽屉顶部缩进槽口(overflow:hidden)被裁掉,残留在槽口上沿的那一小段由横幅(z-index:2)盖住,
       实测在动画约 93% 处就已完全隐没。
       🔄 关掉对比:网址加 &nodrawer=1 */
    var mfEl = wrap.querySelector('.mirror-frame');
    if (mfEl && !NO_DRAWER) {
      mfEl.style.transition = 'none';
      mfEl.style.transform  = 'translate3d(0,' + (opts.opening ? -delta : 0) + 'px,0)';
    }

    void wrap.offsetHeight;                            // 强制起点落地,否则下一步会被合并掉
    var frozen = null;                                 // 第 62 轮:冻结推迟一帧执行(见下方 doFreeze)

    /* ── 播放帧。冻结模式下可以先空转几帧(opts.settle):
       展开时配置器是【第一次】排版+绘制(81 张图 + 16 处毛玻璃 + WebGL + GSAP),
       这笔开销必须在它还被下方内容完全盖住的时候付掉。
       付完再开始揭开,揭开过程就只剩纯合成层位移。
       不空转的话,这笔开销会摊在动画中间 —— 真机录屏拍到整屏全白 2 帧(2026-07-31)。*/
    var startPlay = function () {
      opts.play();
      /* 第 63 轮:宽度的目标端点,与下方内容位移、内容缩放同帧启动、同曲线同时长
         (收起时 .diy-collapsing 把 transition-duration 抬到 .8s,与 dur 一致)*/
      if (!NO_WIDTH_ANIM) {
        var tgtW = opts.opening ? opts.stageOpenW : opts.stageClosedW;
        if (tgtW > 0) stage.style.width = tgtW + 'px';
      }
      /* 外壳(.diy-outer)的高度要【平滑过渡】,不能一直钉着最后一帧硬跳。
         原因:模块底色是 4 层 radial-gradient,位置全是百分比 —— 绿色那团固定在
         「模块高度的 90%」处。模块 902px 高时它在第 812px(远在带子下方),
         缩到 242px 后跑到第 218px(正好钻进带子里)→ 带子右侧从粉变绿。
         高度钉死 = 渐变一直按 902px 渲染,最后一帧才按 242px 重渲染 → 用户看到的「跳色」。
         平滑动它只会每帧重画这一块渐变底(一个元素的背景),
         配置器仍然是绝对定位冻结的 —— 防闪机制完全不受影响。*/
      if (frozen && opts.outerTo != null) {
        var oEl = frozen.outer;
        // 保留它原有的 padding 过渡,只追加 height —— 直接覆盖 transition 会把 padding 动画一起干掉
        var keep = getComputedStyle(oEl).transition;
        oEl.style.transition = 'height ' + dur + 'ms ' + (opts.ease || 'var(--diy-open-ease, cubic-bezier(.4, 0, .2, 1))')
          + (keep && keep !== 'all 0s ease 0s' ? ', ' + keep : '');
        oEl.style.height = opts.outerTo + 'px';
      }
      flipMove(sibs, opts.opening ? 0 : -delta, dur, opts.ease);
      /* 第 65 轮·遮罩抽屉的播放帧:与上面那行【共用 delta / dur / ease】,同帧启动。
         抽屉滑出/缩回的速度恒等于下方内容让开/接管的速度 —— 只有一条曲线,不可能有速度拐点。 */
      if (mfEl && !NO_DRAWER) {
        mfEl.style.transition = 'transform ' + dur + 'ms '
          + (opts.ease || 'var(--diy-open-ease, cubic-bezier(.4, 0, .2, 1))');
        mfEl.style.transform  = 'translate3d(0,' + (opts.opening ? 0 : -delta) + 'px,0)';
      }
      if (opts.duringPlay) opts.duringPlay(delta);
      /* ── 收尾帧:等幕布的 height 过渡真正结束(afterAnim 监听 transitionend,带超时兜底)。
         这里【不能掐表】:机器负载高时过渡实际耗时会明显超过声明值,按表收尾会把动画
         拦腰砍断,表现就是最后猛地跳一大截。
         解锁高度 + 清 transform 必须在同一帧内落地,两者精确抵消 → 肉眼零跳变。*/
      /* 冻结模式下幕布高度不再过渡,它的 transitionend 永远不会来 ——
         改成等下方内容那条 transform 过渡结束(冻结时它是唯一在动的东西)。*/
      var waitFor = opts.freeze
        ? function (cb) {
            var fired = false, tgt = sibs.length ? sibs[0].el : null;
            function fin() { if (fired) return; fired = true; clearTimeout(tm);
              if (tgt) tgt.removeEventListener('transitionend', on); cb(); }
            function on(e) { if (e.propertyName === 'transform') fin(); }
            if (tgt) tgt.addEventListener('transitionend', on);
            var tm = setTimeout(fin, dur + 250);          // 兜底:没有兄弟块 / 事件丢失
          }
        : function (cb) { afterAnim(cb, dur); };
      waitFor(function () {
        /* ⚠️ 这里【不要】给 stage 挂「关掉所有过渡」的类。
           收尾是由幕布的 height 过渡结束触发的,但 .diy-outer 的 padding 过渡可能还差一点没跑完;
           这时候一刀切断,padding 会瞬间跳到终值 —— 实测最后猛跳 108px。
           解锁高度和清 transform 本身都没有过渡,天然就是同帧原子生效,不需要额外关。*/
        thawCurtain(frozen);
        sec.style.height = secH0; sec.style.boxSizing = secB0;
        flipRestore(sibs);
        opts.commit();
        void stage.offsetHeight;
        /* 同任务内自行完成滚动夹取(第 48 轮):文档刚在这一帧变矮,若 scrollTop 超出新极限,
           浏览器会在稍后自行夹取并派发 scroll 事件 —— 主题吸顶头部的滚动回调恰在此竞态窗口里
           读 scrollY。抢先在同一帧写好合法值,提交携带一致的「布局 + 滚动」,不留事后夹取。 */
        var seEl = document.scrollingElement || document.documentElement;
        var maxY = Math.max(0, seEl.scrollHeight - window.innerHeight);
        if (seEl.scrollTop > maxY) seEl.scrollTop = maxY;
        requestAnimationFrame(function () {
          /* 这里不再摘 .diy-animating / 清 will-change —— 拆层挪到 600ms 后的
             安静时刻(scheduleTeardown),提交帧只做几何,收尾不再闪一帧。 */
          scheduleTeardown(sibs, bnrEl, bnrW0, stW0);   // 第 60/63 轮:横幅与 stage 的 inline 宽度也在安静时刻还原
          anchorEl.style.overflowAnchor = anchor0;
          window.__diyFxPause = false;
          busy = false;
          /* 再让一帧才做收尾校正:文档高刚在上一帧一次性换掉,浏览器对 scrollTop 的夹取
             还没落地,这一帧量到的 rect 是夹取前的,会误判「带子被顶出视口」多滚一段。*/
          if (opts.done) requestAnimationFrame(function () { opts.done(); });
        });
      });
    };
    /* ✅ 第 62 轮(2026-08-02)· 起点帧拆分 —— 与第 61 轮是同一个病的镜像另一端。

       取证(用户 00:35 录屏,18s / 450 帧 / 5 次收起 + 4 次展开,逐帧 p95 饱和度非单调下陷):
         收起@帧65  → 帧60、62 闪   ← 起点
         收起@帧160 → **帧154 降到 74%**、帧156 闪   ← 起点
         收起@帧251 → 干净
         收起@帧338 → 帧335 降到 77%   ← 起点
         收起@帧423 → 帧425 降到 80%   ← 收尾
       上一段(00:11)录屏两次闪【全在收尾】,本段 4 次里 3 次跑到了【起点】——
       第 61 轮修的正是收尾帧,这个位移说明改动生效,同时暴露出起点帧有同样的病。
       帧 154 目检:**整个配置器主体全空**,只剩渐变底和横幅按钮(比任何一帧都严重)。

       起点帧原来在【点击那一帧】一次干完三件重活:
         ① opts.start()      —— 收起时摘 .diy-open-done → 幕布 overflow: visible→hidden,
                                整棵配置器子树重新裁切重绘
         ② flipMove(sibs,…)  —— 给下方每个 section 写 translate3d(hover 没提上层时要现场建层)
         ③ freezeCurtain()   —— 幕布 position: static→absolute + 固定尺寸 + overflow:hidden,
                                再一次让 81 张图 + 16 处毛玻璃 + WebGL 整块失效
       外加两次 `void wrap.offsetHeight` 强制同步布局。一帧画不完 → 交白。

       修法:把 ③ 推迟一帧,再空转 settle 帧才 play。每帧只干原来 1/3 的活。
       ⚠️ 这两帧里【没有任何视觉变化】—— ① ② 之后的画面就是 FLIP 的「起点态」,
       ③ 按设计本来就是视觉零变化 —— 所以代价只是点击后晚约 2 帧(33ms)开始动,肉眼无感。
       🔄 关掉对比:网址加 &nosplit=1 */
    var settle = opts.settle || 0;
    var doFreeze = function () {
      frozen = opts.freeze ? freezeCurtain(opts.geom) : null;
      void wrap.offsetHeight;
      (function wait(n) {
        requestAnimationFrame(function () { n > 0 ? wait(n - 1) : startPlay(); });
      })(settle);
    };
    if (NO_SPLIT) { doFreeze(); }                      // 旧行为:冻结与起点同帧
    else requestAnimationFrame(doFreeze);              // 新行为:让浏览器先把 ①② 的失效画完
  }

  // 假开合一次量出真实几何。冻结过渡必须挂在 secEl 上 —— 会跟着变高的 .diy-outer
  // 是 .diy-stage 的【祖先】,挂在 stage 上冻不到它(这个坑犯过两次)。
  function flipMeasure() {
    var secEl = host().closest('.shopify-section') || host();
    /* 第 53 轮(测量曲线时抓到的老 bug):页面接近底部时,下面的假开合会让文档瞬时变矮,
       浏览器在同任务的强制布局里就把 scrollTop 夹掉(实测瞬跳 660px),
       且高度恢复后滚动不会自己回来 —— 收起动画还没开始画面就猛跳一下。
       测量前记住、测量后同任务恢复(绘制前完成,肉眼不可见),把平滑下降交还给 animScroll。 */
    /* ⚡ 第 57 轮:所有「无条件的写」提到最前面统一做完,后面的测量段才能读成整批。
       position 兜底原本夹在 outerOpen 和 geom 两组读中间 —— 首次真写入时会把读批次劈开,
       多逼出一次全子树样式重算。放这里等价(geom 读之前它一定已生效),但不再打断读批次。 */
    if (getComputedStyle(stage).position === 'static') stage.style.position = 'relative';
    var syKeep = scroller.scrollTop;
    var wasOpen = stage.classList.contains('diy-expanded');
    var hadDone = stage.classList.contains('diy-open-done');
    var restore = function () {
      stage.classList.remove('diy-expanded', 'diy-open-done');
      if (wasOpen) stage.classList.add('diy-expanded');
      if (hadDone) stage.classList.add('diy-open-done');
    };

    /* ① 幕布自然高度(仅作参考,真正拿来用的是下面冻结块里的终值)。
       diy-open-done 让幕布 height:auto,量到的就是内容自然高;
       但一旦挂上 diy-measure 把全子树过渡冻死,内部若干元素会瞬间跳到各自的终值,
       排版随之变化,量出来的幕布高会偏小(实测 518 而真值 610)。
       后果:幕布只涨到 518 就「过渡完成」,剩下 92px 全堆在收尾那一帧突现。 */
    stage.classList.add('diy-expanded', 'diy-open-done');
    var openH = host().getBoundingClientRect().height;
    /* ⚠️ 必须用 offsetHeight(布局值)。section 版 .diy-stage 上有 transform: scale(0.85),
       rect 量出来是缩放【之后】的屏幕值,而 --diy-open-h 是拿来当【布局高度】用的 ——
       用 rect 会让幕布目标高整整短 15%(实测 610 vs 真值 718),
       动画跑到 610 就「结束」,末尾交回 height:auto 时再猛跳 108px。这是个一直存在的老 bug。*/
    var curtainH = wrap.offsetHeight;
    restore();
    void host().offsetHeight;

    /* ② section 层的高度差 —— 【必须冻过渡】,否则量到的是过渡起点而不是终点。
       冻结要挂在 secEl 上:会跟着变高的 .diy-outer 是 .diy-stage 的【祖先】,
       挂在 stage 上冻不到它(这个坑犯过两次)。 */
    secEl.classList.add('diy-measure');
    stage.classList.add('diy-expanded', 'diy-open-done');
    /* 画廊居中必须【在这里】做完:它依赖实测舞台宽度,做完后模块高度还会再变几十 px。
       旧代码把它放在动画结束后的 diy:relayout 里 → 「延展到最后突然动一下」(用户 2026-07-31)。
       放进冻结块的好处是:此刻所有过渡都被冻住、模块处于展开【终态】,
       量出来的每个数都是终值,后面照着这些数钉几何就不会有对不上的差额。*/
    try { if (typeof exploreCenter === 'function') exploreCenter(); } catch (e) {}
    /* ⚡ 第 57 轮:删掉原来这里的 `void wrap.offsetHeight` —— 紧接着的 getBoundingClientRect()
       本来就会强制刷新布局,那一行是白白多来一次【全子树样式重算】。
       trace 实测:点击处理器 51.3ms 里 UpdateLayoutTree 占 36.1ms(12 次,每次约 3ms),
       就是被这类「写→读→写→读」穿插逼出来的。 */
    var secOpen = secEl.getBoundingClientRect().height;
    var outerOpen = host().offsetHeight;               // 展开态外壳高度(此刻 padding 已跳到终值)
    /* 第 60 轮:顺手量横幅在【展开终态】的宽度。这两行读操作落在已有的读批次里,不额外触发重排。
       用途见 flipRun 的「横幅冻结」注释。 */
    var _bnr = stage.querySelector('.diy-hero-banner');
    var bannerOpenW = _bnr ? _bnr.offsetWidth : 0;
    var stageOpenW  = stage.offsetWidth;               // 第 63 轮:stage 在【展开终态】的布局宽度(不含 scale)
    /* ⚡ 第 57 轮:position 兜底原本夹在两组读之间,一旦真写入就把读批次劈成两半、多一次重算。
       已移到函数最开头(所有测量之前)统一写完,这里只剩纯读。 */
    var geom = { top: wrap.offsetTop, left: wrap.offsetLeft,     // 展开终态下幕布的几何
                 width: wrap.offsetWidth, height: wrap.offsetHeight, outerH: outerOpen };
    stage.classList.remove('diy-expanded', 'diy-open-done');
    stage.style.removeProperty('--diy-open-h');
    var closedH = host().offsetHeight;                 // 布局值,不受 .diy-stage 的 scale 影响
    var bannerClosedW = _bnr ? _bnr.offsetWidth : 0;   // 第 60 轮:横幅在【折叠终态】的宽度(同上,读批次内)
    var stageClosedW  = stage.offsetWidth;             // 第 63 轮:stage 在【折叠终态】的布局宽度
    var secClosed = secEl.getBoundingClientRect().height;
    restore();
    void host().offsetHeight;
    secEl.classList.remove('diy-measure');
    if (scroller.scrollTop !== syKeep) scroller.scrollTop = syKeep;   // 还原被测量夹掉的滚动位置(见函数头注释)
    // 量到了展开态高度就顺手刷新底色画布尺寸(outerOpen 是冻结块里量的终值,比 openH 准)
    if (BGFIX && outerOpen > 0) host().style.setProperty('--diy-bg-h', Math.round(outerOpen) + 'px');

    return { secEl: secEl, openH: openH, closedH: closedH, curtainH: curtainH,
             outerOpen: outerOpen, geom: geom,
             bannerOpenW: bannerOpenW, bannerClosedW: bannerClosedW,   // 第 60 轮:横幅冻结用
             stageOpenW: stageOpenW, stageClosedW: stageClosedW,       // 第 63 轮:宽度过渡的 px 端点
             secOpen: secOpen, secClosed: secClosed,
             delta: Math.max(0, secOpen - secClosed) };   // 文档将要长高/矮掉多少
  }

  /* ⚡ 第 57 轮:把 flipMeasure 这 36ms 从【点击那一帧】挪到【hover 时】。

     依据(真机 CDP trace,首次实证而非推断):收起 900ms 窗口里 GPU 光栅化只占 16.5ms,
     瓶颈全在主线程 —— 点击处理器本身 51.3ms(隔离无扩展环境),其中 UpdateLayoutTree
     样式重算 12 次共 36.1ms(占 70%),Layout 仅 2.75ms。根因是 flipMeasure 要在两个状态
     之间来回切 4 次量几何,每次「改 class → 读几何」都强制把整个 DIY 子树
     (81 张图 + 16 处玻璃)样式重算一遍。

     这笔活本身省不掉(几何必须实测,写死会退回到「收尾突然跳一下」那一类老 bug),
     但【时机】可以挪:hover 到点击之间通常有几百 ms,那时主线程空闲、没有动画在跑,
     36ms 花在那里用户完全无感;而花在点击那一帧,就是 2-3 帧的直接卡顿。

     缓存只在【完全等价】时才用,任一条件不符就当场重量(宁可慢也不能用错几何):
       · 3 秒内测的(超时可能页面已变)
       · 视口宽高未变(布局分支可能不同)
       · 展开/收起状态与测量时一致(量的是哪一态必须对得上)
     且用完即弃(一次性),避免连续开合复用到过期几何。 */
  var measureCache = null;
  function warmMeasure() {
    if (!FLIP || busy) return;                       // 非 FLIP 路径不用;动画期间量了也是错的
    if (measureCache && performance.now() - measureCache.ts < 1000) return;   // 1s 内不重复量,防连续 hover
    try {
      var snapOpen = stage.classList.contains('diy-expanded');
      measureCache = { ts: performance.now(), vw: innerWidth, vh: innerHeight,
                       wasOpen: snapOpen, m: flipMeasure() };
    } catch (e) { measureCache = null; }
  }
  function takeMeasure() {
    var c = measureCache; measureCache = null;       // 一次性:取走即失效
    if (c && performance.now() - c.ts < 3000 &&
        c.vw === innerWidth && c.vh === innerHeight &&
        c.wasOpen === stage.classList.contains('diy-expanded')) return c.m;
    return flipMeasure();                            // 缓存不可信 → 当场重量(行为与第 56 轮完全一致)
  }

  function expandFlip() {
    warmAssets();
    var hr = host().getBoundingClientRect();
    var m  = takeMeasure();   // 第 57 轮:优先用 hover 时预热的测量结果(见 warmMeasure)
    btn.setAttribute('aria-expanded', 'true');
    flipRun({
      dur: 500,
      opening: true,
      secClosed: m.secClosed, secOpen: m.secOpen,
      bannerOpenW: m.bannerOpenW, bannerClosedW: m.bannerClosedW,   // 第 60 轮:横幅冻结目标宽度
      stageOpenW: m.stageOpenW, stageClosedW: m.stageClosedW,       // 第 63 轮:宽度过渡的 px 端点
      /* ❄️ 展开也冻结(真机录屏定罪:展开中途整屏全白 2 帧)。
         展开时配置器是【第一次】排版 + 绘制 —— 81 张图 + 16 处毛玻璃 + WebGL + GSAP。
         旧做法让幕布高度从 0 长到全高,这笔首次开销摊在动画中间,画不完就交白。
         新做法:起点帧直接铺到全高并冻住(此刻被下方内容完全盖住,看不见),
         空转几帧把账付掉,再开始揭开 —— 揭开过程零重排。
         这也解释了「有时刷新后就不闪」:图和图层已经热了,那笔账本来就不用付。*/
      freeze: true,
      settle: 3,
      geom: m.geom,                                      // 用展开终态的几何钉幕布,不用起点帧的中途值
      start: function () {
        /* 直接进入【最终形态】:diy-expanded + diy-open-done(幕布 height:auto)。
           关键在于 diy-open-done 也要现在就挂上 —— 否则幕布高度用的是点击那一刻量的
           m.curtainH,而收尾帧交回 height:auto 时拿到的是画廊居中【之后】的真实内容高,
           两者差 58px,就是用户说的「延展到最后突然动一下」(2026-07-31 实测)。
           现在起点和终点用的是同一个值,收尾帧清掉 inline 高度后几何完全不变。*/
        var t0 = wrap.style.transition;
        wrap.style.transition = 'none';                // 瞬间到位,不走过渡
        stage.classList.add('diy-expanded', 'diy-open-done');
        /* 第 65 轮:抽屉的起点/终点已改由 flipRun 统一驱动(与 flipMove 共用 delta/dur/ease),
           这里不再单独摆 mirror-frame —— 收起与展开走的是同一段代码,天然互为镜像,
           不会再出现「两个方向各调各的、参数对不上」的问题。
           只保留清掉历史遗留的 opacity(第 51~64 轮的淡入淡出已撤)。*/
        var mf = wrap.querySelector('.mirror-frame');
        if (mf) mf.style.removeProperty('opacity');
        void wrap.offsetHeight;
        wrap.style.transition = t0;
      },
      play:  function () {
        /* 幕布已到位,揭开交给下方内容的位移;内容整体从微缩+透明长到原样(第 51 轮) */
        /* 第 65 轮:抽屉滑出由 flipRun 的播放帧统一驱动,这里不再重复设置 */
      },
      duringPlay: function (delta) {
        // 落点用【现场几何】算,不用点击那一刻的预估值
        animScroll(wantedY(host().getBoundingClientRect().top + scroller.scrollTop, host().offsetHeight, delta), 500);
      },
      commit: function () { stage.style.removeProperty('--diy-open-h'); },   // diy-open-done 起点帧就挂好了
      done: function () {
        // ⛔ 这里不再 dispatch diy:relayout / recenter —— 那两件事已经在 start() 里做完了。
        //    留在这里就是用户说的「最后突然动一下」。
        setTimeout(function () {
          (window.requestIdleCallback || function (f) { return f(); })(hotAssets, { timeout: 2000 });
        }, 400);
        dropSiblingsLater(0);
      }
    });
  }

  function collapseFlip() {
    var m = takeMeasure();    // 第 57 轮:优先用 hover 时预热的测量结果(见 warmMeasure)
    btn.setAttribute('aria-expanded', 'false');
    flipRun({
      dur: 800,
      opening: false,
      secClosed: m.secClosed, secOpen: m.secOpen,
      bannerOpenW: m.bannerOpenW, bannerClosedW: m.bannerClosedW,   // 第 60 轮:横幅冻结目标宽度
      stageOpenW: m.stageOpenW, stageClosedW: m.stageClosedW,       // 第 63 轮:宽度过渡的 px 端点
      freeze: true,                                      // ❄️ 收起:整段动画冻结配置器,零重绘
      /* ⛔ 曾经在这里传 outerTo 让外壳高度平滑收缩(为了修「底色跳色」)——
         真机反馈「反而又闪了一点」,已回退。原因很直接:外壳一变高度,那 4 层
         radial-gradient 就得每帧重画一遍整条全宽底色,这正是本轮要消灭的逐帧重绘。
         底色跳色是另一个问题(渐变尺寸绑在模块高度上),用 &bgfix=1 那条路解。*/
      ease: 'cubic-bezier(.32, .72, 0, 1)',              // 第 53 轮:与 CSS .diy-collapsing 同一条丝滑 ease-out
      start: function () {
        setTargetH(m.curtainH);                          // 先把 auto 钉回像素值
        stage.classList.remove('diy-open-done');
        stage.classList.add('diy-collapsing');           // 收起放慢到 .8s(见 CSS)
      },
      play:  function () { stage.classList.remove('diy-expanded'); },
      duringPlay: function (delta) {
        // 文档矮下去之后浏览器最终会把 scrollTop 夹到哪,现场算,主动平滑滚过去
        var maxAfter = Math.max(0, scroller.scrollHeight - delta - window.innerHeight);
        var targetY  = Math.min(scroller.scrollTop, maxAfter);
        // 第 53 轮:滚动修正与主动画同曲线同时长 —— 曲线不一致时下方内容的
        // 屏上速度 = 位移曲线 + 滚动曲线之和,会出现速度拐点(不丝滑的另一半来源)
        if (targetY < scroller.scrollTop - 1) animScroll(targetY, 800, bezier(.32, .72, 0, 1));
      },
      commit: function () {
        /* 第 52 轮:diy-collapsing 的摘除挪到 runTeardown(+600ms 安静时刻)——
           在提交帧摘它 = 同帧销毁 mirror-frame 的渲染面 + 瞬变横幅全部过渡时长,
           都是提交帧的额外拆层活。留着它在折叠静止态零副作用:
           mirror-frame 保持透明(幕布高 0 本就不可见),时长覆盖没有动画可作用。 */
        stage.style.removeProperty('--diy-open-h');
      },
      done: function () {
        var r = host().getBoundingClientRect();
        if (r.top < headerH() || r.bottom > window.innerHeight) recenter();
      }
    });
  }

  // 等幕布高度过渡结束;带超时兜底,防 transitionend 丢帧导致永远 busy 卡死
  function afterAnim(done, dur) {
    busy = true;
    var fired = false;
    function fin() {
      if (fired) return;
      fired = true; busy = false;
      wrap.removeEventListener('transitionend', onEnd);
      done();
    }
    function onEnd(e) { if (e.target === wrap && e.propertyName === 'height') fin(); }
    wrap.addEventListener('transitionend', onEnd);
    // 兜底超时 = 动画时长 + 300ms 余量,transitionend 丢帧时才走这条。
    // 收起放慢到 .8s 后必须传 dur,否则兜底会在动画还没跑完时就误判结束(2026-07-30)
    setTimeout(fin, (dur || 500) + 300);
  }

  /* ══════════════════════════════════════════════════════════════════
     ⑳ 第 68 轮(2026-08-04)· 开合新实现:「盖子」
     ══════════════════════════════════════════════════════════════════
     ⚠️ 上面那三套旧实现(collapse / collapseSnap / collapseFlip)以及 15 个诊断开关
        (flip/snap/nowa/nokeep/nosplit/nodrawer/noline/bf/nolift/nosib/nolayer/
         nowidth/nopre/nofx/nobgfix)本轮【一行都没有调用】,它们只是还留在文件里没删。
        用户拍板:等新实现确认稳定后再单独一轮清理 —— 万一有问题,拿「能用的旧文件」对比,
        好过在一个删了一半的文件里排查。

     本实现与它们【毫无关系】,不共用任何函数、变量或 CSS 类。整段自包含。 */
  var cover = (function () {
    /* 盖子作用在【DIY 所在的 .shopify-section】上 —— 这一层才直接决定文档高度。
       本地独立版没有 section 外壳,退化到 .diy-outer / stage(本地下方无兄弟块,不影响预览)。*/
    function hostEl() {
      var o = document.querySelector('.diy-outer') || stage;
      return o.closest('.shopify-section') || o;
    }
    var host = hostEl();
    var closed = true;                                 // 默认关闭(用户:日常打开网页时只呈现横幅那一条)
    var hide = 0;                                      // 要藏起来的像素高度,measure() 实测
    var 解锁T = null, 解锁序 = 0;                       // 兜底解锁定时器的句柄与轮次(见 fin() 里的注释)
    var remeasureT = null;                             // 动画期间被推迟的重量定时器(见 measure 注释)

    /* 兄弟块 = host 之后的所有元素。fixed/sticky 跳过(它们不随文档流走,位移会把吸顶头部拖跑)。*/
    function sibs() {
      var out = [];
      for (var e = host.nextElementSibling; e; e = e.nextElementSibling) {
        if (e.nodeType !== 1) continue;
        var cs = getComputedStyle(e);
        if (cs.position === 'fixed' || cs.position === 'sticky' || cs.display === 'none') continue;
        out.push(e);
      }
      return out;
    }

    /* 实测「要藏多少」= host 底边 − 横幅底边。
       ⚠️ 必须在【全开状态】下量,否则量到的是已经被盖住的假值。
       模块永不变形,所以这个值只需在加载后和 resize 时各算一次 ——
       这正是本方案比第 47~65 轮稳的地方之一:不再有「点击那一帧现场测量」的 36ms 强制重排。 */
    function setHide(v) {
      /* 用 ceil 不用 round:宁可多盖零点几个像素,也不能少盖 —— 少盖会让那条 1px 白线露出来
         (第 68 轮用户截图指出的正是这个)。多盖的那部分不足 1px,肉眼无差别。 */
      hide = Math.max(0, Math.ceil(v));
      document.documentElement.style.setProperty('--diy-hide', hide + 'px');
    }
    /* 📐 第 131 轮(2026-08-18)核心改动:两个锚点一律用【布局坐标】,不再用视口坐标。
       ── 为什么 ──────────────────────────────────────────────
       用户 2026-08-17 报「滚上滚下露多露少」。取证脚本 `_diag-hide-contamination.mjs` 实测:
         滚到 1343 时 --diy-hide=1926(CSS 预置表)→ 白线下面还漏 9px
         滚到 1493 时 --diy-hide=1935(JS 实测值)→ 漏 0px       ← 就在这一刻突然变短
       9px 的差本身不致命,**致命的是切换时刻**:measure() 遇到 `.diy-outer.diy-enter`
       会拒绝测量(怕量到动画中途的位置),而那个入场动画恰好在【模块滚进视口那一刻】才播 ——
       于是「预置值 → 真值」的跳变永远发生在用户正盯着它看的时候。
       ── 换坐标系为什么一步治好 ──────────────────────────────
       offsetTop 链有三条性质,正好把历史上三种污染一次全断掉:
         ① 无视 transform → 入场动画的 translateY(2rem) 和 GSAP 的列位移都不计入
            (于是「入场没播完不许量」这条限制可以整段删掉,预置表也不必再等它)
         ② 与滚动完全无关 → 不可能再出现「量出来的值随滚动变化」
         ③ sticky 元素报的是它的【布局位置】而不是被钉住的位置
            (吸顶元素污染 rect.top 这个坑,2026-08-17 一天在验收脚本里踩了三次)
       ── 实测证据(`_diag-offset-vs-rect.mjs`,iPhone 13)──────
         布局量法:14 次采样(10 个滚动位置 + 4 次高度型 resize)**只有 1935 一个值**
         视口量法:同样采样飘出 1902 / 1928 / 1934 / 1935 四个值,全在入场动画期间
         稳定态两者相等(1935 = 1935)→ 换坐标系没引入偏差
         入场动画还挂着时布局量法就已经给出终值 → 预置表退居「JS 跑起来之前的首帧兜底」
       ⚠️ 别改回 getBoundingClientRect —— 那是这个功能连续三轮真机问题的共同源头。
       ── 但纯布局坐标会漏掉一件真事:桌面的 scale(0.85) ──────────
       第一版只用 offsetTop 链,手机三档(375/412/430)完美贴线 0px,**桌面 1280 少盖 26px**:
       `.diy-stage` 上挂着 `transform: scale(0.85)`,那是**永久**的,它真的改变白线在屏幕上的位置,
       不该被无视。于是量法定为「布局坐标 + 只折算稳定 transform」:
         要折算(永久):`.diy-stage { transform: scale(.85) }` —— 样式表规则,无内联、无 .diy-enter
         要排除(临时):`.diy-outer.diy-enter { transform: translateY(2rem) }` —— 认 .diy-enter 类
         要排除(临时):四列的 GSAP 补间 —— 认【内联】style.transform(GSAP 一律写内联)
       两条排除规则都能精确判定,不靠「看起来像临时的」这种猜测。
       实测(`_diag-stable-transform.mjs`,5 视口):新量法在入场动画进行中就等于稳定态的视觉真值,
       且三个滚动位置全程一个值;桌面 651(纯布局)→677(折算后)= 视觉真值。 */
    function 文档顶(el) {                                 /* 纯布局坐标,无视一切 transform */
      var y = 0;
      for (var e = el; e; e = e.offsetParent) y += e.offsetTop;
      return y;
    }
    /* 布局坐标 + 沿途【稳定】transform 的折算结果 = 元素上沿在页面里的视觉位置。
       只处理 scale + translate(本项目没有旋转/斜切):矩阵 matrix(a,b,c,d,e,f) 里 d=scaleY、f=translateY。
       变换以 transform-origin 为不动点,所以要先把点平移到原点系再缩放。 */
    function 视觉顶(el) {
      var y = 文档顶(el);
      for (var a = el; a && a !== document.body; a = a.parentElement) {
        var cs = getComputedStyle(a);
        if (cs.transform === 'none') continue;
        if (a.style.transform) continue;                  /* ① 内联 = GSAP 正在补间,临时,排除 */
        if (a.classList.contains('diy-enter')) continue;  /* ② 入场类的 translateY,临时,排除 */
        var m;
        try { m = new DOMMatrixReadOnly(cs.transform); } catch (err) { continue; }
        var oy = parseFloat((cs.transformOrigin || '0 0').split(' ')[1]) || 0;
        var 原点 = 文档顶(a) + oy;
        y = 原点 + (y - 原点) * m.d + m.f;
      }
      return y;
    }
    /* 🎯 红线的准确定义 = 四列区顶部那条 1px 白发丝线(CSS:`.app-shell--h > .col` 的
       `box-shadow: inset 0 1px 0 var(--hairline)`),**不是**横幅底边 —— 两者差 0.8px。
       第 68 轮初版锚在横幅底边,四种屏幕实测「盖子顶 − 列顶 = +1px」,
       白线正好卡在盖子上方露出来,就是用户截图里箭头指的那条。
       锚到列顶 = 盖子上沿与白线上沿重合 → 白线刚好被盖掉、且一点没多盖。
       (2026-08-18 用户再次确认这就是要的效果:「盖子要刚好盖过按钮下面那条白线」)
       没有四列时(手机端堆叠布局 / 结构异常)退回横幅底边。 */
    function redLine() {
      var col = document.querySelector('.app-shell--h > .col');
      /* 横幅底边同样要折算稳定变换:桌面它和四列一起被 .diy-stage 的 scale(.85) 压着。
         offsetHeight 是【未缩放】的声明高度,所以不能直接加 —— 用横幅自己的下沿元素位置来算:
         视觉顶(横幅) 已含缩放,再加上缩放后的高度 = 视觉底。 */
      var 幅 = banner();
      var 缩 = 幅.getBoundingClientRect().height / (幅.offsetHeight || 1);
      var bb  = 视觉顶(幅) + 幅.offsetHeight * (isFinite(缩) && 缩 > 0 ? 缩 : 1);
      /* 2026-09-24 用户拍板:手机收起态让下一块(The Style Edit)再往上多盖 10px,按钮视觉上更靠下、更稳。
         所有收起几何(露/盒/clip/hide)都从红线派生,只改这一处;电脑 / iPad 不动。
         上线前做过彩排(10 个守卫改前改后对比,0 个新问题)。&coverlift=N 可临时覆盖(排查用)。
         ⚠️ 改这个数必须同步改 CSS 首帧兜底表手机档 --diy-box(= 264 − 抬),否则打开瞬间会跳。 */
      var 抬 = 0;
      if (window.matchMedia && matchMedia('(max-width: 760px), (max-device-width: 760px)').matches) {
        var 参 = location.search.match(/[?&]coverlift=(\d+)/);
        抬 = 参 ? +参[1] : 10;
      }
      if (!col) return bb - 抬;
      return Math.min(视觉顶(col), bb) - 抬;          // 取更靠上的那条,保证白线一定在盖子之下
    }
    /* 🎯 盖子「看得见的最上沿」——第 69 轮踩的坑,值得单独一个函数。
       别用 `first.getBoundingClientRect().top`:那是外壳 `.shopify-section` 的矩形顶边,
       而**眼睛看到的白色面板**是它里面的 `.section`,那个 `.section` 带着
       `margin-block-start: -27.27px`(第 26 轮为做层叠圆角加的),视觉上**比外壳还高 27px**。
       实测:外壳顶 2274(正好压在白线上 ✓)/ .section 顶 2247(高了 27px ✗)。
       换算到观感:按钮底 → 看得见的盖子顶 只有 8.8px,而白线应在 36px 处 —— 正是用户截图圈出的「太近」。
       ⚠️ 这个坑还骗过了验证脚本:它量的也是外壳,所以一直报「0 偏差」的假绿灯。
       写成遍历直接子元素取最靠上的那个(而不是写死 27.27),
       以后主题改了负边距数值也自动跟随,别的带负边距外凸的面板也一并覆盖。
       第 131 轮:改用 文档顶() 布局坐标(理由见上面那段长注释)。负 margin-top 属于布局,
       offsetTop 天然把它算进去,所以「取最靠上的子元素」这个逻辑一字不用改。 */
    function visibleTop(el) {
      var t = 视觉顶(el);
      var kids = el.children;
      for (var i = 0; i < kids.length; i++) {
        var cs = getComputedStyle(kids[i]);
        if (cs.display === 'none' || cs.position === 'fixed' || cs.position === 'absolute') continue;
        var kt = 视觉顶(kids[i]);
        if (kt < t) t = kt;
      }
      return t;
    }
    function measure() {
      /* 🔴🔴 浮层态一律拒绝测量(2026-09-14 加,全案最高危的一行)。
         为什么必须有:.diy-outer 一变 fixed,高度从 2182px 塌成一个视口高 →
         挂在它身上的 ResizeObserver(见 装监听())【必然被动触发】→ 120ms 后 measure() 自己跑起来。
         而 视觉顶()/文档顶() 是靠 offsetParent 链累加 offsetTop 的,元素一 fixed 这条链的语义就变了,
         算出来的 --diy-box 是垃圾值 → 写回 CSS 变量 → 【首页 DIY 下面的所有内容整块跳】,
         量级可达 1900px(--diy-hide 实测 1935)。
         最阴的是:它是在浮层盖住屏幕的时候跳的,用户【关掉浮层才看见】,看起来像"关了之后页面炸了",
         归因极难。第二触发点同样阴:window resize → iOS 地址栏收放、软键盘弹起都会发,
         也就是浮层开着时点一下输入框就可能炸。
         门写在函数最开头第一行,在任何测量、任何 DOM 写入之前。
         条件只认 DOM 上那个类(单一真相),不另设布尔变量。
         关闭浮层后由 close() 显式补量一次。 */
      if (document.documentElement.classList.contains('diy-overlay-open')) return hide;

      /* 🐛 第 72 轮修(用户报「点收回有时候没反应」的真凶):
         measure() 会临时摘掉盖子类去量,量完再按 `closed` 决定要不要加回来。
         但 `closed` 要到动画**结束**才更新 —— 若 measure() 在收合途中被触发,
         此刻 closed 还是 false,它就把盖子类【摘掉不还】→ 盖子弹回展开 = 用户说的「没有收回」。
         动画期间一律不量;等这次开合彻底结束后再补量一次。 */
      if (busy) { clearTimeout(remeasureT); remeasureT = setTimeout(measure, DUR + 400); return hide; }
      /* ⛔ 第 103 轮那道「入场动画没播完不许量」的限制,第 131 轮已【整段删除】。
         它当初是为了躲 `.diy-outer.diy-enter` 的 translateY(2rem) 和四列的 GSAP 位移 ——
         但那些位移全是 transform,而现在两个锚点都走 文档顶()(offsetTop 链)、天然无视 transform,
         再拒绝测量就没有意义了,反而是害处:
           拒绝期间只能用 CSS 预置表的值(实测 1926),等入场播完才换成真值(1935),
           而入场动画恰好在【模块滚进视口那一刻】播 → 9px 的跳变永远发生在用户眼前。
           这就是用户 2026-08-17 报的「滚上滚下,按钮下面有时候漏多有时候漏少」。
         实测(`_diag-offset-vs-rect.mjs`):入场动画还挂着时布局量法就已经给出终值 1935,
         与播完后完全一致 → 现在 init 里第一次 measure() 就是准的,不必等、不必补。 */
      var wasClosed = closed;
      host.classList.remove('diy-cover-closed');        // ⚠️ 必须在【全开态】量,否则量到的是已被盖住的假值
      var bb = redLine();                               // 红线 = 四列顶部那条 1px 白发丝线(见 redLine 注释)
      var first = sibs()[0];
      /* 🎯 直接量【下方第一块「看得见的最上沿」→ 红线】的距离 —— 这就是盖子要走的距离,一步到位。
         ⛔ 别走 `host.bottom - 红线` 那条路(第 68 轮踩过):那要牵扯 host 自身的下内边距
            以及下方 .section 的负 margin-top 与我们负 margin-bottom 之间的**外边距折叠**,
            推算容易错 —— 实测那条路算出 718,比正确值多 12,盖子会把横幅底部吃掉一截。
         ⛔ 也别用 `first.getBoundingClientRect().top`(第 69 轮踩过):那是外壳矩形,
            比【看得见的白面板】低 27px,盖子会盖过头、贴到按钮上(用户截图圈的「太近」)。
            必须用 visibleTop(),见那个函数的注释。
         没有兄弟块时(本地独立版)退化到 host 自身高度,不影响预览。 */
      /* --diy-hide 第 132 轮起【只给开合动画用】(兄弟块那条 translate3d 的补偿量),
         不再决定收起态的排版位置 —— 那已经交给 --diy-box(见下)。
         它的定义没变:开着时下方面板顶 − 红线 = 一开一合两个位置之间的距离。 */
      setHide(first ? (visibleTop(first) - bb)
                    : (视觉顶(host) + host.offsetHeight - bb));   /* 兜底也走同一套量法,保持一致 */

      /* 📦 第 132 轮核心:收起态的两个几何量都改成【从模块顶边往下数】。
         为什么(病根与实测证据)见样式段那条 `--diy-box` 的长注释,一句话:
         旧写法从【模块底边】往上数,而模块总高的 90% 是被盖住看不见的四列区,
         它一变(WebGL 画布 / 图片 / 字体),盖子和切线就一起漂 —— 用户看到「忽远忽近」。

         露 = 要露出来的高度 = 红线 − 模块顶。盒子高度不能直接等于它:
         第一块兄弟面板靠 `margin-top:-26px` 比自己的外壳更高一截(层叠圆角就是这么做的),
         所以盒底要比红线再低那 26px,面板顶才正好落在红线上。
         这 26px 不写死 —— 挂上盒子高度后【当场量一次面板顶,差多少补多少】,
         线性关系,一次就收敛(实测 19 个宽度校准残差全 0,`_diag-box-preset-table.mjs`)。 */
      var 露 = Math.round(bb - 视觉顶(host));
      /* 🛡️ 理智检查(第 132 轮补):量出来的「露出高度」不在合理区间就【原样不动、稍后重试】,
            绝不拿垃圾值去写盒子高度。
         什么时候会量到垃圾:
           ① 打开图卡集时 CSS 有 `.diy-fs-open .diy-hero-banner { height: 0 !important }` ——
              此刻若被 resize/字体事件触发 measure(),横幅底 = 横幅顶,露只剩 48px,
              盒子当场缩到 48 → 盖子直接盖到按钮上;
           ② 锚点被 display:none(祖先隐藏)时 offsetParent 为 null、offsetTop 链返回 0,
              bb 变成 0 → 露 是个大负数。实测把 .app-shell--h 整个隐藏就能复现。
         判据用「横幅【视觉】高度」当下限:露至少要装得下横幅,否则一定是量在半成品/隐藏态上。
         ⚠️ 必须用 rect 高不是 offsetHeight —— 桌面 `.diy-stage` 上挂着 scale(.85),
            offsetHeight 报的是缩放前的 174,而露是缩放后的量(195),拿 174 当下限在更小的
            缩放比下会误伤。留 0.9 的余量吸收亚像素。 */
      var 幅 = banner(), 幅高 = 幅 ? 幅.getBoundingClientRect().height : 0;
      if (!(幅高 > 0 && 露 >= 幅高 * 0.9 && 露 < host.offsetHeight)) {
        if (wasClosed) host.classList.add('diy-cover-closed');
        clearTimeout(remeasureT); remeasureT = setTimeout(measure, 300);
        return hide;
      }
      var 根 = document.documentElement.style;
      根.setProperty('--diy-box', 露 + 'px');
      host.classList.add('diy-cover-closed');
      void host.offsetHeight;                                  // 强制落地,下一行才量得到新布局
      var 盒 = 露 + Math.round(bb - (first ? visibleTop(first) : bb));
      根.setProperty('--diy-box', 盒 + 'px');
      void host.offsetHeight;                                  // 盒子落地后再量面板顶,那才是切线该在的位置
      /* 裁切线 = 盒底往上裁到【面板顶】。两条讲究:
         ① 必须用挂上盒子【之后】实测的面板顶,不能拿 盒−露 这个整数差凑 ——
            露 和校准量都取过整,凑出来的切线会比真面板顶低半个像素。
         ② ceil 之后再 +1:宁可多裁一个像素,也不能少裁。少裁哪怕 0.4px,
            层叠圆角那两个「圆角外的小三角」就会漏出彩虹 —— 逐像素 A/B 实测漏 152 个像素、
            最大差 164,全落在切线那一行的最左边(rgb(135,191,188) 是模块的青绿底)。
            多裁的那 1px 在直边处被面板盖着看不见,在缺口处露出来的是白色 ——
            而白色正是「模块不在那儿」时本来的样子,判据照样过。 */
      var 面顶 = first ? visibleTop(first) : bb;
      /* 🔵 少裁一个「下一块的圆角半径」——把它的两个上圆角还出来(2026-08-19 用户报
         「The Style Edit 模块左右是带 R 角的」/「R 角本来看得见,现在没了」)。

         ── 为什么会没 ────────────────────────────────────────────────
         主题的层叠圆角设计里,下一块面板的两个上圆角【缺口是透明的】,
         靠露出【它上面那块】的颜色来显形。8-18 那轮为了堵住更下面几块的「缺口漏彩虹」,
         把本模块整段裁到面板顶 —— 于是它自己的缺口也没彩虹可露,
         露出来的是 #PageContainer 的白(实测缺口处元素栈:diy-outer 被裁掉后就是 page-container),
         白压白 → 圆角看不见了,边看起来是直的。

         ── 修法 ────────────────────────────────────────────────────
         让本模块【只多画一个圆角高度】。面板本身是不透明白、`z-index:2` 盖在我们之上,
         所以中间那一整段仍被它挡得严严实实,**只有两个圆角缺口会露出彩虹**。
         实测(手机 390,clip 27→11):左角饱和 59 / 右角饱和 98,
         而 x=20 / 中间 / 右内 全部仍是纯白 —— 面板一点没漏,更下面几块离得远更不受影响。

         ⚠️ 半径【实测取值】不写死:手机 16px、桌面 20.2px,主题改配置会自动跟随。
         ⚠️ 预置表(首帧兜底)里的 --diy-clip 故意【不减】:宁可首帧圆角晚半拍出现,
            也不要首帧多画一截、万一几何还没稳就漏到下面去。measure() 一跑就正确了。
         ⚠️ `_verify-covered-clean` 的判据要同步:它原本要求红线以下与「模块不存在」逐像素一致,
            现在那两个缺口【必须】不一致 —— 判据已改成「只允许缺口内不同,其余仍必须 0 差异」。 */
      var 圆角 = 0;
      try {
        var 面板 = first && (first.querySelector('.section') || first);
        圆角 = 面板 ? Math.round(parseFloat(getComputedStyle(面板).borderTopLeftRadius) || 0) : 0;
      } catch (e) { 圆角 = 0; }
      根.setProperty('--diy-clip',
        Math.max(0, Math.ceil(视觉顶(host) + 盒 - 面顶) + 1 - 圆角) + 'px');
      if (!wasClosed) host.classList.remove('diy-cover-closed');   // 同任务内还原,绘制前完成,肉眼不可见
      return hide;
    }
    function banner() { return document.querySelector('.diy-hero-banner'); }

    /* 文档高度一变,浏览器可能自行夹取 scrollTop 并派发 scroll —— 主题吸顶头部的回调正在那个竞态里。
       抢先在同一帧写好合法值,提交时携带一致的「布局 + 滚动」。 */
    function clampScroll() {
      var se = document.scrollingElement || document.documentElement;
      var max = Math.max(0, se.scrollHeight - window.innerHeight);
      if (se.scrollTop > max) se.scrollTop = max;
    }

    /* ═══ 开合手感:起步稍慢 → 中段走快 → 快到位时缓缓刹停(第 137 轮,用户 2026-08-22:
       「盖子拉下跟上盖要有点丝滑感,有点节奏感,而不是突然下去、突然上来」)═══

       改前的病根不是「太快」,是**两条曲线都是纯 ease-out(一上来就冲到顶速)**,
       所以没有起步的加速段,观感就是「啪一下」。逐帧实测(seek 采样 21 点):
         展开 .32,.72,0,1  → 前 25% 的时间走完 77.9% 的距离
         收起 .25,.46,.45,.94 → 前 25% 的时间走完 45.3% 的距离
       而且两侧【时长不同(620 vs 460)、曲线不同】,来回不是同一个动作 —— 实测时长差 25.8%、
       归一化曲线形状最大偏差 0.326。用户明确要求展开与收起对称,所以两侧强制合并成一套参数。

       换 easeInOutQuad = cubic-bezier(.45,0,.55,1):
         · y1=0 → 起点速度为 0,有真正的加速段(前 25% 时间只走 12.0%,不是 77.9%)
         · 关于中心对称 → 展开与收起用同一条,天然互为镜像
         · 末 21% 的距离只占 32% 的时间(原展开 74% / 原收起 48%)—— 不会重蹈第 94 轮
           「尾巴太长,像停在离白线一点点的位置」那个坑
         · 无 overshoot / 回弹(控制点 y 全在 [0,1] 内)—— 用户明确选了「稳重顺滑」

       ⚠️ 为什么可以放心把时长拉长:本模块开合驱动的是兄弟块的 transform(合成属性),
          不是 height。CDP 实测一轮开合只有 6~7 次重排、总计 ~3ms,时长变长【不会】增加
          逐帧重排成本(改后复测同样 6~7 次 / ~3ms)。
       ⚠️ 备选里 easeInOutCubic(.65,0,.35,1)已否决:前 25% 只走 7.1%、中段单帧跳 13.7%,
          观感是「先愣一下再窜出去」,不是「稳重」。 */
    /* 2026-09-15 用户:「下面这块模板展开后收起伸缩的太快了」→ 600 → 900。
       放心拉长的依据见上面那条 ⚠️:驱动的是兄弟块的 transform(合成属性),不是 height,
       CDP 实测一轮开合只有 6~7 次重排 / ~3ms,时长变长不增加逐帧重排成本。 */
    /* 🌊 2026-09-16 用户:「配置器打开跟收起不够丝滑(特别是收起)，感觉一抖一抖的收起，
       肉眼虽然看不出来，但是确实有这种很重的感觉」，并指着本地 `_弹性对照.html` 说那个很柔和。
       先排除了掉帧:WebKit + 有头(有GPU) 实测【收起 60fps / 0 个长帧 / 最大帧距 18ms】——
       帧率是满的，「抖」不是掉帧。
       真因是【速度曲线】:
         · 原 cubic-bezier(.45,0,.55,1) 是 ease-in-out —— 两头慢、中间快。
           起步「粘」、中段窜、临到了又急收，正是「重」的来源。
         · 柔和感要的是反过来:【快起步、缓停下】(ease-out)。
       换成 cubic-bezier(.32,.72,0,1) —— 这正是 Concept 主题自己的吸顶导航在用的那条，
       起步干脆、末段几乎贴着水平线停住，和站内其它动效同一种"口音"。
       时长 900 → 1000ms:这段位移大(下方内容要走 1631px)，多 100ms 能显著降低每帧位移，
       从容感来自这里。再长就拖沓了(用户 2026-09-15 才嫌过 600ms 太快、900 合适，别一次加太多)。
       🔄 回滚 = 改回 900 / cubic-bezier(.45,0,.55,1)。 */
    var DUR = 1500, EASE = 'cubic-bezier(.32,.72,0,1)';
    /* ════════════════════════════════════════════════════════════════════════
       🌊🌊 2026-09-16 第二轮 · 用户拍板的【同速铁律】(这一段是开合节奏的唯一真相)

       用户原话:「抖是不会抖，但配置器展开与收下速度太快……他的帧距一样速度一样，
                 可能有时候配置器再高一点，下面模块躺下来的速度会久一点，
                 但是他配置器跟下面的模块的帧距一样和速度要一样。」

       翻成两条硬约束:
         ① 同一瞬间,配置器挪多少像素,下方内容就挪多少像素 —— 【帧距必须相等】,
            看起来是一整块在动,不是两个各走各的。
         ② 【时长可以变,速度不许变】。这一趟距离长,就多花时间走完,不许提速。

       🔑 为什么这条铁律做得到(关键几何,别再推翻):
            配置器在屏幕上走 本次上盖 ≈ 285px
            下方内容在屏幕上走 屏内行程 ≈ 279px   ← 只差 2%
          它俩【看得见的那段几乎一样长】。下方内容总行程虽然有 1631px,
          但其中 1352px 是滑出屏幕底边【之后】才跑的 —— 那截没人看得见,可以随便快。

       ❌ 旧版为什么对不上(这就是用户说的"速度不一样"):
            配置器  cubic-bezier(.32,.72,0,1)  1000ms 走 285px
            下方内容 分段 linear()               800ms 走 279px   ← 快 22%,而且曲线形状也不同

       ✅ 新做法:把两条曲线拆成【同速段】+【屏幕外段】,让两者的同速段在时间轴上
          完全重合、形状完全一样 ——
            展开:同速段在前(两者一起动) → 下方内容出屏后自己跑掉剩下那截
            收起:屏幕外段在前(下方内容先冲进画面) → 同速段在后(两者一起停)
          两边都由 同速时序() 现场算,不写死。

       🔴 三个别踩回去的坑:
         1. 【速度突变不许落在屏幕边缘】。屏外段靠近边缘的那一头必须已经减到同速
            (出屏形状/进屏形状 的 0.005/0.035 那几级就是干这个的)。
            第 61 轮的「一抖一抖」就是拐点擦着边缘造成的。
         2. 【clamp 不会破坏"同速"】。T基 被夹在 [900,2400] 时,T配 和 T内 是按
            同一个比例缩放的,两者速度仍然严格相等 —— 夹的只是绝对快慢。
         3. 【linear() 不支持就整条退回 EASE】(iOS 17.2+ / Chrome 113+)。
            旧行为一字不变,不要在这里写"降级近似"。
       🔄 回滚 = 让 同速时序() 直接 return null。
       ════════════════════════════════════════════════════════════════════════ */
    /* 基准速度。读法 = 屏幕上 ?ms 走 285px。想整体调快慢【只动这一个数】——
       分子分母一起缩放不影响"配置器和下方内容同速"这件事(两者共用同一个速度)。
       调参历史:
         1000ms  原始      → 用户:「速度太快」(注意:那一版是 ease-in-out + 下方分段曲线,
                                              两头慢中间窜,"快"的感受里有一半是曲线的锅)
         1500ms  1.5 倍档  → 用户从 1.3/1.5/1.8 三档里选的,落地后:「整体有点太慢」
         1300ms            → 每帧 3.65px,快 15% → 用户:「还是有点太慢」
         1150ms            → 每帧 4.13px,再快 12% → 用户:「还是太慢,一次性加多一点」
          950ms            → 每帧 5.00px,再快 17% → 用户认可了效果,但要求「再快一点」
          850ms            → 每帧 5.59px → 用户:「微微有点抖」
          950ms            → 退回 5.00px(我误以为用户要细腻度)
          650ms            → 每帧 7.31px → 用户:「还想再快一点」
          570ms  ← 现在    → 每帧 8.33px
       ── 650ms 那一档的背景(优先级判断,别忘)──────────────────
          用户 2026-09-17 原话:「我一直让你变快,你为什么要变慢…
                             我是希望按照这种规划,然后展开收起的节奏加快一点最好 650ms 就行」
                             ⚠️ 已越过下面那条实测分界线(5.0 过关 / 5.59 报抖),颗粒感是【已知代价】,
                                用户看过数据后仍然拍板要这个速度 —— 别再自作主张调回去。 
       ⚠️ 已经比最初那版还快了。现在的曲线是【匀速 + 末尾平滑收尾】,和当初完全不同 ——
          所以"回到 1000ms 以下"不等于回到当初那种窜的观感。再往下调要小心。 */
    var V基准 = 285 / 570;                      // px/ms
    /* 🔴【别再往下调了】—— 2026-09-17 实测定的天花板。
       用户在 850ms 报「帧数能不能更密一点点,微微有点抖」。量下来(有头+GPU,WebKit):
         页面空闲基线 帧间隔中位 17.0ms(59Hz)
         展开 17.0ms / 跳帧 1.2%   收起 17.0ms / 跳帧 0%
       —— **帧一帧没丢**,所以"让帧更密"没有余地,屏幕就 59Hz。
       那个"抖"是【每帧跨的距离】:850ms 时每帧 5.59px,在 60Hz 下人眼开始看出"一格一格"。
       所以【速度和细腻度在 60Hz 上直接冲突】,只能二选一:
         3.17px/帧(1500ms) 太慢 · 5.00px/帧(950ms) 用户说"效果不错" · 5.59px/帧(850ms) 报抖
       临界点在 5.0~5.6px/帧 之间,950ms 是已知能过关的那一档。
       ⚠️ 想再快,先想清楚是不是要拿这个颗粒感去换 —— 不是调参数能绕过的。
       诊断脚本:scripts/_diag-frame-pacing.mjs(必须有头,无头帧率数据不作数)。 */
    /* 极端几何下的时长护栏(见坑 2)。
       🔴 T下限 必须跟着 V基准 一起降 —— 它是按 1500ms 基准定的。
          基准提到 650ms 后,常用几何算出来的 T基 只有 ~710ms,会被 900 的下限【强行拉回】,
          表现是"改了 V基准 却没反应"。2026-09-17 改基准时差点漏掉这一处。 */
    var T下限 = 480, T上限 = 1900;
    /* 同速段【多走一点点再交棒】:覆盖到 屏内 × 这个系数 的位移。
       🔴 为什么必须 >1:同速段和屏外高速段的交界处有速度落差,落差本身没问题 ——
          问题是它【不能落在屏幕边缘】(第 61 轮「一抖一抖」就是这么来的)。
          多走 18% 之后再放开速度,交界点就沉到屏幕外面去了,看不见。
       实测 1.0(不留缓冲)时边缘速度落差 5.4 倍,判红。 */
    var 出屏缓冲 = 1.18;
    /* 同速段的形状:【严格匀速】。这不是偷懒,是数学上唯一解 —— 别再往里塞缓出。
       🔴 推导(2026-09-16 实测撞出来的,省得下次再试一遍):
          配置器走 285px 用 T配,下方内容走 329px 用 T内,两者时间尺度不同(T配/T内≈0.87)。
          同一条非线性曲线 S 套在【不同时间尺度】上,瞬时速度就【一定】不相等:
            配速(t) = 285·S'(t/T配)/T配   下速(t) = 329·S'(t/T内)/T内
          只有 S' 恒定(= S 线性)时两边才恒等。
          实测带缓出的版本:极端几何下速度差 7.7%、逐帧差最大 30.6% —— 判红。
          改纯线性后:速度 3.17 vs 3.17 px/帧,逐帧差 0.0%。
       ❓ 那「柔和」怎么办 —— 柔和感现在来自【慢】(1500ms 走 285px = 3.17px/帧),
          不来自曲线形状。匀速的起停变化量只有 3px/帧,肉眼注意不到;
          当初报「一抖一抖」的是 58px/帧 的急刹,差了 18 倍,不是一回事。 */
    var 同速形状 = [[1, 1]];
    /* 屏幕外那段的形状。两条【互为镜像】((t,v) ↔ (1−t,1−v)),所以开合是同一个动作的正反面。
       贴着同速段的那一头刻意压得很平(0.005/0.035),让速度在【看得见的范围内】始终是同速,
       放开速度这件事全部发生在屏幕外。 */
    var 出屏形状 = [[0.06, 0.005], [0.18, 0.035], [0.40, 0.170], [0.70, 0.550], [1, 1]];
    var 进屏形状 = [[0.30, 0.450], [0.60, 0.830], [0.82, 0.965], [0.94, 0.995], [1, 1]];
    function 撑linear(点) {
      /* 点 = [[时间0~1, 值0~1], …],首尾自己带。去重 + 单调保护,避免拼出非法/回退的曲线。 */
      var 出 = [], 上次t = -1, 上次v = -1;
      for (var i = 0; i < 点.length; i++) {
        var t = Math.max(0, Math.min(1, 点[i][0])), v = Math.max(0, Math.min(1, 点[i][1]));
        if (t <= 上次t + 0.004 && i < 点.length - 1) continue;   // 太密的点没意义,还会放大舍入误差
        if (v < 上次v) v = 上次v;                                // 绝不允许回退
        出.push(v.toFixed(4) + ' ' + (t * 100).toFixed(2) + '%');
        上次t = t; 上次v = v;
      }
      return 'linear(' + 出.join(', ') + ')';
    }
    function 同速时序(上盖, 总行程, 屏内, 收起) {
      /* 返回 {时长, 配曲线, 下曲线};算不出来 → null(调用方退回 EASE 老行为)。
         上盖   = 配置器在屏幕上要走的距离
         总行程 = 下方内容的全部位移(含屏幕外)
         屏内   = 下方内容【看得见】的那一截 */
      try {
        if (!(window.CSS && CSS.supports &&
              CSS.supports('transition-timing-function', 'linear(0 0%, 0.5 50%, 1 100%)'))) return null;
        上盖 = Math.max(0, 上盖 || 0);
        总行程 = Math.max(0, 总行程 || 0);
        屏内 = Math.max(0, Math.min(屏内 || 0, 总行程));
        if (!(总行程 > 0)) return null;
        /* 🔴 屏内 算出来 ≤0(下方内容这一趟【全程都在屏幕外】)也【不许退回旧曲线】。
           旧那条两段式 linear 在拐点有急刹,正是用户报「一抖一抖」的源头 ——
           退回去等于把已经修好的问题偶发地放回来(2026-09-16 在 412 上实测撞到过一次:
           几何算出负数 → 返回 null → 页面上真的跑回了旧曲线)。
           这种几何下"屏内同速"无从谈起,那就让两者都走【纯匀速】:
           配置器按基准速度走完 上盖,下方内容在同一时长里匀速跑完(反正看不见)。 */
        if (!(屏内 > 0)) {
          if (!(上盖 > 0)) return null;
          var T单 = Math.round(Math.min(T上限, Math.max(T下限, 上盖 / V基准)));
          return { 时长: T单, 视觉时长: T单,
                   配曲线: 'linear(0 0%, 1 100%)', 下曲线: 'linear(0 0%, 1 100%)' };
        }
        var M = Math.max(上盖, 屏内);                 // 谁走得远,谁定这一趟的时长
        if (!(M > 0)) return null;
        var T基 = Math.min(T上限, Math.max(T下限, M / V基准));
        var 速度 = M / T基;                           // 两者【共用】这一个速度 —— 铁律 ①
        /* ══ 共同缓出（2026-09-16 用户：「展开的时候，配置器向上推到最后好像抖了一下」）══
           那一下是【急停】：实测前面稳定 4.21px/帧,最后两帧 4.0 → 2.7 → 0,
           两帧之内从满速砸到零。它不是 bug,是"纯匀速"的必然结果 ——
           而纯匀速又是同速铁律逼出来的（非线性曲线会让两者速度差 7.7%,见 同速形状 的推导）。

           🔑 破局点：配置器到位那一刻（实测 1170ms）,下方内容【已经出屏】了（1125ms 就出屏）。
              所以只要让两者在最后一段【走完全相同的距离、同时减速】,
              同速铁律一点不破,而减速的那部分下方内容在屏幕外,用户只看到配置器平滑停住。

           做法：把下方内容的同速段目标从 屏内×1.18 改成【和配置器一样的 上盖】,
                 两条曲线的同速段因此形状完全一致（匀速 + 末尾匀减速）。
           ⚠️ 只在 上盖 ≥ 屏内 时成立。反过来（模块已很靠近屏幕顶、配置器只需走 200px 出头）,
              减速时下方内容还在屏幕里,会看到"慢一下再窜出去"—— 那种几何退回纯匀速。 */
        /* ⚠️【实测推翻过一次,数字写在这儿别再猜】390×844 滚到横幅居中时：
              配置器走 286.0px · 下方内容【可见行程】310.7px（起点 y=533，视高 844）
           下方比配置器多走 9% ⇒ 严格同速下配置器必然【先到位】(92% 时刻)，
           到位那一刻下方还差 23.9px 才出屏、仍然看得见。
           ⇒ 「配置器减速时下方已出屏」这个设想【不成立】(我按旧注释里的 279 算过，错了)。
           ⇒ 在这个几何下，「两者严格同速」和「配置器平滑停」【数学上不可兼得】。

           用户 2026-09-16 拍板：保【配置器平滑停】，接受最后一小段速度不一致。
           原话场景：他看到的是「配置器向上推到最后抖了一下」——
           那是纯匀速走到终点一脚刹死（实测 4.0 → 2.7 → 0，两帧内从满速到零）。
           代价：缓出那 ~160ms 里两者速度不同，但下方内容此刻只剩屏幕最底部
                 45→5px 的一条窄带、正在向下消失，实际对比不出来。
           🔄 想换回严格同速 = 把 配缓出 设成 0。 */
        /* ══ 追赶段（2026-09-16 用户录屏：模块靠近屏幕顶时点开，
              「配置器突然就闪到顶上去，然后下面模块才慢慢收下来」）══
           实测那个位置的几何：配置器只走 165px、下方要让开 431.7px（比例 1:2.6）。
           对比横幅居中时是 286 : 310.7（1:1.09）—— 模块越靠上，配置器的路越短、
           下方要让的路反而越长（它的起点跟着上移了）。
           两者速度其实一模一样（都 5px/帧），但配置器 627ms 就走完了，而全程 2018ms，
           剩下 1421ms 只有下方在挪 —— 是这段【干等】反衬出"配置器蹦一下就没事干了"。

           🔑 破法：同速铁律是拿来比【两个】东西的；只剩一个在动时，没有比较对象，
              那一段本来就不受同速约束、可以放开速度。
              所以把行程拆成两段：
                · 同速段 = min(上盖, 满同速) —— 两者一起走，严格同速（铁律照旧）
                · 追赶段 = 剩下的那截      —— 只有下方在走，限时 420ms 跑完（不够就加速）
              展开 = 一起起步 → 配置器到位 → 下方赶紧让完
              收起 = 下方先赶回来 → 追上后两者同速 → 一起停住
           实测效果：总时长 2018 → ~1300ms，干等 1421 → 740ms。
           ⚠️ 横幅居中那种均衡几何下 追满 < 420ms、不触发限时，
              算出来和改之前【完全一样】—— 这个改动只影响失衡的位置。 */
        var 满同速 = Math.min(总行程, 屏内 * 出屏缓冲);
        var 同速位移 = Math.min(上盖, 满同速);        // 两者一起走的那段 = 短的那个
        var 追赶位移 = 满同速 - 同速位移;             // 配置器停住后,下方独自走完的部分
        var 同速比 = 同速位移 / 总行程;               // 同速段结束时,下方内容走到的位移比例
        var 追后比 = 满同速 / 总行程;                 // 追赶段结束时的位移比例
        var 追满 = 追赶位移 / 速度;                   // 按同速走完追赶段要多久
        var T追 = Math.min(追满, 420);                // 限时:再远也只给 420ms
        var 加速比 = 追满 > 0 ? T追 / 追满 : 1;       // <1 = 这一段被加速了
        /* 屏幕外那截的时长。🔴 必须【跟着基准速度缩放】,不能写死 ——
           它本身看不见,但占着总时长的开头,直接决定"下方内容多久才进屏"。
           写死 320ms 时:基准从 1500ms 提到 570ms,总时长缩了一半,320 却纹丝不动,
           占比从 21% 涨到 30%,把进屏时刻顶到 51%,判据「进屏够早 ≤50%」当场判红。
           取基准时长的 35%,这样无论快慢,进屏时刻在总时长里的占比都稳定。 */
        var 屏外段 = 追后比 > 0.985 ? 0 : Math.round((285 / V基准) * 0.35);
        /* 配置器末尾用来减速的距离。只加在【配置器】身上,下方内容仍是纯匀速。
           取 22px 而不是更大:缓出段越长,速度不一致的窗口就越长(2d/速度)。
           22px ≈ 9 帧 ≈ 160ms,足够把"一脚刹死"磨成平滑停,又不至于让窗口变长。 */
        var 配缓出 = 上盖 > 90 ? Math.min(22, 上盖 * 0.12) : 0;
        /* 时长:配置器因为末尾减速,要比匀速走完多花 配缓出/速度。
           ⚠️ 不能靠"提高匀速段速度"来抵消这点时间 —— 那会让【整个匀速段】都比下方快,
              等于把 160ms 的局部偏差换成全程偏差,方向完全错了。 */
        var T内 = 同速位移 / 速度;                     // 同速段时长(两者一起走的那段)
        /* ══ 配置器跟着「看得见的整段」走（2026-09-17 用户拍板）══
           用户看录屏问：「配置器为什么弹上去就特别快？他收下来还是有点缓？」
           实测两个方向配置器的速度【完全一样】(都 5.1px/帧)，差别在它处于动画的哪一半：
             展开 第 2 帧就动 → 627ms 到位(占 49%)，之后 663ms 静止
             收起 前 750ms 逐帧位移一串 0.0，然后才动
           —— 这是严格同速 + 路程失衡(165px vs 432px)的必然结果：
              配置器只需要一半时间，剩下一半必然静止；静止那半排在后面就是"弹一下"、
              排在前面就是"干等"。两个感受其实是同一件事。

           ✅ 用户拍板：让配置器【全程都在动】，即时长 = 下方内容走完可见行程的时长。
              代价是两者速度不再严格相等 —— 但：
                · 横幅居中(常用位置) 286 : 311 → 速度比 0.92，肉眼分辨不出
                · 靠近顶部 165 : 432 → 配置器明显慢些，但它全程在动、两个方向对称
              用户原话认可的理由：同速是手段不是目的,当初定它是为了「看起来像一整块在动」,
              而现在同速反而造成一个在动一个在停,恰恰不像一整块。
           🔄 回滚 = 把 T配 改回 (上盖 + 配缓出) / 速度。 */
        var T见;                                       // 下方内容走完【可见行程 屏内】要多久
        if (屏内 <= 同速位移) {
          T见 = 屏内 / 速度;                           // 还没走出同速段就出屏了
        } else if (追赶位移 > 0 && T追 > 0) {
          /* 解 s(u)=r·u+(1−r)u² = q 求 u（追赶段走到 屏内 时的进度）。
             收起方向是它的中心对称镜像,推导下来 T配 完全相同,所以两边共用这一个值。 */
          var q = Math.min(1, (屏内 - 同速位移) / 追赶位移), r = 加速比;
          var u = (1 - r) > 1e-6
            ? (-r + Math.sqrt(r * r + 4 * (1 - r) * q)) / (2 * (1 - r))
            : q;
          T见 = T内 + Math.max(0, Math.min(1, u)) * T追;
        } else {
          T见 = T内;
        }
        /* 🔴 取 max,不能直接等于 T见 —— T见 只管"配置器路比下方短"那种情形(模块靠近屏幕顶)。
           反过来配置器路更长时(模块停在屏幕下缘,实测 上盖 700px vs 屏内 279px),
           硬套 T见 会逼它超速:实测直接算出「一起动 0 帧 / 速度比 0.00」,整段判据塌掉。
           那种几何下配置器按基准速度走自己的路、下方先出屏,本来就该各用各的时长。 */
        var T配 = Math.max(T见, (上盖 + 配缓出) / 速度, 180);
        /* 追赶段的形状:起(展开)/止(收起)那一头的速度必须【正好等于同速】,不然衔接处有突变。
           用 s(u) = r·u + (1−r)·u²（r = 加速比）:
             s(1)=1 ✓   s'(0)=r（= 同速,接上前一段）✓   s'(1)=2−r（加速后的末速）✓
           收起是它的中心对称镜像 —— 先快后慢,末速回到同速,正好接上同速段。 */
        function 追赶形状(收) {
          var 出 = [], r = 加速比;
          [0.25, 0.5, 0.75, 1].forEach(function (u) {
            出.push([u, 收 ? 1 - (r * (1 - u) + (1 - r) * (1 - u) * (1 - u))
                          : (r * u + (1 - r) * u * u)]);
          });
          return 出;
        }
        /* 两条曲线的形状:下方内容纯匀速;配置器 = 匀速 + 末尾 easeOutQuad
           (easeOutQuad 起始斜率正好是 2,归一化后正好接上匀速段,衔接处无速度突变)。 */
        var 下形状 = 同速形状, 配形状 = 同速形状;
        if (配缓出 > 0) {
          var 匀比 = (上盖 - 配缓出) / (上盖 + 配缓出);   // 匀速段占配置器时长的比例
          var 位比 = (上盖 - 配缓出) / 上盖;             // 匀速段占配置器位移的比例
          配形状 = [[匀比, 位比]];
          [[0.25, 0.4375], [0.5, 0.75], [0.75, 0.9375], [1, 1]].forEach(function (q) {
            配形状.push([匀比 + (1 - 匀比) * q[0], 位比 + (1 - 位比) * q[1]]);
          });
        }
        /* 🔑 两者的同速段【共用同一个时间窗】,从同一时刻开始(收起是从"进屏那一刻"开始)。
           谁先走完谁就停住等 —— 这正是用户说的「距离长的久一点」。
           ⚠️ 别改成"同时结束":上盖 很小时(模块已靠近屏幕顶)会算出
              「配置器前 85% 不动、最后一下才掉下来」,那是用户早就否过的两段观感。 */
        /* 🔴 收起时配置器【不能在下方内容进屏之前就动完】。
           同速段的头 (同速位移 − 屏内) 那一截仍在屏幕外(那正是 出屏缓冲 多出来的量),
           配置器若从同速段一开始就走,遇到 上盖 很小的几何(模块已贴近屏幕顶、只需走 50px)
           就会【在下方内容还没露头之前就落到位】—— 观感又变回「先收配置器,再等下面推上来」
           这种两段动作(用户早先明确否过)。所以收起时配置器延后到【进屏那一刻】才起步。
           展开方向不用管:下方内容第一帧就在屏幕里,两者天然从同一刻开始。 */
        /* 时间轴（两个方向互为镜像）：
             展开  [两者同速 T内] → [下方追赶 T追] → [下方跑屏外 屏外段]
                   配置器自己走 T配（= 同速段 + 末尾缓出）,走完就停住
             收起  [下方跑屏外 屏外段] → [下方追赶 T追] → [两者同速 T内] → 一起停
           🔴 收起的配置器【起步时刻 = 追赶段结束】,不再是老的"进屏延迟"。
              老算法在失衡几何下让配置器前 579ms 纹丝不动(实测),观感是
              「下面先走一段 → 配置器才动 → 下面又继续走」三段,用户明确报过。 */
        /* 收起的总时长要【同时容纳两条】,两者一起停:
             下方那条 = 屏外段 + 追赶段 + 同速段
             配置器那条 = T配
           🔴 早先只按下方那条算,遇到"配置器路更长"的几何(模块停在屏幕下缘,上盖 700px)
              就会把配置器的曲线压进更短的 D 里 —— 等于逼它超速,实测 9.31px/帧 vs 下方 6.14。
           谁短谁就【往后排】,所以下面两条都带各自的起步偏移。 */
        var 下条 = 屏外段 + T追 + T内;
        var D = Math.round(收起 ? Math.max(下条, T配)
                                : Math.max(T配, T内 + T追 + 屏外段));
        if (!(D > 60)) return null;
        var 配点 = [[0, 0]], 下点 = [[0, 0]], i, p;
        if (收起) {
          var 下起 = Math.max(0, (D - 下条) / D);       // 下方那条比总时长短时,往后排
          var b = 下起 + 屏外段 / D;                    // 屏外段结束
          var 追止 = 下起 + (屏外段 + T追) / D;         // 追赶段结束 = 同速段开始
          var 配起时 = Math.max(0, (D - T配) / D);      // 配置器起步 = 下方内容进屏那一刻
          if (下起 > 0.004) 下点.push([下起, 0]);
          if (b > 0.004) {
            for (i = 0; i < 进屏形状.length; i++) {
              p = 进屏形状[i]; 下点.push([下起 + (b - 下起) * p[0], (1 - 追后比) * p[1]]);
            }
          }
          if (T追 > 8) {
            var 追收 = 追赶形状(true);
            for (i = 0; i < 追收.length; i++) {
              p = 追收[i]; 下点.push([b + (追止 - b) * p[0], (1 - 追后比) + (追后比 - 同速比) * p[1]]);
            }
          }
          for (i = 0; i < 下形状.length; i++) {
            p = 下形状[i]; 下点.push([追止 + p[0] * T内 / D, (1 - 同速比) + p[1] * 同速比]);
          }
          if (配起时 > 0.004) 配点.push([配起时, 0]);   // 在这之前配置器原地不动(那时下方还在屏幕外)
          for (i = 0; i < 配形状.length; i++) {
            p = 配形状[i]; 配点.push([配起时 + p[0] * T配 / D, p[1]]);
          }
          配点.push([1, 1]); 下点.push([1, 1]);        // 先到位的那个停住等,不是继续慢慢挪
        } else {
          var c = Math.min(1, T配 / D), d = Math.min(1, T内 / D);
          for (i = 0; i < 配形状.length; i++) {
            p = 配形状[i]; 配点.push([c * p[0], p[1]]);
          }
          if (c < 0.996) 配点.push([1, 1]);            // 走完就停在那儿,别再动
          for (i = 0; i < 下形状.length; i++) {
            p = 下形状[i]; 下点.push([d * p[0], 同速比 * p[1]]);
          }
          var 追尾 = Math.min(1, (T内 + T追) / D);
          if (T追 > 8) {
            var 追开 = 追赶形状(false);
            for (i = 0; i < 追开.length; i++) {
              p = 追开[i]; 下点.push([d + (追尾 - d) * p[0], 同速比 + (追后比 - 同速比) * p[1]]);
            }
          }
          if (屏外段 > 0) {
            var 尾 = Math.min(1, (T内 + T追 + 屏外段) / D);
            for (i = 0; i < 出屏形状.length; i++) {
              p = 出屏形状[i]; 下点.push([追尾 + (尾 - 追尾) * p[0], 追后比 + (1 - 追后比) * p[1]]);
            }
            if (尾 < 0.996) 下点.push([1, 1]);
          } else if (追尾 < 0.996) 下点.push([1, 1]);
        }
        /* 视觉时长 = 【肉眼看得到还在动】的那一段。
           收起时最后一刻两者才停,就是 D;
           展开时配置器 T配 停、下方内容 T内/出屏缓冲 就已经滑出屏幕了 —— 之后那截
           (含 320ms 屏外段)没必要继续冻着丝带光效(冻久了会看到光效卡住)。 */
        return {
          时长: D,
          视觉时长: Math.round(收起 ? D : Math.min(D, Math.max(T配, T内 + T追))),
          配曲线: 撑linear(配点), 下曲线: 撑linear(下点),
          /* 给守卫用的分段信息。🔴 判据【不要自己从速度反推分段】——
             试过用"速度高于某阈值就算追赶段",在配置器被拉慢的几何下(它只有 1.5px/帧)
             会把下方的正常同速段(5px/帧)也判成追赶段,抖动判据直接失效。
             分段是这个函数算出来的,就由它如实报出来。 */
          诊断: { 同速位移: 同速位移, 追赶位移: 追赶位移, 满同速: 满同速,
                  T内: Math.round(T内), T追: Math.round(T追), T配: Math.round(T配),
                  T见: Math.round(T见), 屏外段: 屏外段, 速度: 速度 }
        };
      } catch (e) { return null; }
    }
    /* 收起:同时长,但【下方内容】这一条单独用 easeOutQuad —— 2026-09-15 算出来的,不是拍脑袋。
       用户反馈:「收起的时候,他是先收下来到展开的位置,然后下面模块再生长上去,我希望它是同步的」。
       这不是代码写错了,是几何:模块展开后 2181px 高、屏幕只有 844px,
       下方内容要往上扫 1917px,其中【81% 在屏幕外面跑】。用原来那条 easeInOutQuad,
       它要到动画进行到 69% 才进画面,所以观感永远是「页面先回位 → 最后白面板才冲进来」两段。

       白面板顶边在屏幕上的位置 y(p) = 2165 − 1917·s(p) + 285·q(p)
       （s = 下方内容曲线，q = 页面回位曲线，几何值为 iPhone 390 实测）。
       网格扫描结果(scratchpad/_close-curve2.mjs)：

         曲线                     进屏时刻   速度最快/最慢   反向拐点
         easeInOutQuad(原)          69%        156 倍         无
         easeOutQuad ← 选它         49%        6.3 倍         无
         easeOutCubic               35%          —           🔴 有
         easeOutQuart / Quint    26~21%          —           🔴 有

       ⚠️ 必须【两个几何一起调】:窄屏更苛刻。实测
            390×844 → 屏幕外占 81%(进屏需曲线值 > 0.809)
            320×686 → 屏幕外占 87%(进屏需 > 0.875)   ← 按 390 调的曲线在 320 上会不够
          第一版用 easeOutQuad,390 上 49% 进屏、320 上要 70%,320 那轮直接判红。

       🔴 还有一个【必须量“总回退”而不是“单帧回退”】的坑(2026-09-15 差点漏过去):
          曲线改快之后会出现**反向飘** —— 下方内容快停了、页面还在回位,
          白面板在屏幕上往回倒退。屏幕位置 y(p) = 起点 − hide·s(p) + Δscroll·q(p),
          当 `Δ·q' > hide·s'` 就倒退。桌面的 Δ/hide 比例最大(186/649),最容易飘。
          一开始判据只看【单帧最大回退】,桌面报 1~2px 看着没事 ——
          实际是**连续 27 帧、累计倒退 59px(占可见行程 24.8%)**,肉眼一定看得见。
          → 判据必须量【总回退占可见行程的比例】。

       三个几何(390/320/1280)一起网格搜索的结论(scratchpad/_drift.mjs):
         曲线                      进屏时刻(最晚)   总回退(最坏)
         easeInOutQuad(原)             75%           0       —— 观感永远是两段
         easeOutQuad                   61%           0       —— 仍不够
         cubic-bezier(.05,.85,.3,.96)  27%        59px/24.8% 🔴 桌面严重反向飘
         cubic-bezier(.03,.6,.5,.98)   49%        1.2px/0.5% ✅ ← 选它

       为什么选它:它把【屏幕外那 1600px】在前段跑掉,白面板 33~49% 就露头
       (原来要等到 71~75%);而页面回位仍然铺满全程(滚动曲线不变)——
       于是「卡片顶边往下沉」和「白面板往上合」有一半以上的时间是【同时在动】的,
       这才是用户要的「同步、一个合拢动作」;同时三个视口的反向飘都是 0。

       ⚠️ 页面回位那条(滚动曲线)【保持不变】。给它也换成前段快的话,
          页面在 30% 就回位完了,又变回「先收下来、再等白面板」两段。
       ⚠️ 展开【不要】跟着改:展开时白面板一开始就在画面里,
          换成 easeOut 会让它瞬间甩出去,反而更糟。 */
    var DUR_CLOSE = DUR;
    /* 屏幕外行程多时用它把那段快速跑掉,好把时间省给【进屏之后】那段。
       🔴 2026-09-16 用户:「收的时候下面模块也要缓和的上去,跟配置器收下来的速度一样平缓」。
          根因是几何:收起时配置器只走 286px(全程可见),下方内容要走 1631px(其中 1329px 在屏幕外),
          同样 900ms → 下方内容在【屏幕上】的速度是配置器的 1.97 倍,所以显得急。
          解法不是放慢它(那样进屏更晚,又变回「配置器先收完、白面板最后冲进来」的两段观感),
          而是【把屏幕外那段跑得更快】,腾出时间让进屏后的那 302px 走得慢。
          实测(scripts/_try-close-curve.mjs,390×844,速度比越接近 1 越一致):
            (.03,.6,.5,.98)  进屏 47%  比 1.97   ← 旧值
            (.02,.75,.35,1)  进屏 32%  比 1.60
            (.01,.92,.22,1)  进屏 20%  比 1.36
            (.005,.96,.16,1) 进屏 16%  比 1.24
            (.005,.99,.1,1)  进屏 14%  比 1.18   ← 现用
            (0,1,.08,1)      进屏 12%  比 1.23   ← 再陡反而回升,到极限了
       ⚠️ 测这个必须在【点击之前】用带 !important 的 CSS 覆写曲线。
          第一版在点击后改行内 transition,对【已启动】的过渡无效 ——
          四条完全不同的曲线测出一模一样的 1.98/1.99,全是废数据。 */
    var EASE_补偿 = 'cubic-bezier(.005,.99,.1,1)';

    /* 🔴 用哪条曲线要【按几何现场决定】,不能写死(2026-09-15 桌面翻车才发现):
       这条补偿曲线的存在意义,就是把「在屏幕外白跑的那一段」快速消化掉。
       桌面上模块只有 891px 高、视口 800px —— 屏幕外行程只占 35%,
       本来就不需要补偿;硬用反而因为「下方内容早早跑完、页面还在回位」
       甩出 32px / 占可见行程 9.3% 的反向飘(实测)。手机上这个比例是 81~87%,才真的需要。
       判据:屏幕外行程 ÷ 屏幕上总行程 ≥ 0.6 → 用补偿曲线,否则用原来那条(零反向飘)。 */
    /* 把吸顶导航的状态【摆正】—— 兜底,不是主修。
       主修是 animScroll 里「位移不足 1px 就不写」那一条(见那里的注释)。
       但主题的 StickyHeader handler 是 **rAF 节流**的:
       它在 rAF 那一刻才去读 window.scrollY,而我们也在逐帧写 scrollTop,两者存在竞态 ——
       偶发会有一次读到「和上次一样」,而它的判断
       `scrollTop > currentScrollTop ? 隐藏 : 显示` 把【相等】算作往上滚,
       于是顶栏探头 3~8px 再收回去(0.5s 过渡只播了个开头),肉眼就是「闪一下」。
       竞态没法靠控制滚动值彻底消掉(同一份代码连跑两轮,一轮复现一轮不复现),
       所以动画收尾时按事实把它摆正:我们确实是【往下滚】的,那顶栏就该是藏着的。
       ⚠️ 只在真的往下滚过时才做,不改变主题在其它任何场景的行为;
          用户下一次真实滚动时主题照常接管。 */
    var 顶栏看管T = 0;
    function 顶栏段() {
      var 头 = document.querySelector('header.header') || document.querySelector('header');
      return 头 && 头.closest ? 头.closest('.shopify-section') : null;
    }
    /* 动画期间【由我们接管】吸顶导航的隐藏状态,每帧盯着,直到收尾后 400ms。
       为什么必须接管而不是只在收尾摆正一次:实测那一下探头发生在动画进行中(~850ms),
       收尾再摆正只能把它拉回去、拉不掉那一闪。
       只在「这次展开确实要往下滚」时接管 —— 往下滚本来就该藏着导航,
       我们只是把主题那个会误判的判断替我们自己做一遍,不改变它在别处的行为。 */
    /* 🔑 动画期间把吸顶导航的 transform【钉死】在它此刻的位置。
       为什么走到这一步(前面三种都不够,别再退回去试):
         ① 「位移不足 1px 的帧不写 scrollTop」→ 7.7px 降到 3.9px,压不干净
         ② 「动画收尾摆正一次」→ 闪发生在动画进行中,收尾太晚
         ③ 「每帧把 header-hidden 加回去」/「喂它的 currentScrollTop」→ 仍有 ~4px:
            主题在同一帧里还能把类摘掉一次,0.5s 的过渡在那 16ms 里就走了约 4px,
            而且它的 <sticky-header> 元素不一定挂在 DOM 上,喂状态变量可能是空操作。
       行内 transform 带 important,主题怎么切类都盖不过它 —— 这是唯一确定的做法。
       同时把过渡也关掉:钉住期间不需要过渡,松手时才恢复,避免松手那一下自己滑一段。
       ⚠️ 松手时【一定】要把行内样式清掉,否则导航永久卡在藏起来的位置。
       ⚠️ 只在页面还在深处时钉;滚到很靠顶时主题本来就该显示导航,不跟它抢。 */
    /* 🔑 底部那一行菜单栏(主题的 nav.mobile-dock,Home/Menu/Search/Shop/Cart/Account)
       跟顶栏是【同一个 bug 家族】,2026-09-15 用户报「展开之后下面这一行菜单栏会抖一下」。
       它也是按滚动位置判显隐(onScrollForHeader / onScrollForFooter),也用 0.5s transform 过渡。
       实测复现(3 轮中 1 轮):收起收尾那一帧文档高度从 15937 骤减到 14020,
       它离 footer 的距离突变 → 判成「到底了」→ transform 往 61px 走 → 下一帧又判回来,
       0.5s 过渡只播了个开头 = translateY 跳到 3.4px 再拉回 = 肉眼「抖一下」。
       ⚠️ 顶栏有「靠顶时不抢」的限制,dock 没有 —— 它在页面深处露着、靠顶时藏着,
          两种都是合法状态,我们只负责把它【此刻】的状态钉住,不判断该是哪种。 */
    var 钉住列表 = [];
    function 钉住(el) {
      if (!el) return;
      var 当前 = getComputedStyle(el).transform;       // 钉在它【此刻】的位置,不假设具体数值
      钉住列表.push(el);
      el.style.setProperty('transition', 'none', 'important');
      el.style.setProperty('transform', 当前 === 'none' ? 'none' : 当前, 'important');
    }
    function 松开顶栏() {
      cancelAnimationFrame(顶栏看管T);
      while (钉住列表.length) {
        var el = 钉住列表.pop();
        el.style.removeProperty('transform');
        el.style.removeProperty('transition');
      }
    }
    function 接管顶栏(时长, 展开) {
      var 段 = 顶栏段();
      var 头 = document.querySelector('header.header') || document.querySelector('header');
      /* 🔴 2026-09-24 用户报「展开后底部菜单栏还看得见,过一会儿才收掉」:
         展开时 html.diy-open 那条 CSS 要把 dock 藏起来,但这里用行内 !important 把它钉在「此刻露着」的位置,
         压过了隐藏规则,要等滚动静止(约 1.3s)才松手、它才滑走。
         展开时 dock 本来就被 CSS !important 压住,主题怎么切类都动不了它,不存在要防的抖 → 展开时不钉底栏。
         收起时照旧钉(那边的抖是真的,见上面长注释)。守卫 scripts/_verify-dock-hide-on-expand.mjs。 */
      var 底栏 = 展开 ? null : document.querySelector('nav.mobile-dock');
      /* 顶栏靠顶时不抢,但【底栏照钉】—— 所以不能在这里整个 return */
      var 要钉顶栏 = !!(段 && 头) && scroller.scrollTop > 250;
      if (!要钉顶栏 && !底栏) return;
      松开顶栏();
      if (要钉顶栏) 钉住(头);
      钉住(底栏);
      if (要钉顶栏) 段.classList.add('header-hidden');  // 类也摆正,松手后状态才是对的
      /* 🔴 松手时机不能掐表(第一版固定 DUR+400,收起那边翻车):
         收起收尾时文档会瞬间缩掉 hide 那么高(本例 1917px),
         再加上 overflowAnchor 恢复,浏览器可能在动画【结束之后】又派一次滚动事件 ——
         我们刚松手它就来了,主题判成往上滚,顶栏整个滑出来(实测 68.9px,3 轮里中 1 轮)。
         改成【等滚动真正不动了再松手】:连续 300ms 没变化才放手,自己适应各种收尾时长。
         上限兜底,免得页面一直在动就永远不放手。 */
      var 最早 = Date.now() + (时长 || DUR + 400);
      var 上限 = Date.now() + (时长 || DUR + 400) + 1500;
      var 上次滚 = scroller.scrollTop, 静止起点 = Date.now();
      /* 用户自己动手就立刻让位,别跟他抢(和 animScroll 里那套一个道理) */
      var 让位 = false;
      var 事件 = ['wheel', 'touchstart', 'keydown'];
      function 放手() { 让位 = true; }
      事件.forEach(function (e) { window.addEventListener(e, 放手, { once: true, passive: true }); });
      (function 看() {
        var now = Date.now();
        if (scroller.scrollTop !== 上次滚) { 上次滚 = scroller.scrollTop; 静止起点 = now; }
        if (段 && scroller.scrollTop > 250 && !让位) 段.classList.add('header-hidden');
        var 该松了 = 让位 || now > 上限 || (now > 最早 && now - 静止起点 > 300);
        if (!该松了) 顶栏看管T = requestAnimationFrame(看);
        else {
          事件.forEach(function (e) { window.removeEventListener(e, 放手); });
          松开顶栏();
        }
      })();
    }

    function 收起曲线() {
      try {
        var o = document.querySelector('.diy-outer') || stage;
        var 底 = o.getBoundingClientRect().bottom;   // 已含「往上盖」那段 transform,就是视觉底边
        /* 下方内容这一趟要走的距离。
           A 方案时是 hide 减去「页面同时退回的量」；B 方案页面不滚,改成减去「配置器自己退回的量」。
           ⚠️ 别留着旧的 Δ 算式:B 方案下它恒等于 0,会把行程高估 本次上盖 那么多,
              屏幕外占比被低估 → 该用补偿曲线的窄屏选不上它。 */
        var 屏上总行程 = hide - 本次上盖;
        if (!(屏上总行程 > 0)) return EASE;
        var 屏幕外占比 = Math.max(0, 底 - window.innerHeight) / 屏上总行程;
        return 屏幕外占比 >= 0.6 ? EASE_补偿 : EASE;
      } catch (e) { return EASE; }
    }

    /* 📍 打开后把模块居中到屏幕上下正中(用户 2026-08-04 指定,附参考截图)。
       可用高度 = 视口高 − 吸顶头部高(headerH() 是既有工具,用 elementsFromPoint 实测,
       不写死数值,主题换头部也跟得上)。
       模块比可用高度还高时,(avail - h)/2 为负 → Math.max(0,…) 退化成「顶边贴着头部下沿」,
       这也正是参考截图的样子(模块 ~804 高、可用 ~893,余量只有 89,居中与贴顶观感几乎一致)。
       ⚠️ 只在【打开】时滚,关闭不滚 —— 关闭时模块缩成一条带子,再滚一下会显得多余。
       ⚠️ 必须在【文档已经长高之后】算:scrollHeight 变了,上限跟着变。 */
    // 展开时滚过去的落点 = 模块在可视区上下居中,再整体上移 LIFT(用户 2026-08-04 在实机上定的)
    // ⚠️ 只需要在这里加一次。图卡集展开【完全不改滚动位置】(第 74 轮验证:全程 scrollY 恒定,
    //    模块是靠自身留白原地收缩的),所以那边会自动停在同一个落点 —— 千万别在画廊那边再加一次,
    //    否则变成累计上移 120px。
    var LIFT = 25;   // 2026-08-04 实机微调:先试 60 偏多,降 35 → 25
    function centerY() {
      var o = document.querySelector('.diy-outer') || stage;
      var r = o.getBoundingClientRect();
      var hh = headerH();
      var avail = window.innerHeight - hh;
      var y = (r.top + scroller.scrollTop) - hh - Math.max(0, (avail - r.height) / 2) + LIFT;
      var max = Math.max(0, scroller.scrollHeight - window.innerHeight);
      return Math.max(0, Math.min(y, max));   // 顶部/底部滚不动那么多时自然截断,不会出界
    }

    /* 🎯 必须持续校准到「页面真正稳定」为止(第 68 轮实测踩到):
       init 跑在脚本执行时,**字体还没加载完** —— 那时横幅比最终矮 12px,
       量出来的距离就多 12px(实测 718 vs 正确值 706),盖子停在红线上方、把横幅底部吃掉一截。
       光加 load 监听不够:web font 常在 load 之后才交换。
       用 ResizeObserver 盯住横幅与模块内容,尺寸一变就重量 —— 自愈,不用猜时机。
       ⚠️ 第 132 轮:观察对象从 `host`(外壳)改成 `.diy-outer`(内容)。
          因为 measure() 现在会写 host 的 height —— 再观察 host 就成了「自己触发自己」的回路
          (旧写法只改 margin、不改 border-box 尺寸,所以当时观察 host 是安全的)。
          `.diy-outer` 是 host 的子元素,它的高度由内容决定,不受我们写的盒子高度影响,
          而横幅就在它里面,该抓的「字体加载完横幅长高」照样抓得到。
       模块本身永不变形,所以这是「等加载稳定」,不是「跟踪形变」。
       (第 120 轮从 init 里抽出来:开着进/关着进两条路都要装,不能只挂在关着那条上) */
    function 装监听() {
      var t;
      var relayout = function () { clearTimeout(t); t = setTimeout(measure, 120); };
      /* ⚡ 第 103 轮:给入场动画留一个【定向】重量入口。
         入场没播完时 measure() 会拒绝测量(见那里的注释),收尾后必须补量一次。
         曾经用 window.dispatchEvent(new Event('resize')) 顶替 —— 能用,但会顺带惊动
         横幅流彩画布的 syncBgCanvas 等一堆无关的 resize 监听(实测让 _verify-fx 的
         削顶断言更容易偶发飘红)。只暴露这一个函数,谁都不打扰。 */
      window.__diyCoverRemeasure = relayout;
      window.addEventListener('resize', relayout);    // 断点变化时列宽/横幅高会变
      window.addEventListener('load', relayout);
      if (window.ResizeObserver) {
        var ro = new ResizeObserver(relayout);
        ro.observe(banner());
        var 内 = document.querySelector('.diy-outer');
        if (内 && 内 !== host) ro.observe(内);        /* ⚠️ 不能观察 host,见上面注释:会自己触发自己 */
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(relayout);
    }

    /* ═══════════════════════════════════════════════════════════════════════
       🔥 预热(2026-08-19 用户报「点 Design Your Rainbow 有顿挫感」)
       ═══════════════════════════════════════════════════════════════════════
       点击那一帧本来要同时干三件重活,顿挫就是它们挤在一帧里:
         ① 给下方每个板块【现场建合成层】(写 translate3d 的第一帧才提层)
         ② 万一 hide 还没量出来,现场 measure() = 一次强制重排
         ③ 放行被 CSS 掐住的图片(diy-warm)
       这里把 ①②③ 挪到点击【之前】。时机两个:
         · pointerdown —— 手指按下到抬起(才触发 click)通常有 80~150ms,足够干完。
           **这是手机端的关键**:桌面有 hover 可以提前预热,手机没有 hover,
           以前每次点都得现付这笔账,所以手机上顿挫比桌面明显得多。
         · 模块滚进视口 —— 连第一次点击也是热的(pointerdown 那 100ms 也许不够建 4 个大层)
       ⚠️ will-change 会实打实占显存,不能一直挂着 —— 用户看了没点就撤掉(见 预热T)。
       ⚠️ 动画期间不预热:run() 自己会加 .diy-cover-sib,两边抢着加删会打架。
       ⚠️ 不在这里做「提前展开/提前解裁」:被裁掉那 1900px 的内容确实还没画过,
          但提前解裁就会从层叠圆角的缺口漏出彩虹(第 132 轮专门修掉的 bug)。
          那部分开销要不要治,等这一版实机看完再定。 */
    var 预热戳 = 0, 预热T = null;
    /* 🩹 2026-08-20:预热【只提屏幕附近那几块】,不再一次提 15 块。
       用户报「展开后滚动,模块一块一块地缺」= iOS 合成层瓦片光栅化失败的典型症状,
       而一次性给 15 个整屏大的板块挂 will-change 本来就过头了(每块都是一张整屏位图,
       DPR 3 的手机上一块就好几 MB)。离屏那些在动画期间根本不需要光栅化,
       提了纯占显存 —— 挤掉的正是模块自己的瓦片。
       ⚠️ 这不等于已经定位到病根:真凶还要靠真机 A/B(?nowarm=1 等三个开关)确认。
          但「少占显存」本身是无条件正确的,先做。
       上下各留 600px 余量:动画位移量最大约一屏,留够就不会在动画中途才现建层。 */
    function 近视口(e) {
      try {
        var r = e.getBoundingClientRect();
        return r.bottom > -600 && r.top < (window.innerHeight || 0) + 600;
      } catch (err) { return false; }
    }
    function 预热() {
      if (busy || window.__DIY_NOWARM__) return;        // 动画期间不插手(run 自己在管这批类)
      /* 收起动作同样要提前建层 —— 收起时下方板块也是靠 transform 上移的,
         只是它不用付「第一次绘制配置器」那笔账,所以顿挫轻一些。两态都热,代码更简单也更稳。 */
      var now = (window.performance && performance.now) ? performance.now() : Date.now();
      if (now - 预热戳 < 1500) return;                   // 连续按不重复干
      预热戳 = now;
      try {
        if (!hide) measure();                            // ② 把可能的现场重排提前付掉
        if (typeof warmAssets === 'function') warmAssets();   // ③ 放行图片(纯网络,不占主线程)
        sibs().filter(近视口).forEach(function (e) { e.classList.add('diy-cover-sib'); });   // ① 只给屏幕附近的提前建层
      } catch (e) {}
      clearTimeout(预热T);
      预热T = setTimeout(function () {                   // 看了不点 → 把显存还回去
        if (busy) return;
        sibs().forEach(function (e) { e.classList.remove('diy-cover-sib'); });
      }, 12000);
    }

    /* ═══ 页面滚动的曲线:【无弹性】(2026-09-15 用户看完四档对照页后拍板:「我感觉无弹性更好」)═══

       回弹那一版只活了一轮,但它暴露出一个必须记住的连锁反应:
       **回弹的尾巴是一次「向上的滚动」**,而主题的吸顶导航把「向上滚」当成
       「用户想看导航」—— 实测【往回滚 15px 就会把导航放下来】。
       于是展开快结束时导航突然滑下来盖住模块顶部,就是用户报的
       「那个白色的顶梁又推了下来,页面很不稳定」。
       所以这里【不能】再用带 overshoot 的曲线:不只是审美问题,它会唤醒吸顶导航。
       四档参数仍留在本地对照页 `_弹性对照.html`,要回看随时能跑。 */
    var 滚动曲线 = bezier(.45, 0, .55, 1);        // 与下方内容的位移同一条,展开/收起都用

    /* ═══ 历史:弹性版(2026-09-15 当天推翻)═══

       🔴 弹性【只加在页面滚动上】,绝不加在兄弟块的位移上。这是算出来的,不是拍脑袋:
          兄弟块一次要走 hide ≈ 1917px,同一条回弹曲线放上去,回弹量是 39~127px
          (实测表见 scratchpad/_curve.mjs)。而【收起】时那一下会
          「白面板多盖住横幅卡 39~127px 再弹回来」—— 卡片总共才 264px 高,是明显穿帮。
          滚动的回弹则是【整屏一起动】:模块和下方内容的相对位置分毫不变,
          不会啃掉卡片、也不会露缝,屏幕上所有东西一起荡一下再稳住。
       ⚠️ 也因此不会重蹈第 95/137 轮「两条曲线速度拐点」那个坑:
          位移那条保持原样,多出来的回弹是整屏共有的,不是两个元素在打架。
       ⚠️ 曲线必须 f(1) === 1(回弹发生在【中后段】、终点精确归位),
          否则滚动会比位移早收尾,又变成两段动作。阻尼弹簧(1-e^-dt·cos wt)做不到这点
          —— 它在 t≈1/3 就到位了,剩下 2/3 在原地荡,和下方内容完全脱节,已否决。
       📐 峰值时刻要落在 0.62~0.78:太早(<0.55)观感是「中途抖了一下」,
          靠后才是「到位 → 荡过去 → 稳住」。
       🎛️ 四档参数见本地对照页 `_弹性对照.html`。用户最终选了「无弹性」,上面那条 `滚动曲线`
          就是结论;这段结论保留,是为了让下次有人想加回弹时先看到「它会唤醒吸顶导航」。 */
    var 展开前滚动 = null;                        // 展开前页面在哪儿(A 方案遗留,B 方案不滚页面,已不再使用)
    /* 🆕 本轮「往上盖」的距离。展开时现场算出来,收起时要原样退回去 —— 两头必须用同一个值,
       否则收起会收不回原位(或者多退一截,下方内容跟着错位)。 */
    /* 🔵 展开落点的顶部留白(2026-09-18 用户拍板:「电脑版展开后一定要上下居中」)。
         手机:15px 缝(模块比屏高,谈不上居中)。
         桌面:导航自然高 + (可见区 − 模块高)/2 → 模块在「导航底 ~ 屏底」之间正中;
               模块比可见区还高时退化为「顶边贴在导航底下」(取 max 0),不会把顶边推到导航后面。
       ⚠️ 用【导航自然高】不用 headerH():导航滑走时后者返回 0,回滚一点导航放下来就盖住模块顶(见 导航自然高 的注释)。
       ⚠️ run() 开头和 rAF 里两处都必须用它,只改一处 = 曲线按 A 算、位移按 B 走。 */
    function 落点留白(外) {
      var 导 = 0;
      try { 导 = (typeof 导航自然高 === 'function') ? 导航自然高() : 0; }
      catch (e) { console.error('[DIY] 落点留白:读导航高失败,按 0 算', e); }   // 兜底 catch 必须出声
      /* 2026-10-22 用户:「点左边 DESIGN 按钮展开,顶到上面了」。页面在最顶上时,导航上面还露着公告条(48px),
         导航底边实际在 141 而不是自然高 90 → 模块顶被压进去 48px。取「导航此刻在屏上的底边」与自然高的较大值;
         导航滑走时底边 ≤0,自动退回自然高,09-15 那条「位置永远固定」的规矩不受影响。 */
      try {
        var _导条 = document.querySelector('header.header');
        if (_导条) 导 = Math.max(导, Math.round(_导条.getBoundingClientRect().bottom));
      } catch (e) { console.error('[DIY] 落点留白:读导航底边失败', e); }
      /* 手机:导航底下留 15px 缝。2026-09-18 顶栏改常驻(主题级 custom_css 压住 header-hidden 的 transform)之前这里是裸 15
         —— 那时展开会把顶栏滚藏,模块顶 15px 就贴屏顶;顶栏不再藏后必须让出它的高度,否则横幅顶部被顶栏盖住 */
      if (window.matchMedia('(max-width: 760px), (max-device-width: 760px)').matches) return Math.round(导 + 15);
      var 高 = 外 ? 外.getBoundingClientRect().height : 0;
      return Math.round(导 + Math.max(0, (window.innerHeight - 导 - 高) / 2));
    }
    var 本次上盖 = 0;

    /* 滚动落点的演变(别再来回改):
         · ~2026-08-04  居中(centerY) —— 用户 2026-09-14 反馈「像被弹到首页那个固定位置」
         · 2026-09-15a  完全不滚 + 「看不见才滚」的门 —— 用户看完说卡片根本没动,不是伸长
         · 2026-09-15b  【现行】顶边贴屏幕顶,与伸长同帧同曲线 —— 卡片两头同时张开
       centerY() 已无人调用,按本项目惯例保留不删。 */

    function run(toClosed) {
      if (busy) return;
      busy = true;
      /* 展开【之前】把页面位置记下来 —— 收起时要退回这儿(用户 2026-09-15:
         「收起来的时候,能不能让他也回归一开始点开的那个位置」)。
         必须在这里记:下面 animScroll 一启动 scrollTop 就开始变了。 */
      if (!toClosed) 展开前滚动 = scroller.scrollTop;
      clearTimeout(预热T);                             // 预热的撤销定时器不能在动画中途把层撤掉
      /* 🌊 2026-09-16 用户:「配置器在移动的时候上面的渐变动效流彩是停顿的」——
         那个停顿就是这里干的。做了对照实验后【已停用】,改成常关。

         历史:2026-09-15 加这句是为了消除展开卡顿(当时测 39fps → 59fps)。
         为什么现在不需要了 —— 两条依据都变了:
           ① 当初那次是【无头】测的,没有显卡,本项目明确规定这种数据不作数
              (同一份代码无头 39fps / 有头+GPU 120fps,差 3 倍)。
           ② 动画本身从 1000ms、中段每帧 58px 的急刹,变成了 ~1990ms、每帧 3.65px 匀速,
              重光栅的成本分布跟当初完全不是一回事。

         2026-09-16 有头 + GPU 对照实验(scripts/_diag-canvas-freeze-ab.mjs,开合各 4 轮):
           展开  帧率 116.0 → 116.0 fps ·  长帧(>33ms) 3 → 3 个 · 合成器丢帧 34 → 37
           收起  帧率 117.3 → 117.1 fps ·  长帧        3 → 2 个 · 合成器丢帧 31 → 37
         —— 不冻的代价接近于零。补充事实:那片流彩(.dhb-fx)只有 366×174、本来就只跑 30fps,
            远不是当初以为的"整个 2181px 的层每帧重画"。

         🔄 回滚 = 把下面这个开关改回 true。三处渲染循环里的 `if (window.__diyFxPause) return;`
            【保留不动】,机制还在,只是不再被置位;fin() 里那句无条件解冻也保留。 */
      var 动画期间冻结流彩 = false;
      if (动画期间冻结流彩) window.__diyFxPause = true;
      /* 🎯 箭头与盖子【同帧启动、同时长、同曲线】(第 95 轮,用户 2026-08-07:
         「箭头是展开之后才转,收回之后才转,而且慢」)。
         原来这行写在 fin() 的 rAF 里 —— 那是动画**结束之后**,箭头才开始自己转 .45s,
         于是观感变成「动作做完了,箭头再慢悠悠补一下」,而不是一个动作。
         挪到开头 + 用本次开合的时长/曲线覆写,两者才是同一个动作。
         写在 run 开头还有个额外好处:动画被兜底路径打断时,箭头方向也已经是对的。 */
      /* 箭头:跟开合【同时长】,但曲线一律用 EASE。
         2026-09-15 起收起那条曲线为了让白面板早点进屏,变成了前段很陡的补偿曲线；
         那条曲线加在一个小小的箭头旋转上会「啪」地一下弹到位,很难看。
         同时长已经满足第 95 轮那条要求（「箭头要跟盖子是同一个动作,不是做完再补一下」）。 */
      /* ⚠️ 顺序动过(2026-09-16):measure / sibs 提到了 toggle 之前。
         因为箭头要跟本次开合【同时长】,而时长现在是 同速时序() 现场算出来的,
         算它需要 hide(measure 给的) 和下方内容的起点(sibs 给的)。
         安全性:`diy-cover-is-closed` 全站只被一条 CSS 用(.dhb-arrow 的旋转,见 6439 行),
         跟 measure 量的模块高度完全无关 —— 已 grep 确认,调序无副作用。 */
      if (!hide) measure();
      var list = sibs();
      /* 🌊 本次开合的节奏:配置器和下方内容【同速、同帧距】,由 同速时序() 现场算。
         几何全部在这里量完 —— 展开分支的 rAF 里直接复用,不再重算(隔了一帧,重算反而会漂)。
         · 展开:两者都还没动,量到的就是各自的动画起点
         · 收起:配置器停在 -本次上盖 处,下方内容紧贴它底边,所以「屏幕外那截」
                = 配置器底边超出屏幕的量 */
      var _节奏 = null;
      try {
        var _n外 = document.querySelector('.diy-outer') || stage;
        var _n盖 = 本次上盖;
        if (!toClosed) {
          var _n留 = 落点留白(_n外);   // 桌面上下居中 / 手机 15px 缝
          _n盖 = Math.round(_n外.getBoundingClientRect().top - _n留);
        }
        var _n总 = hide - _n盖;
        var _n屏内;
        if (toClosed) {
          _n屏内 = _n总 - Math.max(0, _n外.getBoundingClientRect().bottom - window.innerHeight);
        } else {
          _n屏内 = list[0] ? Math.max(0, window.innerHeight - list[0].getBoundingClientRect().top) : 0;
        }
        _节奏 = 同速时序(Math.abs(_n盖), _n总, _n屏内, toClosed);
        if (_节奏 && !toClosed) _节奏.上盖 = _n盖;   // rAF 里复用,避免跨帧重算漂移
      } catch (e) { _节奏 = null; }
      var 本次时长 = _节奏 ? _节奏.时长 : (toClosed ? DUR_CLOSE : DUR);
      /* 箭头:跟开合【同时长】,但曲线一律用 EASE。
         2026-09-15 起收起那条曲线为了让白面板早点进屏,变成了前段很陡的补偿曲线；
         那条曲线加在一个小小的箭头旋转上会「啪」地一下弹到位,很难看。
         同时长已经满足第 95 轮那条要求（「箭头要跟盖子是同一个动作,不是做完再补一下」）。 */
      var _d = 本次时长, _e = EASE;
      var _arrow = document.querySelector('.diy-hero-banner .dhb-arrow');
      if (_arrow) _arrow.style.transition = 'transform ' + _d + 'ms ' + _e;
      stage.classList.toggle('diy-cover-is-closed', toClosed);
      var anchor = document.documentElement, a0 = anchor.style.overflowAnchor;
      anchor.style.overflowAnchor = 'none';             // 关掉滚动锚定,别让它在文档高变化时偷偷调 scrollTop
      /* 🔴 2026-09-16 用户看录屏:「展开的时候下面模板还是直接闪下去的」。
         根因和收起那个【一模一样】，只是我上一轮只修了收起那一半:
         展开态 host 挂着 z-index:6(「往上盖」必需)，而下方内容没提层叠 ——
         展开时配置器高度瞬间变成 2181px、和下方内容【重叠】了整个下半屏，
         于是下方内容虽然在缓缓下滑(实测 81% 时长、标准差 4)，却【被配置器盖在底下看不见】，
         观感就是「配置器一下子铺满、下面的东西凭空消失」。
         ⚠️ 别再只改一边:开、合两个方向都要提，所以这段挪到了公共位置。
         提上来之后展开的观感才对 —— 下方内容压在配置器上，缓缓往下滑走、把配置器【让】出来。
         ⚠️ 只在它本来是 static 时才设 relative(主题里有 sticky 板块，覆盖了会坏)；
            动画结束在 fin() 里无条件摘干净。 */
      list.forEach(function (e) {
        e.classList.add('diy-cover-sib');
        if (getComputedStyle(e).position === 'static') e.style.position = 'relative';
        e.style.zIndex = '7';                         // 高于展开态 host 的 6
      });

      if (toClosed) {
        /* 关:先平滑上移盖住,到位后同一帧「加负边距 + 清位移」—— 两者精确抵消,肉眼零跳变。*/
        var 本次收起曲线 = 收起曲线();      // ← 按几何现场选，见 收起曲线() 的注释
        /* 🔑 2026-09-16 用户:「下面模块 The Style Edit 也【同时缓缓地】向上推上去」。
           这要求两件事【同时成立】:
             ① 早进屏 —— 晚了就变回「配置器先收完、下面才生长上去」的两段观感(用户早先否过)
             ② 进屏后【匀速慢爬】—— 快了就是「嗖一下」(修完遮挡后实测 100ms 跨过 130px)
           🔴 cubic-bezier 做不到 —— 它是平滑曲线，前段越陡、进屏那一刻的速度就越快，
              两者绑死。实测扫了 9 条(scripts/_try-reveal-curve.mjs，看 5 条横带被越过的时刻):
                (.005,.99,.1,1)   135ms 进屏  间隔标准差 49  ← 冲进来再减速
                (.02,.72,.55,.93) 444ms       标准差 25
                (.15,.42,.7,.97)  612ms       标准差 12      ← 最匀，但 68% 时间看不见它
              越匀 → 进屏越晚，是数学约束，不是参数没调好。
           ✅ 解法:CSS 的【分段线性】缓动 linear()。把「屏幕外那段」和「屏幕内那段」拆开:
              屏幕外的 N% 行程压进前 20% 时间(反正看不见)，剩下 80% 时间【线性】走完屏幕内那段。
              速度拐点正好落在屏幕边缘 —— 拐点本身看不见，用户看到的就是
              「白块从底边出现，然后匀速推上来」。
           ⚠️ N 随视口几何变(模块多高、屏幕多高)，必须运行时算，不能写死。
           ⚠️ linear() 是 CSS Easing Level 2(iOS 17.2+ / Chrome 113+)。不支持就退回
              上面 收起曲线() 选的 cubic-bezier，老行为一字不变。 */
        /* ⚠️ 下面这整段是【降级路径】,只在 同速时序() 算不出来(老浏览器不支持 linear())时才跑。
           正常路径见 run() 开头的 _节奏 —— 那条才满足用户 2026-09-16 的「同速铁律」。
           这段保留不删:它是 linear() 不可用时的老行为,一字未改。 */
        try {
          if (_节奏) throw 0;                                          // 有 _节奏 就别算旧的了
          var _ro = document.querySelector('.diy-outer') || stage;
          var _r总 = hide - 本次上盖;                                  // 下方内容这一趟的总行程
          var _r外 = Math.max(0, _ro.getBoundingClientRect().bottom - window.innerHeight);
          var _r比 = _r总 > 0 ? Math.min(0.94, _r外 / _r总) : 0;       // 其中在屏幕外的占比
          if (_r比 > 0.3 && window.CSS && CSS.supports &&
              CSS.supports('transition-timing-function', 'linear(0, 0.5 50%, 1)')) {
            /* 🌊 2026-09-16:两段式 `linear(0, 比 20%, 1)` 会在拐点【急刹车】——
               实测每帧位移从 132px 骤降到几 px，标准差 42。拐点虽在屏幕外，
               但刹车前后那几帧正好擦着屏幕边，肉眼就是「顿一下」，用户报「一抖一抖」。
               改成多点近似:屏幕外那段自己也有加减速，屏幕内那段做成【缓出】(增量 45/75/92 递减)，
               整条曲线没有速度突变 —— 柔和感来自「处处连续」，不是「分两段」。 */
            /* 🔑 减速必须【在屏幕外就完成】。
               之前把拐点直接放在「进屏那一点」，于是进屏瞬间速度还是 58px/帧、
               下一帧就掉到 8px/帧 —— 那个急刹正好发生在屏幕边缘，就是用户说的「抖」。
               现在在进屏【之前】留两级缓冲(85% → 95% → 100% 的屏外行程)，
               把速度从 5.1 一路降到 0.5，进屏后屏内是 0.29 —— 落差只剩 1.7 倍，衔接不出来。
               代价:进屏时刻从 20% 推到 ~34%，仍远早于「配置器先收完」的两段感阈值。 */
            var _f = function (k) { return (_r比 + (1 - _r比) * k).toFixed(3); };
            本次收起曲线 = 'linear(0, ' + (_r比 * 0.50).toFixed(3) + ' 8%, ' + (_r比 * 0.85).toFixed(3) + ' 18%, ' +
                           (_r比 * 0.95).toFixed(3) + ' 26%, ' + _r比.toFixed(3) + ' 34%, ' +
                           _f(0.42) + ' 55%, ' + _f(0.72) + ' 72%, ' + _f(0.91) + ' 87%, 1)';
          }
        } catch (e) { /* 算不出来就用 收起曲线() 的结果，不影响功能 */ }
        /* 🔴 2026-09-16 用户看录屏报:「收回去的时候，下面的 The Style Edit 是等到
           Design Your Rainbow 收到位置的时候才突然弹上去的」。
           逐帧确认:收起全程(1.9s / 2.2s / 2.5s)屏幕下半【一直是配置器自己的内容】，
           到 3.0s 才整块换成 The Style Edit。

           根因不是它没动 —— 它【一直在往上移】(上一轮实测 14% 就「进屏」了)，
           而是【被配置器压在底下】:为了「往上盖」，展开态给 host 挂了 z-index:6。
           ⚠️ 这也说明上一轮那条「白面板进屏够早」的判据给了【假绿灯】——
              它量的是 DOM 几何位置，没验「看不看得见」。本项目的老教训:判视觉只能读像素。

           光把配置器的 z-index 放掉【不够】:CSS 层叠里【定位元素天生压过未定位元素】，
           而 .diy-outer 带着 transform 也会创建层叠上下文、按 z-index:0 的定位元素参与排序，
           照样盖住 static 的下方 section。所以得反过来【把下方内容抬上去】。
           ⚠️ 只在收起时加、动画结束就摘:常驻会改变收起态/展开态的层叠关系。
           ⚠️ 只在它本来是 static 时才设 relative —— 主题里有 sticky 的板块，覆盖了会坏。 */
        /* 层叠提升已挪到 run() 公共段（开、合都要），这里只写动画本身 */
        /* 🔴 2026-10-22 真机录屏(iPhone,10 次开合):收起第一帧配置器跳 15~19px、下方内容跳 38~40px(≈4 帧的量),
           之后恢复 3~4 / 8px 每帧 —— 不是曲线算快了,是【第一帧晚画了 ~70ms】,计时却已开始,一出来就追位置。
           原因:收起这一刻同步做了一堆重活(html 摘 diy-dock-hide → 整页样式重算、钉顶栏、stage 切类),
           跟「设过渡」挤在同一帧。展开早就是「先摆好、下一帧再动」所以起步是 0,1,4,4…… 收起照它的做法:
           重活先做完并强制落地,隔两帧(重活那一帧完整画完)再设过渡。代价 ~33ms 起步延迟,收尾由 transitionend 驱动
           (兜底 +260ms),不会被截短。算法 / 曲线 / 时长一个字没动。 */
        接管顶栏(本次时长 + 400);
        document.documentElement.classList.remove('diy-dock-hide');   /* 在「钉住」之后摘:钉的是此刻藏着的位置,松手后主题再按滚动接管 */
        void document.documentElement.offsetHeight;                  // 重活在这一帧做完
        requestAnimationFrame(function () { requestAnimationFrame(function () {
        list.forEach(function (e) {
          e.style.transition = 'transform ' + 本次时长 + 'ms ' + (_节奏 ? _节奏.下曲线 : 本次收起曲线);
          e.style.transform  = 'translate3d(0,' + (-hide) + 'px,0)';
        });
        /* 🆕 配置器自己往下收回原位(展开时往上盖了多少,这里就退回多少)。
           和下方内容【同帧、同时长、同曲线】—— 两头一起合拢,不是先收一头再收另一头。 */
        var _oc = document.querySelector('.diy-outer') || stage;
        /* 🔴 配置器【不跟兄弟块用同一条曲线】,用平缓的 EASE。
           补偿曲线的意义是「把屏幕外白跑的那段快速消化掉」—— 配置器【全程都在屏幕上】,
           286px 一寸不浪费,给它前段极陡的曲线只会让它「啪」地掉下来。
           两者仍然【同时长、同时结束】(曲线都满足 f(1)=1),所以不会散成两段动作;
           节奏不同是【故意的】,正是为了抵消 286px vs 1631px 这个 5.7 倍的行程差。 */
        /* 🌊 2026-09-16 第二轮:有 _节奏 时【不再各走各的曲线】——
           用户的同速铁律要求两者帧距相等,所以配置器走 _节奏.配曲线、下方内容走 _节奏.下曲线,
           这两条是【配套算出来的】:同速段在时间轴上完全重合、形状完全一样,
           不同的只有"屏幕外那截什么时候跑掉"。上面那段"节奏不同是故意的"已经作废。 */
        _oc.style.transition = 'transform ' + 本次时长 + 'ms ' + (_节奏 ? _节奏.配曲线 : EASE);
        _oc.style.transform  = 'translate3d(0,0,0)';
        }); });   // ← 上面「隔两帧再设过渡」的收口
        /* 退回展开前的位置,和收起【同帧启动、同时长、同曲线】——
           来回是同一个动作的镜像(第 137 轮用户为这点返工过三轮,别再拆成两套)。
           展开前就在落点上 / 从没展开过 → animScroll 内部 <2px 自动跳过,不用额外判断。
           ⚠️ 如果展开前页面在很靠顶的位置,回弹那几像素会被浏览器夹在 0 ——
              表现是「顶到头就不弹了」,和系统自身的滚动边界行为一致,不另作处理。 */
        /* 收起也要接管:收起是【往上滚】,主题本来就会把导航放出来 ——
           但它同样会在尾段因为「这一帧没滚动」来回抖,用户报「收回原位的时候也会闪,而且极快」。
           整段动画期间保持隐藏,动画结束后松手,用户下一次真实滚动时主题照常接管。
           (2026-10-22:接管顶栏 + 摘 diy-dock-hide 已挪到上面「隔两帧」之前先做) */
        /* 🔴 B 方案下【不再退回滚动位置】—— 因为展开时页面压根没滚过,本来就在原位。
           这反而比 A 方案更稳:「退回原位」这件事从需求里消失了,不存在退不准的可能。
           animScroll / 展开前滚动 保留不删,仅不再被调用(回滚到 A 方案时要用)。 */
      } else {
        /* 开:先【无过渡】去掉负边距(文档瞬间长高 hide,兄弟块跳下 hide),
           同一帧给它们 -hide 的位移把画面按回原样 → 视觉零变化;
           下一帧再把位移平滑归零,兄弟块就「让开」露出配置器。*/
        list.forEach(function (e) { e.style.transition = 'none'; e.style.transform = 'translate3d(0,' + (-hide) + 'px,0)'; });
        host.classList.remove('diy-cover-closed');
        void host.offsetHeight;                         // 强制起点落地,否则下一步会被合并成一步跳变
        requestAnimationFrame(function () {
          /* ⚠️ 兄弟块的终点依赖 本次上盖,所以这一批必须排在下面算完之后写 —— 别挪回来。 */
          /* 与揭开动画【同帧启动、同时长、同曲线】—— 让「下方让开」和「页面滚到居中」
             合成一个动作,而不是两段先后发生的动画(那会有明显的速度拐点)。
             animScroll 内部监听 wheel/touchstart/keydown,用户一动就立刻让位、不跟他抢。 */
          /* 第 137 轮:曲线必须跟着 EASE 一起改成 easeInOutQuad,否则「下方让开」和「页面滚到居中」
             又变成两条不同节奏的动画,拐点会重新出现(这正是第 95 轮已经修过一次的那类问题)。*/
          /* 2026-09-15 用户拍板:落点从「把整块模块上下居中」改成「卡片顶边贴到屏幕顶」。
             用户原话:「感觉 Design Your Rainbow 完全没有动,只是下面那块收回去跟藏起来」
                       「点开的时候 Design Your Rainbow 主动向上伸展到全屏,
                         让人感觉它是伸出来的感觉,而不是只收下面那个模块」。
             实测确认过他的观察:老做法里卡片的【上边缘从头到尾一动没动】(恒在 301),
             动的只有下方兄弟块 —— 所以观感是「下面被收走」,不是「卡片伸出来」。
             把卡片顶边带到屏幕顶,上边缘就跟着往上爬,两头同时张开 = 伸长感。
             顺带也满足「展开后占满全屏」(A 方案:铺满一屏,内容仍可继续往下滑)。

             ⚠️ 必须和「下方让开」同帧启动、同时长(DUR)、同曲线 ——
                这正是第 95/137 轮反复修过的那类问题:两条不同节奏的动画会出现速度拐点,
                观感变成两段动作,而不是一个「被拉长」的动作。
             ⚠️ 这里【不再判断模块在不在屏幕里】:上一版为了「点横幅不滚」加过那道门,
                现在用户要的就是这段上移,横幅和左边小圆按钮走同一条路。
             ⚠️ wantedY 必须在文档已经长高之后算(此刻 diy-cover-closed 已摘),
                否则 scrollHeight 还是旧值,落点会被上限夹住滚不到位。 */
          /* 🔴 别写成 `host()`:外层作用域确实有个同名的工具函数 host(),但在 cover 这个 IIFE 里
                `host` 是【元素变量】(上面 host.classList.remove 用的就是它)。
                写 host() 会抛 "host is not a function",而这行在 rAF 回调里 ——
                异常被静默吞掉,页面看着一切正常、只是永远不滚。踩过一次,别再踩。 */
          var _o = document.querySelector('.diy-outer') || stage;
          var _r = _o.getBoundingClientRect();
          /* 落点 = 模块顶边停在【导航自然高度 + GAP】处。
             这里不用 wantedY():它内部调 headerH(),而展开时导航正藏着、量出来是 0,
             模块会贴到离屏幕顶 16px,随后导航滑下来盖掉空隙和渐变带(见 导航自然高() 的注释)。
             改用预留自然高度:导航显不显示,模块的位置都一样,页面不会再「动一下」。 */
          /* 🔴 2026-09-16 用户拍板【改成贴屏幕顶】：落点从「导航自然高 + GAP」改成「只留 GAP」。
             起因：用户截图问「上面那个红框不是还有这么多高度吗？为什么不推更高一点？」
             那 69px 原本是给吸顶导航预留的避让空间，但导航平时藏着 ——
             静止态下那块就露出【上一段文章的半截文字】，还被模块顶边硬切断,看着像没盖干净。
             ⚠️ 已知代价(用户看过示意图后明确接受)：往上滚时导航滑下来会盖住卡片顶部约 37px。
                所以「导航盖不到模块」那条老判据【不再成立】，已在验收脚本里改成记录事实、不判红。
             回滚 = 把 0 换回 导航自然高() + GAP。

             🔴 2026-09-16 二改：连 GAP(16px) 也去掉，【贴到屏幕最顶】。
             第一版留了 GAP，那 16px 仍露出上一段的文字，于是铺了一层页面底色补上 ——
             用户看到后问「怎么变成纯灰色的？」。他是对的：模块本身是【全宽】的
             （左右都顶到屏幕边），顶上却单独留一条灰边，很不协调。
             GAP=16 当年的语境是「模块顶边与导航底边之间的呼吸位」(2026-07-29)，
             现在贴的是屏幕顶、那儿没有导航，这个空隙就没有意义了。
             🔴 2026-09-16 三改（用户原话）：「手机版配置器展开后上面要漏一条缝大概 15px，
                但是不能挡掉下面的文字」。
                两件事要同时成立，别再搞混（前两版各错了一半）：
                  · 手机要【留 15px 的缝】—— 不是贴死屏幕顶
                  · 那条缝要真的「漏」出后面的页面内容 ——【不许再铺底色去糊它】
                    （上一版铺了灰，用户问「怎么变成纯灰色的？」；这一版明确不盖）
                所以下面【不再插补丁层】，缝里显示什么就是什么。
                ⚠️ 只改手机：用户说的是「手机版」。桌面保持贴顶(0)，要不要跟着留缝由用户定。 */
          var _手机 = window.matchMedia('(max-width: 760px), (max-device-width: 760px)').matches;
          var _留 = 落点留白(_o);   // 2026-09-18:桌面改上下居中(原 0 贴顶),手机仍 15
          /* 🆕【往上盖】:盖多少 = 模块顶边【此刻】离落点还有多远,现场算。
             · 停在屏幕中间点开 → 往上盖掉上半屏
             · 已经靠近顶部点开 → 只盖一点点
             · 负数(模块已在落点之上,比如被导航挡住一截)→ 往下让一点,让顶边精确停在落点
               这里【不 clamp 到 0】:clamp 了的话这种情况顶边会卡在导航底下。 */
          /* 🌊 有 _节奏 时直接复用 run() 开头量好的那个值 —— 别在这里重算。
             这里已经隔了一帧(rAF),重算会把那一帧里的滚动/布局漂移吃进来,
             导致曲线是按 A 算的、位移却按 B 走,同速就对不上了。 */
          本次上盖 = _节奏 ? _节奏.上盖 : Math.round(_r.top - _留);
          host.classList.add('diy-cover-lifting');       // 抬到上方 section 之上,才盖得住
          /* 垫底色 + 盖住顶部那条文字缝。
             🔴 别再试「读 body/html 的 backgroundColor 当页面底色」——【查不出来】：
                实测页面真实底色是 rgb(242,242,242)，而 html/main/#MainContent 全是 transparent、
                body 和 #PageContainer 都是 rgb(255,255,255)。按 DOM 取会拿到【白色】，
                铺上去就是白底压在灰底上，缝隙处一道明显色差。
                这类问题只能读像素，DOM 查询给不出答案（本项目的老教训）。
                所以底色直接用实测值（CSS 里的兜底 #f2f2f2），不做运行时猜测。 */
          /* 🔴 【不再插补丁层】。用户 2026-09-16 明确要求那条缝「不能挡掉下面的文字」——
             缝里要漏出真实的页面内容，铺底色就是在挡。
             .diy-lift-veil 的 CSS 规则保留着（在样式段），但已经没有任何地方插它了；
             要恢复「用底色补缝」只需把这段插入代码加回来。
             ⚠️ 别把它跟「防透光的那层 background-color」搞混：那层铺在模块【自己的盒子内】，
                是为了往上盖的时候不透出被盖的内容，和这条缝无关，仍然要留着。 */
          var _旧幕 = _o.querySelector('.diy-lift-veil');
          if (_旧幕) _旧幕.remove();                        // 清掉上一版可能残留的补丁层
          /* 和「下方让开」写在同一帧、同时长、同曲线 —— 第 95/137 轮反复修过的那类问题:
             两条不同节奏的动画会出现速度拐点,观感变成两段动作而不是一个「铺开」。 */
          _o.style.transition = 'transform ' + 本次时长 + 'ms ' + (_节奏 ? _节奏.配曲线 : EASE);
          _o.style.transform  = 'translate3d(0,' + (-本次上盖) + 'px,0)';
          /* 下方内容:配置器整体上移了 本次上盖,所以它们就少让开这么多 —— 正好贴住模块底边。
             对账:兄弟块自然位置 = 原位 + hide;终点 transform = -本次上盖
                 → 实际落点 = 原位 + hide − 本次上盖;
                 模块底边 = 模块顶 + 自然高 − 本次上盖 = 原位 + hide − 本次上盖 ✓ 严丝合缝 */
          /* 🔑 2026-09-16 用户:「展开的时候 The Style Edit 要和配置器同步缓和地向下，
             而不是展开的时候下面模块马上变没有」。
             和收起那条【完全镜像】:下方内容要往下走 hide−本次上盖(实测 1631px)给配置器让位，
             但【只有前 279px(17%) 在屏幕里】—— 走完就出屏了。
             普通缓动下那 279px 只花 ~270ms，剩下 630ms 它早已在屏幕外，
             所以观感就是「一下子没了」。
             解法同收起，只是比例倒过来:
               前 80% 时间 → 只走屏幕里那 17%(缓缓下滑，全程看得见，跟配置器上移同步)
               后 20% 时间 → 把屏幕外那 83% 跑掉(反正看不见)
             速度拐点同样落在屏幕边缘，看不见。
             ⚠️ 屏幕内占比高的视口(桌面实测 82%)【不套这个】—— 它本来就全程可见，
                普通缓动就是对的，硬套反而把它压成末尾才动。 */
          /* ⚠️ 下面这段同样是【降级路径】,只在 同速时序() 算不出来时跑。保留不删。 */
          var _开曲线 = EASE;
          try {
            if (_节奏) throw 0;                                        // 有 _节奏 就别算旧的了
            var _d1 = list[0];
            if (_d1) {
              var _dTop = _d1.getBoundingClientRect().top;          // 此刻已带 -hide 位移 = 动画起点
              var _出屏要走 = Math.max(0, window.innerHeight - _dTop);
              var _d总 = hide - 本次上盖;
              var _内比 = _d总 > 0 ? _出屏要走 / _d总 : 1;
              if (_内比 > 0.02 && _内比 < 0.7 && window.CSS && CSS.supports &&
                  CSS.supports('transition-timing-function', 'linear(0, 0.5 50%, 1)')) {
                /* 🌊 同收起:两段式在拐点会急加速(屏内缓慢 → 突然冲出屏)。
                   屏内那段做成【缓出】(增量 40/70/88 递减，走到 80% 时间时正好到 _内比)，
                   屏外那段也给个中间点，整条连续无突变。 */
                /* 🔑 镜像收起:屏内那段缓出，【出屏之后】才逐级放开速度，
                   不在屏幕边缘突然加速(那同样是看得见的「抖」)。 */
                /* 屏内段的增量:0.24/0.23/0.22/0.17/0.14 —— 【轻微】递减。
                   ⚠️ 别做成明显缓出(试过 0.30/0.28/0.22/0.13/0.07):末段会拖，
                      实测相邻带的间隔从 117ms 一路涨到 268ms(标准差 59)，观感是「越走越黏」。
                      柔和 ≠ 拖沓;基本匀速 + 收尾稍缓，才是「轻松」的手感。 */
                var _g = function (k) { return (_内比 * k).toFixed(3); };
                _开曲线 = 'linear(0, ' + _g(0.24) + ' 18%, ' + _g(0.47) + ' 36%, ' + _g(0.69) + ' 54%, ' +
                          _g(0.86) + ' 68%, ' + _内比.toFixed(3) + ' 80%, ' +
                          (_内比 + (1 - _内比) * 0.30).toFixed(3) + ' 87%, ' +
                          (_内比 + (1 - _内比) * 0.70).toFixed(3) + ' 94%, 1)';
              }
            }
          } catch (e) { /* 算不出来就用 EASE，老行为不变 */ }
          list.forEach(function (e) {
            e.style.transition = 'transform ' + 本次时长 + 'ms ' + (_节奏 ? _节奏.下曲线 : _开曲线);
            e.style.transform  = 'translate3d(0,' + (-本次上盖) + 'px,0)';
          });
          document.documentElement.classList.add('diy-dock-hide');   /* 点开那一刻就让底部菜单栏滑走,不等动画播完 */
          接管顶栏(本次时长 + 400, true);
          /* 🔴 这里【不再滚动页面】(老 A 方案是 animScroll(落点))。
             animScroll / 滚动曲线 / 展开前滚动 全部保留不删(本项目惯例),只是不再被这条路调用;
             想回到 A 方案:把上面两行 _o.style.* 删掉,恢复 animScroll(_落, DUR, 滚动曲线) 即可。 */
        });
      }

      /* 收尾:等兄弟块那条 transform 过渡结束(带超时兜底,防 transitionend 丢帧导致永远 busy)。*/
      var done = false;
      function fin() {
        if (done) return; done = true;
        clearTimeout(tm);
        if (list[0]) list[0].removeEventListener('transitionend', on);
        /* 🛡️ 第 72 轮:兜底解锁。busy 一旦漏解,按钮就永久失灵(用户「点了没反应」的另一种可能)。
           这里再挂一道独立的定时器,不管下面走哪条分支、有没有抛异常,都保证 busy 一定会被放开。
           ⚠️ 2026-08-18 修:原来这条定时器【没有句柄、从不取消】,于是会被下一次点击继承 ——
              第一次收起结束 → 排一个 ~900ms 后的解锁;用户在 900ms 内再点一次展开 →
              新一轮把 busy 置 true,而上一轮那个定时器随后到期,把【还在动画中】的 busy 清成 false
              → 第三次点击能在动画中途插进来,两套 transform/transition 写在同一批兄弟块上互相覆盖,
              表现就是「连点几下开合就乱」。改成带句柄 + 归属判定:只有本轮排的那条才有资格解锁。 */
        var 本轮 = ++解锁序;
        clearTimeout(解锁T);
        解锁T = setTimeout(function () { if (本轮 === 解锁序) busy = false; }, DUR + 400);
        if (toClosed) {
          host.classList.add('diy-cover-closed');       // 同帧:加负边距 + 清位移,精确抵消
          list.forEach(function (e) { e.style.transition = 'none'; e.style.transform = ''; });
          /* 🆕 配置器本体的上移也要在【同一帧】清掉,和上面那两步精确抵消。
             ⚠️ 必须清干净:留着 transform 会让收起态整块偏移 本次上盖 那么多(肉眼极明显);
                留着 .diy-cover-lifting 则会改变收起态的层叠关系,
                踩掉 `_verify-covered-clean` / `_verify-corner-visible` 那两套逐像素验收。 */
          var _of = document.querySelector('.diy-outer') || stage;
          _of.style.transition = 'none';
          _of.style.transform = '';
          _of.style.removeProperty('--diy-lift-bg');     // 底色只服务展开态,收起后一并撤掉
          var _幕f = _of.querySelector('.diy-lift-veil');
          if (_幕f) _幕f.remove();                        // 遮盖层同理:收起态不需要,留着会盖住上方内容
          host.classList.remove('diy-cover-lifting');
          本次上盖 = 0;
          void host.offsetHeight;
        }
        clampScroll();
        requestAnimationFrame(function () {
          /* ⚠️ 展开态【不能清 transform】—— B 方案下兄弟块的终点是 -本次上盖(不是 0),
             它正撑着「下方贴住模块底」这个位置。A 方案时终点恰好是 0,清空无害,
             照抄过来就会在模块底下露出一条 本次上盖 那么高的空隙(实测 232px)。
             过渡声明照撤:留着的话之后任何一次改 transform 都会自带 900ms 动画。 */
          list.forEach(function (e) {
            e.style.transition = '';
            if (toClosed) e.style.transform = '';
            /* 为了让下方内容能盖住配置器而临时抬的层叠，【开合都要】在动画结束摘干净 ——
               留着会改变这些板块之后的层叠关系（它们会一直压在别的定位元素上面）。
               展开结束后两者不再重叠，摘掉没有副作用。 */
            e.style.removeProperty('position');
            e.style.removeProperty('z-index');
            e.classList.remove('diy-cover-sib');
          });
          if (!toClosed) {
            var _oa = document.querySelector('.diy-outer') || stage;
            _oa.style.transition = '';
          }
          anchor.style.overflowAnchor = a0;
          window.__diyFxPause = false;                  // 🆕 解冻流光(必须无条件执行,见 run() 开头)
          closed = toClosed;
          btn.setAttribute('aria-expanded', String(!toClosed));
          /* 第 95 轮:箭头的 class 已移到 run() 开头(与盖子同帧启动),这里不再重复切 */
          busy = false;
        });
      }
      /* 🐛 第 72 轮修:`transitionend` 是**冒泡**事件。原来只判 propertyName,
         下方那一块里 Instagram 轮播 / 卡片 hover 等任意子元素跑完一次 transform 过渡,
         都会冒泡上来提前触发收尾 —— 动画被拦腰砍断,表现为「有时候直接跳、没有动画」。
         必须同时判 `e.target === list[0]`,只认盖子本体那条过渡。 */
      function on(e) { if (e.target === list[0] && e.propertyName === 'transform') fin(); }
      if (list[0]) list[0].addEventListener('transitionend', on);
      var tm = setTimeout(fin, 本次时长 + 260);           // 兜底跟着本次算出来的时长走
      /* 🌊 丝带光效【按视觉时长】提前解冻,不等 fin()。
         展开时下方内容会在屏幕外多跑 320ms,那段没人看得见,
         继续冻着只会让彩虹光效多停 0.3 秒(肉眼能察觉的"卡住")。
         fin() 里那句无条件解冻仍然保留 —— 这里是提前量,不是替代。 */
      if (_节奏 && _节奏.视觉时长 < 本次时长 - 40) {
        setTimeout(function () { window.__diyFxPause = false; }, _节奏.视觉时长 + 60);
      }
      if (!list.length) fin();                          // 本地独立版没有兄弟块:直接收尾,不卡 busy
    }

    return {
      init: function (开着进) {
        /* 开着进 = 从分享链接(?d=)来的访客,或独立 DIY 页面(/pages/design)。第 120 轮修:
           盖子默认关着(首屏只露一条流光带勾人点开),但分享来的人顶上挂着
           「这副是 X 配出来的搭配」,底下却被盖住什么都没有 —— 用户实测原话「非常奇怪」。
           他是冲着看这副设计来的,盖子必须一开始就是开的。

           ⚠️ 第 128 轮:`closed = false` 必须在 measure() 【之前】。
           measure() 里的 `var wasClosed = closed` 读的是【内部变量】而不是 DOM 上有没有那个类,
           而 closed 的初值是 true。原来的顺序(先 measure 后置 false)会让 measure 的
           「量完还原」那一步凭空把 .diy-cover-closed 加回 DOM —— 解析期内联脚本明明放行了,
           盖子还是盖上了。之后要等 ResizeObserver 触发第二次 measure 才删掉。
           实测独立页面:t=3813 remove → 3818 add → 3982 remove,中间 164ms 挂着 -771px 负边距,
           下方内容整块跳。分享链接(?d=)那条路径吃的是同一个 bug,一并修掉。 */
        if (开着进) closed = false;
        measure();
        if (开着进) {
          btn.setAttribute('aria-expanded', 'true');
          return void 装监听();
        }
        host.classList.add('diy-cover-closed');         // 默认关闭
        stage.classList.add('diy-cover-is-closed');
        btn.setAttribute('aria-expanded', 'false');
        /* 🎯 必须持续校准到「页面真正稳定」为止(第 68 轮实测踩到):
           init 跑在脚本执行时,**字体还没加载完** —— 那时横幅比最终矮 12px,
           量出来的距离就多 12px(实测 718 vs 正确值 706),盖子停在红线上方、把横幅底部吃掉一截。
           光加 load 监听不够:web font 常在 load 之后才交换。
           用 ResizeObserver 盯住横幅与 host,尺寸一变就重量 —— 自愈,不用猜时机。
           ⚠️ measure() 只改 margin(不改 border-box 尺寸),不会自己触发这个观察器,无死循环。
           模块本身永不变形,所以这是「等加载稳定」,不是「跟踪形变」。 */
        装监听();
      },
      toggle: function () { run(!closed); },
      isClosed: function () { return closed; },
      warm: 预热,
    };
  })();

  /* ══════════════════════════════════════════════════════════════════════
     ㉑ 全屏浮层(2026-09-14 用户拍板)。配套 CSS 见 <style> 里「㉑ 全屏浮层」整段。
     ══════════════════════════════════════════════════════════════════════
     🔴 现状(2026-09-15 起):这一整段【没有任何入口在调用】,横幅按钮已改回 cover.toggle()。
        原因见那颗按钮的绑定处 —— 浮层把模块抬出页面塞进一屏高的盒子,
        伸长感和比例都丢了,用户实测退回。
        按本项目惯例【保留不删】:左边小圆按钮(FAB)以后要单独设计呈现方式,
        大概率还用得上它(从按钮矩形长到整屏那套公式已经调到 0.0px 偏差,
        守卫脚本 scripts/_verify-open-morph*.mjs 也还在)。
        要重新启用,只需把按钮绑定改回 `浮层.open(btn)`。 */
  var 浮层 = (function () {
    var 根 = document.documentElement;
    var outer = document.querySelector('.diy-outer');
    var 开着 = false, 忙 = false, 压了栈 = false, 存的滚动 = 0;
    var 关钮 = null;
    /* 时长按路程给:横幅只走两三百像素,小圆按钮要长满整屏 —— 一刀切会让近的拖沓、远的赶。 */
    var 入场横幅 = 400, 入场按钮 = 480, 退场 = 300, 曲线 = 'cubic-bezier(.32,.72,0,1)';  // 曲线照抄画廊(433 行),全站一套语言
    var 起点缩放 = 0.28;                                    // 只在量不出起点矩形时的兜底路径用
    var 起点帧 = null, 起点视口 = [0, 0], 本次入场 = 入场横幅; // 存着给 close() 原路缩回去

    function 造关钮() {
      if (关钮 || !outer) return;
      关钮 = document.createElement('button');
      关钮.className = 'diy-overlay-close';
      关钮.type = 'button';
      /* aria-label 走英文:店铺主语言是英文,而 TR() 定义在段 1 的 IIFE 里,这里够不着。 */
      关钮.setAttribute('aria-label', 'Close');
      关钮.innerHTML = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
        '<path d="M2.5 2.5l11 11M13.5 2.5l-11 11" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
      关钮.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); close(); });
      outer.appendChild(关钮);
    }

    /* ── 入场/退场的唯一一条规则(2026-09-15 用户拍板)────────────────────────
       浮层永远从「用户手指碰到的那个矩形」长到「整块屏幕」。
       起点矩形不同,观感自动不同,【不写两套动画】:
         · 首页彩虹卡 → 起点 = 那张卡的可见窗口 → 原地拉开(用户要的「伸长出来」)
         · 左边小圆钮 → 起点 = 按钮自己的矩形   → 从按钮慢慢放大
       实测(iPhone 390):卡片收起态 366×174、浮层态还是 366×174,顶边 1194→33。
       **大小一模一样,所以横幅这一路绝不能缩放** —— 一缩放肉眼就看得见它先缩小再涨回来。
       老的「从按钮中心 scale(0.28)」只留作量不出起点矩形时的兜底。

       上一版为什么被推翻:整块浮层从 0.28 倍放大,那个倍数下看到的是【整页缩略图】,
       同时原位那张卡瞬间消失留下一个空洞 —— 用户原话「整个页面是变上来的」。 */

    /* 收起态的 clip-path 形如 inset(0px 0px 11px),取它的【底部】内缩值。
       CSS 简写语义:1 个值=四边,2 个值=上下/左右,3~4 个值的第 3 个才是底。 */
    function 读裁剪底(el) {
      try {
        var m = /inset\(([^)]+)\)/.exec(getComputedStyle(el).clipPath || '');
        if (!m) return 0;
        var v = m[1].split('/')[0].trim().split(/\s+/).map(parseFloat);
        return (v.length <= 2 ? v[0] : v[2]) || 0;
      } catch (e) { return 0; }
    }

    /* 量起点矩形。
       ⚠️ 必须在加 .diy-overlay-open 【之前】调 —— 加类之后横幅已被浮层盖住、位置也变了。
          「展开前记视口坐标 / 展开后再换算」这条两步走纪律,跟画廊 readHookCenter
          (11798-11812)是同一个坑,画廊第 75 轮就栽在一次算完上。 */
    function 量起点() {
      /* FAB 在另一个 section(overlay-group 里的 rainbow-diy-fab),它合成的 click
         clientX/clientY 恒为 0,只能靠这个全局变量把自己的矩形传过来。带时间戳防复用上次的值。 */
      var s = window.__diyOpenOrigin;
      if (s && Date.now() - s.t < 1500 && s.w > 0) {
        window.__diyOpenOrigin = null;                      // 读完即清,不许被下一次点横幅复用
        var h = s.h || s.w;                                 // 老版本只传中心点+宽度,兼容
        return { 按钮路: true, 圆角: s.br || 0, 卡前: null,
                 矩: { l: (typeof s.l === 'number') ? s.l : s.x - s.w / 2,
                       t: (typeof s.tp === 'number') ? s.tp : s.y - h / 2, w: s.w, h: h } };
      }
      /* 横幅路。用户看到的「那张卡」= .diy-outer 的收起位置 ∩ section 的裁剪窗口 ∩ 视口,
         【不是按钮本身】—— 按钮只是卡里面那颗白药丸(270×94),照它对位会小一圈。 */
      var o = outer.getBoundingClientRect();
      if (!o.width) return null;
      var 顶 = o.top, 底 = o.bottom;
      var sec = outer.closest ? outer.closest('.shopify-section') : null;
      if (sec) {
        var sr = sec.getBoundingClientRect();
        顶 = Math.max(顶, sr.top);
        底 = Math.min(底, sr.bottom - 读裁剪底(sec));
      }
      /* ⚠️ 下一块 section 是【压在】这张卡上面的(白面板带负边距往上骑一截)。
         浮层一变成 fixed 就爬到它上头,卡片凭空长高约 15px —— 第一帧就露馅。
         所以窗口底边还要再让给下一块真正开始画的位置。直接子元素里取最高的那个:
         section 自己的 box 顶边是量不出负边距的。 */
      var 下 = sec && sec.nextElementSibling;
      if (下) {
        var 下顶 = 下.getBoundingClientRect().top;
        for (var i = 0; i < 下.children.length; i++) {
          var cr = 下.children[i].getBoundingClientRect();
          if (cr.height) 下顶 = Math.min(下顶, cr.top);
        }
        底 = Math.min(底, 下顶);
      }
      顶 = Math.max(顶, 0); 底 = Math.min(底, innerHeight);
      if (底 - 顶 < 40) return null;                         // 卡片几乎不在屏幕里 → 不做对位,走兜底
      var c0 = outer.querySelector('.dhb-card');
      c0 = c0 && c0.getBoundingClientRect();
      if (!c0 || !c0.width) return null;
      return { 按钮路: false, 卡前: c0,
               圆角: parseFloat(getComputedStyle(outer).borderTopLeftRadius) || 0,
               矩: { l: o.left, t: 顶, w: o.width, h: 底 - 顶 } };
    }

    /* 把起点矩形换算成动画首帧。加类【之后】调 —— 这时 outer 才是 inset:0 的终态。
       共享元素对位:.dhb-card 在收起态和浮层态是同一个 DOM,拿它前后两个矩形反推整块
       浮层的位移与缩放比。桌面端 stage 带 scale(.85) 时,这个比值会自动把缩放算进去,
       所以【不需要】画廊那段 sp 父级缩放换算。 */
    function 算首帧(起) {
      if (!起) return null;
      var W = outer.offsetWidth, H = outer.offsetHeight;
      if (!W || !H) return null;
      var 锚前, 锚后;
      if (起.卡前) {
        var c1 = outer.querySelector('.dhb-card');
        c1 = c1 && c1.getBoundingClientRect();
        if (!c1 || !c1.width) return null;
        锚前 = 起.卡前; 锚后 = c1;
      } else {
        锚前 = { left: 起.矩.l, top: 起.矩.t, width: 起.矩.w, height: 起.矩.h };
        锚后 = { left: 0, top: 0, width: W, height: H };     // 没有共享元素 → 整块浮层缩到按钮那么大
      }
      var s = 锚前.width / 锚后.width;
      if (!(s > 0) || !isFinite(s)) return null;
      var dx = 锚前.left - s * 锚后.left, dy = 锚前.top - s * 锚后.top;
      /* clip-path 作用在变换【之前】,所以要把「该露出来的那个视口矩形」换算回浮层自身坐标。
         四条边一律夹到非负:卡片被视口切掉一半时算出来可能是负数,而负的 inset 是非法值。 */
      var L = (起.矩.l - dx) / s, T = (起.矩.t - dy) / s, w = 起.矩.w / s, h = 起.矩.h / s;
      var 夹 = function (v) { return Math.max(0, v).toFixed(2) + 'px'; };
      return {
        transform: 'translate(' + dx.toFixed(2) + 'px, ' + dy.toFixed(2) + 'px) scale(' + s.toFixed(5) + ')',
        clipPath: 'inset(' + 夹(T) + ' ' + 夹(W - L - w) + ' ' + 夹(H - T - h) + ' ' + 夹(L) +
                  ' round ' + 夹((起.圆角 || 0) / s) + ')'
      };
    }

    function 终帧() { return { transform: 'none', clipPath: 'inset(0px 0px 0px 0px round 0px)' }; }

    function open(触发元素) {
      if (开着 || 忙 || !outer) return;
      忙 = true;
      var 起 = 量起点();                          // ← 必须在加类之前量
      存的滚动 = window.scrollY || 0;
      造关钮();
      根.classList.add('diy-overlay-lock');
      根.classList.add('diy-overlay-open');
      开着 = true;
      var 首 = 算首帧(起);
      起点帧 = 首;
      起点视口 = [innerWidth, innerHeight];
      本次入场 = (首 && 起.按钮路) ? 入场按钮 : 入场横幅;
      /* 🔴 用 WAAPI 而不是 CSS transition,关键在 fill:'none' ——
         动画跑完后 computed transform / clip-path 自动回到 none。
         .diy-outer 上【绝不能残留 transform】:它会给后代的 position:fixed 创建包含块,
         而手机版图卡画廊正是靠 fixed 钉视口的(build-section.py:1259 有明确记录)。
         CSS transition 会停在 scale(1) —— 那仍然是一个 transform,埋雷。
         clip-path 同理:这一版新引入,残留会把画廊整个裁掉,同样交给 fill:'none' 自动清。 */
      try {
        if (首) {
          outer.style.transformOrigin = '0 0';    // 公式是按左上角原点推的,必须配套
          outer.animate([首, 终帧()], { duration: 本次入场, easing: 曲线, fill: 'none' });
        } else {
          outer.style.transformOrigin = '50% 50%';
          outer.animate([{ transform: 'scale(' + 起点缩放 + ')', opacity: 0 },
                         { transform: 'none', opacity: 1 }],
                        { duration: 本次入场, easing: 曲线, fill: 'none' });
        }
      } catch (e) {}
      /* 安卓返回键 / iOS 侧滑返回:占一格历史,不然用户一返回直接退出站点 */
      if (!/[?&]noback=1/.test(location.search)) {
        try { history.pushState({ diyOverlay: 1 }, '', location.href); 压了栈 = true; } catch (e) {}
      }
      /* 关闭 ✕ 要等画面张开一多半再淡进来。
         不这么做的话它在【第一帧】就画在卡片右上角了 —— 那一刻卡片本该跟点击前一模一样,
         凭空多一个按钮,正是「断裂感」的来源之一(2026-09-15 逐帧截图抓到)。 */
      if (关钮) {
        关钮.style.transition = 'none';
        关钮.style.opacity = '0';
        setTimeout(function () {
          if (!开着 || !关钮) return;
          关钮.style.transition = 'opacity .18s ease';
          关钮.style.opacity = '1';
        }, Math.round(本次入场 * 0.55));
      }
      if (btn) btn.setAttribute('aria-expanded', 'true');
      setTimeout(function () { 忙 = false; }, 本次入场);
    }

    function close(来自返回键) {
      if (!开着 || 忙 || !outer) return;
      忙 = true;
      /* ✕ 立刻收掉:退场是「折回那张卡」,卡上不该挂着一个关闭按钮跟着缩 */
      if (关钮) { 关钮.style.transition = 'none'; 关钮.style.opacity = '0'; }
      /* 原路缩回去:从哪个矩形长出来的,就折回哪个矩形 ——
         开和关是同一扇门,不然会有「进出不是一个地方」的别扭感。
         中途转屏 / 改窗口大小 → 存的起点帧已经失效,退回老的中心缩放。 */
      var 可原路 = !!起点帧 && 起点视口[0] === innerWidth && 起点视口[1] === innerHeight;
      var 本次退场 = 可原路 ? Math.max(260, 本次入场 - 80) : 退场;
      var 动 = null;
      try {
        outer.style.transformOrigin = 可原路 ? '0 0' : '50% 50%';
        /* 🔴 退场这里用 fill:'forwards' 而不是 'none' —— 'none' 会在最后一帧先弹回全屏、
           下一刻才被摘类,闪一下。代价是 forwards 会把 transform/clip-path 钉在元素上,
           那正是埋给画廊的雷,所以收尾里摘完类【立刻】cancel() 退干净。少那一行就出事。 */
        动 = 可原路
          ? outer.animate([终帧(), 起点帧], { duration: 本次退场, easing: 曲线, fill: 'forwards' })
          : outer.animate([{ transform: 'none', opacity: 1 },
                           { transform: 'scale(' + 起点缩放 + ')', opacity: 0 }],
                          { duration: 本次退场, easing: 曲线, fill: 'forwards' });
      } catch (e) {}
      var 收过 = false;
      function 收尾() {
        if (收过) return; 收过 = true;
        /* ⚠️ 顺序有讲究:摘掉 diy-overlay-open 的同时 clip-path 会还原,
           而还原那一下 section 圆角处会漏出彩虹小三角(5791 那个坑)。
           所以必须等退场动画【播完】再摘 —— 动画期间浮层还盖着,看不见。 */
        根.classList.remove('diy-overlay-open');
        根.classList.remove('diy-overlay-lock');
        /* 🔴 紧接着摘类把 fill:'forwards' 留下的 transform / clip-path 退干净。
           残留 transform 会给后代 position:fixed 造包含块、残留 clip-path 会把画廊裁没,
           两样都是手机版图卡的死穴。摘类和 cancel 在同一个任务里,中间不会有绘制。 */
        try { if (动) 动.cancel(); } catch (e) {}
        outer.style.transformOrigin = '';
        开着 = false;
        /* 锁 overflow 期间 iOS 某些版本会重置 scrollTop,还原一次(照抄画廊 11733/11956 那套)。
           正常情况下浮层全程没滚过页面 —— 这正是老方案 centerY() 那段滚动被根治的地方。 */
        try { window.scrollTo(0, 存的滚动); } catch (e) {}
        if (btn) btn.setAttribute('aria-expanded', 'false');
        /* 浮层期间 measure() 一直被那道门挡着,现在补量一次让 --diy-box 回到真值。
           用定向入口而不是 dispatchEvent(new Event('resize')) —— 后者会惊动横幅流彩画布的
           syncBgCanvas 等一堆无关监听,历史上让 _verify-fx 偶发飘红。 */
        try { window.__diyCoverRemeasure && window.__diyCoverRemeasure(); } catch (e) {}
        忙 = false;
      }
      if (动) { 动.onfinish = 收尾; setTimeout(收尾, 本次退场 + 140); }  // onfinish 不保证必达,兜底
      else 收尾();
      if (压了栈 && !来自返回键) { 压了栈 = false; try { history.back(); } catch (e) {} }
      else if (来自返回键) 压了栈 = false;
    }

    window.addEventListener('popstate', function () { if (开着) close(true); });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !开着) return;
      /* 画廊自己也监听 ESC(11011,在段 2)。段 2 先执行先注册先跑,
         所以这一下如果画廊开着,就是给它的,我们让路。 */
      if (document.querySelector('.fs-gallery.is-open')) return;
      close();
    });

    /* 桌面点空白处关闭。只认点在 outer 自己身上(= 配置器卡片四周那圈渐变底),
       点到卡片内部时 e.target 是子元素,不会误关。手机不做:满屏几乎没有空白可点。 */
    if (outer) outer.addEventListener('click', function (e) {
      if (开着 && e.target === outer && innerWidth >= 761) close();
    });

    return { open: open, close: close, isOpen: function () { return 开着; } };
  })();
  window.__diyOverlay = 浮层;        // 给 FAB / 验收脚本用

  btn.addEventListener('click', function (e) {
    e.preventDefault();                                // 横幅按钮是 <a href="#">,永远要拦掉跳锚点
    if (!TOGGLE_ENABLED) return;                       // 独立页 /pages/design 进来即全开,不做开合
    /* 2026-09-15 用户拍板【改回 cover.toggle()】。
       中间那一版(2026-09-14)把它换成了全屏浮层,用户实测反馈:
         「体验感没有之前那么好,之前是非常丝滑的伸长感,现在都是闪出来的,
           而且横版的效果那个比例也是不对的」。
       两条都成立,而且是同一个根因:浮层把整块抬出页面、塞进一个刚好一屏高的盒子里
       —— 高度不再真的在长(所以没有伸长感,只是开了个窗),比例也被压变。
       原则(用户原话):在之前的基础上不断优化,不要颠覆。
       浮层那套代码保留不删、也不再被这颗按钮调用,留给左边小圆按钮以后单独设计。 */
    cover.toggle();
  });

  /* ══════════════════════════════════════════════════════════════
     🔬 真机排查开关(2026-08-20 用户报「展开后滚动,模块一块一块地缺」)
     ══════════════════════════════════════════════════════════════
     症状(用户真机截图 3 张):展开态滚动时,模块的彩底成片缺失、顶部内容不见、
     中间飘着一个糊掉的按钮 —— 典型的 iOS **合成层瓦片光栅化失败**
     (图层太多/太大 → 显存不够 → 瓦片被丢弃 → 留白)。
     **桌面引擎复现不出来**,所以只能在真机上做 A/B。三个开关各关掉一个嫌疑:
       ?nowarm=1      关掉 2026-08-19 加的预热(给下方板块提前建合成层)
       ?noheadroom=1  关掉 2026-08-19 加的顶边净空(padding + 负 margin)
       ?noglass=1     关掉模块内所有毛玻璃(backdrop-filter)—— iOS 上最经典的光栅化开销
     用法:在预览网址后面追加,例如
       https://monixibi.com/?preview_theme_id=150657892525&nowarm=1
     哪个开关一加症状就消失,病根就是它。三个都加还在 → 与这三者无关,另查。 */
  /* ⏸️ 离屏就停(2026-08-21)。CSS 侧见 `.diy-outer.diy-offscreen` 那段的完整说明。
     一句话:模块滚出视口后仍在每秒重画 135 次(实测静止 6 秒 808 次),纯属给看不见的东西打工。
     ⚠️ 初始【不挂】.diy-offscreen:IntersectionObserver 的首次回调会同步给出真实状态,
        先挂后撤会让首屏那一帧的动画停一下再启动(等于自己制造一次卡顿)。
     ⚠️ rootMargin 300px:提前解冻,别让用户看到"刚滚进来是静止的"。 */
  if (!/[?&]nopause=1/.test(location.search) && 'IntersectionObserver' in window) {
    var 模块 = document.querySelector('.diy-outer');
    if (模块) {
      new IntersectionObserver(function (es) {
        var 在屏 = es.some(function (x) { return x.isIntersecting; });
        模块.classList.toggle('diy-offscreen', !在屏);
      }, { rootMargin: '300px 0px 300px 0px' }).observe(模块);
    }
  }

  /* 🤫 滚动期间静音(CSS 侧见 `.diy-outer.diy-quiet` 那段的完整说明)。
     滚动那一刻把装饰动画全停,把算力让给瓦片光栅化;停下 150ms 恢复。
     ⚠️ 监听必须 passive:滚动事件里做任何阻塞都会直接变成卡顿。
     ⚠️ capture:true —— 页面里有内部滚动容器(四列横向滚动条),冒泡阶段未必收得到。
     ⚠️ 只加/删一个类,不做任何测量:滚动回调里读几何 = 强制同步布局,那是真卡顿源。 */
  if (!/[?&]noquiet=1/.test(location.search)) {
    var 模块Q = document.querySelector('.diy-outer');
    if (模块Q) {
      var 静音T = null;
      addEventListener('scroll', function () {
        if (!模块Q.classList.contains('diy-quiet')) 模块Q.classList.add('diy-quiet');
        clearTimeout(静音T);
        静音T = setTimeout(function () { 模块Q.classList.remove('diy-quiet'); }, 150);
      }, { passive: true, capture: true });
    }
  }

  var 排查 = location.search;
  if (/[?&]nowarm=1/.test(排查)) window.__DIY_NOWARM__ = true;
  if (/[?&]noglow=1/.test(排查)) document.documentElement.classList.add('diy-noglow');
  /* 这两个是「把已删掉的效果临时找回来」的开关,方便和旧版对比(默认都不生效) */
  if (/[?&]glow=1/.test(排查)) document.documentElement.classList.add('diy-glow-on');
  if (/[?&]btnglass=1/.test(排查)) document.documentElement.classList.add('diy-btnglass-on');
  if (/[?&]noheadroom=1/.test(排查)) document.documentElement.style.setProperty('--diy-glow-headroom', '0px');
  if (/[?&]noglass=1/.test(排查)) document.documentElement.classList.add('diy-noglass');

  /* 🔥 预热的两个触发点(见 cover 内部 预热() 的大段注释)。
     ⚠️ pointerdown 必须用,不能只用 click:click 是【手指抬起】才触发的,
        那时已经晚了。pointerdown 在【按下】就触发,白赚 80~150ms。
     ⚠️ 同时挂 touchstart 兜底:老 Safari 没有 pointer 事件。passive 让它不影响滚动。
     ⚠️ mouseenter 也挂上:桌面鼠标移过去时就热,比按下更早。 */
  if (TOGGLE_ENABLED && cover && cover.warm) {
    var 预热钩 = function () { cover.warm(); };
    ['pointerdown', 'touchstart', 'mouseenter'].forEach(function (evt) {
      btn.addEventListener(evt, 预热钩, { passive: true });
    });
    /* 模块滚进视口就先热一次 —— 手机上 pointerdown 那 100ms 未必够建 4 个整屏大的合成层。
       rootMargin 给 200px:还没滚到就开始准备。只做一次,之后交给 pointerdown 续热。 */
    if ('IntersectionObserver' in window) {
      var 视口热 = new IntersectionObserver(function (es) {
        if (!es.some(function (x) { return x.isIntersecting; })) return;
        视口热.disconnect();
        (window.requestIdleCallback || function (f) { return setTimeout(f, 0); })(预热钩, { timeout: 1200 });
      }, { rootMargin: '200px' });
      var 观察目标 = document.querySelector('.diy-hero-banner') || btn;
      if (观察目标) 视口热.observe(观察目标);
    }
  }

  /* 底色画布尺寸要在【首屏就正确】—— 折叠态的带子是访客第一眼看到的东西,
     不能等到第一次开合才修正,否则颜色会在用户点击后变一次。
     放在 rAF 里而不是同步执行:避开首屏的关键渲染路径;窗口尺寸变了也要重量。*/
  requestAnimationFrame(syncBgCanvas);
  window.addEventListener('resize', function () {
    clearTimeout(window.__diyBgT);
    window.__diyBgT = setTimeout(syncBgCanvas, 200);
  });

  // 初始态:本地独立预览默认「展开」,线上 section 默认「折叠」(用户 2026-07-28)
  //   本地这个 index.html 是拿来看完整中文 DIY 模块的工作页 —— 打开只剩一条流光带没法用;
  //   线上嫁接版才需要默认折叠成一条带子勾人点开。
  //   靠有没有 section 外壳 .diy-outer 来区分,不用改任何构建逻辑。
  // 手动覆盖:?diy=open 强制展开(自检脚本用)、?diy=fold 强制折叠(本地看折叠态用)
  // ⑯ Add to Cart hover:白色弧面上涌(照搬主题 theme.HoverButton 的进/出两段动作)
  //   为什么要 JS:CSS transition 离开时只会原路退回(往下走),而主题的动作进出都是**向上**的,
  //   必须切两段不同的 keyframes 才能复刻。CSS 在 <style> 的 ⑯ 段。
  (function () {
    var cta = document.getElementById('add-to-cart');
    if (!cta || !matchMedia('(hover: hover)').matches) return;
    cta.addEventListener('mouseenter', function () {
      if (cta.disabled) return;
      cta.classList.remove('cta-fill-out'); cta.classList.add('cta-fill-in');
    });
    cta.addEventListener('mouseleave', function () {
      if (!cta.classList.contains('cta-fill-in')) return;   // 没进过就别播出场,免得首屏白闪
      cta.classList.remove('cta-fill-in'); cta.classList.add('cta-fill-out');
    });
  })();

  /* 第 66 轮:初始态已上移到 IIFE 顶部(必须早于 ⑲ 段的资源预热判断,见那里的注释),此处不再重复。

     第 68 轮:盖子的初始化放在这里 —— 必须等模块完全排版好(横幅高度、四列高度都到位)才能量准。
     ⚠️ 顺序很重要:上面已经把 .diy-expanded / .diy-open-done / .diy-warm 挂好了,
        模块此刻是【最终形态】,measure() 量到的就是真值,之后永不再变。
     ?diy=open 可跳过默认关闭,直接全开(自检脚本 / 排查用)。 */
  /* 第 120 轮:从分享链接(?d=)进来的访客,盖子一开始就得是开的,而且要把模块送到眼前。
     用户实测:点开朋友发的链接,顶上写着「这副是 X 配出来的搭配」,底下却是盖着的一条流光带,
     配置器躺在 2240px 处 —— 他原话「这对用户来说非常奇怪」。
     他是冲着看这副设计来的,不是来逛首页的,所以两件事都得做:开盖 + 滚过去。 */
  /* 第 129 轮:?pick=(配件产品页的单件预选)也算「冲着看某样东西来的」,同样要开盖 + 送到眼前。
     现在按钮指向 /pages/design(本来就全开),这条是为「以后按钮改指首页」留的兜底 ——
     不加的话那种链接点进去是一条盖着的流光带,和第 120 轮分享链接踩的坑一模一样。 */
  var 分享进来 = /[?&](?:d=1\.|pick=)/.test(location.search);
  /* 第 128 轮:独立 DIY 页面(/pages/design)。__DIY_STANDALONE__ 由 section 的 liquid 在
     template.suffix == 'diy' 时输出(见 build-section.py 那段注释)。本地静态版没有它 = undefined,
     所以 index.html 直接开着看的行为一点没变。
     为什么要走「开着进」而不是让盖子照常关:盖子是靠负下边距把【下一个板块】拉上来当盖子的,
     那个页面上模块是 <main> 唯一的子元素,没有下一个板块 —— 负边距空转,配置器全露着,
     但状态机仍认为自己关着(实测 aria-expanded=false),点横幅会跑一遍开合动画去推不存在的板块。
     而且专属页面本来就该进来即全开。⚠️ 只在这里判不够,解析期的内联防闪脚本也判了同一条。 */
  var 独立页 = window.__DIY_STANDALONE__ === true;
  /* ⛔ 2026-08-17 用户拍板(方案 C):盖子默认停用。__DIY_NO_COVER__ 由 section 的 liquid 在
     `cover_enabled` 没勾时输出(见 scripts/build-section.py 那段注释里的完整停用理由)。
     本地静态版没有它 = undefined,index.html 直接开着看的行为一点没变。
     走「开着进」这条既有路径而不是新写分支:那条路本来就是给独立页/分享链接用的,
     已验证过「进站即摊开」的完整行为(closed=false → 不加 .diy-cover-closed →
     负下边距不生效 → measure() 里 wasClosed 为假,也不会把盖子类凭空加回来)。 */
  var 不用盖子 = window.__DIY_NO_COVER__ === true;
  if (!/[?&]diy=open(&|$)/.test(location.search)) cover.init(分享进来 || 独立页 || 不用盖子);

  if (分享进来) {
    var 送到眼前 = function () {
      var 锚 = stage;
      if (!锚) return;
      // 不用 scrollIntoView:它会把元素顶到视口最上沿,正好被主题那条固定页头压住。
      // 手动留 130px 给页头。也不用 smooth —— 2000+px 的长距离平滑滚动只会让人晕,
      // 点链接看某样东西,预期是"直接到",不是"带你飞过去"。
      var y = window.scrollY + 锚.getBoundingClientRect().top - 130;
      window.scrollTo(0, Math.max(0, y));
    };
    // 量两次:布局稳定一次、图片/字体加载完再补一次(模块上方有 hero 轮播,图载入后高度会变)
    window.addEventListener('load', function () { setTimeout(送到眼前, 240); });
    setTimeout(送到眼前, 800);
  }
})();



(function () {
  var t;
  document.addEventListener('scroll', function (e) {
    var row = e.target;
    if (!row || !row.classList || !row.classList.contains('picker-row')) return;
    // 🔒 防自激(用户 2026-09-19 iPad 视频:头带行每 0.2s 左右跳 1px 不停):自己写 scrollLeft 也会触发 scroll 事件,
    //    iPad 缩放后目标是小数、浏览器落点被量化,两者永远差 >0.5 → 写→事件→再写 无限循环(周期 = 2×90ms + 1 帧,与视频吻合)。
    //    自己写完 250ms 内的滚动一律不理(iOS 自带 scroll-snap 的补吸也在这窗口里),循环在结构上就断了;用户再滑才重新吸附。
    if (row.__snapUntil && performance.now() < row.__snapUntil) return;
    clearTimeout(t);
    t = setTimeout(function () {
      var chips = row.querySelectorAll('.picker-chip');
      if (chips.length < 4) return;
      // 关键修正(2026-07-12):跟面盖对齐 = 一屏 4 chip「在屏幕上居中成组」(面盖就是 4 chip 居中布局)。
      // 坑:有个 ~0.93 缩放祖先,布局坐标(offsetLeft/clientWidth)≠ 屏幕坐标;对齐是屏幕上的事,
      // 在布局坐标里算会偏(远端 ~26px)→ 旧吸附把对齐位拉到 chip 起点,选头带后整排右移。
      // 正解:直接用 getBoundingClientRect 在屏幕坐标里找「离屏幕中心最近的 4 连 chip 组」,
      // 算出让它居中要平移多少屏幕 px,再按缩放比换算回 scrollLeft 增量。位置已对齐时增量≈0→不移动。
      var sl = row.scrollLeft, GROUP = 4;
      var rowRect = row.getBoundingClientRect();
      var rowCenter = rowRect.left + rowRect.width / 2;
      var rects = [];
      for (var i = 0; i < chips.length; i++) rects.push(chips[i].getBoundingClientRect());
      var scale = chips[0].offsetWidth > 0 ? (rects[0].width / chips[0].offsetWidth) : 1;
      if (scale <= 0) return;
      var bestK = -1, bestDist = Infinity;
      for (var k = 0; k + GROUP - 1 < chips.length; k++) {
        var gCenter = (rects[k].left + rects[k + GROUP - 1].right) / 2;   // 这 4 chip 组的屏幕中心
        var d = Math.abs(gCenter - rowCenter);
        if (d < bestDist) { bestDist = d; bestK = k; }
      }
      if (bestK < 0) return;
      var groupCenter = (rects[bestK].left + rects[bestK + GROUP - 1].right) / 2;
      var deltaScreen = groupCenter - rowCenter;          // >0:组偏右→需右滚(增大 scrollLeft)让它回中
      var snapped = sl + deltaScreen / scale;
      snapped = Math.max(0, Math.min(snapped, row.scrollWidth - row.clientWidth));
      if (Math.abs(snapped - row.scrollLeft) > 0.5) {
        // 用户 2026-07-12 选②:归位改"几乎瞬间到位"——临时关 CSS scroll-behavior:smooth,
        // 直接赋值瞬时落位再还原,消除平滑滑动那"飘一下"的拖尾感(不再像页面自己在动)
        var prevBhv = row.style.scrollBehavior;
        row.style.scrollBehavior = 'auto';
        row.__snapUntil = performance.now() + 250;
        row.scrollLeft = snapped;
        row.style.scrollBehavior = prevBhv;
      }
    }, 90);  // 130→90:松手后更快归位,跟着手势走,不像"页面自己在动"
  }, true); // capture:捕获 picker-row 的滚动(即使重渲染也生效)
})();
